<template>
    <div class="doc-overflow">
        <ob-layout :type="5">

            <template slot="content-section">
                <div class="row" style="background-color:#fff;margin:30px">
                <h5 class="request-doc-header">H-1B PETITION CHECKLIST</h5>
                <p class="upload-text">Please provide all the requested information & documents.</p>
                <div calss="col-md-12" style="border-bottom:2px dashed grey;"></div>
                <div class="col-md-12" style="padding-bottom:10px;">
                    <div class="col-md-12" style="padding-top:30px;padding-bottom:10px;padding-left:75px;">
                        <div class="col-md-1">
                            <span v-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_one_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_one_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_one_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_one_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_one_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_one_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1" style="padding-top:6px;">
                            <span v-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_arrow_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1">
                            <span v-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_two_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_two_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_two_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_two_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_two_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_two_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1" style="padding-top:6px;">
                            <span v-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1">
                            <span v-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_three_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_three_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_three_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_three_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_three_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_three_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1" style="padding-top:6px;">
                            <span v-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_arrow_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1">
                            <span v-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_four_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_four_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_four_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_four_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_four_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_four_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1" style="padding-top:6px;">
                            <span v-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1">
                            <span v-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_five_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_five_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/grey_five_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/grey_five_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/grey_five_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/grey_five_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1" style="padding-top:6px;">
                            <span v-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/green_arrow_icon.svg`"/></span>
                            <span v-else-if="OpendependentInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_arrow_icon.svg`"/></span>
                            <span v-else-if="OpeneducationalInfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenemploymentinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                            <span v-else-if="OpenimmigrationinfoForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                            <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/gray_arrow_icon.svg`"/></span>
                        </div>
                        <div class="col-md-1">
                            <div class="col-md-12">
                                <span v-if="OpenpreviewForm"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_six_icon.svg`"/></span>
                                <span v-else><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/grey-six_icon.svg`"/></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="col-md-2" style="padding-left:53px;">
                            <span v-if="OpeneducationalInfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Personal Info</span>
                            <span v-else-if="OpenemploymentinfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Personal Info</span>
                            <span v-else-if="OpenimmigrationinfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Personal Info</span>
                            <span v-else-if="OpendependentInfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Personal Info</span>
                            <span v-else-if="OpenpreviewForm" style="font-weight: bold;color: rgb(40, 167, 69);">Personal Info</span>
                            <span v-else style="font-weight: bold;color: rgb(74, 144, 226);">Personal Info</span>
                            <template v-if="!(H1BCheckListData.CurrentStatus == 'Rejected' && H1BCheckListData.IsHrAReviewer && H1BCheckListData.IsThirdPartyReviewerExists) "><span class="col-md-12 pL0" v-for ="(d,dIndex) in reviewStatusCommentsData" :key="dIndex"><span v-if="d.Status == 'Approved' && d.TabType == 'Personal'" style="font-weight: bold;font-size:12px;color: rgb(40, 167, 69);"><span class="document-list__ApproveStatusESSStyle">&#10003;</span>&nbsp;Approved</span><span v-if="d.Status == 'Rejected' && d.TabType == 'Personal'" style="font-weight: bold;font-size:12px;color: #D60000;"><span class="document-list__RejectStatusESSStyle">!</span>&nbsp;Rejected</span></span></template>
                        </div>
                        <div class="col-md-2" style="padding-left:35px;">
                            <span v-if="OpenemploymentinfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Educational Info</span>
                            <span v-else-if="OpeneducationalInfoForm" style="font-weight: bold;color: rgb(74, 144, 226);">Educational Info</span>
                            <span v-else-if="OpenimmigrationinfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Educational Info</span>
                            <span v-else-if="OpendependentInfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Educational Info</span>
                            <span v-else-if="OpenpreviewForm" style="font-weight: bold;color: rgb(40, 167, 69);">Educational Info</span>
                            <span v-else style="font-weight: bold;color: rgb(158, 158, 158);">Educational Info</span>
                            <template v-if="!(H1BCheckListData.CurrentStatus == 'Rejected' && H1BCheckListData.IsHrAReviewer && H1BCheckListData.IsThirdPartyReviewerExists) "><span class="col-md-12 pL0" v-for ="(d,dIndex) in reviewStatusCommentsData" :key="dIndex"><span v-if="d.Status == 'Approved' && d.TabType == 'Education'" style="font-weight: bold;font-size:12px;color: rgb(40, 167, 69);"><span class="document-list__ApproveStatusESSStyle">&#10003;</span>&nbsp;Approved</span><span v-if="d.Status == 'Rejected' && d.TabType == 'Education'" style="font-weight: bold;font-size:12px;color: #D60000;"><span class="document-list__RejectStatusESSStyle">!</span>&nbsp;Rejected</span></span></template>
                        </div>
                        <div class="col-md-2" style="padding-left:26px;">
                            <span v-if="OpenimmigrationinfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Employment Info</span>
                            <span v-else-if="OpenemploymentinfoForm" style="font-weight: bold;color: rgb(74, 144, 226);">Employment Info</span>
                            <span v-else-if="OpendependentInfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Employment Info</span>
                            <span v-else-if="OpenpreviewForm" style="font-weight: bold;color: rgb(40, 167, 69);">Employment Info</span>
                            <span v-else-if="OpeneducationalInfoForm" style="font-weight: bold;color: rgb(158, 158, 158);">Employment Info</span>
                            <span v-else style="font-weight: bold;color: rgb(158, 158, 158);">Employment Info</span>
                            <template v-if="!(H1BCheckListData.CurrentStatus == 'Rejected' && H1BCheckListData.IsHrAReviewer && H1BCheckListData.IsThirdPartyReviewerExists) "><span class="col-md-12 pL0" v-for ="(d,dIndex) in reviewStatusCommentsData" :key="dIndex"><span v-if="d.Status == 'Approved' && d.TabType == 'Employment'" style="font-weight: bold;font-size:12px;color: rgb(40, 167, 69);"><span class="document-list__ApproveStatusESSStyle">&#10003;</span>&nbsp;Approved</span><span v-if="d.Status == 'Rejected' && d.TabType == 'Employment'" style="font-weight: bold;font-size:12px;color: #D60000;"><span class="document-list__RejectStatusESSStyle">!</span>&nbsp;Rejected</span></span></template>
                        </div>
                        <div class="col-md-2" style="padding-left:18px;">
                            <span v-if="OpendependentInfoForm" style="font-weight: bold;color: rgb(40, 167, 69);">Immigration Info</span>
                            <span v-else-if="OpenimmigrationinfoForm" style="font-weight: bold;color: rgb(74, 144, 226);">Immigration Info</span>
                            <span v-else-if="OpenpreviewForm" style="font-weight: bold;color: rgb(40, 167, 69);">Immigration Info</span>
                            <span v-else-if="OpeneducationalInfoForm" style="font-weight: bold;color: rgb(158, 158, 158);">Immigration Info</span>
                            <span v-else-if="OpenemploymentinfoForm" style="font-weight: bold;color: rgb(158, 158, 158);">Immigration Info</span>
                            <span v-else style="font-weight: bold;color: rgb(158, 158, 158);">Immigration Info</span>
                           <template v-if="!(H1BCheckListData.CurrentStatus == 'Rejected' && H1BCheckListData.IsHrAReviewer && H1BCheckListData.IsThirdPartyReviewerExists) "> <span class="col-md-12 pL0" v-for ="(d,dIndex) in reviewStatusCommentsData" :key="dIndex"><span v-if="d.Status == 'Approved' && d.TabType == 'Immigration'" style="font-weight: bold;font-size:12px;color: rgb(40, 167, 69);"><span class="document-list__ApproveStatusESSStyle">&#10003;</span>&nbsp;Approved</span><span v-if="d.Status == 'Rejected' && d.TabType == 'Immigration'" style="font-weight: bold;font-size:12px;color: #D60000;"><span class="document-list__RejectStatusESSStyle">!</span>&nbsp;Rejected</span></span></template>
                        </div>
                        <div class="col-md-2" style="padding-left:12px;">
                            <span v-if="OpenpreviewForm" style="font-weight: bold;color: rgb(40, 167, 69);">Dependent Info</span>
                            <span v-else-if="OpendependentInfoForm" style="font-weight: bold;color: rgb(74, 144, 226);">Dependent Info</span>
                            <span v-else-if="OpeneducationalInfoForm" style="font-weight: bold;color: rgb(158, 158, 158);">Dependent Info</span>
                            <span v-else-if="OpenemploymentinfoForm" style="font-weight: bold;color: rgb(158, 158, 158);">Dependent Info</span>
                            <span v-else-if="OpenimmigrationinfoForm" style="font-weight: bold;color: rgb(158, 158, 158);">Dependent Info</span>
                            <span v-else style="font-weight: bold;color: rgb(158, 158, 158);">Dependent Info</span>
                            <template v-if="!(H1BCheckListData.CurrentStatus == 'Rejected' && H1BCheckListData.IsHrAReviewer && H1BCheckListData.IsThirdPartyReviewerExists) "><span class="col-md-12 pL0" v-for ="(d,dIndex) in reviewStatusCommentsData" :key="dIndex"><span v-if="d.Status == 'Approved' && d.TabType == 'Dependent'" style="font-weight: bold;font-size:12px;color: rgb(40, 167, 69);"><span class="document-list__ApproveStatusESSStyle">&#10003;</span>&nbsp;Approved</span><span v-if="d.Status == 'Rejected' && d.TabType == 'Dependent'" style="font-weight: bold;font-size:12px;color: #D60000;"><span class="document-list__RejectStatusESSStyle">!</span>&nbsp;Rejected</span></span></template>
                        </div>
                        <div class="col-md-2" style="padding-left:10px;">
                            <span v-if="OpenpreviewForm" style="font-weight: bold;color: rgb(74, 144, 226);">Preview & Submit</span>
                            <span v-else style="font-weight: bold;color: rgb(158, 158, 158);">Preview & Submit</span>
                        </div>
                    </div>
                    <div class="col-md-12 pL0" :class="{'padBottomStyle': d.TabType == 'Personal'}" v-for ="(d,dIndex) in reviewStatusCommentsData" :key="dIndex">
                    <div class="col-md-12" v-if="showPersonalApproveOrRejectComments == true && d.TabType == 'Personal' && d.Status == 'Rejected' ">
                    <div class="col-md-12 pL0 padBotStyle">
                                Reason for Rejection:
                    </div>
                    <div class="col-md-12 commentTopStyle colorFontStyle">
                    {{d.Comments}}

                    </div>
                    </div>
                    <div class="col-md-12" v-if="showEducationalApproveOrRejectComments && d.TabType == 'Education' && d.Status == 'Rejected' ">
                    <div class="col-md-12 pL0 padBotStyle">
                                Reason for Rejection:
                    </div>
                    <div class="col-md-12 commentTopStyle colorFontStyle">
                    {{d.Comments}}

                    </div>
                    </div>
                    <div class="col-md-12" v-if="showEmploymentApproveOrRejectComments && d.TabType == 'Employment' && d.Status == 'Rejected' ">
                    <div class="col-md-12 pL0 padBotStyle">
                                Reason for Rejection:
                    </div>
                    <div class="col-md-12 commentTopStyle colorFontStyle">
                    {{d.Comments}}

                    </div>
                    </div>
                    <div class="col-md-12" v-if="showImmigrationApproveOrRejectComments && d.TabType == 'Immigration' && d.Status == 'Rejected' ">
                    <div class="col-md-12 pL0 padBotStyle">
                                Reason for Rejection:
                    </div>
                    <div class="col-md-12 commentTopStyle colorFontStyle">
                    {{d.Comments}}

                    </div>
                    </div>
                    <!-- showEducationalApproveOrRejectComments:false,
                    showEmploymentApproveOrRejectComments:false,
                    showImmigrationApproveOrRejectComments:false,
                    showDependentApproveOrRejectComments:false, -->
                    <div class="col-md-12" v-if="showDependentApproveOrRejectComments && d.TabType == 'Dependent' && d.Status == 'Rejected' ">
                    <div class="col-md-12 pL0 padBotStyle">
                                Reason for Rejection:
                    </div>
                    <div class="col-md-12 commentTopStyle colorFontStyle">
                    {{d.Comments}}

                    </div>
                    </div>
                    </div>

                </div>
              <!-- Starting of Educational Info -->
                <div class="col-md-12" v-if="OpeneducationalInfoForm">
                    <h4 style="color:#000;padding-left:17px;" class="heading-text">Educational Information</h4>
                     <div class="col-md-12">
                        <p class="names-text" style="padding-top:10px;padding-left:2px;">Do you have a Master’s Degree or Higher?
                           <span class="radio-inline" ><ob-radio id="ms1" name="masters" @input="mastersDegree" v-model="educationinfo.mastersDegreeVal" val='Yes'>Yes</ob-radio></span>
                            <span class="radio-inline"><ob-radio id="ms2" name="masters" @input="mastersDegree" v-model="educationinfo.mastersDegreeVal" val='No'>No</ob-radio></span>
                        </p>
                    </div>
                    <div class="col-md-12" style="padding-bottom:10px;padding-top: 10px;" v-if="isShowMastersDegree">
                        <div class="col-md-3 ">
                            <label style="margin-left: -13px;" class="label-text">Date Degree awarded<span class="rcss-text-red">*</span></label>
                            <ob-date-time-picker style="margin-left:-15px;" id="dob2" placeholder="Select Date" @updated="(v)=>this.educationinfo.Datedegree = v" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.Datedegree.$error }" :options="options2" :inputvalue="educationinfo.Datedegree" v-model="educationinfo.Datedegree"></ob-date-time-picker>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-15px;" v-if="$v.educationinfo.Datedegree.$dirty && !$v.educationinfo.Datedegree.requiredIf"> Please select Date</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text" style="margin-left:-15px;"> Type of Degree <span class="rcss-text-red">*</span> </label>
                            <ob-select2 placeholder="Type of Degree" maxLength="30" style="margin-left:-15px;" key="" :options="degreeTypeOpt" v-model.trim="educationinfo.TypeofDegree" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.TypeofDegree.$error }"></ob-select2>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-15px;" v-if="$v.educationinfo.TypeofDegree.$dirty && !$v.educationinfo.TypeofDegree.requiredIf">Please select Degree</span>
                        </div>
                        <div class="col-md-6">
                            <label class="label-text"> Major field of study<span class="rcss-text-red">*</span></label>
                            <ob-input placeholder="Major field of study" maxLength="150" v-model="educationinfo.Majorfield" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.Majorfield.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.Majorfield.$dirty && !$v.educationinfo.Majorfield.requiredIf">Please enter Major field of study</span>
                        </div>
                    </div>
                    <div class="col-md-12" style="margin-left:-15px;" v-if="isShowMastersDegree">
                        <div class="col-md-6">
                            <label class="label-text"> Name of the Institution of Higher Education<span class="rcss-text-red">*</span></label>
                            <ob-input placeholder="Enter the name of the Institution" maxLength="150" v-model="educationinfo.Nameofinstitution" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.Nameofinstitution.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.Nameofinstitution.$dirty && !$v.educationinfo.Nameofinstitution.requiredIf"> Please enter Name of Institution  </span>
                           <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.Nameofinstitution.$dirty && !$v.educationinfo.Nameofinstitution.alphawithsplchar"> Please enter vaild Name of institution  </span>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" style="padding-left:16px">
                                <label>Upload Document<span class="rcss-text-red">*</span></label>
                                <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                 <ob-upload-new :validation="ValidationType2" :end-point="EndPoint" :type="2"  @file-complete="uploadComplete" :IsFileExists="educationDetailsDocURL | fileName" @remove-file="removeEducationDocDetails">
                                    <template slot="file-text" style="height: 28px;">
                                        <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                    </template>

                                </ob-upload-new>
                                <span class="ob-vuelidate_error-msg" v-if="$v.educationDetailsDocURL.$dirty && !$v.educationDetailsDocURL.requiredIf">Please upload the document</span>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-12">
                        <p class="names-text" style="padding-top:10px;padding-left:2px;">Do you have a U.S Master's Degree or Higher?
                           <span class="radio-inline" ><ob-radio id="USMSD1" :key="compreset" name="options1" val="Yes" @input="AnyMasterDegree" v-model="educationinfo.appeareYes">Yes</ob-radio></span>
                            <span class="radio-inline"><ob-radio id="USMSD2" name="options1" val="No"  @input="AnyMasterDegree" v-model="educationinfo.appeareNo">No</ob-radio></span>
                        </p>
                    </div>
                    <div v-if="Opendegree">
                        <div class="col-md-12">
                            <div class="col-md-3 ">
                                <label class="label-text" style="margin-left:-15px;">Date Degree awarded<span class="rcss-text-red">*</span></label>
                                <ob-date-time-picker style="margin-left:-15px;" id="dob1" placeholder="Select date" @updated="(v)=>this.educationinfo.yesDatedegree = v" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.yesDatedegree.$error }" :options="options2" :inputvalue="educationinfo.yesDatedegree" v-model="educationinfo.yesDatedegree"></ob-date-time-picker>
                                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-15px;" v-if="$v.educationinfo.yesDatedegree.$dirty && !$v.educationinfo.yesDatedegree.requiredIf"> Please select Date</span>
                            </div>
                            <div class="col-md-3">
                                <label class="label-text" style="margin-left:-15px;"> Type of Degree <span class="rcss-text-red">*</span> </label>
                                <ob-select2 placeholder="Type of Degree" maxLength="30" style="margin-left:-15px;" key="" :options="degreeTypeOpt" v-model.trim="educationinfo.yesTypeofDegree" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.yesTypeofDegree.$error }"></ob-select2>
                                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-15px;" v-if="$v.educationinfo.yesTypeofDegree.$dirty && !$v.educationinfo.yesTypeofDegree.requiredIf">Please select Degree</span>
                            </div>
                            <div class="col-md-6">
                                <label style="margin-left:-1px;" class="label-text"> Major field of study<span class="rcss-text-red">*</span></label>
                                <ob-input placeholder="Major field of study" maxLength="150" style="margin-left: 1px;" v-model="educationinfo.yesMajorfield" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.yesMajorfield.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.yesMajorfield.$dirty && !$v.educationinfo.yesMajorfield.requiredIf">Please enter Major field of study</span>
                                <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.yesMajorfield.$dirty && !$v.educationinfo.yesMajorfield.alpha"> Please enter vaild Major field</span> -->
                            </div>
                        </div>
                        <div class="col-md-12" style="padding:20px 0px 0px 0px;">
                            <div class="col-md-6">
                                <label class="label-text" style="margin-left:-2px;"> Name of the Institution of Higher Education<span class="rcss-text-red">*</span></label>
                                <ob-input placeholder="Enter the name of the Institution" maxLength="150" v-model="educationinfo.yesNameofinstitution" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.yesNameofinstitution.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.yesNameofinstitution.$dirty && !$v.educationinfo.yesNameofinstitution.requiredIf"> Please enter Name of Institution</span>
                                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.yesNameofinstitution.$dirty && !$v.educationinfo.yesNameofinstitution.alphawithsplchar"> Please enter vaild Name of institution</span>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group" style="padding-left:10px">
                                    <label>Upload Document<span class="rcss-text-red">*</span></label>
                                    <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                    <ob-upload-new :validation="ValidationType2" :end-point="EndPoint" :type="2"  @file-complete="highuploadComplete" :IsFileExists="higherEducationDetailsDocURL | fileName" @remove-file="removehigherEducationDetailsDocURL">

                                        <template slot="file-text" style="height: 28px;"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                        </template>

                                    </ob-upload-new>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.higherEducationDetailsDocURL.$dirty && !$v.higherEducationDetailsDocURL.requiredIf">Please upload the document</span>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="col-md-12"  v-if="Opendegree">
                        <h4 style="color:#000;margin-left:-15px;" class="heading-text">Address of the United States institution of higher education</h4>
                        <div class="form-group status-options">
                            <div class="col-md-6 pL0">
                                <label class="label-text" style="padding-left:1px;"> Street Number and Name<span style="color:red">*</span></label>
                                <ob-input style="margin-left:2px;" placeholder="Enter Street Number and Name" maxLength="150" v-model.trim="educationinfo.Street" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.Street.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:4px;" v-if="$v.educationinfo.Street.$dirty && !$v.educationinfo.Street.requiredIf"> Please enter Street number</span>

                            </div>
                            <div class="col-md-3">
                                <label class="label-text">Building Type</label>
                                <div class="radio-buttons">
                                    <span class="radio-inline"><ob-radio id="radio13" name="btype4" val="ap3"  @input="eduBuildingType" v-model="educationinfo.Selectedapt">Apt.</ob-radio></span>
                                    <span class="radio-inline"><ob-radio id="radio14" name="btype4" val="st4"  @input="eduBuildingType" v-model="educationinfo.Selectedste">Ste.</ob-radio></span>
                                    <span class="radio-inline"><ob-radio id="radio15" name="btype4" val="fl4"  @input="eduBuildingType" v-model="educationinfo.Selectedflr">Flr.</ob-radio></span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <label class="label-text">Building Number <span style="color:red">*</span></label>
                                <ob-input placeholder="Enter Number" v-model.trim="educationinfo.BuildingNumber" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.BuildingNumber.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.educationinfo.BuildingNumber.$dirty && !$v.educationinfo.BuildingNumber.requiredIf"> Please enter  Building number </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding:20px 0px 0px 0px;"  v-if="Opendegree">
                        <div class="col-md-3">
                            <label class="label-text" style="padding-left:5px;"> City,State <span class="rcss-text-red">*</span> </label>
                            <location-search :vmodelData.sync="educationinfo.currentCity" @input="getZipCodeForEduInfo(educationinfo)" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.currentCity.$error }"></location-search>
                            <!-- <ob-select2 placeholder="Select" maxLength="30" style="margin-left:1px;" key="" :options="currentCity"  v-model.trim="educationinfo.currentCity" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.currentCity.$error }" ></ob-select2> -->
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:3px;" v-if="$v.educationinfo.currentCity.$dirty && !$v.educationinfo.currentCity.requiredIf"> Please select City,State</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text" style="margin-left:-1px;"> Zip Code <span class="rcss-text-red">*</span> </label>
                            <ob-input placeholder="Enter Zip Code" maxLength="5" v-model.trim="educationinfo.zipcode" :class="{ 'ob-vuelidate_input-error': $v.educationinfo.zipcode.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.educationinfo.zipcode.$dirty && !$v.educationinfo.zipcode.requiredIf"> Please enter Zip Code</span>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-else-if="!$v.educationinfo.zipcode.numeric || !$v.educationinfo.zipcode.minLength "> Please enter valid Zipcode</span>
                        </div>
                    </div>
                    <div class="col-md-12" v-if="IsEducationRequestedDocsExists">
                        <h4 style="color:#000;padding-left:3px;" class="heading-text" v-if="isShowEducationalandTrainingDocs">Educational & Training Document</h4>
                        <div class="col-md-12 pL0" :key="`documentlist-${index}`" v-for="(l, index) in educationInfomation.Documents">
                             <ob-document-list-ess :documentList="l" :key='increVal' :checklistIsDocAvailable="l.IsDocumentNotAvailable" :CheckListTabType="'education'" :FromCheckList="true"  v-if="l.DocumentType != 'DegreeCerificates' && l.DocumentType != 'Certifications' " @onDocumentUpdate="updateeducatonalDoc(index , ...arguments, docStatus)" @isEducationDocAvailable="isEducationDocumentAvailable(...arguments)" @onDocumentRemove="removeEducationDoc(index , ...arguments, docStatus)"></ob-document-list-ess>
                        </div>
                                    </div>
                    <div class="footer-buttons">
                        <div class="col-md-12" style="border-bottom:1px solid grey;padding-bottom:20px;"></div>
                        <div class="col-md-12" style="padding:25px 0px 25px 0px;">
                            <ob-button type="secondary" width="100px;" @click="backforEduInfo"> Back</ob-button>
                            <ob-button type="secondary" style="margin-left:15px;" width="100px;" @click="backtoHome">Cancel</ob-button>
                            <template v-if="showEducationButtons">
                            <ob-button type="primary" v-if="disableEducSaveBtn" style="margin-left:15px;"  width="120px;" :disabled="true">Save & Proceed</ob-button>
                            <ob-button type="primary" v-else style="margin-left:15px;"  width="120px;" @click="gotoempInfo">Save & Proceed</ob-button>
                            </template>
                        </div>
                    </div>
                </div>
                <!-- Ending of Educational Info -->
                <!-- Starting of Employemnt Info -->
                <div v-else-if="OpenemploymentinfoForm">
                    <h4 style="color:#000;padding-left:30px;" class="heading-text">Employment Information</h4>
                    <div class="col-md-12" style="padding-bottom:10px;padding-top: 10px;">
                        <div class="col-md-5 ">
                            <label class="label-text" style="padding-left:-10px;">Name of the Employer (Sponsoring H-1B)<span class="rcss-text-red">*</span></label>
                            <ob-input placeholder="Name of the Employer" maxLength="150" v-model.trim="Employeeinfo.Name" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.Name.$error }" @input="updateValue('empName', Employeeinfo.Name)"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-1px;" v-if="$v.Employeeinfo.Name.$dirty && !$v.Employeeinfo.Name.required"> Please enter Name</span>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-1px;" v-if="$v.Employeeinfo.Name.$dirty && !$v.Employeeinfo.Name.alphawithsplchar"> Please enter vaild Name </span> -->
                        </div>
                        <!-- <div class="col-md-2">
                <label class="label-text"> Job Title <span class="rcss-text-red">*</span> </label>
                <ob-input placeholder="Type of Job" maxLength="30" v-model.trim="Employeeinfo.Job" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.Job.$error }"></ob-input>
                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:4px;" v-if="$v.Employeeinfo.Job.$dirty && !$v.Employeeinfo.Job.required"> Please enter jobtittle</span>
                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:4px;" v-if="$v.Employeeinfo.Job.$dirty && !$v.Employeeinfo.Job.alpha"> Please enter vaild jobtittle </span>
            </div>
            <div class="col-md-2">
                <label class="label-text"> Salary Ofered<span class="rcss-text-red">*</span></label>
                <ob-input placeholder="Type of Job" maxLength="30" v-model.trim="Employeeinfo.Salary" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.Salary.$error }"></ob-input>
                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:4px;" v-if="$v.Employeeinfo.Salary.$dirty && !$v.Employeeinfo.Salary.required"> Please enter salary </span>
                <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:4px;" v-if="$v.Employeeinfo.Salary.$dirty && !$v.Employeeinfo.Salary.numeric"> Please enter vaildsalary </span>
            </div>
            <div class="col-md-2">
                <label class="label-text"> Per<span class="rcss-text-red">*</span></label>
                <ob-date-time-picker id="immDate" placeholder="Select Date" :options="options2"  @updated="(v) => this.Employeeinfo.Pre = v" v-model.trim="Employeeinfo.Pre" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.Pre.$error }"></ob-date-time-picker>
                 <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:1px;" v-if="$v.Employeeinfo.Pre.$dirty && !$v.Employeeinfo.Pre.required"> Please select Pre</span>
            </div>-->
                    </div>
                    <div>

                        <div class="col-md-12">
                            <!-- <h4 style="color:#000;padding-right:20px;padding-top:10px;" class="heading-text">Work Location Address -Is your address different from companies location?</h4>
                            <div class="col-md-12"> -->
                        <p class="names-text" style="color:#000;padding-top:10px;padding-left: 13px;">Is your work location different from company location? If yes, Please list the full address of the third party work site location (end-client site) :
                           <span class="radio-inline" ><ob-radio id="empadd1" name="empaddr" @input="empAddress" v-model="Employeeinfo.empAddressVal" val='Yes'>Yes</ob-radio></span>
                            <span class="radio-inline"><ob-radio id="empadd2" name="empaddr" @input="empAddress" v-model="Employeeinfo.empAddressVal" val='No'>No</ob-radio></span>
                        </p>
                    <!-- </div> -->
                            <div class="form-group status-options" v-if="isShowEmpAddress">
                                <div class="col-md-6">
                                    <label class="label-text">Street Number and Name<span style="color:red">*</span></label>
                                    <ob-input placeholder="Enter Street Number and Name" maxLength="150" v-model.trim="Employeeinfo.empStreet" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.empStreet.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-1px;" v-if="$v.Employeeinfo.empStreet.$dirty && !$v.Employeeinfo.empStreet.requiredIf">please enter Street number</span>
                                </div>
                                 <div class="col-md-3">
                                    <label class="label-text">Building Type<span style="color:red">*</span></label>
                                    <div class="radio-buttons">
                                        <span class="radio-inline"><ob-radio id="radio7" name="btype2" v-model="Employeeinfo.buildType" val="apt2" >Apt.</ob-radio></span>
                                        <span name="options1" class="radio-inline"><ob-radio id="radio8" name="btype2" v-model="Employeeinfo.buildType" val="ste2">Ste.</ob-radio></span>
                                        <span name="options1" class="radio-inline"><ob-radio id="radio9" name="btype2" v-model="Employeeinfo.buildType" val="flr2">Flr.</ob-radio></span>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label class="label-text">Building Number<span style="color:red">*</span></label>
                                    <ob-input placeholder="Enter Number" maxLength="150" v-model.trim="Employeeinfo.empBuildingNumber" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.empBuildingNumber.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-7px;" v-if="$v.Employeeinfo.empBuildingNumber.$dirty && !$v.Employeeinfo.empBuildingNumber.requiredIf"> Please enter Building number  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding-top:9px;" v-if="isShowEmpAddress">
                        <div class="col-md-3">
                            <label class="label-text"> City,State<span style="color:red">*</span></label>
                            <location-search :vmodelData.sync="Employeeinfo.empcurrentCity" @input="getZipCodeForEmpInfo(Employeeinfo)" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.empcurrentCity.$error }"></location-search>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.Employeeinfo.empcurrentCity.$dirty && !$v.Employeeinfo.empcurrentCity.requiredIf"> Please select City,State</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text" style="margin-left:-1px;"> Zip Code<span style="color:red">*</span></label>
                            <ob-input placeholder="Enter Zip Code" maxLength="5" v-model.trim="Employeeinfo.empzipcode" :class="{ 'ob-vuelidate_input-error': $v.Employeeinfo.empzipcode.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.Employeeinfo.empzipcode.$dirty && !$v.Employeeinfo.empzipcode.requiredIf"> Please enter Zip Code</span>
                        </div>
                    </div>

	    <div class="col-md-12" style="padding-bottom: 35px">
            <link-to-end-client :link.sync="clientsList" linkTaxterm="W2" :isESS.sync="isESS" :isValid.sync="isValid" :validate="validate" ></link-to-end-client>
    <!-- <h4 class="heading-text" style="margin-right: -14px;">Client Details (List all Clients, Explain contractual part from Petitioner to End-client)</h4>
       <div class="flow-digram">
       <div class="endclient-details">
          <svg class="line" height="2" width="40">
          <line x1="0" y1="0" x2="200" y2="0" style="stroke:#DFDFDF;stroke-width:2" />
        </svg>
        <div class="col-md-6" style="padding-left:0px;">
            <p class="end-client-name">End Client Name</p>
             <ob-input class="input-field" :disabled="true" v-model="EndClient.OrganizationName"></ob-input>
         </div>
         <div class="col-md-6">
             <p class="end-client-website">End Client Website</p>
             <ob-input  class="input-field" :disabled="true" v-model="EndClient.website"></ob-input>
         </div>
         </div>
      <div class="vl">
      <img class="add-position" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_plus_icon.svg`" @click="addClient">
      </div>
      <div class="add-another-text-align" style="margin-left: 68px">
       <span class="add-another-client" @click="addClient">Add Another Client</span>
       </div>
       <div>
         <div class="vl" v-for="(client , dIndex) in clientsList" :key="dIndex">
         <div class="fixed-org">
          <svg class="line" height="4" width="40">
            <line x1="0" y1="0" x2="200" y2="0" style="stroke:#DFDFDF;stroke-width:2" />
          </svg>
          <div class="col-md-6" style="padding-top:22px;padding-left:0px;">
          <ob-input class="input-client-field" placeholder="Client Name" v-model="client.OrganizationName"></ob-input>
          </div>
          <div class="col-md-6" style="padding-top:22px;">
          <ob-input class="input-client-field" placeholder="Client Website" v-model="client.website"></ob-input>
          </div>
          <img src="/static/Images/cross-circle.svg" width="25" height="25" v-if="dIndex != 0" style="cursor:pointer;display:inline-block;margin-top: 21px;" @click="removeClient(clientsList,dIndex)">
        </div>
        <img class="add-position" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_plus_icon.svg`" @click="addClient()">
        <div class="add-another-text-align">
       <span class="add-another-client" @click="addClient">Add Another Client</span>
       </div>

       </div>

       <div class="align-org org-vl">
        <svg class="org-line" height="4" width="40">
            <line x1="0" y1="0" x2="200" y2="0" style="stroke:#DFDFDF;stroke-width:2" />
        </svg>
     <div class="col-md-6" style="padding-left:0px;">
    <p class="organization">Your Organization</p>
    <ob-input :value="this.candidatesOrgName" :disabled="true"></ob-input>
     </div>
    </div>
    </div>
 </div> -->
</div>
<div class="col-md-12" v-if="IsEmploymentRequestedDocsExists">
                        <h4 style="color:#000;margin-right: -14px;" class="heading-text">Employment Documents</h4>
                        <div class="col-md-12 pL0" :key='increVal' style="padding-left:16px;">
                            <ob-document-list-ess :documentList="l" :checklistIsDocAvailable="l.IsDocumentNotAvailable" :CheckListTabType="'employment'" :FromCheckList="true" :key="`documentlist-${index}`" v-for="(l, index) in employmentInfomation.Documents" @onDocumentUpdate ="updateEmpDocumentsObj(index , ...arguments, docStatus)" @isEmploymentDocAvailable="isEmploymentDocumentAvailable(...arguments)" @onDocumentRemove="removeEmploymentDoc(index , ...arguments, docStatus)"></ob-document-list-ess>
                        </div>
                       <!-- <ob-document-list :documentList="documentList5" :FromCheckList="true"></ob-document-list>
                        <ob-document-list :documentList="documentList6" :FromCheckList="true"></ob-document-list>
                        <ob-document-list :documentList="documentList7" :FromCheckList="true"></ob-document-list>
                        <ob-document-list :documentList="documentList8" :FromCheckList="true"></ob-document-list>
                        <ob-document-list :documentList="documentList9" :FromCheckList="true"></ob-document-list>
                        <ob-document-list :documentList="documentList10" :FromCheckList="true"></ob-document-list>
                        <ob-document-list :documentList="documentList11" :FromCheckList="true"></ob-document-list>
                        <ob-document-list :documentList="documentList12" :FromCheckList="true"></ob-document-list> -->

                    </div>
                    <div class="col-md-12" style="border-bottom:1px solid grey;padding-bottom:35px;"></div>
                    <div class="footer-buttons">
                        <div class="col-md-12" style="padding:25px 0px 25px 0px;">
                            <ob-button type="secondary" width="120px;" @click="backforEmpInfo">Back</ob-button>
                            <ob-button type="secondary" style="margin-left:15px;" width="100px;" @click="backtoHome">Cancel</ob-button>
                           <template  v-if="showEmploymentButtons">
                            <ob-button type="primary" style="margin-left:15px;" v-if="disableEmpSaveBtn" :disabled="true" width="120px;" @click="gotoimmiinfo">Save & Proceed</ob-button>
                        <ob-button v-else type="primary" style="margin-left:15px;" width="120px;" @click="gotoimmiinfo">Save & Proceed</ob-button>
                       </template>

                        </div>
                    </div>
                </div>
                <!-- Ending of Employemnt Info -->
                <!-- Starting of Immigartion Info -->
                <div v-else-if="OpenimmigrationinfoForm">
                    <div class="col-md-12" style="padding-left:29px;">
                        <p class="doc-header" >Are you in the United States?
                            <span class="radio-inline" @click="isactiveYes(1)"><ob-radio id="st1" name="states" v-model="ImmigrationInfo.visible" val='Yes'>Yes</ob-radio></span>
                            <span class="radio-inline" @click="isactiveNo(1)"><ob-radio id="st2" name="states" v-model="ImmigrationInfo.visible" val='No'>No</ob-radio></span>
                        </p>
                    </div>
                    <div class="col-md-12" v-if="isShowStay" style="padding-left:0px;">
                        <div class="col-md-12" style="padding-left:29px;padding-top:9px;">
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>I-94 Arrival - Departure Record Number<span style="color:red">*</span></label>
                                    <ob-input v-number-only v-model.trim="ImmigrationInfo.recordNumber" :maxLength="11" placeholder="Enter I-94 Number" :class="{ 'ob-vuelidate_input-error': $v.ImmigrationInfo.recordNumber.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.recordNumber.$dirty && !$v.ImmigrationInfo.recordNumber.requiredIf"> Please enter Record number </span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Date of Last Arrival (mm/dd/yyyy)<span style="color:red">*</span></label>
                                    <ob-date-time-picker id="immDate" ref="statesDateoflastArrival" placeholder="Select Date" :options="datePickerOptions" @updated="(v) => this.ImmigrationInfo.immLastArrivalDate = v" v-model.trim="ImmigrationInfo.immLastArrivalDate" :inputvalue="ImmigrationInfo.immLastArrivalDate" :class="{ 'ob-vuelidate_input-error': $v.ImmigrationInfo.immLastArrivalDate.$error }" :dpchange="onlastarrivalDateChange"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.immLastArrivalDate.$dirty && !$v.ImmigrationInfo.immLastArrivalDate.requiredIf"> Please select Date </span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Current Nonimmigrant Status<span style="color:red">*</span><img v-tooltip="{content:'Current Non-immigrant status represents present status of the individual who enters the U.S. temporarily.',placement:'right'}" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_icon.svg`"></label>
                                    <ob-select2 v-if="NonimmigrantStatusOpt.data.length > 0" :options="NonimmigrantStatusOpt" v-model="ImmigrationInfo.nonimmigrantStatus" :class="{ 'ob-vuelidate_input-error': $v.ImmigrationInfo.nonimmigrantStatus.$error }"></ob-select2>                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.nonimmigrantStatus.$dirty && !$v.ImmigrationInfo.nonimmigrantStatus.requiredIf"> Please Enter Current Status</span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Date Status Expires or D/S (Duration of Status)<span style="color:red">*</span></label>
                                    <ob-date-time-picker id="immDate1" ref="dateofStatusExpireDate" placeholder="Select Date" :options="datePickerOptions" @updated="(v) => this.ImmigrationInfo.StatusExpDate = v" v-model.trim="ImmigrationInfo.StatusExpDate" :inputvalue="ImmigrationInfo.StatusExpDate" :class="{ 'ob-vuelidate_input-error': $v.ImmigrationInfo.StatusExpDate.$error }"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.StatusExpDate.$dirty && !$v.ImmigrationInfo.StatusExpDate.requiredIf"> Please select Date</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style="padding-left:29px;padding-top:5px;">
                            <div class="col-md-6 pL0">
                                <div class="form-group">
                                    <label>Student and Exchange Visitor Information System (SEVIS) Number (if any)</label>
                                    <ob-input v-model.trim="ImmigrationInfo.SEVISNumber" placeholder="N" :maxLength="11" v-on:keyup.native="patternMatch"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="isShowSEVISNumberVal"> Please enter valid SEVIS number(Ex:N1234567814)</span>
                                </div>
                            </div>
                            <div class="col-md-6 pL0">
                                <div class="form-group">
                                    <label>Employment Authorization Document (EAD) Number (if any)</label>
                                    <ob-input v-model.trim="ImmigrationInfo.EADNumber" placeholder="Enter EAD Number" :maxLength="16" v-on:keyup.native="patternMatch(1)"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="isShowEADValidation">Please enter Exact Format of EAD Number with Hyphen (Example :EAC-17-123-45678.)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-12" style="padding-left:11px;"> -->
                        <div class="col-md-12" style="padding-left:29px;">
                            <p class="doc-header" >Have you spent significant period of time outside the US?
                                <span class="radio-inline" @click="isactiveYes(2)"><ob-radio id="st3" val='Yes' name="significant" v-model="ImmigrationInfo.outofStates" >Yes</ob-radio></span>
                                <span class="radio-inline" @click="isactiveNo(2)"><ob-radio id="st4" val='No' name="significant" v-model="ImmigrationInfo.outofStates">No</ob-radio></span>
                            </p>
                        </div>
                        <div class="col-md-12" v-if="isShowSignificant" style="padding-left:29px;">
                                <p>(Start from your first entry) while on H-1b or L1-status</p>
                            <div class="col-md-12" style="padding-left:0px;" v-for="(addAnotherStay , dIndex) in addAnotherStayArray" :key="dIndex">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Exit from US<span style="color:red">*</span></label>
                                        <ob-date-time-picker :id="`immExit-${dIndex}`"  placeholder="Select Date" ref="exitUSdateRef" :options="options3" @updated="(v)=> addAnotherStay.exitDate = v" v-model="addAnotherStay.exitDate" :inputvalue="addAnotherStay.exitDate" :class="{'ob-vuelidate_input-error':$v.addAnotherStayArray.$each[dIndex].exitDate.$error }"></ob-date-time-picker>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.addAnotherStayArray.$each[dIndex].exitDate.$dirty && !$v.addAnotherStayArray.$each[dIndex].exitDate.requiredIf">Please select Exit date </span>
                                        <!-- <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.exit.$dirty && !$v.ImmigrationInfo.exit.requiredIf"> Please select date</span> -->
                                    </div>
                                </div>
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Entry to US (mm/dd/yyyy)<span style="color:red">*</span></label>
                                        <ob-date-time-picker :id="`immEntry-${dIndex}`" placeholder="Select Date" ref="entryUSdateRef" :options="options3" :dpchange="onFromEntryDateChange(dIndex, ...arguments)" @updated="(v)=> addAnotherStay.entryDate = v" v-model.trim="addAnotherStay.entryDate" :inputvalue="addAnotherStay.entryDate" :class="{'ob-vuelidate_input-error':$v.addAnotherStayArray.$each[dIndex].entryDate.$error }"></ob-date-time-picker>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.addAnotherStayArray.$each[dIndex].entryDate.$dirty && !$v.addAnotherStayArray.$each[dIndex].entryDate.requiredIf">Please select Entry date </span>
                                    </div>
                                </div>
                                <div class="col-md-2 pL0" v-if="dIndex != 0" style="margin-top:24px;margin-left:-2px;">
                                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/red_minus_icon.svg`" @click="removeAddanotherStayperiod(addAnotherStayArray,dIndex)" width="20" style="cursor:pointer;" slot="reference" /><span class="remove-name" @click="removeAddanotherStayperiod(addAnotherStayArray,dIndex)">Remove</span>
                                    </div>
                                 </div>
                                <a style="color: #4A90E2;font-weight:650;font-style:italic;font-size: 13px" @click="anotherStayPeriodAdding"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_plus_icon.svg`" style="width:17px"> Add another period of stay
                                </a>
                        </div>
                        <div class="col-md-12" style="padding-left:29px;padding-top:20px;">
                            <h4 class="doc-header">Passport Details</h4>
                        </div>
                        <div class="col-md-12" style="padding-left:29px;">
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Passport or Travel Document Number<span style="color:red">*</span></label>
                                    <ob-input v-model.trim="ImmigrationInfo.docNumber" placeholder="Enter Passport Number" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.docNumber.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.docNumber.$dirty && !$v.ImmigrationInfo.docNumber.required"> Please enter Document number</span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Date Passport of Travel Document Issued<span style="color:red">*</span></label>
                                    <!-- <ob-date-time-picker id="immDate4" placeholder="Select Date" :options="options2" @updated="(v)=> this.ImmigrationInfo.PassportIssueDate = v" :inputvalue="ImmigrationInfo.PassportIssueDate" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.PassportIssueDate.$error }" v-model.trim="ImmigrationInfo.PassportIssueDate"></ob-date-time-picker> -->
                                    <ob-date-time-picker id="immDate4" ref="dateofDocumentIsuued" class="offer-input"  placeholder="Select Date" :inputvalue="ImmigrationInfo.PassportIssueDate" :options="datePickerOptions" @updated="(v) => this.ImmigrationInfo.PassportIssueDate = v" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.PassportIssueDate.$error }" v-model.trim="ImmigrationInfo.PassportIssueDate"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.PassportIssueDate.$dirty && !$v.ImmigrationInfo.PassportIssueDate.required"> Please select Issue date</span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Date Passport of Travel Document Expires<span style="color:red">*</span></label>
                                    <!-- <ob-date-time-picker id="immDate5" placeholder="Select Date" :options="options3" @updated="(v)=> this.ImmigrationInfo.PassportExpireDate = v" v-model.trim="ImmigrationInfo.PassportExpireDate" :inputvalue="ImmigrationInfo.PassportExpireDate" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.PassportExpireDate.$error }"></ob-date-time-picker> -->
                                    <ob-date-time-picker id="immDate5" ref="dateofDocumentExpires" class="offer-input" placeholder="Select Date" :inputvalue="ImmigrationInfo.PassportExpireDate" :options="datePickerOptions" @updated="(v) => this.ImmigrationInfo.PassportExpireDate = v" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.PassportExpireDate.$error }" :dpchange="onTravelDocumentExpiresDateChange"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.PassportExpireDate.$dirty && !$v.ImmigrationInfo.PassportExpireDate.required"> Please select Expiry date</span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Country of Issue<span style="color:red">*</span></label>
                                      <ob-select2 v-if="countryNameOpt.data.length > 0" :options="countryNameOpt" v-model="ImmigrationInfo.Country" :class="{ 'ob-vuelidate_input-error': $v.ImmigrationInfo.Country.$error }"  > </ob-select2>
                                      <div v-else class="emptyDiv"><i>Fetching the country's...</i></div>
                                      <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.ImmigrationInfo.Country.$dirty && !$v.ImmigrationInfo.Country.required">Please select Country</span>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-11 pL0">
                            <div class="form-group" style="padding-left: 32px">
                                <label>Upload Document<span style="color:red">*</span></label>
                                <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                <ob-upload-new :validation="ValidationType2" :end-point="EndPoint" :type="2" :IsFileExists="immigrationPassportDocURL | fileName" @remove-file="removeImmigrationPassport" @file-complete="uploadImmigrationPassport">
                                    <template slot="file-text" style="height: 28px;"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                    </template>
                                </ob-upload-new>
                                <span class="ob-vuelidate_error-msg" v-if="$v.immigrationPassportDocURL.$dirty && !$v.immigrationPassportDocURL.required">Please upload the document</span>
                            </div>
                        </div>
                        <div class="col-md-12" style="padding-left:29px;">
                            <h4 class="doc-header">Visa Details</h4>
                        </div>
                        <div class="col-md-12" style="padding-left:29px;padding-top:9px;">
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Date of last arrival<span style="color:red" v-if="ImmigrationInfo.visible == 'Yes' || IsVisaDetailsprovided">*</span></label>
                                    <ob-date-time-picker id="immDate6" ref="visaLastArrivalDate" placeholder="Select Date" :options="datePickerOptions" @updated="(v)=> this.ImmigrationInfo.lastArrivalDate = v" v-model.trim="ImmigrationInfo.lastArrivalDate" :inputvalue="ImmigrationInfo.lastArrivalDate" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.lastArrivalDate.$error }" :dpchange="onVisalastArrivalDateChange"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.lastArrivalDate.$dirty && !$v.ImmigrationInfo.lastArrivalDate.requiredIf"> Please select Date</span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Admit Until<span style="color:red" v-if="ImmigrationInfo.visible == 'Yes' || IsVisaDetailsprovided">*</span></label>
                                    <ob-date-time-picker id="immDate7" ref="dateofVisaAdmitting" placeholder="Select Date" :options="datePickerOptions" @updated="(v)=> this.ImmigrationInfo.admitUntil = v" v-model.trim="ImmigrationInfo.admitUntil" :inputvalue="ImmigrationInfo.admitUntil" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.admitUntil.$error }" :dpchange="onVisaAdmitUntilDateChange"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.admitUntil.$dirty && !$v.ImmigrationInfo.admitUntil.requiredIf"> Please select Date</span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label>Current Visa Status<span style="color:red" v-if="ImmigrationInfo.visible == 'Yes' || IsVisaDetailsprovided">*</span></label>
                                    <ob-select2 v-if="CurrentvisastatusOpt.data.length > 0" :options="CurrentvisastatusOpt" v-model="ImmigrationInfo.visaStatus" v-bind:class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.visaStatus.$error }"></ob-select2>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.visaStatus.$dirty && !$v.ImmigrationInfo.visaStatus.requiredIf"> Please select Status</span>
                                </div>
                            </div>
                            <div class="col-md-3 pL0" v-if='ImmigrationInfo.visaStatus=="Others"'>
                                <div class="form-group">
                                    <label>Other Visa Name <span style="color:red" v-if="ImmigrationInfo.visible == 'Yes' || IsVisaDetailsprovided">*</span></label>
                                    <ob-input v-model.trim="ImmigrationInfo.otherVisaName" placeholder="Other Visa Name" :class="{'ob-vuelidate_input-error':$v.ImmigrationInfo.otherVisaName.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.ImmigrationInfo.otherVisaName.$dirty && !$v.ImmigrationInfo.otherVisaName.requiredIf"> Please enter Other Visa Name</span>

                                    </div>
                            </div>

                        </div>
                        <div class="col-md-11 pL0">
                            <div class="form-group" style="padding-left: 32px">
                                <label>Upload Document<span style="color:red" v-if="ImmigrationInfo.visible == 'Yes' || IsVisaDetailsprovided">*</span></label>
                                <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                <ob-upload-new :validation="ValidationType2" :end-point="EndPoint" :type="2" :IsFileExists="immigrationVisaDocURL | fileName" @remove-file="removeImmigrationVisa" @file-complete="uploadImmigrationVisa">
                                    <template slot="file-text" style="height: 28px;"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                    </template>
                                </ob-upload-new>
                                <span class="ob-vuelidate_error-msg" v-if="$v.immigrationVisaDocURL.$dirty && !$v.immigrationVisaDocURL.requiredIf">Please upload the document</span>
                            </div>
                        </div>
                        <div class="col-md-12" style="padding-left:11px;">
                            <div class="col-md-12">
                                <p class="doc-header" style="padding-left:2px;">Do you have a current/previous H-1B/L-1 Approvals?
                                    <span class="radio-inline" @click="isactiveYes(3)"><ob-radio id="approve1" name="approval" v-model="ImmigrationInfo.h1bApproval" val='Yes'>Yes</ob-radio></span>
                                    <span class="radio-inline" @click="isactiveNo(3)"><ob-radio id="approve2" name="approval" v-model="ImmigrationInfo.h1bApproval" val='No'>No</ob-radio></span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="isShowH1Bapproval" style="padding-left:0px;">
                            <div class="col-md-12" style="padding-left:26px;">
                                <p>(Start with most recent)</p>
                            </div>
                            <div class="col-md-12" style="padding-left:26px;padding-top:9px;" v-for="(anotherApproval, dIndex) in addAnotherApprovalArray" :key="dIndex">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Start Date (mm/dd/yyyy)<span style="color:red">*</span></label>
                                        <ob-date-time-picker :id="`addimmdate-${dIndex}`" placeholder="Select Date" ref="startdateRef" :options="options3" @updated="(v) => anotherApproval.startDate = v" v-model.trim="anotherApproval.startDate" :inputvalue="anotherApproval.startDate" :class="{'ob-vuelidate_input-error':$v.addAnotherApprovalArray.$each[dIndex].startDate.$error }"></ob-date-time-picker>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.addAnotherApprovalArray.$each[dIndex].startDate.$dirty && !$v.addAnotherApprovalArray.$each[dIndex].startDate.requiredIf">Please select Start date </span>
                                    </div>
                                </div>
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>End date (mm/dd/yyyy)<span style="color:red">*</span></label>
                                        <ob-date-time-picker :id="`addimmdate1-${dIndex}`" placeholder="Select Date" ref="enddateRef" :dpchange="onEndDateChange(dIndex, ...arguments)" :options="options3" @updated="(v)=> anotherApproval.endDate = v" v-model.trim="anotherApproval.endDate" :inputvalue="anotherApproval.endDate" :class="{'ob-vuelidate_input-error':$v.addAnotherApprovalArray.$each[dIndex].endDate.$error }"></ob-date-time-picker>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.addAnotherApprovalArray.$each[dIndex].endDate.$dirty && !$v.addAnotherApprovalArray.$each[dIndex].endDate.requiredIf">Please select End date </span>
                                    </div>
                                </div>
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Company Name<span style="color:red">*</span></label>
                                        <ob-input v-model.trim="anotherApproval.compName" placeholder="Enter Company Name" :class="{'ob-vuelidate_input-error':$v.addAnotherApprovalArray.$each[dIndex].compName.$error }"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.addAnotherApprovalArray.$each[dIndex].compName.$dirty && !$v.addAnotherApprovalArray.$each[dIndex].compName.requiredIf">Please enter Company name </span>
                                    </div>
                                </div>
                                <div class="col-md-3 pL0">
                                    <a href="javascript:;" style="margin-top:0px;" v-if="dIndex != 0" class="remove-worklocation" @click="removeAddanotherApproval(addAnotherApprovalArray,dIndex)"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/red_minus_icon.svg`" style="width:17px"> Remove </a>
                                    <div class="form-group">
                                        <label>H-1b or L-1 approval number<span style="color:red">*</span></label>
                                        <ob-input v-model.trim="anotherApproval.h1orl1approval" placeholder="Enter H-1b or L-1 approval number" :class="{'ob-vuelidate_input-error':$v.addAnotherApprovalArray.$each[dIndex].h1orl1approval.$error }"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.addAnotherApprovalArray.$each[dIndex].h1orl1approval.$dirty && !$v.addAnotherApprovalArray.$each[dIndex].h1orl1approval.requiredIf">Please enter Approval number </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-left:26px;">
                            <a style="color: #4A90E2;font-weight:650;font-style:italic;font-size: 13px" @click="addAnotherApproval"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_plus_icon.svg`" style="width:17px"> Add another approval document
                                </a>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="doc-header" style="padding-left:12px;padding-top:9px;">Do you have approved I-140?
                                <span class="radio-inline" @click="isactiveYes(4)"><ob-radio id="i140" name="approve140" v-model="ImmigrationInfo.i140Approval" val='Yes'>Yes</ob-radio></span>
                                <span class="radio-inline" @click="isactiveNo(4)"><ob-radio id="i141"  name="approve140" v-model="ImmigrationInfo.i140Approval" val='No'>No</ob-radio></span>
                            </p>
                        </div>
                        <div class="col-md-12" v-if="isShowi140Approval" :key="`documentlist-${index}`" v-for="(l, index) in immigrationInfomation.Documents">
                          <ob-document-list-ess :documentList="l" :key='increVal' :FromCheckList="true" v-if="l.DocumentType != 'Passport' && l.DocumentType != 'Visa' " @onDocumentUpdate="updateImmigrationInfoDoc(index , ...arguments)"></ob-document-list-ess>
                        </div>
                        <div class="col-md-12" style="border-bottom:1px solid grey;padding-bottom:20px;"></div>
                        <div class="footer-buttons">
                            <div class="col-md-12" style="padding:25px 0px 25px 0px;">
                                <ob-button type="secondary" width="120px;" @click="backtoEmpinfo">Back</ob-button>
                                <ob-button type="secondary" style="margin-left:15px;" width="100px;" @click="backtoHome">Cancel</ob-button>
                                <!-- <ob-button type="primary" style="margin-left:15px;" width="120px;" @click="gotodepInfo">Save & Proceed</ob-button> -->
                            <template  v-if="showImmigrationButtons">
                               <ob-button type="primary" style="margin-left:15px;" v-if="disableImmigrationSaveBtn" :disabled="true" width="120px;" @click="gotodepInfo">Save & Proceed</ob-button>
                               <ob-button v-else type="primary" style="margin-left:15px;" width="120px;" @click="gotodepInfo">Save & Proceed</ob-button>
                            </template>
                            </div>
                        </div>
                        <ob-modal2 :show.sync="showUpdatePopup" :backdrop="false">
                            <template slot="modal-title">Upload Document</template>
                            <template slot="modal-body">
                                <p></p>

                                <div class="form-group">
                                    <label for="documentname1">Document Name</label>

                                </div>

                            </template>
                            <template slot="modal-footer">
                                <ob-button type="secondary" @click="cancelUpload">Cancel</ob-button>
                                <ob-button type="primary" @click="cancelUpload">Upload</ob-button>
                            </template>
                        </ob-modal2>

                </div>
                <!-- Ending of Immigration Info -->
                <!-- Starting of Dependent Info -->
                <div class="col-md-12" v-else-if="OpendependentInfoForm">

                    <div>
                        <h4 class="section-heading-dependent">H-4 Details (Spouse & Child) - Need Details of all Children to be included on the H-4</h4>
                        <div class="row">
                            <div class="col-md-4 pL0">
                                <div class="col-md-6" style="padding-top:5px">
                                    <p class="radio-label">Do you have any dependents?</p>
                                </div>
                                <div class="col-md-6">
                                    <div class="radio-inline">
                                        <ob-radio name="options1" val="1" v-model="checkDependents" @input="selectDependentRadioBtn">Yes</ob-radio>
                                    </div>
                                    <div class="radio-inline">
                                        <ob-radio name="options1" val="2" v-model="checkDependents" @input="selectDependentNoRadioBtn">No</ob-radio>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row" v-if="dependentsArray.length == 0 && checkDependents == '1'">
                            <div class="col-md-4 pL0" style="padding-top: 15px;">
                                <div class="col-md-6" style="padding-top:5px">
                                    <span>  Please select the type of dependent : </span>
                                </div>
                                <div class="col-md-5">
                                    <ob-select2 :options="options" v-model="typeOfDependent" @input="changeDependentType"></ob-select2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="checkDependents == '1'">
                        <div v-for="(dependentArr , dIndex) in dependentsArray" :key="dIndex">
                            <div class="row">
                                <div class="col-md-5 pL0" style="padding-top: 15px;">
                                    <div class="col-md-5" style="padding-top:5px">
                                        <span>  Please select the type of dependent : </span>
                                    </div>
                                    <div class="col-md-5">
                                        <ob-select2 :options="options" v-model="dependentArr.type" @input="changeDependentType(dIndex)"></ob-select2>
                                    </div>
                                </div>
                            </div>
                            <template>
                                <div class="col-md-12 pL0" style="padding-top:15px">
                                    <div class="col-md-12 p0">
                                        <div class="col-md-8 p0">
                                            <h4 class="section-heading-dependent"> Provide Details of {{dependentArr.type}} </h4>
                                        </div>
                                        <div class="col-md-4 p0">
                                            <a href="javascript:;" v-if="dIndex != 0" class="remove-location" @click="removeDependent(dependentsArray,dIndex)"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/red_minus_icon.svg`" style="width:17px"> Remove </a>
                                        </div>
                                    </div>
                                    <div class="col-md-12 p0">
                                        <div class="col-md-3 pL0">
                                            <label>Family Name (Last Name) <span style="color:red">*</span></label>
                                            <ob-input placeholder="Enter Family Name" v-formi9-name v-model="dependentArr.basicInfoObj.familyName" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.familyName.$error}" @input="updateValue('dLastName', dependentArr.basicInfoObj.familyName, dIndex)"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].basicInfoObj.familyName.$dirty && !$v.dependentsArray.$each[dIndex].basicInfoObj.familyName.requiredIf">Please enter Family Name </span>
                                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.dependentsArray.$each[dIndex].basicInfoObj.familyName.alphawithspace">Please enter only alphabets</span> -->
                                        </div>
                                        <div class="col-md-3">
                                            <label> Given Name (First Name) <span style="color:red">*</span></label>
                                            <ob-input placeholder="Enter Given Name" v-formi9-name v-model="dependentArr.basicInfoObj.givenName" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.givenName.$error}" @input="updateValue('dFirstName', dependentArr.basicInfoObj.givenName, dIndex)"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].basicInfoObj.givenName.$dirty && !$v.dependentsArray.$each[dIndex].basicInfoObj.givenName.requiredIf">Please enter Given Name </span>
                                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.dependentsArray.$each[dIndex].basicInfoObj.givenName.alphawithspace">Please enter only alphabets</span> -->
                                        </div>
                                        <div class="col-md-3" >
                                            <label>Middle Name</label>
                                            <ob-input placeholder="Enter Middle Name" v-formi9-name v-model="dependentArr.basicInfoObj.middleName" @input="updateValue('dMiddleName', dependentArr.basicInfoObj.middleName, dIndex)"></ob-input>
                                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.dependentsArray.$each[dIndex].basicInfoObj.middleName.alphawithspace">Please enter only alphabets</span> -->
                                        </div>
                                        <div class="col-md-3" v-if="dependentArr.type == 'Spouse'">
                                            <label>Maiden Name</label>
                                            <ob-input placeholder="Enter Maiden Name" v-formi9-name v-model="dependentArr.basicInfoObj.maidenName" @input="updateValue('dMaidenName', dependentArr.basicInfoObj.maidenName, dIndex)"></ob-input>
                                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.dependentsArray.$each[dIndex].basicInfoObj.maidenName.alphawithspace">Please enter only alphabets</span> -->
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding: 10px 0 0 0">
                                        <div class="col-md-3 pL0">
                                            <label>Date of Birth (mm/dd/yyyy)<span style="color:red">*</span></label>
                                            <ob-date-time-picker v-if="dependentArr.type == 'Spouse'" :id="`dob-${dIndex}`" :options="dobOptions" placeholder="Select Date" :inputvalue="dependentArr.basicInfoObj.birthDate" @updated="(v) => dependentArr.basicInfoObj.birthDate = v" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.birthDate.$error}"></ob-date-time-picker>
                                               <ob-date-time-picker v-else :id="`dobChild-${dIndex}`" :key="increVal1" :options="options2Child" placeholder="Select Date" :inputvalue="dependentArr.basicInfoObj.birthDate" @updated="(v) => dependentArr.basicInfoObj.birthDate = v" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.birthDate.$error}"></ob-date-time-picker>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].basicInfoObj.birthDate.$dirty && !$v.dependentsArray.$each[dIndex].basicInfoObj.birthDate.requiredIf">Please select Date of birth </span>
                                        </div>
                                        <div class="col-md-3">
                                            <label> Country of Citizenship <span style="color:red">*</span></label>
                                            <!-- <ob-input v-model="dependentArr.basicInfoObj.countryCitizenShip" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.countryCitizenShip.$error}"></ob-input> -->
                                             <!-- <ob-select2 v-if="countryNameOpt.data.length > 0" :options="countryNameOpt" v-model="dependentArr.basicInfoObj.countryCitizenShip"> </ob-select2> -->
                                             <ob-input placeholder="Enter Nationality" v-model.trim="dependentArr.basicInfoObj.countryCitizenShip" :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.countryCitizenShip.$error }"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].basicInfoObj.countryCitizenShip.$dirty && !$v.dependentsArray.$each[dIndex].basicInfoObj.countryCitizenShip.requiredIf">Please enter Country of Citizenship </span>
                                        </div>
                                        <div class="col-md-3">
                                            <label>Country of Birth <span style="color:red">*</span></label>
                                             <ob-select2 v-if="countryNameOpt.data.length > 0" :options="countryNameOpt" v-model="dependentArr.basicInfoObj.birthCountry" :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.birthCountry.$error }"> </ob-select2>
                  <div v-else class="emptyDiv"><i>Fetching the country's...</i></div>
                  <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].basicInfoObj.birthCountry.$dirty && !$v.dependentsArray.$each[dIndex].basicInfoObj.birthCountry.requiredIf">Please select Country</span>
                                            <!-- <ob-input v-model="dependentArr.basicInfoObj.birthCountry" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.birthCountry.$error}"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].basicInfoObj.birthCountry.$dirty && !$v.dependentsArray.$each[dIndex].basicInfoObj.birthCountry.requiredIf">Please enter Country of Birth </span> -->
                                        </div>
                                        <div class="col-md-3">
                                            <label>SSN Number</label>
                                            <ob-input v-number-only placeholder="Enter SSN number" maxLength="9" v-model.trim="dependentArr.basicInfoObj.ssnNumber" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].basicInfoObj.ssnNumber.$error}"></ob-input>
                                        <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.dependentsArray.$each[dIndex].basicInfoObj.ssnNumber.minLength"> Please enter vaild SSN number</span>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding: 10px 0 0 0" v-if="dependentArr.type == 'Spouse'">
                                        <div class="col-md-3 pL0">
                                            <label>Email Address</label>
                                            <ob-input placeholder="Enter Email Address" v-model="dependentArr.basicInfoObj.emailAddr"></ob-input>
                                            <span class="ob-vuelidate_error-msg"  v-if="!$v.dependentsArray.$each[dIndex].basicInfoObj.emailAddr.email"> Please enter vaild Email</span>
                                        </div>
                                        <div class="col-md-3">
                                            <label> Phone number</label>
                                            <ob-input placeholder="Enter Phone number" v-number-only maxLength="10" v-model.trim="dependentArr.basicInfoObj.phoneNum"></ob-input>
                                           <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.dependentsArray.$each[dIndex].basicInfoObj.phoneNum.minLength"> Please enter vaild Phone number</span>
                                        </div>

                                    </div>

                                </div>
                                <div class="col-md-12 pL0" style="padding-top:15px">
                                    <h4 class="section-heading-dependent"> Current Residential U.S Address (applicable if residing in the United States) <span style="font-weight:400">(do not list a P.O. Box)</span></h4>
                                    <div class="col-md-12 p0">
                                        <div class="col-md-6 pL0">
                                            <label>Street Number and Name </label>
                                            <ob-input placeholder="Enter Street Number and Name" maxLength="150" v-model="dependentArr.addressObj.streetName" ></ob-input>
                                            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].addressObj.streetName.$dirty && !$v.dependentsArray.$each[dIndex].addressObj.streetName.requiredIf">Please enter Street name </span> v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].addressObj.streetName.$error}"-->
                                        </div>

                                        <div class="col-md-3">
                                            <!-- <label>&nbsp;</label> -->
                                            <!-- Bug 162059 -->
                                            <label>Building Type</label><br/>
                                            <div class="radio-inline" style="margin-right: 15px;">
                                                <ob-radio :name="`options2-${dIndex}`" val="Apt" v-model="dependentArr.addressObj.aptRadio" style="margin-left: -15px;">Apt.</ob-radio>
                                            </div>
                                            <div class="radio-inline" style="margin-right: 15px;">
                                                <ob-radio :name="`options2-${dIndex}`" val="Ste" v-model="dependentArr.addressObj.aptRadio" style="margin-left: -15px;">Ste.</ob-radio>
                                            </div>
                                            <div class="radio-inline" style="margin-right: 15px;">
                                                <ob-radio :name="`options2-${dIndex}`" val="Flr" v-model="dependentArr.addressObj.aptRadio" style="margin-left: -15px;">Flr.</ob-radio>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <label>Building Number</label>
                                            <ob-input placeholder="Enter Number" maxLength="150" v-model="dependentArr.addressObj.Number"></ob-input>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding: 10px 0 0 0">
                                        <div class="col-md-3 pL0">
                                            <label>City,State </label>
                                            <location-search :vmodelData.sync="dependentArr.addressObj.cityState" @input="getZipCode(dependentArr.addressObj)" ></location-search>
                                            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].addressObj.cityState.$dirty && !$v.dependentsArray.$each[dIndex].addressObj.cityState.requiredIf">Please enter City,State </span> v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].addressObj.cityState.$error}"-->
                                        </div>
                                        <div class="col-md-3">
                                            <label> Zip Code </label>
                                            <ob-input placeholder="Enter Zip Code" v-model="dependentArr.addressObj.zipCode" ></ob-input>
                                            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].addressObj.zipCode.$dirty && !$v.dependentsArray.$each[dIndex].addressObj.zipCode.requiredIf">Please enter Zip Code </span> v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].addressObj.zipCode.$error}"-->
                                        </div>
                                        <div class="col-md-3">
                                            <label>Immigration Status </label>
                                            <ob-select2 :options="ImmigrationStatusOpt" v-model="dependentArr.addressObj.immigrationStatus" > </ob-select2>
                                            <!-- <ob-input v-model="dependentArr.addressObj.immigrationStatus" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].addressObj.immigrationStatus.$error}"></ob-input> :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].addressObj.immigrationStatus.$error }" -->
                                            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].addressObj.immigrationStatus.$dirty && !$v.dependentsArray.$each[dIndex].addressObj.immigrationStatus.requiredIf">Please select Immigration Status </span> -->
                                        </div>
                                        <div class="col-md-3">

                                        </div>
                                    </div>

                                </div>


                                <div class="col-md-12 pL0" style="padding-top:15px" v-if="dependentArr.type == 'Spouse'">
                                    <h4 class="section-heading-dependent">Foreign Address (applicable if <span style="font-weight:700">not</span> residing in the United States)   </h4>
                                    <div class="col-md-12 p0">
                                        <div class="col-md-6 pL0">
                                            <label>Street Number and Name</label>
                                            <ob-input placeholder="Enter Street Number and Name" maxLength="150" v-model="dependentArr.foreginAddressObj.streetName"></ob-input>
                                        </div>
                                        <div class="col-md-3">
                                            <!-- Bug 162059 -->
                                            <label>Building Type</label><br/>
                                        <span class="radio-inline" style="margin-right: 15px;"><ob-radio id="fradio1" name="fbtype1" val="Apt" v-model="dependentArr.foreginAddressObj.aptRadio" style="margin-left: -15px;"> Apt.</ob-radio></span>
                                        <span class="radio-inline" style="margin-right: 15px;"><ob-radio id="fradio2" name="fbtype1" val="Ste" v-model="dependentArr.foreginAddressObj.aptRadio" style="margin-left: -15px;">Ste.</ob-radio></span>
                                        <span class="radio-inline" style="margin-right: 15px;"><ob-radio id="fradio3" name="fbtype1" val="Flr" v-model="dependentArr.foreginAddressObj.aptRadio" style="margin-left: -15px;">Flr.</ob-radio></span>
                                        </div>

                                        <div class="col-md-3">
                                            <label>Building Number</label>
                                            <ob-input placeholder="Enter Number" maxLength="150" v-model="dependentArr.foreginAddressObj.AptNumber"></ob-input>
                                        </div>
                                    </div>
                        <div class="col-md-12" style="padding:10px 0px 0px 0px;">
                        <div class="col-md-3 pL0">
                            <label class="label-text">Country</label>
                         <ob-select2 v-if="countryNameOpt.data.length > 0" :options="countryNameOpt" v-model="dependentArr.foreginAddressObj.Country" @input="resetForeignAddrsValues(dependentArr.foreginAddressObj)"  > </ob-select2>
                        <div v-else class="emptyDiv"><i>Fetching the country's...</i></div>
                             <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].foreginAddressObj.Country.$dirty && !$v.dependentsArray.$each[dIndex].foreginAddressObj.Country.requiredIf">Please select Country</span>  :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].foreginAddressObj.Country.$error }"-->
                      </div>
                       <div class="col-md-3" v-if="dependentArr.foreginAddressObj.Country == 'United States'">
                            <label class="label-text">City,State</label>
                            <location-search :vmodelData.sync="dependentArr.foreginAddressObj.cityState" @input="getZipCodeForDependentForeignAddr(dependentArr.foreginAddressObj)" ></location-search>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].foreginAddressObj.cityState.$dirty && !$v.dependentsArray.$each[dIndex].foreginAddressObj.cityState.requiredIf"> Please select City,State</span> :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].foreginAddressObj.cityState.$error }"-->
                        </div>
                        <div class="col-md-3" v-if="dependentArr.foreginAddressObj.Country != 'United States'">
                            <label class="label-text">State</label>
                            <ob-input v-model="dependentArr.foreginAddressObj.State"></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].foreginAddressObj.State.$dirty && !$v.dependentsArray.$each[dIndex].foreginAddressObj.State.requiredIf"> Please enter State</span>  :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].foreginAddressObj.State.$error }"-->
                        </div>
                        <div class="col-md-3" v-if="dependentArr.foreginAddressObj.Country != 'United States'">
                            <label class="label-text">City</label>
                            <ob-input v-model="dependentArr.foreginAddressObj.city"></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].foreginAddressObj.city.$dirty && !$v.dependentsArray.$each[dIndex].foreginAddressObj.city.requiredIf"> Please enter City</span> :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].foreginAddressObj.city.$error }" -->
                        </div>
                    </div>
                    <div class="col-md-12" style="padding:10px 0px 0px 0px;">

                        <div class="col-md-3 pL0" v-if="dependentArr.foreginAddressObj.Country == 'United States'">
                            <label class="label-text">Zip Code</label>
                            <ob-input placeholder="Enter Zipcode" maxLength="5" v-model.trim="dependentArr.foreginAddressObj.Zip"></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].foreginAddressObj.Zip.$dirty && !$v.dependentsArray.$each[dIndex].foreginAddressObj.Zip.requiredIf"> Please enter Zipcode</span> :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].foreginAddressObj.Zip.$error }" -->
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressZip.$dirty && (!$v.dependentsArray.$each[dIndex].foreginAddressObj.Zip.numeric ||!$v.dependentsArray.$each[dIndex].foreginAddressObj.Zip.minLength)"> Please enter valid zipcode</span> -->
                        </div>
                        <!-- <div class="col-md-3" v-if="dependentArr.foreginAddressObj.Country != 'India'">
                            <label class="label-text">Province</label>
                            <ob-input placeholder="Enter Province" v-model.trim="dependentArr.foreginAddressObj.Province" ></ob-input>
                        </div>
                        <div class="col-md-3 pL0" v-else>
                            <label class="label-text">Province</label>
                            <ob-input placeholder="Enter Province" v-model.trim="dependentArr.foreginAddressObj.Province" ></ob-input>
                        </div> -->
                        <div class="col-md-3 pL0" v-if="dependentArr.foreginAddressObj.Country != 'United States'">
                            <label class="label-text">Postal Code</label>
                            <ob-input v-number-only :maxLength="6" placeholder="Enter Postal Code" v-model.trim="dependentArr.foreginAddressObj.CountryCode" ></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].foreginAddressObj.Zip.$dirty && !$v.dependentsArray.$each[dIndex].foreginAddressObj.CountryCode.requiredIf"> Please enter Postal Code</span> :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].foreginAddressObj.CountryCode.$error }" -->
                        </div>
                         <div class="col-md-3">
                            <label class="label-text">Province</label>
                            <ob-input placeholder="Enter Province" v-model.trim="dependentArr.foreginAddressObj.Province" ></ob-input>
                        </div>
                    </div>
                </div>

                   <div class="row">
                       <div class="col-md-12 pL0" style="padding-top: 30px">
                            <div class="col-md-6 pL0">
                                <div class="col-md-5" style="padding-top:5px">
                                    <p class="radio-label">Do you have a valid passport?</p>
                                </div>
                                <div class="col-md-6">
                                    <div class="radio-inline">
                                        <ob-radio :name="`options2512-${dIndex}`" :val="true" v-model="dependentArr.passPortDetails.showPassportDetails" @input="isSpousePassportDetails(dIndex, ...arguments)">Yes</ob-radio>
                                    </div>
                                    <div class="radio-inline">
                                        <ob-radio :name="`options2512-${dIndex}`" :val="false" v-model="dependentArr.passPortDetails.showPassportDetails">No</ob-radio>
                                    </div>
                                </div>

                            </div>
                            </div>
                        </div>



                                <div class="col-md-12 pL0" style="padding-top:15px" v-if="dependentArr.passPortDetails.showPassportDetails">
                                    <h4 class="section-heading-dependent">Passport Details of {{dependentArr.type}}</h4>
                                    <div class="col-md-12 p0">
                                        <div class="col-md-3 pL0">
                                            <label>Passport or Travel Document Number <span style="color:red">*</span></label>
                                            <ob-input placeholder="Enter Passport Number" v-model="dependentArr.passPortDetails.Number" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].passPortDetails.Number.$error}" ></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].passPortDetails.Number.$dirty && !$v.dependentsArray.$each[dIndex].passPortDetails.Number.requiredIf">Please enter Passport Number</span>
                                        </div>
                                        <div class="col-md-3">
                                            <label> Date passport of travel document issued <span style="color:red">*</span></label>
                                            <ob-date-time-picker :id="`passportIssueDate-${dIndex}`" :options="options1date" ref="dpdntpassportissued" placeholder="Select Date" :inputvalue="dependentArr.passPortDetails.issueDate" @updated="(v) => dependentArr.passPortDetails.issueDate = v" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].passPortDetails.issueDate.$error}"></ob-date-time-picker>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].passPortDetails.issueDate.$dirty && !$v.dependentsArray.$each[dIndex].passPortDetails.issueDate.requiredIf">Please enter Issue date</span>

                                        </div>
                                        <div class="col-md-3">
                                            <label>Date passport of travel document expires <span style="color:red">*</span></label>
                                            <ob-date-time-picker :id="`passportExpiryDate-${dIndex}`" :options="options1date" ref="dpdntpassportexpired" placeholder="Select Date" :inputvalue="dependentArr.passPortDetails.expirydate" @updated="(v) => dependentArr.passPortDetails.expirydate = v" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].passPortDetails.expirydate.$error}" :dpchange="onDependentPassportDateExpires(dIndex,...arguments)"></ob-date-time-picker>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].passPortDetails.expirydate.$dirty && !$v.dependentsArray.$each[dIndex].passPortDetails.expirydate.requiredIf">Please enter Expiry date </span>
                                        </div>
                                        <div class="col-md-3">
                                            <label>Country of issue <span style="color:red">*</span></label>
                                           <ob-select2 v-if="countryNameOpt.data.length > 0" :options="countryNameOpt" v-model="dependentArr.passPortDetails.issuedBy" :class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].passPortDetails.issuedBy.$error }"  > </ob-select2>
                  <div v-else class="emptyDiv"><i>Fetching the country's...</i></div>
                  <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.dependentsArray.$each[dIndex].passPortDetails.issuedBy.$dirty && !$v.dependentsArray.$each[dIndex].passPortDetails.issuedBy.requiredIf">Please select Country</span> -->
                                            <!-- <ob-input placeholder="Enter Maiden Name" v-model="dependentArr.passPortDetails.issuedBy" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].passPortDetails.issuedBy.$error}"></ob-input>-->
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].passPortDetails.issuedBy.$dirty && !$v.dependentsArray.$each[dIndex].passPortDetails.issuedBy.requiredIf">Please select Issued by </span>
                                        </div>
                                        <div class="col-md-12 pL0" style="    padding-top: 15px">
                                            <label>Upload Document <span style="color:red">*</span></label>
                                            <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                            <ob-upload-new :validation="ValidationType2" :end-point="EndPoint" :type="2" :IsFileExists="dependentArr.passPortDetails.documentUrl | fileName" @file-complete="updatePassportDocsForDepen(dIndex, ...arguments)" :isUploading.sync="isUploading" :key="dependentArr.passPortDetails.passportDocIncrement">
                                                <template slot="file-text"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                                </template>
                                            </ob-upload-new>
                                            <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="$v.dependentsArray.$each[dIndex].passPortDetails.documentUrl.$dirty && !$v.dependentsArray.$each[dIndex].passPortDetails.documentUrl.requiredIf"> please upload the document </span>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding: 10px 0 0 0">
                                        <!-- <div class="col-md-3">
                            <label>Expiry Date as on I-94 card <span style="color:red">*</span></label>
                            <ob-input></ob-input>
                        </div> -->

                                    </div>

                                </div>
                                <!-- <div class="col-md-12 pL0" style="padding-top:15px">
                                    <h4 class="section-heading-dependent">Visa Details of {{dependentArr.type}}</h4>
                                    <div class="col-md-12 p0">
                                        <div class="col-md-3 pL0">
                                            <label>Date of last arrival <span style="color:red">*</span></label>
                                            <ob-date-time-picker :id="`lastArrivalDate-${dIndex}`" :options="options1date" placeholder="Select Date" :inputvalue="dependentArr.visaDetailsObj.lastEntrydate" @updated="(v) => dependentArr.visaDetailsObj.lastEntrydate = v" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].visaDetailsObj.lastEntrydate.$error}"></ob-date-time-picker>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].visaDetailsObj.lastEntrydate.$dirty && !$v.dependentsArray.$each[dIndex].visaDetailsObj.lastEntrydate.requiredIf">Please enter Date of last arrival </span>
                                        </div>
                                        <div class="col-md-3">
                                            <label> Admit until <span style="color:red">*</span></label>
                                            <ob-date-time-picker :id="`admitUntil-${dIndex}`" :options="options1date" placeholder="Select Date" :inputvalue="dependentArr.visaDetailsObj.admitUntil" @updated="(v) => dependentArr.visaDetailsObj.admitUntil = v" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].visaDetailsObj.admitUntil.$error}"></ob-date-time-picker>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].visaDetailsObj.admitUntil.$dirty && !$v.dependentsArray.$each[dIndex].visaDetailsObj.admitUntil.requiredIf">Please enter Date of admit until </span>
                                        </div>
                                        <div class="col-md-3">
                                            <label>Current visa status</label>
                                            <ob-input placeholder="Enter current visa status" v-model="dependentArr.visaDetailsObj.currenStatus" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].visaDetailsObj.currenStatus.$error}"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].visaDetailsObj.currenStatus.$dirty && !$v.dependentsArray.$each[dIndex].visaDetailsObj.currenStatus.requiredIf">Please enter Current visa status </span>
                                        </div>
                                        <div class="col-md-3">

                                        </div>
                                        <div class="col-md-12 pL0" style="    padding-top: 15px">
                                            <label>Upload Document</label>
                                            <ob-upload-new :validation="ValidationType2" @file-complete="updateVisaDocsForDepen(dIndex, ...arguments)" :end-point="EndPoint" :type="2" :IsFileExists="dependentArr.visaDetailsObj.documentUrl | fileName" :isUploading.sync="isUploading">
                                                <template slot="file-text"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                                </template>
                                            </ob-upload-new>
                                             <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="$v.dependentsArray.$each[dIndex].visaDetailsObj.documentUrl.$dirty && !$v.dependentsArray.$each[dIndex].visaDetailsObj.documentUrl.requiredIf"> please upload the document </span>
                                        </div>
                                    </div>
                                </div>-->
                                  <div class="row">
                       <div class="col-md-12 pL0" style="padding-top: 30px">
                            <div class="col-md-6 pL0">
                                <div class="col-md-5" style="padding-top:5px">
                                    <p class="radio-label">Do you have a valid I-94?</p>
                                </div>
                                <div class="col-md-6">
                                    <div class="radio-inline">
                                        <ob-radio :name="`options251I-94-${dIndex}`" :val="true" v-model="dependentArr.I94DetailsObj.showI94Details" @input="isSpouseI94Details(dIndex, ...arguments)">Yes</ob-radio>
                                    </div>
                                    <div class="radio-inline">
                                        <ob-radio :name="`options251I-94-${dIndex}`" :val="false" v-model="dependentArr.I94DetailsObj.showI94Details">No</ob-radio>
                                    </div>
                                </div>

                            </div>
                            </div>
                        </div>
                                <div class="col-md-12 pL0" style="padding-top:15px" v-if="dependentArr.I94DetailsObj.showI94Details">
                                    <h4 class="section-heading-dependent">I-94 card details</h4>
                                    <div class="col-md-12 p0">
                                        <div class="col-md-3 pL0">
                                            <label>I-94 Number <span style="color:red">*</span></label>
                                            <ob-input placeholder="Enter I-94 Number" v-alpha-numeric :maxLength="11" v-model="dependentArr.I94DetailsObj.i94ReceiptNumber" @input="$v.dependentsArray.$each[dIndex].I94DetailsObj.i94ReceiptNumber.$touch()" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].I94DetailsObj.i94ReceiptNumber.$error}"></ob-input>
                                             <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].I94DetailsObj.i94ReceiptNumber.$dirty && !$v.dependentsArray.$each[dIndex].I94DetailsObj.i94ReceiptNumber.minLength"> Please enter 11 characters </span>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].I94DetailsObj.i94ReceiptNumber.$dirty && !$v.dependentsArray.$each[dIndex].I94DetailsObj.i94ReceiptNumber.requiredIf">Please enter I-94 Number</span>
                                        </div>
                                        <div class="col-md-3">
                                            <label>I-94 Start Date <span style="color:red">*</span></label>
                                            <ob-date-time-picker :id="`I94EssStartDate-${dIndex}`" :options="options1date" ref="i94startdateref" placeholder="Select Date" :inputvalue="dependentArr.I94DetailsObj.i94StartDate" @updated="(v) => dependentArr.I94DetailsObj.i94StartDate = v"  v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].I94DetailsObj.i94StartDate.$error}" ></ob-date-time-picker>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].I94DetailsObj.i94StartDate.$dirty && !$v.dependentsArray.$each[dIndex].I94DetailsObj.i94StartDate.requiredIf">Please enter I-94 Start Date </span>
                                        </div>
                                        <div class="col-md-3">
                                            <label>I-94 End Date <span style="color:red">*</span></label>
                                            <ob-date-time-picker :id="`I94EssEndDate-${dIndex}`" :options="options1date" ref="i94enddateref" placeholder="Select Date" :inputvalue="dependentArr.I94DetailsObj.i94EndDate" @updated="(v) => dependentArr.I94DetailsObj.i94EndDate = v" v-bind:class="{ 'ob-vuelidate_input-error': $v.dependentsArray.$each[dIndex].I94DetailsObj.i94EndDate.$error}" :dpchange="oni94EndDateChange(dIndex,...arguments)"></ob-date-time-picker>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.dependentsArray.$each[dIndex].I94DetailsObj.i94EndDate.$dirty && !$v.dependentsArray.$each[dIndex].I94DetailsObj.i94EndDate.requiredIf">Please enter I-94 End Date </span>
                                        </div>
                                        <div class="col-md-3">

                                        </div>
                                        <div class="col-md-12 pL0" style="padding-top: 15px">
                                            <label>Upload Document <span style="color:red">*</span></label>
                                            <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                                            <ob-upload-new :validation="ValidationType2" @file-complete="updateI94DocsForDepen(dIndex, ...arguments)" :end-point="EndPoint" :type="2" :IsFileExists="dependentArr.I94DetailsObj.documentUrl | fileName" :isUploading.sync="isUploading" :key="dependentArr.I94DetailsObj.i94DocIncrement">
                                                <template slot="file-text"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose The File
                                                </template>
                                            </ob-upload-new>
                                             <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="$v.dependentsArray.$each[dIndex].I94DetailsObj.documentUrl.$dirty && !$v.dependentsArray.$each[dIndex].I94DetailsObj.documentUrl.requiredIf"> please upload the document </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 pL0" style="padding-top:15px">
                                    <div class="row">
                                        <div class="col-md-5 pL0" style="padding-top:20px">
                                            <div class="col-md-8" style="padding-top:5px">
                                                <p class="radio-label">Do you have extension/change of status of H-4 dependent?</p>
                                            </div>
                                            <div class="col-md-4 pL0">
                                                <div class="radio-inline pL0">
                                                    <ob-radio :name="`options55-${dIndex}`" val="1" v-model="dependentArr.selectH4" @input="selectH4Dpdnt">Yes</ob-radio>
                                                </div>
                                                <div class="radio-inline">
                                                    <ob-radio :name="`options55-${dIndex}`" val="2" v-model="dependentArr.selectH4" @input="selectH4Dpdnt">No</ob-radio>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row" v-if="dependentArr.selectH4 == '1'">
                                        <div class="col-md-12" style="padding-top: 10px" v-if="dependentArr.type =='Spouse'" >
                                            <div v-for="(docList,ddsIndex) in dependentArr.Documents" :key="ddsIndex" >
                                             <ob-document-list-ess :documentList="docList" v-if="docList.DocumentType != 'BirthCertificate' && docList.DocumentType != 'Passport' && docList.DocumentType != 'Visa' && docList.DocumentType != 'I94' "  :FromCheckList="true" :key="increVal" @onDocumentUpdate="updateDependentDocsObj(dIndex , ...arguments)"></ob-document-list-ess>
                                            </div>
                                            <!-- <div class="col-md-4 pL0">
                                                <div class="btn-upload">
                                                    <span class="document-list__headingStyle">Marriage Certificate&nbsp;<span class="document-list__statusStyle">?</span></span>
                                                </div>
                                                <div class="btn-upload">
                                                    <div class="document-list__headingStyle">Form I-539&nbsp;<span class="document-list__statusStyle">?</span></div>
                                                </div>

                                            </div>
                                            <div class="col-md-6" style="text-align:right;margin-left:150px;">
                                                <div class="btn-upload">
                                                    <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
                                                </div>
                                                <div class="btn-upload">
                                                    <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
                                                </div>

                                            </div> -->
                                        </div>
                                        <div class="col-md-12" style="padding-top: 10px" v-else>
                                             <div v-for="(docList,ddIndex) in dependentArr.Documents" :key="ddIndex" >
                                             <ob-document-list-ess :documentList="docList" v-if="docList.DocumentType == 'BirthCertificate'"  :FromCheckList="true" :key="increVal" @onDocumentUpdate="updateDependentDocsObj(dIndex , ...arguments)"></ob-document-list-ess>
                                            </div>
                                            <!-- <div class="col-md-4 pL0">
                                                <div class="btn-upload">
                                                    <span class="document-list__headingStyle">Birth Certificate&nbsp;<span class="document-list__statusStyle">?</span></span>
                                                </div>

                                            </div>
                                            <div class="col-md-6" style="text-align:right;margin-left:150px;">
                                                <div class="btn-upload">
                                                    <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
                                                </div>

                                            </div> -->
                                        </div>

                                    </div>
                                </div>

                          </template>
                            <div class="col-md-12" style="padding-top:15px">
                                <a v-if="dependentsArray.length == dIndex+1" style="color: #4A90E2;font-weight:650;font-style:italic;font-size: 13px" @click="AddAnotherDependent"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_plus_icon.svg`" style="width:17px"> Add another dependent
                                </a>
                            </div>

                        </div>
                    </template>
                    <div class="col-md-12 BorderStyle" :class="{'ContenttoBottomStyle': this.checkDependents == '2'}"></div>
                    <div class="footer-buttons">
                        <div class="col-md-12" style="padding:25px 0px 25px 0px;">
                            <ob-button type="secondary" width="120px;" @click="backforImmigrationInfo">Back</ob-button>
                            <ob-button type="secondary" style="margin-left:15px;" width="100px;" @click="backtoHome">Cancel</ob-button>
                            <template  v-if="showDpdntButtons">
                               <ob-button type="primary" style="margin-left:15px;" v-if="dependentSaveDisable" :disabled="true" width="120px;" @click="gotopreInfo">Save & Proceed</ob-button>
                               <ob-button v-else type="primary" style="margin-left:15px;" width="120px;" @click="gotopreInfo">Save & Proceed</ob-button>
                            </template>
                            <!-- <ob-button type="primary" style="margin-left:15px;" @click="gotopreInfo">Save & Proceed</ob-button> -->
                        </div>
                    </div>

                </div>
                <!-- Ending of Dependent Info -->
                <!-- Starting of Preview -->
                <div class="col-md-12" v-else-if="OpenpreviewForm">
                    <!-- <h4>Preview & Submit</h4> -->
                    <!-- <ob-button type="primary" @click="gotoprevInfo">Save & Proceed</ob-button> -->
                    <!-- <div class="col-md-12 fontStyle">
                H-1B PETITION CHECKLIST
            </div>
            <div class="col-md-12 infoStyle">
                            <span class="fontSizeInfoIconStyle"><img src="/static/Images/ic_info.svg"></span>
                            <span>Here is a preview of the information you have provided. If required, click on <span class="fontSubHeadBoldStyle">Back</span> to make any changes</span>
            </div>
            <div class="col-md-12 padIconStyle">
                <div class="col-md-2 alignStyle">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12">
                            <span class="padLeftStyle"><img src="/static/Images/green_one_icon.svg" ></span>
                            <span class="padArrowLeftStyle"><img src="/static/Images/green_arrow_icon.svg" ></span>
                        </div>
                    </div>
                    <div class="col-md-12 IconTitleColor" style="padding-left:5px;">
                        Personal Info
                    </div>

                </div>
                <div class="col-md-2 alignStyle">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12">
                            <span class="padLeftStyle"><img src="/static/Images/green_two_icon.svg" ></span>
                            <span class="padArrowLeftStyle"><img src="/static/Images/green_arrow_icon.svg" ></span>
                        </div>
                    </div>
                    <div class="col-md-12 IconTitleColor" style="padding-left:0px;">
                        Educational Info
                    </div>

                </div>
                <div class="col-md-2 alignStyle">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12">
                            <span class="padLeftStyle"><img src="/static/Images/green_three_icon.svg" ></span>
                            <span class="padArrowLeftStyle"><img src="/static/Images/green_arrow_icon.svg" ></span>
                        </div>
                    </div>
                    <div class="col-md-12 IconTitleColor" style="padding-left:0px;">
                        Employment Info
                    </div>

                </div>
                <div class="col-md-2 alignStyle">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12">
                            <span class="padLeftStyle"><img src="/static/Images/green_four_icon.svg" ></span>
                            <span class="padArrowLeftStyle"><img src="/static/Images/green_arrow_icon.svg" ></span>
                        </div>
                    </div>
                    <div class="col-md-12 IconTitleColor" style="padding-left:0px;">
                        Immigration Info
                    </div>

                </div>
                <div class="col-md-2 alignStyle">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12">
                            <span class="padLeftStyle"><img src="/static/Images/green_five_icon.svg" ></span>
                            <span class="padArrowLeftStyle"><img src="/static/Images/green_arrow_icon.svg" ></span>
                        </div>
                    </div>
                    <div class="col-md-12 IconTitleColor" style="padding-left:3px;">
                        Dependent Info
                    </div>

                </div>
                <div class="col-md-2 alignStyle">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12">
                            <span class="padLeftStyle"><img src="/static/Images/blue_six_icon.svg" ></span>
                        </div>
                    </div>
                    <div class="col-md-12  IconTitleblueColor">
                        Preview & Submit
                    </div>

                </div>

            </div> -->
                    <div class="col-md-12 infoStyle">
                        <span class="fontSizeInfoIconStyle"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_icon.svg`"></span>
                        <span>Make sure all the information you have provided is appropriate. If required, click on <span class="fontSubHeBoldStyle">Back</span> to make any changes.</span>
                    </div>
                    <div id="EssPreviewSubmitPrint">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12 pL0 fontHeadStyle">
                            Personal Information
                        </div>
                        <div class="col-md-6 pL0" sty="padding-top:7px;">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Beneficiary Information

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Family Name (Last Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.PrimaryContact.LastName != null && personalInfomation.PrimaryContact.LastName != ''">
                                    {{personalInfomation.PrimaryContact.LastName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Given Name (First Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.PrimaryContact.FirstName != null && personalInfomation.PrimaryContact.FirstName != ''">
                                    {{personalInfomation.PrimaryContact.FirstName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Middle Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.PrimaryContact.MiddleName != null && personalInfomation.PrimaryContact.MiddleName != ''">
                                    {{personalInfomation.PrimaryContact.MiddleName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="col-md-12 padStyle">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Other Information

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Date of Birth (mm/dd/yyyy):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.PrimaryContact.DOB != null && personalInfomation.PrimaryContact.DOB != '' && personalInfomation.PrimaryContact.DOB != '0001-01-01T00:00:00'">
                                    {{personalInfomationPrimaryContactDOB}}
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Gender:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.Gender != null && personalInfomation.Gender != ''">
                                    {{personalInfomation.Gender}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Marital Status:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.MaritalStatus != null && personalInfomation.MaritalStatus != ''">
                                    {{personalInfomation.MaritalStatus}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country of Birth:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.BirthCountry != null && personalInfomation.BirthCountry != ''">
                                    {{personalInfomation.BirthCountry}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>


                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Province of Birth:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ProvienceOfBirth != null && personalInfomation.ProvienceOfBirth != ''">
                                    {{personalInfomation.ProvienceOfBirth}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country of Citizenship or Nationality:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.Nationality != null && personalInfomation.Nationality != ''">
                                    {{personalInfomation.Nationality}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    U.S. Social Security Number (if any):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.PrimaryContact.SocialSecurtiyNumber != null && personalInfomation.PrimaryContact.SocialSecurtiyNumber != ''">
                                    {{personalInfomation.PrimaryContact.SocialSecurtiyNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Alien Registration Number (A-Number):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.AlienNumber != null && personalInfomation.AlienNumber != ''">
                                    {{personalInfomation.AlienNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Contact Information

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Telephone number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.PrimaryContact.MobileNo != null && personalInfomation.PrimaryContact.MobileNo != ''">
                                    {{personalInfomation.PrimaryContact.MobileNo}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>


                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Email Address:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.PrimaryContact.Email != null && personalInfomation.PrimaryContact.Email != ''">
                                    {{personalInfomation.PrimaryContact.Email}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 padStyle">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Foreign Address (applicable if <span style="font-weight:700">not</span> residing in the United States)

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.Address1 != null && personalInfomation.ForeignAddress.Address1 != ''">
                                    {{personalInfomation.ForeignAddress.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Building Type:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.IsApt == true">
                                    Apartment
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="personalInfomation.ForeignAddress.IsSuite == true">
                                    Suite
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="personalInfomation.ForeignAddress.IsFloor == true">
                                    Floor
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                   Building Number:

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.AptNumber != null && personalInfomation.ForeignAddress.AptNumber != ''">
                                    {{personalInfomation.ForeignAddress.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country:

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.County != null && this.personalInfomation.ForeignAddress.County != ''">
                                    {{personalInfomation.ForeignAddress.County}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City, State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.AddressSummary != null && personalInfomation.ForeignAddress.AddressSummary != '' && personalInfomation.ForeignAddress.AddressSummary != ', '">
                                    {{personalInfomation.ForeignAddress.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div v-if="personalInfomation.ForeignAddress.County != 'United States'">
                                    <div class="col-md-6 pL0">
                                        Postal Code:
                                    </div>
                                    <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.CountryCode != null && personalInfomation.ForeignAddress.CountryCode != ''">
                                        <span>{{personalInfomation.ForeignAddress.CountryCode}}</span>
                                    </div>
                                    <div v-else class="col-md-6 pL0 fontSubHeadBoldStyle"> N/A </div>
                                </div>

                                <div v-else-if="personalInfomation.ForeignAddress.County == 'United States'">
                                    <div class="col-md-6 pL0">
                                        Zip Code:
                                    </div>
                                    <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.Zip != null && personalInfomation.ForeignAddress.Zip != ''">
                                        <span>{{personalInfomation.ForeignAddress.Zip}}</span>
                                    </div>
                                    <div v-else class="col-md-6 pL0 fontSubHeadBoldStyle"> N/A</div>
                                </div>
                                <!-- <div class="col-md-6 pL0" v-if="personalInfomation.ForeignAddress.County != 'United States'">
                                    Postal Code:
                                </div>
                                <div class="col-md-6 pL0" v-else>
                                    Zip Code:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="(personalInfomation.ForeignAddress.Zip != null && personalInfomation.ForeignAddress.Zip != '') || (personalInfomation.ForeignAddress.CountryCode != null && personalInfomation.ForeignAddress.CountryCode != '')">
                                    <span v-if="personalInfomation.ForeignAddress.County != 'United States'">{{personalInfomation.ForeignAddress.CountryCode}}</span><span v-else>{{personalInfomation.ForeignAddress.Zip}}</span>

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div> -->

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Province:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.ForeignAddress.Province != null && personalInfomation.ForeignAddress.Province != ''">
                                    {{personalInfomation.ForeignAddress.Province}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                           Current Residential U.S Address (applicable if residing in the United States) <span style="font-weight:400">(do not list a P.O. Box)</span>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.CurrentAddress.Address1 != null && personalInfomation.CurrentAddress.Address1 != ''">
                                    {{personalInfomation.CurrentAddress.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Building Type:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.CurrentAddress.IsApt == true">
                                    Apartment
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="personalInfomation.CurrentAddress.IsSuite == true">
                                    Suite
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="personalInfomation.CurrentAddress.IsFloor == true">
                                    Floor
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                  Building Number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.CurrentAddress.AptNumber != null && personalInfomation.CurrentAddress.AptNumber != ''">
                                    {{personalInfomation.CurrentAddress.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City,State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.CurrentAddress.AddressSummary != null && personalInfomation.CurrentAddress.AddressSummary != ''">
                                    {{personalInfomation.CurrentAddress.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    ZipCode:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="personalInfomation.CurrentAddress.Zip != null && personalInfomation.CurrentAddress.Zip != ''">
                                    {{personalInfomation.CurrentAddress.Zip}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" v-if="personalInfomation.IsLegalContactAvailable" style="padding-bottom: 25px">
                        <div class="col-md-12 pL0 fontHeadStyle">
                                Other Beneficiary Names

                            </div>
                        <div class="col-md-12 pL0" v-for="(extraName, dIndex) in personalInfomation.LegalContacts" :key="dIndex" :class="{'variant-border':personalInfomation.LegalContacts.length > 0 && dIndex != 0}">

                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Family Name (Last Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="extraName.LastName != null && extraName.LastName != ''">
                                    {{extraName.LastName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                 N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Given Name (First Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="extraName.FirstName != null && extraName.FirstName != ''">
                                    {{extraName.FirstName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Middle Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="extraName.MiddleName != null && extraName.MiddleName != ''">
                                    {{extraName.MiddleName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                        </div>
                        </div>
                    <div class="col-md-12" v-if="IsPersonalRequestedDocsExists">
                        <div class="col-md-12 pL0 fontHeadStyle">Beneficiary Documents</div>
                        <div class="col-md-12 pL0" :key='increVal'>
                            <ob-document-list-ess :documentList="l" :FromCheckList="true" :FromPreviewSubmit ="true" :key="`documentlist-${index}`" v-for="(l, index) in personalInfomation.Documents" @onDocumentUpdate="updateDocsObj(index , ...arguments)"></ob-document-list-ess>
                        </div>
                    </div>
                    <div class="col-md-12 p0 conditionalBorder" v-if="educationInfomation.IsEducationDetails || educationInfomation.IsMasterDegree || isShowEducationalandTrainingDocs"></div>
                    <div class="col-md-12 padStyle">
                         <div class="col-md-12 pL0 fontHeadStyle" v-if="educationInfomation.IsEducationDetails || educationInfomation.IsMasterDegree || isShowEducationalandTrainingDocs">
                                Educational Information
                            </div>
                        <div class="col-md-6 pL0" v-if="educationInfomation.IsEducationDetails">
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Name of the Institution of Higher Education:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.EducationDetails.InstituteName != null && educationInfomation.EducationDetails.InstituteName != ''">
                                    {{educationInfomation.EducationDetails.InstituteName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Date Degree awarded:

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.EducationDetails.DegreeCompletedDate != null && educationInfomation.EducationDetails.DegreeCompletedDate != '' && educationInfomation.EducationDetails.DegreeCompletedDate != '0001-01-01T00:00:00'">
                                    {{educationinfo.Datedegree}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Type of Degree:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.EducationDetails.DegreeType != null && educationInfomation.EducationDetails.DegreeType != ''">
                                    {{educationInfomation.EducationDetails.DegreeType}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                             <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Major field of study:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.EducationDetails.StudyCategory != null && educationInfomation.EducationDetails.StudyCategory != ''">
                                    {{educationInfomation.EducationDetails.StudyCategory}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>
                            </div>
                             <div class="col-md-12 pL0 padStyle">
                          <div class="col-md-12 pL0" :key="`documentlist-${index}`" v-for="(l, index) in educationInfomation.Documents">
                             <ob-document-list-ess :documentList="l" :key='increVal' :FromCheckList="true" :FromPreviewSubmit ="true" v-if="l.DocumentType == 'DegreeCerificates'"></ob-document-list-ess>
                        </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-12 padStyle" v-if="educationInfomation.IsMasterDegree">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Highest Level of Education

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Name of the United States Institution of Higher Education:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.HigherEducationDetails.InstituteName != null && educationInfomation.HigherEducationDetails.InstituteName != ''">
                                    {{educationInfomation.HigherEducationDetails.InstituteName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Date Degree awarded:

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.HigherEducationDetails.DegreeCompletedDate != null && educationInfomation.HigherEducationDetails.DegreeCompletedDate != '' && educationInfomation.HigherEducationDetails.DegreeCompletedDate != '0001-01-01T00:00:00'">
                                    {{educationinfo.yesDatedegree}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Type of Degree:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.HigherEducationDetails.DegreeType != null && educationInfomation.HigherEducationDetails.DegreeType != ''">
                                    {{educationInfomation.HigherEducationDetails.DegreeType}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                             <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Major field of study:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.HigherEducationDetails.StudyCategory != null && educationInfomation.HigherEducationDetails.StudyCategory != ''">
                                    {{educationInfomation.HigherEducationDetails.StudyCategory}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Address of the United States institution of higher education

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.Address1 != null && educationInfomation.Address.Address1 != ''">
                                   {{educationInfomation.Address.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Building Type:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.IsApt == true">
                                    Apartment
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="educationInfomation.Address.IsSuite == true">
                                    Suite
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="educationInfomation.Address.IsFloor == true">
                                    Floor
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                   Building Number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.AptNumber != null && educationInfomation.Address.AptNumber != ''">
                                    {{educationInfomation.Address.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City,State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.AddressSummary != null && educationInfomation.Address.AddressSummary != ''">
                                    {{educationInfomation.Address.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    ZipCode:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.Zip != null && educationInfomation.Address.Zip != ''">
                                    {{educationInfomation.Address.Zip}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                        </div>
                        <div class="col-md-12 pL0" :key="`documentlist-${index}`" v-for="(l, index) in educationInfomation.Documents">
                             <ob-document-list-ess :documentList="l" :key='increVal' :FromCheckList="true" :FromPreviewSubmit ="true" v-if="l.DocumentType != 'HighestDegreeCertificate' && l.DocumentType != 'DegreeCerificates' && l.DocumentType != 'TrainingCertificates' && l.DocumentType != 'ExperienceCertificate'"></ob-document-list-ess>
                        </div>

                    </div>
                    <!-- <div class="col-md-12 padStyle" v-else>
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Address of the United States institution of higher education

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.Address1 != null && educationInfomation.Address.Address1 != ''">
                                   {{educationInfomation.Address.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.AptNumber != null &&  educationInfomation.Address.AptNumber != ''">
                                    {{educationInfomation.Address.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City,State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.AddressSummary != null && educationInfomation.Address.AddressSummary != ''">
                                    {{educationInfomation.Address.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    ZipCode:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="educationInfomation.Address.Zip != null && educationInfomation.Address.Zip != ''">
                                    {{educationInfomation.Address.Zip}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                        </div>
                    </div> -->
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12 pL0 fontHeadStyle" v-if="isShowEducationalandTrainingDocs">Educational & Training Documents</div>
                        <div class="col-md-12 pL0" :key="`documentlist-${index}`" v-for="(l, index) in educationInfomation.Documents">
                             <ob-document-list-ess :documentList="l" :key='increVal' :FromCheckList="true" :FromPreviewSubmit ="true" v-if="l.DocumentType != 'DegreeCerificates' && l.DocumentType != 'Certifications' "></ob-document-list-ess>
                              <!-- <div class="col-md-12 pL0 margPillStyle" v-else>
                            <span v-if="l.MetadataValues.length > 0" class="document-list__headingApprovedStyle" style="margin:10px;" ><span>{{l.DisplayName}}&nbsp;<span class="document-list__statusApprovedStyle">&#10003;</span></span></span>
                             </div> -->
                        </div>
                    </div>
                    <div class="col-md-12 p0 conditionalBorder"></div>
                    <div class="col-md-12 padStyle">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Employment Information

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Name of the Employer(Sponsoring H-1B):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="employmentInfomation.EmployerName != null && employmentInfomation.EmployerName != ''">
                                    {{employmentInfomation.EmployerName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <!-- <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Job Title:

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    2018

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Salary Ofered:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    N/A

                                </div>

                            </div> -->
                        </div>
                        <div class="col-md-6 pL0" v-if="employmentInfomation.IsAddress">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Address of where you will work

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="employmentInfomation.Address.Address1 != null && employmentInfomation.Address.Address1 != ''">
                                    {{employmentInfomation.Address.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Building Type:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="employmentInfomation.Address.IsApt == true">
                                    Apartment
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="employmentInfomation.Address.IsSuite == true">
                                    Suite
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="employmentInfomation.Address.IsFloor == true">
                                    Floor
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                   Building Number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="employmentInfomation.Address.AptNumber != null && employmentInfomation.Address.AptNumber != ''">
                                    {{employmentInfomation.Address.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City,State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="employmentInfomation.Address.AddressSummary != null && employmentInfomation.Address.AddressSummary != ''">
                                    {{employmentInfomation.Address.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    ZipCode:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="employmentInfomation.Address.Zip != null && employmentInfomation.Address.Zip != ''">
                                    {{employmentInfomation.Address.Zip}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 padStyle" v-if="IsEmploymentRequestedDocsExists">
                        <div class="col-md-12 pL0 fontHeadStyle">Employment Documents</div>
                        <div class="col-md-12 pL0" :key='increVal'>
                            <ob-document-list-ess :documentList="l" :FromCheckList="true" :FromPreviewSubmit ="true" :key="`documentlist-${index}`" v-for="(l, index) in employmentInfomation.Documents"></ob-document-list-ess>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="col-md-12 pL0 fontSubHeadStyle">Client Details (List all Clients, Explain contractual part from Petitioner to End-client) </div>
                        <link-flow-diagram :link="dataDetails" :onTaxTermData="summaryFlowDiagram" :showBorder="isShowBorder"></link-flow-diagram>
                    </div>
                    <div class="col-md-12 p0 conditionalBorder"></div>
                    <!-- <div id="project_clientDetails">
        <div class="ul clearfix">
            <div class="li">
                <i><span><div class="circle" style="font-size: 5px;margin:-31px;"></div></span></i>
                <p class="website_txt m0 text-uppercase">
                    <span>Client</span>
                    <span>Tier 1</span>
                </p>
              <p class="website_org m0 text-capitalize">Accenture</p>
            </div>
        </div>
    </div>   -->
           <div class="col-md-12 padStyle">
                        <div class="col-md-12 pL0 fontHeadStyle">
                            Immigration Information

                        </div>
                        <div class="col-md-12 pL0" v-if="immigrationInfomation.IsOutsideUS">
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                I-94 Arrival - Departure Record Number:

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="immigrationInfomation.I94Number != null && immigrationInfomation.I94Number != ''">
                                {{immigrationInfomation.I94Number}}

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                Date of Last Arrival (mm/dd/yyyy):
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="immigrationInfomation.LastArrivalDate != '0001-01-01T00:00:00' && immigrationInfomation.LastArrivalDate != null && immigrationInfomation.LastArrivalDate != ''">
                                {{immigrationInfomationLastArrivalDate}}

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                Current Nonimmigrant Status:
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="immigrationInfomation.NonImmigrantStatus != null && immigrationInfomation.NonImmigrantStatus != ''">
                                {{immigrationInfomation.NonImmigrantStatus}}

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                Date Status Expires or D/S(Duration of Status):
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="immigrationInfomation.StatusExpiresDate != '0001-01-01T00:00:00' && immigrationInfomation.StatusExpiresDate != null && immigrationInfomation.StatusExpiresDate != ''">
                                {{immigrationInfomationStatusExpiresDate}}
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                Student and Exchange Visitor Information System (SEVIS) Number (if any):
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="immigrationInfomation.SEVISNumber != null && immigrationInfomation.SEVISNumber != ''">
                                {{immigrationInfomation.SEVISNumber}}

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                Employment Authorization Document (EAD) Number (if any):
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="immigrationInfomation.EADNumber != null && immigrationInfomation.EADNumber != ''">
                                {{immigrationInfomation.EADNumber}}

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>

                        </div>
                        </div>
                        <div class="col-md-12 pL0" v-if="immigrationInfomation.EntryExitDetails.length > 0">
                            <div class="col-md-12 pL0 fontHeadStyle">Significant period of time outside the US</div>
                        <div class="col-md-12 pL0 padToppSty" v-for="(d,dIndex) in immigrationInfomation.EntryExitDetails" :key="dIndex" >
                          <div class="col-md-6 pL0" :class="{'variant-border':immigrationInfomation.EntryExitDetails.length > 0 && dIndex != 0}">
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                Exit from US:
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="d.EndDate != null && d.EndDate != '' && d.EndDate != '0001-01-01T00:00:00'">
                                {{ExitfromUsEndDate(d)}}

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>


                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                Entry to US (mm/dd/yyyy):
                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-if="d.StartDate != null && d.StartDate != '' && d.StartDate != '0001-01-01T00:00:00'">
                                {{ExitfromUsStartDate(d)}}

                            </div>
                            <div class="col-md-3 fontSubHeadBoldPadStyle" v-else>
                                N/A
                            </div>

                        </div>
                        </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12 pL0 fontHeadStyle">Immigration Documents</div>
                        <div class="col-md-12 pL0" :key="`documentlist-${index}`" v-for="(l, index) in immigrationInfomation.Documents">
                          <ob-document-list-ess v-if="l.MetadataValues.length > 0" :documentList="l" :key='increVal' :FromCheckList="true" :FromPreviewSubmit ="true"></ob-document-list-ess>
                        </div>
                    </div>
                    <div class="col-md-12 pL0" v-if="immigrationInfomation.IsPreviousApproval" >
                        <div class="col-md-12 pL0 fontHeadStyle">
                            Details of current/previous H-1B/L-1 Approvals.(Start with most recent)

                        </div>
                    <div class="col-md-12 padStyle" v-for="(d,dIndex) in immigrationInfomation.ApprovalsData" :key="dIndex" :class="{'variant-border':immigrationInfomation.ApprovalsData.length > 0 && dIndex != 0}">

                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0 ">
                                Start Date(mm/dd/yyyy):
                            </div>
                            <div class="col-md-3 fontStySubHeadBoldPadStyle" v-if="d.StartDate != null && d.StartDate != '' && d.StartDate != '0001-01-01T00:00:00'">
                                {{currentprevh1bOrL1StartDate(d)}}

                            </div>
                            <div class="col-md-6 fontStySubHeadBoldPadStyle" v-else>
                            N/A

                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                End Date(mm/dd/yyyy):

                            </div>
                            <div class="col-md-3 fontStySubHeadBoldPadStyle" v-if="d.EndDate != null && d.EndDate != '' && d.EndDate != '0001-01-01T00:00:00'">
                                {{currentprevh1bOrL1EndDate(d)}}

                            </div>
                            <div class="col-md-3 fontStySubHeadBoldPadStyle" v-else>
                            N/A

                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0 ">
                                Company Name:
                            </div>
                            <div class="col-md-3 fontStySubHeadBoldPadStyle" v-if="d.CompanyName != null && d.CompanyName != ''">
                                {{d.CompanyName}}

                            </div>
                            <div class="col-md-3 fontStySubHeadBoldPadStyle" v-else>
                            N/A

                            </div>

                        </div>
                        <div class="col-md-12 pL0 fontSubHeadPadStyle">
                            <div class="col-md-3 pL0">
                                H1/L1 Approval Number:

                            </div>
                            <div class="col-md-3 fontStySubHeadBoldPadStyle" v-if="d.DocumentNumber != null && d.DocumentNumber != ''">
                                {{d.DocumentNumber}}

                            </div>
                            <div class="col-md-3 fontStySubHeadBoldPadStyle" v-else>
                            N/A

                            </div>

                        </div>
                    </div>
                    </div>
                    <div class="col-md-12 p0" :class="{'conditionalBorder': this.checkDependents == '1'}"></div>
                    <div class="col-md-12  fontHeadStyle" v-if="this.checkDependents == '1'">
                            Dependent Information
                        </div>
                    <div class="col-md-12 pL0" v-for="(e,eIndex) in dependentInformation" :key="eIndex">
                    <div class="col-md-12 pL0" v-if="e.IsAnyDependent">
                    <div class="col-md-12 pL0 padStyle" v-if="e.DependentType == 'Spouse'">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-12 pL0 fontSubHeadStyle">H-4 Details (Spouse & Child) - Need Details of all Children to be included on the H-4</div>
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Details of Spouse

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Family Name (Last Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.LastName != null && e.SpouseDetails.LastName !=''">
                                    {{e.SpouseDetails.LastName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Given Name (First Name):

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.FirstName != null && e.SpouseDetails.FirstName != ''">
                                    {{e.SpouseDetails.FirstName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Middle Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.MiddleName != null && e.SpouseDetails.MiddleName != ''">
                                    {{e.SpouseDetails.MiddleName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Maiden Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.OtherLastName != null && e.SpouseDetails.OtherLastName != ''">
                                    {{e.SpouseDetails.OtherLastName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                        <!-- <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Other Beneficiary Names

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Family Name (Last Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    Maurice Riley

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Given Name (First Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    Mauriceriley

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Middle Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    riley

                                </div>

                            </div>
                        </div> -->
                    </div>
                    <div class="col-md-12 padStyle">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Other Information

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Date of Birth(mm/dd/yyyy):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.DOB != null && e.SpouseDetails.DOB != '' && e.SpouseDetails.DOB != '0001-01-01T00:00:00'">
                                    {{SpouseOrChildDetailsDOB(e)}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country of Citizenship:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.CountryOfCitizenship != null && e.CountryOfCitizenship != ''">
                                    {{e.CountryOfCitizenship}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country of Birth:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.DateOfBirth != null && e.SpouseDetails.DateOfBirth != ''">
                                    {{e.SpouseDetails.DateOfBirth}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    U.S. Social Security Number (if any):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.SocialSecurtiyNumber != null && e.SpouseDetails.SocialSecurtiyNumber != ''">
                                    {{e.SpouseDetails.SocialSecurtiyNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Email Address:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.Email != null && e.SpouseDetails.Email != ''">
                                    {{e.SpouseDetails.Email}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Phone number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.MobileNo != null && e.SpouseDetails.MobileNo != ''">
                                    {{e.SpouseDetails.MobileNo}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                               Current Residential U.S Address (applicable if residing in the United States) <span style="font-weight:400">(do not list a P.O. Box)</span>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.Address1 != null && e.SpouseAddress.Address1 != ''">
                                    {{e.SpouseAddress.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Building Type:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.IsApt == true">
                                    Apartment
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="e.SpouseAddress.IsSuite == true">
                                    Suite
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="e.SpouseAddress.IsFloor == true">
                                    Floor
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                   Building Number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.AptNumber != null && e.SpouseAddress.AptNumber != ''">
                                    {{e.SpouseAddress.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City,State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.AddressSummary != null && e.SpouseAddress.AddressSummary != '' && e.SpouseAddress.AddressSummary != ','">
                                    {{e.SpouseAddress.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    ZipCode:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.Zip != null && e.SpouseAddress.Zip != ''">
                                    {{e.SpouseAddress.Zip}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Immigration Status:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.ImmigrationStatus != null && e.ImmigrationStatus != ''">
                                    {{e.ImmigrationStatus}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                    </div>

                            </div>
                        </div>

                    </div>

                    <div class="col-md-12 padStyle">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Foreign Address (applicable if <span style="font-weight:700">not</span> residing in the United States)

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.Address1 != null && e.SpouseForeignAddress.Address1 != ''">
                                    {{e.SpouseForeignAddress.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Building Type:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.IsApt == true">
                                    Apartment
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="e.SpouseForeignAddress.IsSuite == true">
                                    Suite
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="e.SpouseForeignAddress.IsFloor == true">
                                    Floor
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>
                            </div>
                             <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                   Building Number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.AptNumber != null && e.SpouseForeignAddress.AptNumber != ''">
                                    {{e.SpouseForeignAddress.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country:

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.County != null && e.SpouseForeignAddress.County != ''">
                                    {{e.SpouseForeignAddress.County}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City, State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.AddressSummary != null && e.SpouseForeignAddress.AddressSummary != '' && e.SpouseForeignAddress.AddressSummary != ','">
                                    {{e.SpouseForeignAddress.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div v-if="e.SpouseForeignAddress.County != 'United States'">
                                    <div class="col-md-6 pL0">
                                        Postal Code:
                                    </div>
                                    <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.CountryCode != null && e.SpouseForeignAddress.CountryCode != ''">
                                        <span>{{e.SpouseForeignAddress.CountryCode}}</span>
                                    </div>
                                    <div v-else class="col-md-6 pL0 fontSubHeadBoldStyle"> N/A </div>
                                </div>

                                <div v-else-if="e.SpouseForeignAddress.County == 'United States'">
                                    <div class="col-md-6 pL0">
                                        Zip Code:
                                    </div>
                                    <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.Zip != null && e.SpouseForeignAddress.Zip != ''">
                                        <span>{{e.SpouseForeignAddress.Zip}}</span>
                                    </div>
                                    <div v-else class="col-md-6 pL0 fontSubHeadBoldStyle"> N/A</div>
                                </div>
                                <!-- <div class="col-md-6 pL0" v-if="e.SpouseForeignAddress.County != 'United States'">
                                    Postal Code:
                                </div>
                                <div class="col-md-6 pL0" v-else>
                                    Zip Code:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="(e.SpouseForeignAddress.Zip != null && e.SpouseForeignAddress.Zip != '') || (e.SpouseForeignAddress.CountryCode != null && e.SpouseForeignAddress.CountryCode != '')">
                                    <span v-if="e.SpouseForeignAddress.County != 'United States'">{{e.SpouseForeignAddress.CountryCode}}</span><span v-else>{{e.SpouseForeignAddress.Zip}}</span>

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div> -->

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Province:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseForeignAddress.Province != null && e.SpouseForeignAddress.Province != ''">
                                    {{e.SpouseForeignAddress.Province}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>

                    </div>
                        <!-- <div class="col-md-12 pL0" v-for="(f,fIndex) in e.Documents" :key="fIndex">
                         <div class="col-md-12 pL0" v-for="(h,hIndex) in f.MetadataValues" :key="hIndex">
                         <div class="col-md-12 pL0" v-for="(g,gIndex) in h.DocumentData" :key="gIndex">

                        </div>
                        </div>
                        </div> -->
                        <!-- <div class="col-md-12 pL0" v-for="(f,fIndex) in e.Documents" :key="fIndex">
                         <div class="col-md-12 pL0"  v-for="(h,hIndex) in f.MetadataValues" :key="hIndex">
                         <div class="col-md-12 pL0" v-for="(g,gIndex) in h.DocumentData" :key="gIndex">

                        </div>
                        </div>
                        </div> -->
                    <div class="col-md-12 fontHeadStyle" v-if="e.Documents && e.Documents.length > 0">Dependent Documents of Spouse</div>
                    <div class="col-md-12" :key="`documentlist-${index}`" v-for="(l, index) in e.Documents">
                          <ob-document-list-ess :documentList="l" :key='increVal' :FromCheckList="true" :FromPreviewSubmit ="true"></ob-document-list-ess>
                    </div>
                    </div>
                    </div>
                    <div class="col-md-12 pL0 padStyle" v-if="e.DependentType == 'Child'">
                    <div class="col-md-12 padStyle">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Details of Child

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Family Name (Last Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.LastName != null && e.SpouseDetails.LastName != ''">
                                    {{e.SpouseDetails.LastName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Given Name (First Name):

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.FirstName != null && e.SpouseDetails.FirstName != ''">
                                    {{e.SpouseDetails.FirstName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Middle Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.MiddleName != null && e.SpouseDetails.MiddleName != ''">
                                    {{e.SpouseDetails.MiddleName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Maiden Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.OtherLastName != null && e.SpouseDetails.OtherLastName != ''">
                                    {{e.SpouseDetails.OtherLastName}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                        <!-- <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Other Beneficiary Names

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Family Name (Last Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    Maurice Riley

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Given Name (First Name):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    Mauriceriley

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Middle Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle">
                                    riley

                                </div>

                            </div>
                        </div> -->
                    </div>
                    <div class="col-md-12 padStyle">
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                                Other Information

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Date of Birth(mm/dd/yyyy):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.DOB != null && e.SpouseDetails.DOB != '' && e.SpouseDetails.DOB!= '0001-01-01T00:00:00'">
                                    {{SpouseOrChildDetailsDOB(e)}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country of Citizenship:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.CountryOfCitizenship != null && e.CountryOfCitizenship != ''">
                                    {{e.CountryOfCitizenship}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Country of Birth:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.DateOfBirth != null && e.SpouseDetails.DateOfBirth != ''">
                                    {{e.SpouseDetails.DateOfBirth}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    U.S. Social Security Number (if any):
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseDetails.SocialSecurtiyNumber != null && e.SpouseDetails.SocialSecurtiyNumber != ''">
                                    {{e.SpouseDetails.SocialSecurtiyNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>
                        <div class="col-md-6 pL0">
                            <div class="col-md-12 pL0 fontHeadStyle">
                         Current Residential U.S Address (applicable if residing in the United States) <span style="font-weight:400">(do not list a P.O. Box)</span>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Street Number and Name:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.Address1 != null && e.SpouseAddress.Address1 != ''">
                                    {{e.SpouseAddress.Address1}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Building Type:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.IsApt == true">
                                    Apartment
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="e.SpouseAddress.IsSuite == true">
                                    Suite
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else-if="e.SpouseAddress.IsFloor == true">
                                    Floor
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                    N/A
                                </div>
                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                   Building Number:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.AptNumber != null && e.SpouseAddress.AptNumber != ''">
                                    {{e.SpouseAddress.AptNumber}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    City,State:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.AddressSummary != null && e.SpouseAddress.AddressSummary != '' && e.SpouseAddress.AddressSummary != ','">
                                    {{e.SpouseAddress.AddressSummary}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    ZipCode:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.SpouseAddress.Zip != null && e.SpouseAddress.Zip != ''">
                                    {{e.SpouseAddress.Zip}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                            <div class="col-md-12 pL0 fontSubHeadPadStyle">
                                <div class="col-md-6 pL0">
                                    Immigration Status:
                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-if="e.ImmigrationStatus != null && e.ImmigrationStatus != ''">
                                    {{e.ImmigrationStatus}}

                                </div>
                                <div class="col-md-6 pL0 fontSubHeadBoldStyle" v-else>
                                N/A

                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="col-md-12 fontHeadStyle" v-if="e.Documents && e.Documents.length > 0">Dependent Documents of Child</div>
                    <div class="col-md-12" :key="`documentlist-${index}`" v-for="(l, index) in e.Documents">
                          <ob-document-list-ess :documentList="l" :key='increVal' :FromCheckList="true" :FromPreviewSubmit ="true"></ob-document-list-ess>
                    </div>
                    </div>
                    </div>
                    <div class="col-md-12 fontborderStyle hide-in-print">
                        <div class="checkbox-inline" style="padding-left:15px;">
                            <ob-checkbox v-model="checkboxValue" :val="1"><span class="fontCheckStyle">I, hereby acknowledge that all the information provided is true to the best of my knowledge.</span> </ob-checkbox>
                        </div>

                    </div>
                    <div class="col-md-12 fontborderSolidStyle hide-in-print">
                        <ob-button width="100px" type="secondary" @click="backtodepInfo">Back</ob-button>
                        <ob-button width="100px" style="margin-left:10px;" type="secondary" @click="backtoHome">Cancel</ob-button>
                        <ob-button width="100px" style="margin-left:10px;" type="primary" :disabled="disableCheckValue" @click="ShowSubmitionSuccess">Submit</ob-button>

                    </div>
                </div>
                </div>
                <!-- Ending of Preview -->
                <!-- Starting of Personal Info -->
                <div class="col-md-12" v-else>
                    <!-- <p style="padding-left:12px;padding-bottom: 10px;color:#000">Reason for Rejection:</p> -->
                    <!-- <div class="col-md-12" style="background-color:#facde7;margin-left:12px;width:100%;margin-top:20px;">
             <p> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout</p>
             <p> The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here</p>
             </div>  -->
                    <h4 class="heading-text" style="padding-top:10px;">Provide Your information</h4>
                    <div class="col-md-12" style="padding-left:0px;">
                        <div class="col-md-3">
                            <label class="label-text">Family Name (Last Name)<span class="star">*</span></label>
                            <ob-input class="f1" placeholder="Enter Family Name (Last Name)" v-formi9-name v-model.trim="personalInfoPrimaryContactLastNameVal" :class="{ 'ob-vuelidate_input-error': $v.personalInfoPrimaryContactLastNameVal.$error }" @input="updateValue('pLastName', personalInfoPrimaryContactLastNameVal)"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoPrimaryContactLastNameVal.$dirty && !$v.personalInfoPrimaryContactLastNameVal.required"> Please enter Last name</span>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.personalInfoPrimaryContactLastNameVal.alphawithspace">Please enter only alphabets</span> -->
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Given Name (First Name)<span class="star">*</span></label>
                            <ob-input placeholder="First Name" v-formi9-name v-model.trim="personalInfoPrimaryContactFirstNameVal" :class="{ 'ob-vuelidate_input-error': $v.personalInfoPrimaryContactFirstNameVal.$error }" @input="updateValue('pFirstName', personalInfoPrimaryContactFirstNameVal)"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoPrimaryContactFirstNameVal.$dirty && !$v.personalInfoPrimaryContactFirstNameVal.required"> Please enter First name</span>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.personalInfoPrimaryContactFirstNameVal.alphawithspace">Please enter only alphabets</span> -->
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Middle Name</label>
                            <ob-input placeholder="Middle Name" v-formi9-name v-model.trim="personalInfoPrimaryContactMiddleNameVal" @input="updateValue('pMiddleName', personalInfoPrimaryContactMiddleNameVal)"></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.personalInfoPrimaryContactMiddleNameVal.alphawithspace">Please enter only alphabets</span> -->
                        </div>
                    </div>
                    <div class="col-md-12">
                        <p class="names-text">Have you ever used any names other than the legal names listed above?
                            <span class="radio-inline"><ob-radio val="Yes"  v-model="PersonalInfoIsLegalContactAvailable">Yes</ob-radio></span>
                            <span class="radio-inline"><ob-radio val="No" v-model="PersonalInfoIsLegalContactAvailable">No</ob-radio></span>
                        </p>
                        <p v-if="OpenotherName">Include nicknames,aliases,maiden name,and names from all previous marriages.</p>
                    </div>
                    <!-- <div class="col-md-12" style="padding:15px 0px 0px 0px;" v-if="OpenotherName">
                        <div class="col-md-3">
                            <label class="label-text">Family Name (Last Name)</label>
                            <ob-input placeholder="Enter Family Name (Last Name)" v-model.trim="PersonalInfoLegalContactsLastName"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.PersonalInfoLegalContactsLastName.alpha"> Please enter vaild lastname</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Given Name(First Name)</label>
                            <ob-input placeholder="First Name" v-model.trim="PersonalInfoLegalContactsFirstName"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.PersonalInfoLegalContactsFirstName.alpha"> Please enter vaild firstname</span>

                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Middle Name</label>
                            <ob-input placeholder="Middle Name" v-model.trim="PersonalInfoLegalContactsMiddleName"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.PersonalInfoLegalContactsMiddleName.alpha"> Please enter vaild middlename</span>
                        </div>
                    </div> -->
                    <div v-if="OpenotherName">
                        <div class="col-md-12" style="padding:15px 0px 0px 0px;"  v-for="(extraname, exIndex) in addAnotherNameArray" :key="exIndex">
                            <div class="col-md-3">
                                <label class="label-text">Family Name (Last Name)</label>
                                <ob-input :id="`legallast-${exIndex}`" placeholder="Enter Family Name(Last Name)" v-formi9-name v-model.trim="extraname.OtherLastName" @input="updateValue('otherLastName', extraname.OtherLastName, exIndex)"></ob-input>
                                <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.addAnotherNameArray.$each[exIndex].OtherLastName.alphawithspace">Please enter only alphabets</span> -->
                            </div>
                            <div class="col-md-3">
                                <label class="label-text">Given Name (First Name)</label>
                                <ob-input :id="`legalfirst-${exIndex}`" placeholder="First Name" v-formi9-name v-model.trim="extraname.OtherFirstName" @input="updateValue('otherFirstName', extraname.OtherFirstName, exIndex)"></ob-input>
                                <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.addAnotherNameArray.$each[exIndex].OtherFirstName.alphawithspace">Please enter only alphabets</span> -->
                            </div>
                            <div class="col-md-3">
                                <label class="label-text">Middle Name</label>
                                <ob-input :id="`legalmiddle-${exIndex}`" placeholder="Middle Name" v-formi9-name v-model.trim="extraname.OtherMiddleName" @input="updateValue('otherMiddleName', extraname.OtherMiddleName, exIndex)"></ob-input>
                                <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.addAnotherNameArray.$each[exIndex].OtherMiddleName.alphawithspace">Please enter only alphabets</span> -->
                            </div>
                            <div class="col-md-2" v-if="exIndex != 0" style="margin-top:32px;margin-left:-15px;">
                           <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/red_minus_icon.svg`" @click="removeAddanotherName(addAnotherNameArray,exIndex)" width="20" style="cursor:pointer;" slot="reference" /><span class="remove-name" @click="removeAddanotherName(addAnotherNameArray,exIndex)">Remove</span>
                         </div>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding-top:15px;" v-if="OpenotherName">
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Add.svg`" @click="addanothername" width="25" style="cursor:pointer;" slot="reference" /><span class="add-name" @click="addanothername">Add another name</span>
                    </div>
                    <div class="col-md-12">
                        <h4 class="contact-info-text">Contact information</h4>
                        <div class="col-md-3" style="margin-left:-15px;">
                            <label class="label-text">Telephone Number</label>
                            <ob-input placeholder="Telephone Number" maxLength="10" v-model.trim="personalInfoPrimaryContactMobileNoVal"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.personalInfoPrimaryContactMobileNoVal.numeric"> Please enter vaild Phone number</span>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-else-if="!$v.personalInfoPrimaryContactMobileNoVal.minLength"> Please enter vaild Phone number</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Email Address (if any)</label>
                            <ob-input placeholder="Email" v-model.trim="personalInfoPrimaryContactEmailVal"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.personalInfoPrimaryContactEmailVal.email"> Please enter vaild Email</span>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <h4 class="contact-info-text">Other information</h4>
                        <div class="col-md-3 pL0">
                            <label class="label-text">Date of Birth (mm/dd/yyyy)<span class="star">*</span></label>
                            <ob-date-time-picker id="DOB" placeholder="MM/DD/YYYY" @updated="(v)=>this.personaInfoPrimaryContactDOB = v" :class="{ 'ob-vuelidate_input-error': $v.personaInfoPrimaryContactDOB.$error }" :options="dobOptions" :inputvalue="personaInfoPrimaryContactDOB" v-model="personaInfoPrimaryContactDOB"></ob-date-time-picker>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personaInfoPrimaryContactDOB.$dirty && !$v.personaInfoPrimaryContactDOB.required"> Please select Date of birth</span>
                        </div>
                        <div class="col-md-4">
                            <div class="col-md-12 pL0">
                                <label class="label-text">Select Gender<span class="star">*</span></label>
                            </div>
                            <div class="col-md-12 pL0">
                                <span class="col-md-2 pL0"><ob-radio id="radio1" name="gender" val="Male" v-model="PersonalInfoGender">Male</ob-radio></span>
                                <span class="col-md-2 pL0"><ob-radio id="radio2" name="gender" val="Female" v-model="PersonalInfoGender">Female</ob-radio></span>
                                <span class="col-md-8"><ob-radio id="radio3" name="gender" val="Choose not to disclose" v-model="PersonalInfoGender">Choose not to disclose</ob-radio></span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="col-md-12 pL0">
                                <label class="label-text">Marital Status<span class="star">*</span></label>
                            </div>
                            <div class="col-md-12 pL0">
                                <span class="col-md-3 pL0"><ob-radio val="Married" name="M1" v-model="personalInfoMaritalStatus">Married</ob-radio></span>
                                <span class="col-md-3"><ob-radio val="Single" name="M1" v-model="personalInfoMaritalStatus">Single</ob-radio></span>
                                <span class="col-md-3"><ob-radio val="Divorced" name="M1" v-model="personalInfoMaritalStatus">Divorced</ob-radio></span>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="label-text">Country of Birth<span class="star">*</span></label>
                     <ob-select2 v-if="countryNameOpt.data.length > 0" :options="countryNameOpt" v-model="personalInfoBirthCountry" :class="{ 'ob-vuelidate_input-error': $v.personalInfoProvienceOfBirth.$error }"  > </ob-select2>
                  <div v-else class="emptyDiv"><i>Fetching the country's...</i></div>
                  <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoBirthCountry.$dirty && !$v.personalInfoBirthCountry.required">Please select Country</span>

                </div>
                    </div>
                    <div class="col-md-12" style="padding:20px 0px 0px 0px;">
                        <div class="col-md-3">
                            <label class="label-text">Province of Birth<span class="star">*</span></label>
                            <ob-input placeholder="Enter Province of Birth" v-model.trim="personalInfoProvienceOfBirth" :class="{ 'ob-vuelidate_input-error': $v.personalInfoProvienceOfBirth.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoProvienceOfBirth.$dirty && !$v.personalInfoProvienceOfBirth.required"> Please enter Province of Birth</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Country of Citizenship or Nationality<span class="star">*</span></label>
                            <ob-input placeholder="Enter Nationality" v-model.trim="personalInfoNationality" :class="{ 'ob-vuelidate_input-error': $v.personalInfoNationality.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoNationality.$dirty && !$v.personalInfoNationality.required"> Please enter Citizenship</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">U.S.Social Security Number</label>
                            <ob-input v-number-only placeholder="Enter U.S.Social Security Number" maxLength="9" v-model.trim="personalInfoPrimaryContactSocialSecurtiyNumber"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.personalInfoPrimaryContactSocialSecurtiyNumber.numeric || !$v.personalInfoPrimaryContactSocialSecurtiyNumber.minLength"> Please enter valid SSN Number</span>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Alien Registration Number (A-Number)</label>
                            <ob-input placeholder="A" :maxLength="10" v-model.trim="personalInfoAlienNumber" v-on:keyup.native="noinAlienNumber" :class="{ 'ob-vuelidate_input-error': $v.personalInfoAlienNumber.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.personalInfoAlienNumber.$dirty && !$v.personalInfoAlienNumber.noinAlienNumber && personalInfoAlienNumber !== ''">Please enter valid number(Ex:A12345678 or A123456789)</span>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="isShowAlienNumberVal"> Please enter valid number(Ex:A12345678 or A123456789)</span> -->
                        </div>
                    </div>
                    <div class="col-md-12" style="padding-left:0px;">
                        <h4 class="current-info-text"> Current Residential U.S Address (applicable if residing in the United States) <span style="font-weight:400">(do not list a P.O. Box)</span></h4>
                        <div class="col-md-6">
                            <label class="label-text">Street Number and Name</label>
                            <ob-input placeholder="Enter Street Number and Name " maxLength="150" v-model.trim="personalInfoCurrentAddressStreetNo"></ob-input>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Building Type</label>
                            <div class="radio-buttons">
                                <span class="radio-inline"><ob-radio id="radio10" name="btype3" val="Apt" v-model="personalInfoCurrentAddressAptORSteOrFlr">Apt.</ob-radio></span>
                                <span name="options1" class="radio-inline"><ob-radio id="radio11" name="btype3" val="Ste" v-model="personalInfoCurrentAddressAptORSteOrFlr">Ste.</ob-radio></span>
                                <span name="options1" class="radio-inline"><ob-radio id="radio12" name="btype3" val="Flr" v-model="personalInfoCurrentAddressAptORSteOrFlr">Flr.</ob-radio></span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Building Number</label>
                            <ob-input placeholder="Enter Number" maxLength="150" v-model.trim="personalInfoCurrentAddressAptNumber"></ob-input>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding:20px 0px 0px 0px;">
                        <div class="col-md-3">
                            <label class="label-text">City,State</label>
                            <!-- <ob-select2 key="" :options="Cstate" v-model="PersonalInfo.State" ></ob-select2> -->
                            <location-search :vmodelData.sync="personalInfoCurrentAddressCity"></location-search> <!-- Zip code is auto popupating for the previous selected city state -->
                            <!-- <location-search :vmodelData.sync="personalInfoCurrentAddressCity" @input="getZipCodeForCurrentAddr(personalInfoCurrentAddressCity)"></location-search> -->
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block;margin-left:-2px;" v-if="$v.personalInfoCurrentAddressCity.$dirty && !$v.personalInfoCurrentAddressCity.required"> Please select City,State</span> -->
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Zip Code</label>
                            <ob-input placeholder="Enter Zipcode" maxLength="5" v-model.trim="personalInfoCurrentAddressZip"></ob-input>
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="!$v.personalInfoCurrentAddressZip.numeric || !$v.personalInfoCurrentAddressZip.minLength "> Please enter valid Zipcode</span>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding-left:0px;">
                        <h4 class="current-info-text" style="font-weight:600"> Foreign Address (applicable if <span style="font-weight:700">not</span> residing in the United States)  </h4>
                        <div class="col-md-6">
                            <label class="label-text">Street Number and Name</label>
                            <ob-input placeholder="Enter Street Number and Name " maxLength="150" v-model.trim="personalInfoForeignAddressStreetNo"></ob-input>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text" style="margin-left: 19px;">Building Type</label>
                            <div class="radio-buttons">
                                <span class="radio-inline"><ob-radio id="radio4" name="btype1" val="Apt" v-model="personalInfoForeignAddressAptORSteOrFlr"> Apt.</ob-radio></span>
                                <span class="radio-inline"><ob-radio id="radio5" name="btype1" val="Ste" v-model="personalInfoForeignAddressAptORSteOrFlr">Ste.</ob-radio></span>
                                <span class="radio-inline"><ob-radio id="radio6" name="btype1" val="Flr" v-model="personalInfoForeignAddressAptORSteOrFlr">Flr.</ob-radio></span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Building Number</label>
                            <ob-input placeholder="Enter Number" maxLength="150" v-model.trim="personalInfoForeignAddressAptNumber"></ob-input>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding:20px 0px 0px 0px;">
                        <div class="col-md-3">
                            <label class="label-text">Country</label>
                         <ob-select2 v-if="countryNameOpt.data.length > 0" :options="countryNameOpt" v-model="personalInfoForeignAddressCounty"  > </ob-select2>
                        <div v-else class="emptyDiv"><i>Fetching the country's...</i></div>
                             <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressCounty.$dirty && !$v.personalInfoForeignAddressCounty.required">Please select Country</span> :class="{ 'ob-vuelidate_input-error': $v.personalInfoForeignAddressCounty.$error }"-->
                      </div>
                       <div class="col-md-3" v-if="personalInfoForeignAddressCounty == 'United States'">
                            <label class="label-text">City,State</label>
                            <!-- <ob-select2 key="" :options="Cstate" v-model="PersonalInfo.State" ></ob-select2> -->
                            <location-search :vmodelData.sync="personalInfoForeignAddressCity"></location-search>
                            <!-- <location-search :vmodelData.sync="personalInfoForeignAddressCity" @input="getZipCodeForForeignAddr(personalInfoForeignAddressCity)" ></location-search> -->
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressCity.$dirty && !$v.personalInfoForeignAddressCity.requiredIf"> Please select City,State</span>  :class="{ 'ob-vuelidate_input-error': $v.personalInfoForeignAddressCity.$error }"-->
                        </div>
                        <div class="col-md-3" v-if="personalInfoForeignAddressCounty != 'United States'">
                            <label class="label-text">State</label>
                            <!-- <ob-select2 key="" :options="Cstate" v-model="PersonalInfo.State" ></ob-select2> -->
                            <ob-input v-model="personalInfoForeignAddressIndiaState"  ></ob-input>
                            <!-- class="{ 'ob-vuelidate_input-error': $v.personalInfoForeignAddressIndiaState.$error }" -->
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressIndiaState.$dirty && !$v.personalInfoForeignAddressIndiaState.requiredIf"> Please enter State</span> -->
                        </div>
                        <div class="col-md-3" v-if="personalInfoForeignAddressCounty != 'United States'">
                            <label class="label-text">City</label>
                            <!-- <ob-select2 key="" :options="Cstate" v-model="PersonalInfo.State" ></ob-select2> -->
                            <ob-input v-model="personalInfoForeignAddressIndiaCity"  ></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressIndiaCity.$dirty && !$v.personalInfoForeignAddressIndiaCity.requiredIf"> Please enter City</span> :class="{ 'ob-vuelidate_input-error': $v.personalInfoForeignAddressIndiaCity.$error }" -->
                        </div>
                    </div>
                    <div class="col-md-12" style="padding:20px 0px 0px 0px;">

                        <div class="col-md-3" v-if="personalInfoForeignAddressCounty == 'United States'">
                            <label class="label-text">Zip Code</label>
                            <ob-input placeholder="Enter Zipcode" maxLength="5" v-model.trim="personalInfoForeignAddressZip" ></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressZip.$dirty && !$v.personalInfoForeignAddressZip.requiredIf"> Please enter Zipcode</span> :class="{ 'ob-vuelidate_input-error': $v.personalInfoForeignAddressZip.$error }" -->
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-else-if="$v.personalInfoForeignAddressZip.$dirty && (!$v.personalInfoForeignAddressZip.numeric ||!$v.personalInfoForeignAddressZip.minLength)"> Please enter valid zipcode</span> -->
                            <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressZip.$dirty && (!$v.personalInfoForeignAddressZip.numeric ||!$v.personalInfoForeignAddressZip.minLength)"> Please enter valid zipcode</span>
                        </div>
                        <div class="col-md-3" v-if="personalInfoForeignAddressCounty != 'United States'">
                            <label class="label-text">Postal Code</label>
                            <ob-input v-number-only :maxLength="6" placeholder="Enter Postal Code" v-model.trim="personalInfoForeignAddressCountryCode" ></ob-input>
                            <!-- <span class="ob-vuelidate_error-msg" style="margin-bottom:5px;display:inline-block" v-if="$v.personalInfoForeignAddressCountryCode.$dirty && !$v.personalInfoForeignAddressCountryCode.requiredIf"> Please enter Postal Code</span> :class="{ 'ob-vuelidate_input-error': $v.personalInfoForeignAddressCountryCode.$error }"-->
                        </div>
                        <div class="col-md-3">
                            <label class="label-text">Province</label>
                            <ob-input placeholder="Enter Province" v-model="personalInfoForeignAddressProvince"></ob-input>
                        </div>
                    </div>

                    <div class="col-md-12" v-if="IsPersonalRequestedDocsExists">
                        <h4 class="required-docs-text">Beneficiary Documents</h4>
                        <div class="col-md-12 pL0" :key='increVal'>
                            <ob-document-list-ess :documentList="l" :checklistIsDocAvailable="l.IsDocumentNotAvailable" :CheckListTabType="'personal'" :FromCheckList="true" :key="`documentlist-${index}`" v-for="(l, index) in personalInfomation.Documents" @onDocumentUpdate="updateDocsObj(index , ...arguments, docStatus)" @isPersonalDocAvailable="isPersonalDocumentAvailable(...arguments)" @onDocumentRemove="removePersonalDoc(index , ...arguments, docStatus)"></ob-document-list-ess>
                        </div>
                        <!-- <div class="col-md-4 pL0">
           <div class="btn-upload">
          <span class="document-list__headingStyle">Copy of Previous Year's W2&nbsp;<span class="document-list__statusStyle">?</span></span>
          </div>
         <div class="btn-upload">
         <div class="document-list__headingStyle">Copy of Previous Year's performance Review&nbsp;<span class="document-list__statusStyle">?</span></div>
         </div>
         <div class="btn-upload">
          <div class="document-list__headingStyle">Time Sheets&nbsp;<span class="document-list__statusStyle">?</span></div>
         </div>
         <div class="btn-upload">
          <div class="document-list__headingStyle">Direct Performance Review&nbsp;<span class="document-list__statusStyle">?</span></div>
         </div>
         <div class="btn-upload">
          <div class="document-list__headingStyle">Client Letter&nbsp;<span class="document-list__statusStyle">?</span></div>
         </div>
      </div> -->
                        <!-- <div class="col-md-6" style="text-align:right;margin-left:150px;">
           <div class="btn-upload">
           <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
           </div>
           <div class="btn-upload">
           <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
           </div>
           <div class="btn-upload">
           <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
           </div>
           <div class="btn-upload">
           <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
           </div>
           <div class="btn-upload">
           <ob-button type="primary" width="100px" @click="uploadw2Docs">Upload</ob-button>
           </div>
      </div> -->
                    </div>
                    <div class="col-md-12" style="border-bottom:1px solid grey;padding-bottom:20px;"></div>
                    <div class="footer-buttons">
                        <div class="col-md-12" style="padding:25px 0px 25px 0px;">
                            <ob-button type="secondary" width="100px;" @click="backtoHome">Cancel</ob-button>
                            <template v-if="showPersonalButtons">
                            <ob-button type="primary" v-if="disablePersonalSaveBtn"  style="margin-left:15px;" :disabled="disablePersonalSaveBtn" width="120px;" >Save & Proceed</ob-button>
                            <ob-button type="primary" v-else  style="margin-left:15px;"  width="120px;" @click="gotoeduinfo">Save & Proceed</ob-button>
                            </template>
                        </div>
                    </div>
                </div>
                <!-- Ending of Personal Info -->
                   </div>
                <!-- Upload DocumentsPopup -->
                <ob-modal2 :show.sync="openw2docpopup" :width="650" :backdrop="false">
                    <template slot="modal-title">
                    </template>
                    <template slot="modal-body">
                    </template>
                    <template slot="modal-footer">
                        <div calss="col-md-12" style="text-align:center;">
                            <ob-button type="primary" @click="Cancel">Cancel</ob-button>
                        </div>
                    </template>
                </ob-modal2>
                <!-- Upload DocumentsPopup -->
                <ob-modal2 :show="showSuccessPopup" :type="1" width="41%" :backdrop="false">
                    <div style="padding:25px;">
                        <div class="modal-soc--body" style="padding:30px 15px;text-align:center">
                            <img style="width: 56px;color: #1be81b" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/success_tick_icon.png`" width="65" slot="reference" />
                            <br/>
                            <label class="at">H-1B Petition Checklist Submitted Successfully.</label>
                            <br/>
                            <br/>
                            <div class="pas">
                                <p>All the documents have been submitted to the reviewer</p>
                                <p>You will be informed once they are verified.</p>
                            </div>
                        </div>
                        <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
                            <ob-button style="width: 102px; margin-right: 14px;font-weight: 600;" type="secondary" @click="close">Close</ob-button>
                        </div>
                    </div>
                </ob-modal2>
                <!-- Warning DocumentsPopup -->
                <ob-modal2 :show="isShowWarningMsgPopup" :type="1" width="41%" :backdrop="false">
                    <div style="padding:25px;">
                        <div class="modal-soc--body" style="padding:30px 15px 30px 10px;text-align:center">
                            <img style="width: 56px;color: #1be81b" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info-icon-orange.svg`" width="65" slot="reference" />
                            <br/>
                            <label class="at" style="color: #f07431;!important padding-left:10px;!important"> Attention</label>
                            <br/>
                            <br/>
                            <div class="pas" style="padding-bottom: 10px!important;font-size:15px;!important">{{warningContent}}</div>
                        </div>
                        <div class="modal-soc--footer" style="padding: 0px 20px 20px 40px;text-align:center;">
                            <ob-button style="width: 102px; margin-right: 14px;font-weight: 600;" type="secondary" @click="backtoHome">Close</ob-button>
                        </div>
                    </div>
                </ob-modal2>

            </template>

        </ob-layout>
    </div>
</template>
<script>
    import namevalidation from "Vue/Core/namevalidation.js"
    import c from "Vue/Core/constants.js";
    import LinkFLowDiagram from "../ESSProjects/EmpLinkFlowDiagram.vue"
    import LinkToEndClient from "../ESSProjects/EmpLinkToEndClient.vue"
    import {
        required, minLength, alpha, email, numeric, requiredIf, maxLength
    }
    from 'vuelidate/lib/validators'
    import jquery from 'jquery'
    const alphawithspace = (value) => {
    var alsp = /^[a-zA-Z\s]*$/i
    return alsp.test(value)
    }
    const alphanumeric = value => {
        if (typeof value === 'undefined' || value === null || value === '') {
            return true
        }
        return /^[a-zA-Z0-9]*$/.test(value)
    }
    const noinAlienNumber = (value) => {
        if (value === '') {
            // Allow submission if the field is empty
            return true;
        }
        let regex = /^(A)([0-9]{8,9})$/gm; // Match 'A' followed by 8-9 digits
        let re = new RegExp(regex, 'g');
        let res = re.test(value);

        if (!res && value !== '') {
            this.isShowAlienNumberVal = true;
        } else {
            this.isShowAlienNumberVal = false;
        }
        return res;
    };

    const alphawithsplchar = value => {
         if (typeof value === 'undefined' || value === null || value === '') {
            return true
        }
        return /^[a-zA-Z! “ # $ % & '( ) * + , -./ : ; < = > ?@ [ \] ^ _ `{ | } ~]*$/.test(value)
    }
    export default {
        data() {
                return {
                    candidatesOrgName: '',
                    compreset:0,
                    isValid: true,
                    isValidOtherName: false,
                    validate: false,
                    isESS: true,
                    // showPersonalApproveOrRejectIcon:true,
                    // showEducationalApproveOrRejectIcon:false,
                    // showEmploymentApproveOrRejectIcon:false,
                    // showImmigrationApproveOrRejectIcon:false,
                    // showDependentApproveOrRejectIcon:false,
                    showPersonalApproveOrRejectComments:true,
                    showEducationalApproveOrRejectComments:false,
                    showEmploymentApproveOrRejectComments:false,
                    showImmigrationApproveOrRejectComments:false,
                    showDependentApproveOrRejectComments:false,
                    isShowH4Dpdntdoc: false,
                    isShowWarningMsgPopup: false,
                    isShowEducationalandTrainingDocs: false,
                    warningContent: '',
                    isresetForeginValues: true,
                    reviewStatusCommentsData:[],
                    approverInformation:[],
                    summaryFlowDiagram:"W2",
                    isShowBorder: false,
                    dataDetails:[],
                    EndClient:{
                        OrganizationName: '',
                        website: '',
                        type:'EndClient',
                    },
                    self:{
                        OrganizationName:'',
                        type:'Self',
                    },
                    disablePersonalSaveBtn:true,
                    disableEducSaveBtn:true,
                    disableEmpSaveBtn:true,
                    disabledpdntSaveBtn:true,
                    disableImmigrationSaveBtn:true,
                    employmentInfoId: '',
                    clientsList: [],
                    //vendorsList : [],
                    educationalInfoId:'',
                    personalInfoId:'',
                    employmentInfoId: '',
                    personalInfoPrimaryContactLastNameVal: '',
                    personalInfoPrimaryContactFirstNameVal: '',
                    personalInfoPrimaryContactMiddleNameVal: '',
                    // PersonalInfoLegalContactsLastName: '',
                    // PersonalInfoLegalContactsFirstName: '',
                    // PersonalInfoLegalContactsMiddleName: '',
                    PersonalInfoIsLegalContactAvailable: "No",
                    PersonalInfoIsLegalContactAvailableYes: false,
                    personalInfoPrimaryContactMobileNoVal: '',
                    personalInfoPrimaryContactEmailVal: '',
                    personaInfoPrimaryContactDOB: '',
                    PersonalInfoGender: "Male",
                    personalInfoMaritalStatus: "Single",
                    personalInfoBirthCountry: "",
                    personalInfoProvienceOfBirth: "",
                    personalInfoNationality: "",
                    personalInfoPrimaryContactSocialSecurtiyNumber: "",
                    personalInfoAlienNumber: "",
                    personalInfoCurrentAddressStreetNo: "",
                    personalInfoCurrentAddressAptORSteOrFlr: "Apt",
                    personalInfoCurrentAddressApt: false,
                    personalInfoCurrentAddressSte: false,
                    personalInfoCurrentAddressFlr: false,
                    personalInfoCurrentAddressAptNumber: "",
                    personalInfoCurrentAddressCity: "",
                    personalInfoCurrentAddressZip: "",
                    personalInfoForeignAddressStreetNo: "",
                    personalInfoForeignAddressAptORSteOrFlr: "Apt",
                    personalInfoForeignAddressApt: false,
                    personalInfoForeignAddressSte: false,
                    personalInfoForeignAddressFlr: false,
                    personalInfoForeignAddressAptNumber: "",
                    personalInfoForeignAddressCity: "",
                    personalInfoForeignAddressZip: "",
                    personalInfoForeignAddressProvince: "",
                    personalInfoForeignAddressCountryCode: "",
                    personalInfoForeignAddressCounty: "",
                    personalInfoForeignAddressIndiaCity:'',
                    personalInfoForeignAddressIndiaState:'',
                    personalInfomation: {},
                    educationInfomation: {},
                    employmentInfomation: {},
                    immigrationInfomation: {},
                    dependentInformation: {},
                    H1BCheckListData: {},
                    disableCheckValue: true,
                    checkboxValue: '',
                    showSuccessPopup: false,
                    increVal:0,
                    Opendegree: false,
                    showgreenEduicon: false,
                    showgreenEmpicon: false,
                    showgreenImmicon: false,
                    showgreenDepicon: false,
                    showgreenpreicon: false,
                    OpenpersonalinfoForm: false,
                    OpendependentinfoForm: false,
                    OpenimmigrationinfoForm: false,
                    OpenemploymentinfoForm: false,
                    OpeneducationalInfoForm: false,
                    OpendependentInfoForm: false,
                    OpenpreviewForm: false,
                    OpenotherName: false,
                    openw2docpopup: false,
                    isShowAlienNumberVal: false,
                    addAnotherNameArray: [],
                      dobOptions: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    minDate: "1900/01/01",
                    maxDate: moment().subtract(15, 'years')
                },
                    PersonalInfo: {
                        lastName: '',
                        firstName: '',
                        middleName: '',
                        OtherLastName: '',
                        OtherFirstName: '',
                        OtherMiddleName: '',
                        selectedYes: '',
                        selectedNo: 'No',
                        selectedMale: 'M',
                        selectedFeMale: '',
                        selectedDivorced: '',
                        selectedMarried: 'Married',
                        selectedSingle: '',
                        selecteddisclose: '',
                        selectedApt: 'apt3',
                        selectedStr: '',
                        selectedFlr: '',
                        Selectedapt: 'apt4',
                        Selectedste: '',
                        Selectedflr: '',
                        Lastname: '',
                        Firstname: '',
                        MiddleName: '',
                        Number: '',
                        EmailAddress: '',
                        dateofBirth: '',
                        provinceofBirth: '',
                        citizenship: '',
                        uscisNumber: '',
                        alienNumber: '',
                        streetNumber: '',
                        buildingNumber: '',
                        StreetNumber: '',
                        BuildingNumber: '',
                        city: '',
                        zipcode: '',
                        Province: '',
                        Zipcode: '',
                        PostalCode: '',
                        State: '',
                        Country: '',
                    },
                    //Education Info
                    increVal1:0,
                    educationinfo: {
                        mastersDegreeVal: 'Yes',
                        Datedegree: '',
                        TypeofDegree: '',
                        Majorfield: '',
                        Nameofinstitution: '',
                        appeareYes: '',
                        appeareNo: '',
                        Street: '',
                        currentCity: '',
                        State: '',
                        zipcode: '',
                        BuildingNumber: '',
                        //empcurrentCity: '',
                        yesDatedegree: '',
                        yesTypeofDegree: '',
                        yesMajorfield: '',
                        yesNameofinstitution: '',
                         Selectedapt: 'ap3',
                        Selectedste: '',
                        Selectedflr: '',
                    },
                    educationDetailsDocURL:'',
                    higherEducationDetailsDocURL:'',
                    //Employee Info
                    Employeeinfo: {
                        Name: '',
                        //Job:'',
                        //Salary:'',
                        //Pre:'',
                        empStreet: '',
                        empBuildingNumber: '',
                        empzipcode: '',
                        buildType: 'apt2',
                        // buildApt: 'apt2',
                        // buildSte: '',
                        // buildFlr: '',
                        empcurrentCity: '',
                        empAddressVal: 'Yes'
                    },
                    //immigrationifo
                    isShowEADValidation: false,
                    isShowSEVISNumberVal: false,
                    isShowMastersDegree: true,
                    isShowEmpAddress: true,
                    isUploading: false,
                    inStates: false,
                    // statesStatus: '1',
                    // outofStates: '1',
                    // h1bApproval: '1',
                    // i140Approval: '1',
                    showUpdatePopup: false,
                    isShowStay: true,
                    isShowSignificant: true,
                    isShowH1Bapproval: true,
                    isShowi140Approval: true,
                    isAddanotherStay: false,
                    addAnotherStayArray: [],
                    addAnotherApprovalArray: [],
                    spent: '',
                    immI94Number: '',
                    filename: '',

                    ImmigrationInfo: {
                        recordNumber: '',
                        immLastArrivalDate: '',
                        nonimmigrantStatus: '',
                        StatusExpDate: '',
                        SEVISNumber: '',
                        EADNumber: '',
                        exit: '',
                        entry: '',
                        docNumber: '',
                        PassportIssueDate: '',
                        PassportExpireDate: '',
                        Country: '',
                        lastArrivalDate: '',
                        admitUntil: '',
                        visaStatus: '',
                        startDate: '',
                        endDate: '',
                        compName: '',
                        approvalNumber: '',
                        visible: 'Yes',
                        outofStates: 'Yes',
                        IsoutOfStates: false,
                        h1bApproval: 'Yes',
                        Ish1bApproval: false,
                        i140Approval: 'Yes',
                        Isi140Approval: false,
                        otherVisaName:''
                    },
                    immigrationPassportDocURL: '',
                    immigrationVisaDocURL:'',
                    immigrationI140DocURL:'',
                    educationDegree:'',
                   cityState: {
                        placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: ['Hyderabad, Telangana']
                    },
                    Cstate: {
                        placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: ['Hyderabad, Telangana']
                    },
                    State: {
                        placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: ['Hyderabad, Telangana']
                    },
                    Country: {
                        placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: ['Hyderabad, Telangana']
                    },
                    Citizenship: {
                        placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: ['Citizenship']
                    },
                    currentTypeofdegree: {
                        placeholder: {
                            id: '-1',
                            text: 'Please Select degree'
                        },
                        data: ['Mca']
                    },
                    NonimmigrantStatusOpt: {
                        placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: []
                    },
                    ImmigrationStatusOpt:{
                         placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: ['US Citizen','Non US Citizen','Permanent Resident','Alien Authorized to work']
                    // data: [{ id: '1', text: 'US Citizen' },
                    // { id: '2', text: 'Non US Citizen' },
                    // { id: '3', text: 'Permanent Resident' },
                    // { id: '4', text: 'Alien Authorized to work' }],

                    },
                    dobOptions: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    minDate: "1900/01/01",
                    maxDate: moment().subtract(15, 'years')
                },
				// alienAuthorized: {
                //     data: [{

                //         id: '1',
                //         text: 'US Citizen'
                //     }, {
                //         id: '2',
                //         text: 'Non US Citizen'
                //     }, {
                //         id: '3',
                //         text: 'Permanent Resident'
                //     }, {
                //         id: '4',
                //         text: 'Alien Authorized to work'
                //     }],
                //     placeholder: {
                //         id: '-1',
                //         text: ' Status of Citizenship'
                //     }
                // },
                    CurrentvisastatusOpt:{
                     placeholder: {
                            id: '-1',
                            text: 'Select'
                        },
                        data: []

                    },
                    currentCity: {
                        placeholder: {
                            id: '-1',
                            text: 'Plesase Select City'
                        },
                        ajax: {
                        type: 'GET',
                        url: function(params) {
                            return `${c.APIBASEURL}/Consultant/GetDegreeNames`
                        },
                        delay: 250,
                        data: function (params) {
                            var query = {

                            }
                            // Query paramters will be ?search=[term]&page=[page]
                            return query;
                        },
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                        },
                        processResults: function (data) {
                            try {
                                data = JSON.parse(data);
                            } catch(ex) {

                            }
                            let results = []
                            if(data !== null) {
                                data.forEach((e) => {
                                    results.push({
                                        id: e,
                                        text: e
                                    })
                                })
                            }

                            return {
                                results: results
                            };
                        }
                    }
                    },
                    // currentPre: {
                    //     placeholder: {
                    //         id: '-1',
                    //         text: 'Please Select'
                    //     },
                    //     data: ['sa']
                    // },

                   // EndPoint: "https://httpbin.org/post",
                    ValidationType2: {
                        Rules: {
                            Type: ["pdf", "zip", "doc", "docx"],
                            Size: 50000000, // In Bytes
                            multiplefiles: false
                        },
                        Messages: {
                            Type: "Please upload valid file formats",
                            Size: `Please upload a file which is less than 50MB`,
                        },
                    },
                    options2: {
                        format: 'MM/DD/YYYY',
                        dayViewHeaderFormat: 'MM/DD/YYYY',
                        maxDate: moment().add(0, 'days'),
                    },
                    options2Child: {
                        format: 'MM/DD/YYYY',
                        dayViewHeaderFormat: 'MM/DD/YYYY',
                        maxDate: moment().add(0, 'days'),
                    },
                    options3: {
                        format: 'MM/DD/YYYY',
                        dayViewHeaderFormat: 'MM/DD/YYYY'
                    },
                    datePickerOptions: {
                        format: 'MM/DD/YYYY'
                    },
                    checkDependents: '2',
                    selected: '',
                    selectedValue: '',
                    options: {
                        placeholder: {
                            id: '-1', // the value of the option
                            text: 'Select an option'
                        },
                        data: [{
                            id: 'Spouse',
                            text: 'Spouse'
                        }, {
                            id: 'Child',
                            text: 'Child'
                        }],

                    },
                    typeOfDependent: "",
                    EndPoint: `${c.APIBASEURL}/File/FileUpload`,
                    ValidationType2: {
                        Rules: {
                            Type: ["pdf", "jpg", "png", "bmp", "jpeg","zip", "doc", "docx"],
                            Size: 110000000, //Bytes
                            multiplefiles: false,
                        },
                        Messages: {
                            Type: "Please upload valid file formats",
                            Size: `Please upload a file less than 100MB`,
                        },

                    },
                    options1date: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                  // maxDate: moment().subtract(15, 'years'),
                    },
                    countryNameOpt: {
                    placeholder: {
                        id: '-1',
                        text: 'Select Country'
                    },
                    data: []
                    },
                    degreeTypeOpt: {
                        placeholder: {
                        id: '-1',
                        text: 'Select Degree'
                    },
                    data: []

                    },
                    dependentsArray: [
                        //     {
                        //     type: '',
                        //     basicInfoObj: {
                        //         "familyName": '',
                        //         "givenName": '',
                        //         "middleName": '',
                        //         "maidenName": '',
                        //         "birthDate": '',
                        //         "countryCitizenShip": '',
                        //         "birthCountry": '',
                        //         "ssnNumber": '',
                        //         "emailAddr": '',
                        //         "phoneNum": ''
                        //     },
                        //     addressObj: {
                        //         "streetName": '',
                        //         "aptRadio": '',
                        //         "Number": '',
                        //         "cityState": '',
                        //         "zipCode": '',
                        //         "immigrationStatus": ''

                        //     },
                        //     passPortDetails: {
                        //         "Number": '',
                        //         "issueDate": '',
                        //         "expirydate": '',
                        //         "issuedBy": '',
                        //         "documentUrl": ''
                        //     },
                        //     visaDetailsObj: {
                        //         "lastEntrydate": '',
                        //         "admitUntil": '',
                        //         "currenStatus": '',

                        //     },
                        //     I94DetailsObj: {
                        //         "i94ReceiptNumber": '',
                        //         "i94StartDate": '',
                        //         "i94EndDate": '',
                        //     }

                        // }
                    ]
                }
            },
            created() {
                this.getDegreeType()
                this.getCountryList()
                this.getEssRequestDetails()

                this.addClient()
                //this.addVendor()
                this.anotherStayPeriodAdding()
                this.addAnotherApproval()
                this.getNonimmigrantStatusList()
                this.getCurrentVisaStatusList()
            },
            components:{
                "link-flow-diagram" : LinkFLowDiagram,
                "link-to-end-client" :  LinkToEndClient
            },
            computed:{
                IsVisaDetailsprovided() {
                    if(this.ImmigrationInfo.lastArrivalDate != '' || this.ImmigrationInfo.admitUntil != '' || this.ImmigrationInfo.visaStatus != '' || (this.ImmigrationInfo.immigrationVisaDocURL != '' && this.ImmigrationInfo.immigrationVisaDocURL != undefined)){
                        return true
                    }
                    else
                        return false
                },
                IsPersonalRequestedDocsExists() {
                    if(this.personalInfomation != null && this.personalInfomation.Documents != null && this.personalInfomation.Documents.length > 0)
                        return true
                    else
                        return false
                },
                IsEducationRequestedDocsExists() {
                    let eduFlag =false
                    if(this.educationInfomation.Documents != null && this.educationInfomation.Documents != null && this.educationInfomation.Documents.length > 0){
                    this.educationInfomation.Documents.forEach((eduDocs ,eduIndex) =>{
                        if(eduDocs.DocumentType != "DegreeCerificates" || eduDocs.DocumentType != "Certifications")
                        {
                            eduFlag = true
                        }
                    })
                    }
                    return eduFlag
                },
                IsEmploymentRequestedDocsExists() {
                    if(this.employmentInfomation != null && this.employmentInfomation.Documents != null && this.employmentInfomation.Documents.length > 0)
                        return true
                    else
                        return false
                },
                personalInfomationPrimaryContactDOB(){
                //return moment(this.personalInfomation.PrimaryContact.DOB).format("MM/DD/YYYY")
                let date = new Date(this.personalInfomation.PrimaryContact.DOB)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                educationInfomationHigherEducationDetailsDegreeCompletedDate(){
                //return moment(this.educationInfomation.HigherEducationDetails.DegreeCompletedDate).format("MM/DD/YYYY")
                let date = new Date(this.educationInfomation.HigherEducationDetails.DegreeCompletedDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                educationInfomationDegreeCompletedDate(){
               // return moment(this.educationInfomation.EducationDetails.DegreeCompletedDate).format("MM/DD/YYYY")
                let date = new Date(this.educationInfomation.EducationDetails.DegreeCompletedDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                immigrationInfomationStatusExpiresDate(){
                 //return moment(this.immigrationInfomation.StatusExpiresDate).format("MM/DD/YYYY")
                 let date = new Date(this.immigrationInfomation.StatusExpiresDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                immigrationInfomationLastArrivalDate(){
                //return moment(this.immigrationInfomation.LastArrivalDate).format("MM/DD/YYYY")
                 let date = new Date(this.immigrationInfomation.LastArrivalDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                dependentSaveDisable(){
                    //
                    let tempBoolFlag = false
                    if(this.dependentsArray && this.dependentsArray.length > 0){
                        this.dependentsArray.forEach((dependentItem , dIndex)=>{
                             if(dependentItem.selectH4 == '1'){
                                 if(dependentItem.tempDocsBinding && dependentItem.tempDocsBinding.length > 0 && (((dependentItem.tempDocsBinding.filter(x => x.docType == 'BirthCertificate').length > 0) && dependentItem.type=="Child")|| (dependentItem.tempDocsBinding.filter(x => x.docType == 'MarriageCertificate').length > 0)&& dependentItem.type=="Spouse") ){
                                       tempBoolFlag = false
                                 }else{
                                     tempBoolFlag = true
                                     return tempBoolFlag
                                 }

                             }else{
                                 tempBoolFlag = false
                             }
                        })
                       // return true
                    }else{
                         tempBoolFlag
                    }
                    return tempBoolFlag

                },
                 showPersonalButtons(){
                    //  if(this.personalInfomation.Id != null && this.personalInfomation.Id != '') {
                    //     this.disablePersonalSaveBtn = false
                    //  }
                    //  else {
                        let tempFlag = false
                        let tempArrVal = []
                        let BoolCount = 0
                        if(this.personalInfomation.Documents){
                            this.personalInfomation.Documents.forEach((personalDocs ,pIndex) =>{
                                 if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                     //this.disablePersonalSaveBtn = false
                                     var boolFlag = false
                                     tempArrVal.push(boolFlag)
                                 }else{
                                     if(personalDocs.IsDocumentNotAvailable == true){
                                         var boolCRFlag = false
                                        tempArrVal.push(boolCRFlag)
                                     }
                                     else {
                                        var boolTrueFlag = true
                                        tempArrVal.push(boolTrueFlag)
                                     }
                                 }
                            })

                           BoolCount  = (tempArrVal.filter(v => v).length);


                        }
                        if(BoolCount > 0){
                            tempFlag = true
                        }else{
                            tempFlag = false
                        }
                        this.disablePersonalSaveBtn = tempFlag
                    //}

                    return true
                 },
                 showEducationButtons(){
                    // if(this.educationInfomation.Id != null && this.educationInfomation.Id != '') {
                    //     this.disableEducSaveBtn = false
                    // }
                    // else {
                        let tempFlag = false
                        let tempArrVal = []
                        let BoolCount = 0
                        if(this.educationInfomation.Documents){
                            this.educationInfomation.Documents.forEach((personalDocs ,pIndex) =>{
                                if(personalDocs.DocumentType != 'DegreeCerificates' && personalDocs.DocumentType != 'Certifications'){
                                    if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                        //this.disablePersonalSaveBtn = false
                                        var boolFlag = false
                                        tempArrVal.push(boolFlag)
                                    }else{
                                        if(personalDocs.IsDocumentNotAvailable == true){
                                            var boolCRFlag = false
                                            tempArrVal.push(boolCRFlag)
                                        }
                                        else {
                                            var boolTrueFlag = true
                                            tempArrVal.push(boolTrueFlag)
                                        }
                                    }
                                }
                            })

                           BoolCount  = (tempArrVal.filter(v => v).length);

                        }
                        if(BoolCount > 0){
                            tempFlag = true
                        }else{
                            tempFlag = false
                        }
                        this.disableEducSaveBtn = tempFlag
                    //}
                    return true
                 },
                  showEmploymentButtons(){
                    //   if(this.employmentInfomation.Id != null && this.employmentInfomation.Id != ''){
                    //       this.disableEmpSaveBtn = false
                    //   }
                    //   else {
                        this.updateDisableForEmploymentSave()
                      //}
                           return true

                 },

                 showImmigrationButtons(){
                     //
                     let tempFlag = false
                     let tempArrVal = []
                     let BoolCount = 0
                      if(this.immigrationInfomation.Documents){
                            this.immigrationInfomation.Documents.forEach((ImmigrantDocs ,pIndex) =>{
                                if(ImmigrantDocs.DocumentType != 'Visa') {
                                     if(ImmigrantDocs.MetadataValues && ImmigrantDocs.MetadataValues.length > 0){
                                     //this.disablePersonalSaveBtn = false
                                     var boolFlag = false
                                     tempArrVal.push(boolFlag)
                                        }else{
                                            var boolTrueFlag = true
                                            tempArrVal.push(boolTrueFlag)
                                        }
                                }


                            })

                           BoolCount  = (tempArrVal.filter(v => v).length);


                        }
                         if(BoolCount > 0){
                               tempFlag = true
                           }else{
                               tempFlag = false
                           }
                           if(this.ImmigrationInfo.i140Approval == 'Yes'){
                               this.immigrationInfomation.Documents.forEach((ImmigrantDocs ,pIndex) =>{
                                    if(ImmigrantDocs.DocumentType == 'ApprovedFormI140') {
                                        if(ImmigrantDocs.MetadataValues && ImmigrantDocs.MetadataValues.length > 0){
                                            this.disableImmigrationSaveBtn = false
                                        }else{
                                            this.disableImmigrationSaveBtn = tempFlag
                                        }
                                    }
                                })
                             //this.disableImmigrationSaveBtn = tempFlag
                           }else{
                             this.disableImmigrationSaveBtn = false
                           }

                           return true

                 },
                 showDpdntButtons(){
                     let tempFlag = false
                     let tempArrVal = []
                     let BoolCount = 0

                     if(this.dependentsArray.length > 0){
                     this.dependentsArray[0].Documents.forEach((depenDoc , mIndex) =>{
                         if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                             var boolFlag = false
                             tempArrVal.push(boolFlag)
                         }else{
                             var boolTrueFlag = true
                             tempArrVal.push(boolTrueFlag)
                         }
                          BoolCount  = (tempArrVal.filter(v => v).length);
                     })
                     }else{
                        this.disabledpdntSaveBtn = false
                     }

                         if(BoolCount > 0){
                               tempFlag = true
                           }else{
                               tempFlag = false
                           }
                           if(this.checkDependents == '1'){
                               if(this.dependentsArray.selectH4 == '1'){
                                   this.disabledpdntSaveBtn = tempFlag
                               }else{
                                   this.disabledpdntSaveBtn = false
                               }
                           }
                    //this.disabledpdntSaveBtn = false
                           return true
                 },
            },
            methods: {
                updateValue(modelName, value, index){
                  let val = namevalidation.getValidName(value);
                  if(modelName == "empName")
                    this.Employeeinfo.Name = value;
                  else if(modelName == "dFirstName")
                    this.dependentsArray[index].basicInfoObj.givenName = val
                  else if(modelName == "dLastName")
                    this.dependentsArray[index].basicInfoObj.familyName = val
                  else if(modelName == "dMiddleName")
                    this.dependentsArray[index].basicInfoObj.middleName = val
                  else if(modelName == "dMaidenName")
                    this.dependentsArray[index].basicInfoObj.maidenName = val
                  else if(modelName == "pFirstName")
                    this.personalInfoPrimaryContactFirstNameVal = val
                  else if(modelName == "pLastName")
                    this.personalInfoPrimaryContactLastNameVal = val
                  else if(modelName == "pMiddleName")
                    this.personalInfoPrimaryContactMiddleNameVal = val
                  else if(modelName == "otherFirstName")
                    this.addAnotherNameArray[index].OtherFirstName = val
                  else if(modelName == "otherLastName")
                    this.addAnotherNameArray[index].OtherLastName = val
                  else if(modelName == "otherMiddleName")
                    this.addAnotherNameArray[index].OtherMiddleName = val
                },
                updateDisableForEmploymentSave(){
                   let tempFlag = false
                    let tempArrVal = []
                    let BoolCount = 0
                    if(this.employmentInfomation.Documents){
                        // if(this.employmentInfomation.Documents.filter(x => x.DocumentType == 'I797A').length  > 0){
                        //     this.employmentInfomation.Documents.forEach((personalDocs ,pIndex) => {
                        //         if(personalDocs.DocumentType != 'I797A' && personalDocs.DocumentType != 'I797B' ){
                        //             if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                        //              //this.disablePersonalSaveBtn = false
                        //              var boolFlag = false
                        //              tempArrVal.push(boolFlag)
                        //                 }else{
                        //                     var boolTrueFlag = true
                        //                     tempArrVal.push(boolTrueFlag)
                        //                 }
                        //             }
                        //         })

                        //         BoolCount  = (tempArrVal.filter(v => v).length);
                        //         if(BoolCount > 0){
                        //             tempFlag = true
                        //         }else{
                        //             tempFlag = false
                        //         }
                        //         if(tempFlag == false){
                        //             this.employmentInfomation.Documents.forEach((personalDocs ,pIndex) => {
                        //                 if(personalDocs.DocumentType == 'I797A'){
                        //                     if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                        //                         tempFlag = false
                        //                     }else{
                        //                         tempFlag = true
                        //                     }
                        //                 }
                        //             })
                        //             if(tempFlag){
                        //                 this.employmentInfomation.Documents.forEach((personalDocs ,pIndex) => {
                        //                     if(personalDocs.DocumentType == 'I797B'){
                        //                         if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                        //                             tempFlag = false
                        //                         }else{
                        //                             tempFlag = true
                        //                         }
                        //                     }
                        //                 })
                        //             }
                        //         }
                        //     }
                            //else{
                               this.employmentInfomation.Documents.forEach((personalDocs ,pIndex) => {
                                    if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                        //this.disablePersonalSaveBtn = false
                                        var boolFlag = false
                                        tempArrVal.push(boolFlag)
                                    }else{
                                        if(personalDocs.IsDocumentNotAvailable == true){
                                            var boolCRFlag = false
                                            tempArrVal.push(boolCRFlag)
                                        }
                                        else {
                                            if(personalDocs.DocumentType == "DirectDeposit" && personalDocs.DirectDepositBankDetails != null && personalDocs.DirectDepositBankDetails.length >0){
                                                var boolCRFlag = false
                                                tempArrVal.push(boolCRFlag)
                                            }else{
                                                var boolTrueFlag = true
                                                tempArrVal.push(boolTrueFlag)
                                            }
                                        }
                                    }
                                })
                                BoolCount  = (tempArrVal.filter(v => v).length);
                                if(BoolCount > 0){
                                    tempFlag = true
                                }else{
                                    tempFlag = false
                                }
                            //}
                    }
                    this.disableEmpSaveBtn = tempFlag
                },
                onEndDateChange(index,e){
                    if(this.$refs.startdateRef != undefined && e.endDate != '' && this.$refs.startdateRef.length > 0){
                        var mindate = this.$refs.startdateRef[index].value
                        if(mindate == ''){
                            mindate = e.startDate
                         }
                    if (mindate != '')
                        this.$refs.enddateRef[index].data.minDate(mindate)
                        else
                        this.$refs.enddateRef[index].data.minDate(false)
                    }
                },
                onTravelDocumentExpiresDateChange(e){
                        var mindate = this.$refs.dateofDocumentIsuued.value
                    if(mindate == ''){
                        mindate = this.ImmigrationInfo.PassportIssueDate
                    }
                    if (mindate != ''){
                        this.$refs.dateofDocumentExpires.data.minDate(mindate)
                    }else{
                        this.$refs.dateofDocumentExpires.data.minDate(false)
                    }

                },
                onDependentPassportDateExpires(index,e){
                    if(this.$refs.dpdntpassportissued != undefined && e.passPortDetails.expirydate != '' && this.$refs.dpdntpassportissued.length > 0 && this.$refs.dpdntpassportissued[index]){
                        var mindate = this.$refs.dpdntpassportissued[index].value
                        if(mindate == ''){
                            mindate = e.passPortDetails.issueDate
                         }
                    if (mindate != '')
                        this.$refs.dpdntpassportexpired[index].data.minDate(mindate)
                        else
                        this.$refs.dpdntpassportexpired[index].data.minDate(false)
                    }
                },
                oni94EndDateChange(index,e){
                    if(this.$refs.i94startdateref != undefined && e.I94DetailsObj.i94EndDate != '' && this.$refs.i94startdateref.length > 0 && this.$refs.i94startdateref[index]){
                        var mindate = this.$refs.i94startdateref[index].value
                        if(mindate == ''){
                            mindate = e.I94DetailsObj.i94StartDate
                         }
                    if (mindate != '')
                        this.$refs.i94enddateref[index].data.minDate(mindate)
                        else
                        this.$refs.i94enddateref[index].data.minDate(false)
                    }
                },
                onlastarrivalDateChange(e) {
                  this.$refs.dateofStatusExpireDate.data.minDate(e.date)
                },
                onVisalastArrivalDateChange(e){
                    this.$refs.dateofVisaAdmitting.data.minDate(e.date)
                },
                onVisaAdmitUntilDateChange(e){
                    var mindate = this.$refs.visaLastArrivalDate.value
                    if(mindate == ''){
                        mindate = this.ImmigrationInfo.lastArrivalDate
                    }
                    if (mindate != ''){
                        this.$refs.dateofVisaAdmitting.data.minDate(mindate)
                    }else{
                        this.$refs.dateofVisaAdmitting.data.minDate(false)
                    }
                },
                onFromEntryDateChange(index,e){
                    if(this.$refs.exitUSdateRef != undefined && e.entryDate != '' && this.$refs.exitUSdateRef.length > 0){
                         var mindate = this.$refs.exitUSdateRef[index].value
                        if(mindate == ''){
                             mindate = e.exitDate
                        }
                        if (mindate != '')
                            this.$refs.entryUSdateRef[index].data.minDate(mindate)
                        else
                            this.$refs.entryUSdateRef[index].data.minDate(false)

                    }

                },
                SpouseOrChildDetailsDOB(e){
                //return moment(e.SpouseDetails.DOB).format("MM/DD/YYYY")
                let date = new Date(e.SpouseDetails.DOB)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                ExitfromUsStartDate(d){
                //return moment(d.StartDate).format("MM/DD/YYYY")
                let date = new Date(d.StartDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                ExitfromUsEndDate(d){
                //return moment(d.EndDate).format("MM/DD/YYYY")
                let date = new Date(d.EndDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                currentprevh1bOrL1StartDate(d){
                //return moment(d.StartDate).format("MM/DD/YYYY")
                let date = new Date(d.StartDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                currentprevh1bOrL1EndDate(d){
                //return moment(d.EndDate).format("MM/DD/YYYY")
                let date = new Date(d.EndDate)
                return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                },
                selectH4Dpdnt(v){
                    if(v == '1'){
                        this.isShowH4Dpdntdoc = true

                        if(this.dependentInformation != null && this.dependentInformation != '' && this.dependentInformation.length > 0){
                            this.dependentInformation.forEach((dependentDetails)=>{
                                dependentDetails.Documents.forEach((depenDoc) =>{
                                     if(depenDoc.DocumentType == 'MarriageCertificate' && dependentDetails.DependentType == 'Spouse') {
                                       this.disabledpdntSaveBtn = false
                                    }else{
                                        this.disabledpdntSaveBtn = true
                                    }
                                })
                            })

                        }else{
                            this.disabledpdntSaveBtn = true
                        }
                    }else{
                        this.isShowH4Dpdntdoc = false
                        this.disabledpdntSaveBtn = false
                    }
                },
                personalInformationESSData(){
                    //

                       if(this.personalInfomation.Id){
                            this.personalInfoId = this.personalInfomation.Id
                        }

                        if (this.personalInfomation.PrimaryContact.LastName != null) {
                            this.personalInfoPrimaryContactLastNameVal = this.personalInfomation.PrimaryContact.LastName
                        }
                        if (this.personalInfomation.PrimaryContact.FirstName != null) {
                            this.personalInfoPrimaryContactFirstNameVal = this.personalInfomation.PrimaryContact.FirstName
                        }
                        if (this.personalInfomation.PrimaryContact.MiddleName != null) {
                            this.personalInfoPrimaryContactMiddleNameVal = this.personalInfomation.PrimaryContact.MiddleName
                        }
                        if (this.personalInfomation.IsLegalContactAvailable != null) {
                            if (this.personalInfomation.IsLegalContactAvailable == true) {
                                this.PersonalInfoIsLegalContactAvailable = "Yes"
                            } else {
                                this.PersonalInfoIsLegalContactAvailable = "No"
                            }
                        }
                         this.addAnotherNameArray = []
                        if (this.personalInfomation.IsLegalContactAvailable && this.personalInfomation.LegalContacts != null) {
                            this.personalInfomation.LegalContacts.forEach((e) => {
                                if (e.FirstName != null || e.LastName != null || e.MiddleName != null) {
                                    // this.PersonalInfoLegalContactsFirstName = e.FirstName
                                    // this.PersonalInfoLegalContactsLastName = e.LastName
                                    // this.PersonalInfoLegalContactsMiddleName = e.MiddleName
                                    let anotherNameObj = {
                                        "OtherLastName": e.LastName,
                                        "OtherFirstName": e.FirstName,
                                        "OtherMiddleName": e.MiddleName,
                                    }
                                    this.addAnotherNameArray.push(anotherNameObj)
                                }
                            })
                        }
                        if (this.personalInfomation.PrimaryContact.MobileNo != null) {
                            this.personalInfoPrimaryContactMobileNoVal = this.personalInfomation.PrimaryContact.MobileNo
                        }
                        if (this.personalInfomation.PrimaryContact.Email != null) {
                            this.personalInfoPrimaryContactEmailVal = this.personalInfomation.PrimaryContact.Email
                        }
                        if (this.personalInfomation.PrimaryContact.DOB != null && this.personalInfomation.PrimaryContact.DOB != "0001-01-01T00:00:00") {
                            let date = new Date(this.personalInfomation.PrimaryContact.DOB)
                            this.personaInfoPrimaryContactDOB = (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear() //moment(this.personalInfomation.PrimaryContact.DOB)._d.toLocaleDateString() //moment(this.personalInfomation.PrimaryContact.DOB).format('MM/DD/YYYY')
                        }
                        if (this.personalInfomation.Gender != null) {
                            if (this.personalInfomation.Gender == "Male") {
                                this.PersonalInfoGender = "Male"

                            } else if (this.personalInfomation.Gender == "Female") {
                                this.PersonalInfoGender = "Female"

                            } else {
                                if (this.personalInfomation.Gender == "Choose not to disclose") {
                                    this.PersonalInfoGender = "Choose not to disclose"
                                }
                            }

                        }
                        if (this.personalInfomation.MaritalStatus != null) {
                            if (this.personalInfomation.MaritalStatus == "Single") {
                                this.personalInfoMaritalStatus = "Single"
                            } else if (this.personalInfomation.MaritalStatus == "Married") {
                                this.personalInfoMaritalStatus = "Married"
                            } else {
                                this.personalInfoMaritalStatus = "Divorced"
                            }
                        }
                        if (this.personalInfomation.BirthCountry != null) {
                            this.personalInfoBirthCountry = this.personalInfomation.BirthCountry
                        }
                        if (this.personalInfomation.ProvienceOfBirth != null) {
                            this.personalInfoProvienceOfBirth = this.personalInfomation.ProvienceOfBirth
                        }
                        if (this.personalInfomation.Nationality != null) {
                            this.personalInfoNationality = this.personalInfomation.Nationality
                        }
                        if (this.personalInfomation.PrimaryContact.SocialSecurtiyNumber != null) {
                            this.personalInfoPrimaryContactSocialSecurtiyNumber = this.personalInfomation.PrimaryContact.SocialSecurtiyNumber
                        }
                        if (this.personalInfomation.AlienNumber != null) {
                            this.personalInfoAlienNumber = this.personalInfomation.AlienNumber
                        }
                        if (this.personalInfomation.CurrentAddress.IsApt != null && this.personalInfomation.CurrentAddress.IsSuite != null && this.personalInfomation.CurrentAddress.IsFloor != null) {
                            if (this.personalInfomation.CurrentAddress.IsApt == true) {
                                this.personalInfoCurrentAddressAptORSteOrFlr = "Apt"
                            } else if (this.personalInfomation.CurrentAddress.IsSuite == true) {
                                this.personalInfoCurrentAddressAptORSteOrFlr = "Ste"
                            } else {
                                if (this.personalInfomation.CurrentAddress.IsFloor == true) {
                                    this.personalInfoCurrentAddressAptORSteOrFlr = "Flr"
                                }

                            }
                        }
                        if (this.personalInfomation.CurrentAddress.Address1 != null) {
                            this.personalInfoCurrentAddressStreetNo = this.personalInfomation.CurrentAddress.Address1
                        }
                        if (this.personalInfomation.CurrentAddress.AptNumber != null) {
                            this.personalInfoCurrentAddressAptNumber = this.personalInfomation.CurrentAddress.AptNumber
                        }
                        if (this.personalInfomation.CurrentAddress.AddressSummary != null) {
                            this.personalInfoCurrentAddressCity = this.personalInfomation.CurrentAddress.AddressSummary
                        }
                        if (this.personalInfomation.CurrentAddress.Zip != null) {
                            this.personalInfoCurrentAddressZip = this.personalInfomation.CurrentAddress.Zip
                        }
                        if (this.personalInfomation.ForeignAddress.IsApt != null && this.personalInfomation.ForeignAddress.IsSuite != null && this.personalInfomation.ForeignAddress.IsFloor != null) {
                            if (this.personalInfomation.ForeignAddress.IsApt == true) {
                                this.personalInfoForeignAddressAptORSteOrFlr = "Apt"
                            } else if (this.personalInfomation.ForeignAddress.IsSuite == true) {
                                this.personalInfoForeignAddressAptORSteOrFlr = "Ste"
                            } else {
                                if (this.personalInfomation.ForeignAddress.IsFloor == true) {
                                    this.personalInfoForeignAddressAptORSteOrFlr = "Flr"
                                }

                            }
                        }
                        if (this.personalInfomation.ForeignAddress.AptNumber != null) {
                            this.personalInfoForeignAddressAptNumber = this.personalInfomation.ForeignAddress.AptNumber
                        }
                        if (this.personalInfomation.ForeignAddress.Address1 != null) {
                            this.personalInfoForeignAddressStreetNo = this.personalInfomation.ForeignAddress.Address1
                        }
                        if (this.personalInfomation.ForeignAddress.AddressSummary != null) {
                            this.personalInfoForeignAddressCity = this.personalInfomation.ForeignAddress.AddressSummary
                        }
                        if (this.personalInfomation.ForeignAddress.Zip != null) {
                            this.personalInfoForeignAddressZip = this.personalInfomation.ForeignAddress.Zip
                        }
                        if (this.personalInfomation.ForeignAddress.Province != null) {
                            this.personalInfoForeignAddressProvince = this.personalInfomation.ForeignAddress.Province
                        }
                        if (this.personalInfomation.ForeignAddress.CountryCode != null) {
                            this.personalInfoForeignAddressCountryCode = this.personalInfomation.ForeignAddress.CountryCode
                        }
                        if (this.personalInfomation.ForeignAddress.County != null) {
                            this.personalInfoForeignAddressCounty = this.personalInfomation.ForeignAddress.County
                            if(this.personalInfoForeignAddressCounty != 'United States'){
                                this.personalInfoForeignAddressIndiaCity = this.personalInfomation.ForeignAddress.City
                                this.personalInfoForeignAddressIndiaState = this.personalInfomation.ForeignAddress.State
                            }
                        }

                },
                getEssRequestDetails(){
                this.$loading({ 'loadingText': 'Loading...' })
                 ajax.get(`H1BCheckList/GetH1BRequestedDocsInformation?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}`, {}, res => {
                    if (res.data.State == true) {
                        this.H1BCheckListData = res.data
                        this.personalInfomation = this.H1BCheckListData.PersonalInfomation
                        this.dependentInformation = this.H1BCheckListData.DependentInformation
                        this.personalInformationESSData()
                        this.BindingDependentInformationData()

                        this.educationInfomation = this.H1BCheckListData.EducationInfomation
                        // //Education docs count
                         if(this.educationInfomation.Id){
                            this.educationalInfoId = this.educationInfomation.Id
                        }
                        if(this.educationInfomation.EducationDetails.DegreeCompletedDate != null && this.educationInfomation.EducationDetails.DegreeCompletedDate!= "0001-01-01T00:00:00"){
                               let date = new Date(this.educationInfomation.EducationDetails.DegreeCompletedDate)
                              //var date =  moment(this.educationInfomation.EducationDetails.DegreeCompletedDate).format("MM/DD/YYYY");
                              var date1 =  (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                                this.educationinfo.Datedegree = date1
                            }

                        if(this.educationInfomation.EducationDetails.DegreeType != null && this.educationInfomation.EducationDetails.DegreeType != "0001-01-01T00:00:00"){
                            this.educationinfo.TypeofDegree = this.educationInfomation.EducationDetails.DegreeType
                        }
                        if(this.educationInfomation.EducationDetails.StudyCategory != null){
                            this.educationinfo.Majorfield = this.educationInfomation.EducationDetails.StudyCategory
                        }


                         if(this.educationInfomation.EducationDetails.InstituteName != null){
                            this.educationinfo.Nameofinstitution = this.educationInfomation.EducationDetails.InstituteName
                        }
                    //     // if(this.educationInfomation.EducationDetailsDocURL != null){

                    //         this.educationDetailsDocURL = this.educationInfomation.EducationDetailsDocURL
                    //    // }
                        if(this.educationInfomation.IsMasterDegree == true)
                        {
                           this.compreset++
                           this.educationinfo.appeareYes = "Yes"
                           this.Opendegree = true
                        }
                        else
                        {
                            this.educationinfo.appeareNo = "No"

                        }
                        if(this.educationInfomation.HigherEducationDetails.DegreeCompletedDate != null && this.educationInfomation.HigherEducationDetails.DegreeCompletedDate!= "0001-01-01T00:00:00"){
                                 let date = new Date(this.educationInfomation.HigherEducationDetails.DegreeCompletedDate)

                              //var date =  moment(this.educationInfomation.EducationDetails.DegreeCompletedDate).format("MM/DD/YYYY");
                              var date11 =  (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                                //var date =  moment(this.educationInfomation.HigherEducationDetails.DegreeCompletedDate).format("MM/DD/YYYY");
                                this.educationinfo.yesDatedegree = date11
                            }
                            if(this.educationInfomation.HigherEducationDetails.DegreeType != null){
                            this.educationinfo.yesTypeofDegree = this.educationInfomation.HigherEducationDetails.DegreeType
                        }
                         if(this.educationInfomation.HigherEducationDetails.StudyCategory != null){
                            this.educationinfo.yesMajorfield = this.educationInfomation.HigherEducationDetails.StudyCategory
                        }
                        if(this.educationInfomation.HigherEducationDetails.InstituteName != null){
                            this.educationinfo.yesNameofinstitution = this.educationInfomation.HigherEducationDetails.InstituteName
                        }
                        if(this.educationInfomation.IsEducationDetails != null){
                            if(this.educationInfomation.IsEducationDetails == true){
                                this.educationinfo.mastersDegreeVal = "Yes"
                                this.isShowMastersDegree = true
                            }else{
                                this.educationinfo.mastersDegreeVal = "No"
                                this.isShowMastersDegree = false
                            }
                        }
                        //  if(this.educationInfomation.HigherEducationDetailsDocURL != null){

                        //     this.higherEducationDetailsDocURL = this.educationInfomation.HigherEducationDetailsDocURL
                        // }

                            if (this.educationInfomation.Documents != null) {
                                this.educationInfomation.Documents.forEach((doc) => {
                                    if (doc.DocumentType == 'DegreeCerificates') {
                                        if (doc.MetadataValues.length > 0) {
                                            doc.MetadataValues[0].DocumentData.forEach((f) => {
                                                if (f.Key == 'DocumentUrl') {
                                                    this.educationDetailsDocURL = f.Value
                                                }
                                            })
                                        } else
                                            this.educationDetailsDocURL = ""
                                    }
                                    else if(doc.DocumentType == 'Certifications') {
                                        if (doc.MetadataValues.length > 0) {
                                            doc.MetadataValues[0].DocumentData.forEach((f) => {
                                                if (f.Key == 'DocumentUrl') {
                                                    this.higherEducationDetailsDocURL = f.Value
                                                }
                                            })
                                        } else if(doc.DocumentType == 'HighestDegreeCertificate') {
                                        if (doc.MetadataValues.length > 0) {
                                          // this.disableEmpSaveBtn = false
                                        }
                                    }
                                        else
                                            this.higherEducationDetailsDocURL = ""
                                    } else if(doc.DocumentType != 'Certifications' && doc.DocumentType != 'DegreeCerificates'){
                                        //if (doc.MetadataValues.length > 0){
                                            this.isShowEducationalandTrainingDocs = true
                                       // }
                                    }
                                })
                            }



                        if(this.educationInfomation.Address.Address1 != null){
                            this.educationinfo.Street = this.educationInfomation.Address.Address1
                        }
                        if(this.educationInfomation.Address.AptNumber != null){
                            this.educationinfo.BuildingNumber = this.educationInfomation.Address.AptNumber
                        }
                        if (this.educationInfomation.Address.IsApt != null && this.educationInfomation.Address.IsSuite != null && this.educationInfomation.Address.IsFloor != null) {
                            if (this.educationInfomation.Address.IsApt == true) {
                                this.educationinfo.Selectedapt = "ap3"
                                this.educationinfo.Selectedste = ""
                                this.educationinfo.Selectedflr = ""
                            } else if (this.educationInfomation.Address.IsSuite == true) {
                                this.educationinfo.Selectedapt = ""
                                this.educationinfo.Selectedste = "st4"
                                this.educationinfo.Selectedflr = ""
                            } else if (this.educationInfomation.Address.IsFloor == true) {
                                this.educationinfo.Selectedapt = ""
                                this.educationinfo.Selectedste = ""
                                this.educationinfo.Selectedflr = "fl4"
                            }
                        }

                        if(this.educationInfomation.Address.Zip != null){
                            this.educationinfo.zipcode = this.educationInfomation.Address.Zip
                        }

                        if(this.educationInfomation.Address.AddressSummary != null){
                            this.educationinfo.currentCity = this.educationInfomation.Address.AddressSummary
                        }

                        //Employment Info Binding
                        this.employmentInfomation = this.H1BCheckListData.EmploymentInfomation
                        // //Education docs count

                         if(this.employmentInfomation.Id){
                            this.employmentInfoId = this.employmentInfomation.Id
                         }
                         if (this.employmentInfomation.EmployerName != null){
                            this.Employeeinfo.Name = this.employmentInfomation.EmployerName
                         }

                         if(this.employmentInfomation.Address.AptNumber != null){
                            this.Employeeinfo.empBuildingNumber = this.employmentInfomation.Address.AptNumber
                         }
                         if(this.employmentInfomation.Address.AddressSummary != null){
                            this.Employeeinfo.empcurrentCity = this.employmentInfomation.Address.AddressSummary
                         }
                         if(this.employmentInfomation.Address.Address1 != null){
                            this.Employeeinfo.empStreet = this.employmentInfomation.Address.Address1
                         }
                          if (this.employmentInfomation.Address.IsApt  != null && this.employmentInfomation.Address.IsSuite != null && this.employmentInfomation.Address.IsFloor != null) {
                            if (this.employmentInfomation.Address.IsApt == true) {
                                //this.Employeeinfo.buildApt = "apt2"
                                this.Employeeinfo.buildType = "apt2"
                            } else if (this.employmentInfomation.Address.IsSuite == true) {
                                //this.Employeeinfo.buildSte = "Ste"
                                this.Employeeinfo.buildType = "ste2"
                            } else {
                                if (this.employmentInfomation.Address.IsFloor == true) {
                                    //this.Employeeinfo.buildFlr = "Flr"
                                    this.Employeeinfo.buildType = "flr2"
                                }
                             }
                             }
                       if(this.employmentInfomation.IsAddress != null){
                       if(this.employmentInfomation.IsAddress == true){
                           this.Employeeinfo.empAddressVal = 'Yes'
                           this.isShowEmpAddress = true
                       }else{
                           this.Employeeinfo.empAddressVal = 'No'
                           this.isShowEmpAddress = false

                       }
                       }
                       if(this.employmentInfomation.Address.Zip != null){
                       this.Employeeinfo.empzipcode = this.employmentInfomation.Address.Zip
                       }
                       if(this.employmentInfomation.LayerDetails != null){
                            this.clientsList = []
                            this.clientsList = this.employmentInfomation.LayerDetails
                            this.dataDetails = this.employmentInfomation.LayerDetails
                            // //this.vendorsList = []
                            // this.employmentInfomation.LayerDetails.forEach((e) => {
                            //     if (e.OrganizationName != null && e.Website != null) {
                            //         if(e.Type == "Client"){
                            //             var client = {
                            //             "OrganizationName" :e.OrganizationName != null && e.OrganizationName != '' ? e.OrganizationName : "N/A",
                            //             "website": e.Website != null && e.Website != '' ? e.Website : "N/A",
                            //             "type" : e.Type
                            //             }
                            //             this.clientsList.push(client)

                            //         }
                            //         // if(e.Type == "Vendor"){
                            //         //     var client = {
                            //         //     "vendorOrganizationName" :e.OrganizationName != null && e.OrganizationName != '' ? e.OrganizationName : "N/A",
                            //         //     "vendorWebsite": e.Website != null && e.Website != '' ? e.Website : "N/A",
                            //         //     "type" : e.Type
                            //         //     }
                            //         //     this.vendorsList.push(client)
                            //         // }
                            //         if(e.Type == "EndClient") {
                            //             this.EndClient.OrganizationName = e.OrganizationName != null && e.OrganizationName != '' ? e.OrganizationName : "N/A",
                            //             this.EndClient.website = e.Website != null && e.Website != '' ? e.Website : "N/A",
                            //             this.EndClient.type = e.Type

                            //         }
                            //     }
                            // })
                            // this.candidatesOrgName = this.employmentInfomation.candidateOrgName
                        }else{
                            this.clientsList = []
                            //this.vendorsList = []
                             var endClient = {
                                 "IsEdit":false,
                            "OrganizationName" : this.employmentInfomation.EndClientOrganizationName != '' && this.employmentInfomation.EndClientOrganizationName != null ? this.employmentInfomation.EndClientOrganizationName : "N/A",
                            "website": "N/A",
                            "Type" : "EndClient"
                            }
                            this.clientsList.push(endClient)
                            var client = {
                                 "IsEdit":true,
                            "OrganizationName" : this.employmentInfomation.ClientOrganizationName != '' && this.employmentInfomation.ClientOrganizationName != null ? this.employmentInfomation.ClientOrganizationName : "N/A",
                            "website": this.employmentInfomation.ClientOrganizationWebsite != '' && this.employmentInfomation.ClientOrganizationWebsite != null ? this.employmentInfomation.ClientOrganizationWebsite : "N/A",
                            "Type" : "Client"
                            }
                            this.clientsList.push(client)
                            var typeSelf ={
                                "IsEdit":false,
                            "OrganizationName" : this.employmentInfomation.candidateOrgName,
                            "website": this.employmentInfomation.ClientOrganizationWebsite != '' && this.employmentInfomation.ClientOrganizationWebsite != null ? this.employmentInfomation.ClientOrganizationWebsite : "N/A",
                            "Type" : "Self"

                            }
                            this.clientsList.push(typeSelf)


                            // var client = {
                            // "vendorOrganizationName" :this.employmentInfomation.VendorOrganizationName != '' && this.employmentInfomation.VendorOrganizationName != null ? this.employmentInfomation.VendorOrganizationName : "N/A",
                            // "vendorWebsite": this.employmentInfomation.VendorOrganizationWebsite != '' && this.employmentInfomation.VendorOrganizationWebsite != null ? this.employmentInfomation.VendorOrganizationWebsite : "N/A",
                            // "type" : "Vendor"
                            // }
                            // this.vendorsList.push(client)

                           // this.EndClient.OrganizationName = this.employmentInfomation.EndClientOrganizationName != '' && this.employmentInfomation.EndClientOrganizationName != null ? this.employmentInfomation.EndClientOrganizationName : "N/A"
                           // this.EndClient.website = "N/A"

                            this.candidatesOrgName = this.employmentInfomation.candidateOrgName

                        }
                    //     if(this.employmentInfomation.LayerDetails != null){
                    //     this.employmentInfomation.LayerDetails.forEach((e) => {
                    //             if (e.OrganizationName != null && e.Website  != null && e.Type == "Client") {
                    //                 this.clientsList.OrganizationName = e.OrganizationName
                    //                 this.clientsList.website = e.Website
                    //                 this.clientsList.type = e.Type
                    //             }
                    //         })
                    //    }
                    //   if(this.employmentInfomation.LayerDetails != null){
                    //     this.employmentInfomation.LayerDetails.forEach((e) => {
                    //            if (e.OrganizationName != null && e.Website  != null && e.Type == "Vendor") {
                    //                 this.vendorsList.vendorOrganizationName = e.OrganizationName
                    //                 this.vendorsList.vendorWebsite = e.Website
                    //                 this.vendorsList.type = e.Type

                    //             }
                    //         })
                    //    }
                     this.immigrationInfomation = this.H1BCheckListData.ImmigrationInfomation
                       if(this.immigrationInfomation.I94Number != null){
                                this.ImmigrationInfo.recordNumber = this.immigrationInfomation.I94Number
                            }
                            if(this.immigrationInfomation.LastArrivalDate != null && this.immigrationInfomation.LastArrivalDate != "0001-01-01T00:00:00"){
                                let date = new Date(this.immigrationInfomation.LastArrivalDate)

                              var date11 =  (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                                //var date =  moment(this.immigrationInfomation.LastArrivalDate).format("MM/DD/YYYY");
                                if(date11 == '01/01/0001'){
                                    this.ImmigrationInfo.immLastArrivalDate = ''
                                }else{
                                    this.ImmigrationInfo.immLastArrivalDate = date11
                                }
                            }
                            if(this.immigrationInfomation.NonImmigrantStatus != null){
                                this.ImmigrationInfo.nonimmigrantStatus = this.immigrationInfomation.NonImmigrantStatus
                            }
                            if(this.immigrationInfomation.StatusExpiresDate != null && this.immigrationInfomation.LastArrivalDate != "0001-01-01T00:00:00"){
                                 let date = new Date(this.immigrationInfomation.StatusExpiresDate)

                              var statudate =  (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' +  date.getUTCFullYear()
                               // var statudate = moment(this.immigrationInfomation.StatusExpiresDate).format("MM/DD/YYYY")
                                if(statudate == '01/01/0001'){
                                    this.ImmigrationInfo.StatusExpDate = ''
                                }else{
                                    this.ImmigrationInfo.StatusExpDate = statudate
                                }
                            }
                            if(this.immigrationInfomation.SEVISNumber != null){
                                this.ImmigrationInfo.SEVISNumber = this.immigrationInfomation.SEVISNumber
                            }
                            if(this.immigrationInfomation.EADNumber != null){
                                this.ImmigrationInfo.EADNumber = this.immigrationInfomation.EADNumber
                            }
                            if(this.immigrationInfomation.IsOutsideUS != null){
                                if(this.immigrationInfomation.IsOutsideUS == true){
                                    this.ImmigrationInfo.visible = 'Yes'
                                    this.isactiveYes(1)
                                }else{
                                    this.ImmigrationInfo.visible = 'No'
                                    this.isactiveNo(1)
                                }
                            }
                           if(this.immigrationInfomation.EntryExitDetails != null){
                                if(this.immigrationInfomation.EntryExitDetails.length > 0){
                                    this.ImmigrationInfo.outofStates = 'Yes'
                                     this.isactiveYes(2)
                                     this.immigrationInfomation.EntryExitDetails.forEach((e, index) => {
                                        if (e.StartDate != null && e.EndDate  != null) {

                                             let tempStrtdate = new Date(e.StartDate)
                                             var formattedStrtDate =  (tempStrtdate.getUTCMonth() + 1) + '/' + tempStrtdate.getUTCDate() + '/' +  tempStrtdate.getUTCFullYear()

                                            let tempEnddate = new Date(e.EndDate)
                                             var formattedEndDate =  (tempEnddate.getUTCMonth() + 1) + '/' + tempEnddate.getUTCDate() + '/' +  tempEnddate.getUTCFullYear()

                                            if(index == 0) {
                                                this.addAnotherStayArray[0].entryDate = formattedStrtDate == '01/01/0001' ? '' : formattedStrtDate
                                                this.addAnotherStayArray[0].exitDate = formattedEndDate == '01/01/0001' ? '' : formattedEndDate
                                            }
                                            else {
                                                if(formattedStrtDate != '01/01/0001' && formattedEndDate != '01/01/0001') {
                                                    var immgObj = {
                                                        "entryDate" : formattedStrtDate == '01/01/0001' ? '' : formattedStrtDate,
                                                        "exitDate" : formattedEndDate == '01/01/0001' ? '' : formattedEndDate
                                                    }
                                                    this.addAnotherStayArray.push(immgObj)
                                                }
                                            }
                                        }
                                    })
                                }else{
                                    this.ImmigrationInfo.outofStates = 'No'
                                     this.isactiveNo(2)
                                }
                                // this.immigrationInfomation.EntryExitDetails.forEach((e) => {
                                //     if (e.StartDate != null && e.EndDate  != null) {
                                //         this.addAnotherStayArray.entry = e.StartDate
                                //         this.addAnotherStayArray.exit = e.EndDate
                                //     }
                                // })
                            }
                            if(this.immigrationInfomation.IsPreviousApproval != null){
                                if(this.immigrationInfomation.IsPreviousApproval == true){
                                    this.ImmigrationInfo.h1bApproval = 'Yes'
                                    this.isactiveYes(3)
                                }else{
                                    this.ImmigrationInfo.h1bApproval = 'No'
                                    this.isactiveNo(3)
                                }

                            }
                            if(this.immigrationInfomation.ApprovalsData != null){
                                this.immigrationInfomation.ApprovalsData.forEach((e, index) => {
                                    if(e.StartDate != null && e.EndDate  != null && e.CompanyName != null && e.DocumentNumber != null){
                                          let tempStrtdate1 = new Date(e.StartDate)
                                             var formattedStrtDate1 =  (tempStrtdate1.getUTCMonth() + 1) + '/' + tempStrtdate1.getUTCDate() + '/' +  tempStrtdate1.getUTCFullYear()

                                            let tempEnddate1 = new Date(e.EndDate)
                                             var formattedEndDate1 =  (tempEnddate1.getUTCMonth() + 1) + '/' + tempEnddate1.getUTCDate() + '/' +  tempEnddate1.getUTCFullYear()
                                        if(index == 0) {
                                            this.addAnotherApprovalArray[0].startDate = formattedStrtDate1 == '01/01/0001'   ? '' : formattedStrtDate1
                                            this.addAnotherApprovalArray[0].endDate = formattedEndDate1 == '01/01/0001' ? '' : formattedEndDate1
                                            this.addAnotherApprovalArray[0].compName = e.CompanyName
                                            this.addAnotherApprovalArray[0].h1orl1approval = e.DocumentNumber
                                        }
                                        else
                                        {
                                            var immgObj = {
                                                "startDate" : formattedStrtDate1 == '01/01/0001' ? '' : formattedStrtDate1,
                                                "endDate" : formattedEndDate1 == '01/01/0001' ? '' : formattedEndDate1,
                                                "compName" : e.CompanyName != null ? e.CompanyName : '',
                                                "h1orl1approval" : e.DocumentNumber != null ? e.DocumentNumber : '',

                                            }
                                            this.addAnotherApprovalArray.push(immgObj)
                                        }
                                    }
                                })
                            }
                            if(this.immigrationInfomation.IsApprovedI140 != null){
                                if(this.immigrationInfomation.IsApprovedI140 == true && this.immigrationInfomation.Documents.length > 0){
                                    this.ImmigrationInfo.i140Approval = 'Yes'
                                    this.isactiveYes(4)
                                }else{
                                    this.ImmigrationInfo.i140Approval = 'No'
                                    this.isactiveNo(4)
                                }
                            }
                            if(this.immigrationInfomation.Documents.length > 0){
                                this.immigrationInfomation.Documents.forEach((e) => {
                                    if(e.MetadataValues.length > 0){
                                         if(e.DocumentType == 'Passport'){
                                        e.MetadataValues.forEach((g) =>{
                                             g.DocumentData.forEach((f) =>{
                                                  if(f.Key == 'DocumentNumber'){
                                                this.ImmigrationInfo.docNumber = f.Value
                                            }
                                            if(f.Key == 'IssuingAuthority'){
                                                this.ImmigrationInfo.Country = f.Value
                                            }
                                            if(f.Key == 'IssueDate'){
                                                this.ImmigrationInfo.PassportIssueDate = f.Value
                                            }
                                            if(f.Key == 'ExpiryDate'){
                                                this.ImmigrationInfo.PassportExpireDate = f.Value
                                            }
                                            if(f.Key == 'DocumentUrl'){
                                                this.immigrationPassportDocURL = f.Value
                                            }

                                             })
                                        })

                                    }
                                    if(e.DocumentType == 'Visa'){
                                        //
                                        var visaNa = '';
                                        e.MetadataValues.forEach((g) => {
                                             g.DocumentData.forEach((f) => {
                                                 if(f.Key == 'Name'){
                                                    //
                                                   if(this.checkvisaName(f.Value) == true)
                                                   {

                                                    this.ImmigrationInfo.visaStatus = f.Value
                                                   }
                                                   else
                                                   {
                                                    this.ImmigrationInfo.otherVisaName = f.Value
                                                    this.ImmigrationInfo.visaStatus = "Others"
                                                   }
                                                //
                                            }
                                            if(f.Key == 'IssueDate'){
                                                this.ImmigrationInfo.lastArrivalDate = f.Value
                                            }
                                            if(f.Key == 'ExpiryDate'){
                                                this.ImmigrationInfo.admitUntil = f.Value
                                            }
                                            if(f.Key == 'DocumentUrl'){
                                                this.immigrationVisaDocURL = f.Value
                                            }
                                            if(f.Key == 'Others'){
                                                if(f.Value == true)
                                                this.ImmigrationInfo.visaStatus = 'Others'
                                                else
                                                this.ImmigrationInfo.visaStatus = visaNa
                                            }
                                             })

                                        })
                                    }
                                    if(e.DocumentType == 'ApprovedFormI140' && e.IsApprovedI140 == true){
                                        e.MetadataValues.forEach( (f) => {
                                            f.DocumentData.forEach( (g) => {
                                                if(g.Key == 'DocumentUrl'){
                                                    this.immigrationI140DocURL = f.Value
                                                }
                                            })
                                        })

                                    }

                                    }
                                })
                            }
                        this.dependentInformation = this.H1BCheckListData.DependentInformation
                        this.approverInformation = this.H1BCheckListData.ApproverInformation
                        if(this.approverInformation.length > 0){
                            this.approverInformation.forEach((d)=>{
                                if(d.ReviewStatus != null && d.ReviewStatus.length > 0){
                                    d.ReviewStatus.forEach((e) => {
                                        var reviewStatusData = {
                                            "Comments" : e.Comments,
                                            "Status" : e.Status,
                                            "CreatedDateTime" : e.CreatedDateTime,
                                            "TabType" : e.TabType,
                                        }
                                        this.reviewStatusCommentsData.push(reviewStatusData)
                                    })
                                }
                            })
                        }
                        if(this.$route.query.Status == 'InComplete'){
                             this.checkIncompleteTabType()
                        }
                    }
                    else {
                        this.$loading({}).close()
                            if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                this.isShowWarningMsgPopup = true
                                this.warningContent = res.data.WarningMessage
                            }
                            else {
                                 this.$message({
                                type: 'error',
                                    message: res.data.Message
                                })

                            }
                    }

                   this.$loading({}).close()
                })
                },
                checkIncompleteTabType(){
                    if(this.H1BCheckListData.ESSIncompleteTabType == 'Personal'){
                         this.OpeneducationalInfoForm = true
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=true
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=false
                         this.showDependentApproveOrRejectComments=false

                    }
                     else if(this.H1BCheckListData.ESSIncompleteTabType == 'Education'){
                         this.OpenemploymentinfoForm = true
                        this.showPersonalApproveOrRejectComments = false
                        this.showEducationalApproveOrRejectComments=false
                        this.showEmploymentApproveOrRejectComments=true
                        this.showImmigrationApproveOrRejectComments=false
                        this.showDependentApproveOrRejectComments=false

                    }
                     else if(this.H1BCheckListData.ESSIncompleteTabType == 'Employment'){
                         this.OpenimmigrationinfoForm = true
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=false
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=true
                         this.showDependentApproveOrRejectComments=false

                    }
                    else if(this.H1BCheckListData.ESSIncompleteTabType == 'Immigration'){
                        this.OpendependentInfoForm = true
                        this.showPersonalApproveOrRejectComments = false
                        this.showEducationalApproveOrRejectComments=false
                        this.showEmploymentApproveOrRejectComments=false
                        this.showImmigrationApproveOrRejectComments=false
                        this.showDependentApproveOrRejectComments=true

                    }
                    else if(this.H1BCheckListData.ESSIncompleteTabType == 'Dependent'){
                            this.OpenpreviewForm = true
                            this.showgreenImmicon = true
                            this.showgreenDepicon = true
                            this.showDependentApproveOrRejectComments = false
                            this.showPersonalApproveOrRejectComments = false
                            this.showEducationalApproveOrRejectComments=false
                            this.showEmploymentApproveOrRejectComments=false
                            this.showImmigrationApproveOrRejectComments=false
                            this.showDependentApproveOrRejectComments=false

                    }

                },
                uploadComplete(v) {

                if (v[0].response.Url != null){

                    this.educationDetailsDocURL = v[0].response.Url
                }
         },
          uploadImmigrationPassport(v) {
                if (v[0].response.Url != null){
                    this.immigrationPassportDocURL = v[0].response.Url
                }
         },
         uploadImmigrationVisa(v) {
                if (v[0].response.Url != null){
                    this.immigrationVisaDocURL = v[0].response.Url
                }
         },
         removeImmigrationPassport(){
               this.immigrationPassportDocURL = ''
         },
         removeImmigrationVisa(){
               this.immigrationVisaDocURL = ''
         },
         removeEducationDocDetails(){
             this.educationDetailsDocURL = ''
         },
         removehigherEducationDetailsDocURL(){
             this.higherEducationDetailsDocURL = ''
         },
         updatePassportDocsForDepen(index, v){
             if (v[0].response.Url != null){
             this.dependentsArray[index].passPortDetails.documentUrl = v[0].response.Url
             }

         },
          updateVisaDocsForDepen(index, v){
             if (v[0].response.Url != null){
             this.dependentsArray[index].visaDetailsObj.documentUrl = v[0].response.Url
             }

         },
          updateI94DocsForDepen(index, v){
             if (v[0].response.Url != null){
             this.dependentsArray[index].I94DetailsObj.documentUrl = v[0].response.Url
             }

         },
            BindingDependentInformationData(){
                //
                this.dependentsArray = []

                    this.dependentInformation.forEach((dependentDetails,dIndex)=>{
                        if(dependentDetails.IsAnyDependent == true){
                            this.checkDependents = '1'
                        }else{
                            this.checkDependents = '2'
                        }
                           let tempAptRadio = ''
                           let tempForeignAptRadio = ''
                           let docsArray = []
                           let sampleArrObj = []
                           let tempMarriageDocObj = {}
                           let tempFormI539DocObj = {}
                           let tempBirthCertificateDocObj = {}
                        if(dependentDetails.SpouseAddress.IsApt){
                                tempAptRadio = 'Apt'
                        }else if(dependentDetails.SpouseAddress.IsSuite){
                                 tempAptRadio = 'Ste'
                        }else if(dependentDetails.SpouseAddress.IsFloor){
                                    tempAptRadio = 'Flr'
                        }

                        if(dependentDetails.SpouseForeignAddress.IsApt){
                                tempForeignAptRadio = 'Apt'
                        }else if(dependentDetails.SpouseForeignAddress.IsSuite){
                                 tempForeignAptRadio = 'Ste'
                        }else if(dependentDetails.SpouseForeignAddress.IsFloor){
                                tempForeignAptRadio = 'Flr'
                        }

                        let tempIsH4DependentFlag = '2'

                        if(dependentDetails.IsAnyDependent){
                            dependentDetails.Documents.forEach((depenDoc , mIndex) =>{
                                if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                    if(depenDoc.DocumentType == 'MarriageCertificate' && dependentDetails.DependentType == 'Spouse') {
                                        depenDoc.Message = dependentDetails.DependentType+' ('+dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName+')'
                                    //    depenDoc.Message  = dependentDetails.SpouseDetails.FirstName+' '+dependentDetails.SpouseDetails.LastName
                                    //    depenDoc.DependentDocumentCategory = dependentDetails.DependentType
                                        docsArray.push(depenDoc)
                                        if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                             tempIsH4DependentFlag = '1'
                                             let obj1 ={
                                                 'docType': depenDoc.DocumentType
                                             }
                                             sampleArrObj.push(obj1)
                                       }else{
                                             tempIsH4DependentFlag = '2'
                                       }
                                       this.selectH4Dpdnt(tempIsH4DependentFlag)
                                    }
                                    if( depenDoc.DocumentType == 'FormI539' && dependentDetails.DependentType == 'Spouse') {
                                         depenDoc.Message = dependentDetails.DependentType+' ('+dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName+')'
                                    //       depenDoc.Message  = dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName
                                    //    depenDoc.DependentDocumentCategory = dependentDetails.DependentType
                                        docsArray.push(depenDoc)
                                    }
                                    if(  depenDoc.DocumentType == 'BirthCertificate' && dependentDetails.DependentType == 'Child') {
                                         depenDoc.Message = dependentDetails.DependentType+' ('+dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName+')'
                                    //      depenDoc.Message  = dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName
                                    //    depenDoc.DependentDocumentCategory = dependentDetails.DependentType
                                        docsArray.push(depenDoc)
                                         if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                             tempIsH4DependentFlag = '1'
                                             let obj1 ={
                                                 'docType': depenDoc.DocumentType
                                             }
                                             sampleArrObj.push(obj1)
                                       }else{
                                             tempIsH4DependentFlag = '2'
                                       }
                                       this.selectH4Dpdnt(tempIsH4DependentFlag)
                                    }
                                    if(depenDoc.DocumentType == 'Passport' && dependentDetails.DependentType == 'Spouse'){
                                         depenDoc.Message = dependentDetails.DependentType+' ('+dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName+')'
                                    //      depenDoc.Message  = dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName
                                    //    depenDoc.DependentDocumentCategory = dependentDetails.DependentType
                                        docsArray.push(depenDoc)
                                    }
                                    // if(depenDoc.DocumentType == 'Visa' && dependentDetails.DependentType == 'Spouse'){
                                    //      depenDoc.Message = dependentDetails.DependentType
                                    //         docsArray.push(depenDoc)
                                    // }
                                    if(depenDoc.DocumentType == 'I94' && dependentDetails.DependentType == 'Spouse'){
                                         depenDoc.Message = dependentDetails.DependentType+' ('+dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName+')'
                                    //      depenDoc.Message  = dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName
                                    //    depenDoc.DependentDocumentCategory = dependentDetails.DependentType
                                            docsArray.push(depenDoc)
                                    }

                                    if(depenDoc.DocumentType == 'Passport' && dependentDetails.DependentType == 'Child'){
                                    //    depenDoc.Message  = dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName
                                    //    depenDoc.DependentDocumentCategory = dependentDetails.DependentType
                                        docsArray.push(depenDoc)
                                    }
                                    if(depenDoc.DocumentType == 'I94' && dependentDetails.DependentType == 'Child'){
                                         depenDoc.Message = dependentDetails.DependentType+' ('+dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName+')'
                                    //      depenDoc.Message  = dependentDetails.SpouseDetails.FirstName+ ' '+dependentDetails.SpouseDetails.LastName
                                    //    depenDoc.DependentDocumentCategory = dependentDetails.DependentType
                                            docsArray.push(depenDoc)
                                    }
                                }

                                //   if(depenDoc.DocumentType == 'MarriageCertificate' && dependentDetails.DependentType == 'Spouse'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //     //   else{
                                //     //      tempMarriageDocObj =  {
                                //     //         "Group": "DependentDocuments",
                                //     //         "DocumentType": "MarriageCertificate",
                                //     //         "DisplayName": "Marriage Certificate",
                                //     //         "UploadMultiple": false,
                                //     //         "CanESign": false,
                                //     //         "EntityType": 0,
                                //     //         "CanBeApproved": true,
                                //     //         "DocumentStatus": "Initiate",
                                //     //         "Metadata": [{
                                //     //                 "DataType": "System.String",
                                //     //                 "Key": "DocumentUrl",
                                //     //                 "DisplayName": "Document Url",
                                //     //             },

                                //     //         ],
                                //     //         "MetadataValues": []
                                //     //     }

                                //     //     docsArray.push(tempMarriageDocObj)
                                //     //  }
                                //   }
                                //   if( depenDoc.DocumentType == 'FormI539' && dependentDetails.DependentType == 'Spouse'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //     //   else{

                                //     //     tempFormI539DocObj =  {
                                //     //         "Group": "DependentDocuments",
                                //     //         "DocumentType": "FormI539",
                                //     //         "DisplayName": "Form I-539",
                                //     //         "UploadMultiple": false,
                                //     //         "CanESign": false,
                                //     //         "EntityType": 0,
                                //     //         "CanBeApproved": true,
                                //     //         "DocumentStatus": "Initiate",
                                //     //         "Metadata": [{
                                //     //                 "DataType": "System.String",
                                //     //                 "Key": "DocumentUrl",
                                //     //                 "DisplayName": "Document Url",
                                //     //             },

                                //     //         ],
                                //     //         "MetadataValues": []
                                //     //     }
                                //     //     docsArray.push(tempFormI539DocObj)
                                //     //   }
                                //   }
                                //   if(depenDoc.DocumentType == 'Passport' && dependentDetails.DependentType == 'Spouse'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //   }
                                //   if(depenDoc.DocumentType == 'Visa' && dependentDetails.DependentType == 'Spouse'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //   }
                                //   if(depenDoc.DocumentType == 'I94' && dependentDetails.DependentType == 'Spouse'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //   }


                                //   if(  depenDoc.DocumentType == 'BirthCertificate' && dependentDetails.DependentType == 'Child'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //     //   else{

                                //     //      tempBirthCertificateDocObj =  {
                                //     //         "Group": "DependentDocuments",
                                //     //         "DocumentType": "BirthCertificate",
                                //     //         "DisplayName": "Birth Certificate",
                                //     //         "UploadMultiple": false,
                                //     //         "CanESign": false,
                                //     //         "EntityType": 0,
                                //     //         "CanBeApproved": true,
                                //     //         "DocumentStatus": "Initiate",
                                //     //         "Metadata": [{
                                //     //                 "DataType": "System.String",
                                //     //                 "Key": "DocumentUrl",
                                //     //                 "DisplayName": "Document Url",
                                //     //             },

                                //     //         ],
                                //     //         "MetadataValues": []
                                //     //     }

                                //     //     docsArray.push(tempBirthCertificateDocObj)

                                //     //   }
                                //   }
                                //   if(  depenDoc.DocumentType == 'Passport' && dependentDetails.DependentType == 'Child'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //   }
                                //   if(  depenDoc.DocumentType == 'Visa' && dependentDetails.DependentType == 'Child'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //   }
                                //   if(  depenDoc.DocumentType == 'I94' && dependentDetails.DependentType == 'Child'){
                                //       if(depenDoc.MetadataValues && depenDoc.MetadataValues.length > 0){
                                //             docsArray.push(depenDoc)
                                //       }
                                //   }
                              })
                              if(dependentDetails.Documents.filter(x => x.DocumentType == 'MarriageCertificate').length == 0){
                                            tempMarriageDocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "MarriageCertificate",
                                            "DisplayName": "Marriage Certificate",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                    "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }

                                        docsArray.push(tempMarriageDocObj)
                                         }
                               if(dependentDetails.Documents.filter(x => x.DocumentType == 'FormI539').length == 0){
                                        tempFormI539DocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "FormI539",
                                            "DisplayName": "Form I-539",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                    "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }
                                        docsArray.push(tempFormI539DocObj)
                                        }
                                   if(dependentDetails.Documents.filter(x => x.DocumentType == 'BirthCertificate').length == 0){
                                            tempBirthCertificateDocObj =  {
                                             "Group": "DependentDocuments",
                                             "DocumentType": "BirthCertificate",
                                             "DisplayName": "Birth Certificate",
                                             "UploadMultiple": false,
                                             "CanESign": false,
                                             "EntityType": 0,
                                             "CanBeApproved": true,
                                             "DocumentStatus": "Initiate",
                                             "Metadata": [{
                                                     "DataType": "System.String",
                                                     "Key": "DocumentUrl",
                                                     "DisplayName": "Document Url",
                                                 },

                                             ],
                                             "MetadataValues": []
                                         }

                                         docsArray.push(tempBirthCertificateDocObj)
                                        }

                        }
                        else{

                        tempMarriageDocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "MarriageCertificate",
                                            "DisplayName": "Marriage Certificate",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                    "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }

                                        docsArray.push(tempMarriageDocObj)

                                        tempFormI539DocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "FormI539",
                                            "DisplayName": "Form I-539",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                    "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }
                                        docsArray.push(tempFormI539DocObj)

                                         tempBirthCertificateDocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "BirthCertificate",
                                            "DisplayName": "Birth Certificate",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                    "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }

                                        docsArray.push(tempBirthCertificateDocObj)

                        }


                        let cityStateTemp = dependentDetails.SpouseAddress.City +','+dependentDetails.SpouseAddress.State
                        if(cityStateTemp == ',' || cityStateTemp == null){
                            cityStateTemp = ''
                        }

                           let tempPassPortDetails = {
                                "Number": '',
                                "issueDate": '',
                                "expirydate": '',
                                "issuedBy": '',
                                "documentUrl": '',
                                "showPassportDetails":false
                               }
                    let tempVisaDetails = {
                                "lastEntrydate": '',
                                "admitUntil": '',
                                "currenStatus": '',
                                "documentUrl": ''
                               }
                                let tempI94Details = {
                                "i94ReceiptNumber": '',
                                "i94StartDate": '',
                                "i94EndDate": '',
                                "documentUrl": '',
                                "showI94Details":false

                               }
                            dependentDetails.Documents.forEach((dependentDoc, depIndex)=>{
                                   if( dependentDoc.MetadataValues &&  dependentDoc.MetadataValues.length > 0){
                                       dependentDoc.MetadataValues[0].DocumentData.forEach((dMetaData, dMindex)=>{
                                            if(dependentDoc.DocumentType == 'Passport'){
                                                tempPassPortDetails.showPassportDetails = true
                                                     if(dMetaData.Key == 'DocumentNumber')
                                                        tempPassPortDetails.Number= dMetaData.Value
                                                      else if(dMetaData.Key == 'IssueDate')
                                                      tempPassPortDetails.issueDate= dMetaData.Value
                                                      else if(dMetaData.Key == 'ExpiryDate')
                                                      tempPassPortDetails.expirydate= dMetaData.Value
                                                      else if(dMetaData.Key == 'IssuingAuthority')
                                                      tempPassPortDetails.issuedBy= dMetaData.Value
                                                      else if(dMetaData.Key == 'DocumentUrl')
                                                      tempPassPortDetails.documentUrl= dMetaData.Value
                                            }
                                          else  if(dependentDoc.DocumentType == 'Visa'){
                                                     if(dMetaData.Key == 'IssueDate')
                                                      tempVisaDetails.lastEntrydate= dMetaData.Value
                                                      else if(dMetaData.Key == 'ExpiryDate')
                                                      tempVisaDetails.admitUntil= dMetaData.Value
                                                      else if(dMetaData.Key == 'Name')
                                                      tempVisaDetails.currenStatus= dMetaData.Value
                                                      else if(dMetaData.Key == 'DocumentUrl')
                                                      tempVisaDetails.documentUrl= dMetaData.Value
                                                      //else if(dMetaData.Key == 'IssuingAuthority')
                                                      tempVisaDetails.Name = 'Visa'
                                            }
                                            else  if(dependentDoc.DocumentType == 'I94'){
                                                tempI94Details.showI94Details = true
                                                     if(dMetaData.Key == 'DocumentNumber')
                                                        tempI94Details.i94ReceiptNumber= dMetaData.Value
                                                      else if(dMetaData.Key == 'IssueDate')
                                                      tempI94Details.i94StartDate= dMetaData.Value
                                                      else if(dMetaData.Key == 'ExpiryDate')
                                                      tempI94Details.i94EndDate= dMetaData.Value
                                                      else if(dMetaData.Key == 'DocumentUrl')
                                                      tempI94Details.documentUrl= dMetaData.Value
                                            }
                                       })
                                   }
                            })

                             let tempDOBdate = new Date(dependentDetails.SpouseDetails.DOB)
                              var formattedDOBDate =  (tempDOBdate.getUTCMonth() + 1) + '/' + tempDOBdate.getUTCDate() + '/' +  tempDOBdate.getUTCFullYear()

                            let obj = {

                            type: dependentDetails.DependentType,
                            basicInfoObj: {
                                "familyName": dependentDetails.SpouseDetails.LastName,
                                "givenName": dependentDetails.SpouseDetails.FirstName,
                                "middleName": dependentDetails.SpouseDetails.MiddleName,
                                "maidenName": dependentDetails.SpouseDetails.OtherLastName,
                                "birthDate": formattedDOBDate,
                                "countryCitizenShip": dependentDetails.CountryOfCitizenship,
                                "birthCountry": dependentDetails.SpouseDetails.DateOfBirth,
                                "ssnNumber": dependentDetails.SpouseDetails.SocialSecurtiyNumber,
                                "emailAddr": dependentDetails.SpouseDetails.Email,
                                "phoneNum": dependentDetails.SpouseDetails.MobileNo
                            },
                            addressObj: {
                                "streetName": dependentDetails.SpouseAddress.Address1,
                                "aptRadio": tempAptRadio,
                                "Number": dependentDetails.SpouseAddress.AptNumber,
                                "cityState": cityStateTemp,
                                "zipCode": dependentDetails.SpouseAddress.Zip,
                                "immigrationStatus": dependentDetails.ImmigrationStatus

                            },
                            foreginAddressObj:{
                                "streetName": dependentDetails.SpouseForeignAddress.Address1,
                                "aptRadio": tempForeignAptRadio,
                                "AptNumber": dependentDetails.SpouseForeignAddress.AptNumber,
                                "cityState": dependentDetails.SpouseForeignAddress.County == 'United States' ? dependentDetails.SpouseForeignAddress.AddressSummary : '',
                                "city": dependentDetails.SpouseForeignAddress.City,
                                "State": dependentDetails.SpouseForeignAddress.State,
                                "Zip": dependentDetails.SpouseForeignAddress.Zip,
                                "Province": dependentDetails.SpouseForeignAddress.Province,
                                "CountryCode": dependentDetails.SpouseForeignAddress.County != 'United States' ? dependentDetails.SpouseForeignAddress.CountryCode : '',
                                "Country": dependentDetails.SpouseForeignAddress.County,
                                "type": dependentDetails.DependentType
                            },
                            id:dependentDetails.Id,
                            selectH4:tempIsH4DependentFlag,
                            passPortDetails: tempPassPortDetails,
                          //  visaDetailsObj: tempVisaDetails,
                            I94DetailsObj: tempI94Details,
                            tempDocsBinding: sampleArrObj,
                             Documents:docsArray

                        }

                        this.dependentsArray.push(obj)


                    })

                },

         highuploadComplete(v){
         if (v[0].response.Url != null)
                    this.higherEducationDetailsDocURL = v[0].response.Url
         },
                mastersDegree(val){
                    if(val == "Yes"){
                        this.isShowMastersDegree = true
                        this.resetMasterDegreeValues()
                    }else{
                        this.isShowMastersDegree = false
                    }

                },
                empAddress(val){
                    if(val == "Yes"){
                        this.isShowEmpAddress = true
                        this.resetEmployeeAddressValues()
                    }else{
                        this.isShowEmpAddress = false
                    }

                },
                AnyMasterDegree(val){
                    if(val == "Yes")
                    {
                     this.educationInfomation.IsMasterDegree = true
                     this.isavailableDegree()
                    }
                    if(val == "No")
                      {
                          this.educationInfomation.IsMasterDegree = false
                          this.isnotavailabledegree()
                          this.educationinfo.yesDatedegree=""
                          this.educationinfo.yesTypeofDegree =""
                          this.educationinfo.yesMajorfield=""
                          this.educationinfo.yesNameofinstitution=""
                          this.higherEducationDetailsDocURL = ""
                          this.educationinfo.Street =""
                          this.educationinfo.BuildingNumber=""
                          this.educationinfo.currentCity =""
                          this.educationinfo.zipcode =""
                      }
                },
                isSpousePassportDetails(index,val){
                    if(val){
                        this.$v.dependentsArray.$each[index].passPortDetails.$reset();
                    }
                },
                isSpouseI94Details(index,val){
                    if(val){
                        this.$v.dependentsArray.$each[index].I94DetailsObj.$reset();
                    }
                },
                // DisappeareYes(val){

                //       if(val == "No")
                //       {
                //           this.educationInfomation.IsMasterDegree = false
                //           this.isnotavailabledegree()
                //       }
                // },

                eduBuildingType(val) {

                    if(val == "ap3")
                    {
                        this.educationinfo.Selectedapt = "ap3"
                        this.educationinfo.Selectedste = ""
                        this.educationinfo.Selectedflr = ""
                    }
                    if(val == "st4")
                    {
                        this.educationinfo.Selectedapt = ""
                        this.educationinfo.Selectedste = "st4"
                        this.educationinfo.Selectedflr = ""
                    }
                    if(val == "fl4")
                    {
                        this.educationinfo.Selectedapt = ""
                        this.educationinfo.Selectedste = ""
                        this.educationinfo.Selectedflr = "fl4"
                    }
                },

                getCountryList() {
                    ajax.get("H1B/GetCountryList", {}, (res) => {
                        let countryList = res.data
                        countryList.forEach((c) => {
                        this.countryNameOpt.data.push({
                            'id': c.Id,
                            'text': c.Name
                        })
                        })
                    })
                    },
                     getDegreeType() {
                    ajax.get("Consultant/GetDegreeNames", {}, (res) => {
                        let degreeType = res.data
                        degreeType.forEach((e) => {
                        this.degreeTypeOpt.data.push({
                            'id': e,
                            'text': e
                        })
                        })
                      })
                    },
                    getNonimmigrantStatusList(){
                    ajax.get("H1BCheckList/GetNonImmigrantStatusList", {}, (res) => {
                     let NonImmigrantstatusList = res.data
                        NonImmigrantstatusList.forEach((c) => {
                        this.NonimmigrantStatusOpt.data.push({
                            'id': c.code,
                            'text': c.name
                        })
                        })
                    })
                   },
                   getCurrentVisaStatusList(){
                    ajax.get(`OnBoard/GetWorkPermitTypesForOnBoarding?empType=${this.loggedInUserObj.HireType}`, {}, (res) => {
                        let CurrentvisaType = res.data.WorkPermitList
                        CurrentvisaType.push('Others');
                         CurrentvisaType.forEach((e) => {
                        this.CurrentvisastatusOpt.data.push({
                            'id': e,
                            'text': e
                        })
                        })
                       })
                    },
                    isPersonalDocumentAvailable(argsDocObj) {
                        //
                        let tempFlag = false
                        let tempArrVal = []
                        let BoolCount = 0
                        this.personalInfomation.Documents.forEach((d, dIndex) => {
                            if(argsDocObj.DocumentType != 'OtherDocuments'){
                                if (d.DocumentType == argsDocObj.DocumentType) {
                                    this.personalInfomation.Documents[dIndex] = argsDocObj
                                }
                            }else{
                                if(argsDocObj.OtherDocumentCategory == d.OtherDocumentCategory){
                                    this.personalInfomation.Documents[dIndex] = argsDocObj
                                }
                            }
                        })

                        if(this.personalInfomation.Documents){
                            this.personalInfomation.Documents.forEach((personalDocs ,pIndex) =>{
                                if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                    //this.disablePersonalSaveBtn = false
                                    var boolFlag = false
                                    tempArrVal.push(boolFlag)
                                }
                                else{
                                    if(personalDocs.IsDocumentNotAvailable == true){
                                        var boolCRFlag = false
                                        tempArrVal.push(boolCRFlag)
                                    }
                                    else {
                                        var boolTrueFlag = true
                                        tempArrVal.push(boolTrueFlag)
                                    }
                                }
                            })

                           BoolCount  = (tempArrVal.filter(v => v).length);
                        }
                        if(BoolCount > 0){
                            tempFlag = true
                        }else{
                            tempFlag = false
                        }
                        this.disablePersonalSaveBtn = tempFlag
                    },
                    removePersonalDoc(index, args, docStatus) {
                        //
                        let doc
                        this.$loading({ 'loadingText': 'Removing...' })
                        ajax.post(`H1BCheckList/RemoveCheckListDocuments?documentId=${args.DocumentId}&h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}&tabType=Personal&docType=${args.DocumentType}`, args, (res) => {
                            if(res.data.State == true){
                                //
                                this.$loading({}).close()
                                doc = res.data.Document
                                this.personalInfoId = this.personalInfomation.Id
                                this.personalInfomation.Documents.forEach((d, dIndex) => {
                                    if(args.DocumentType != 'OtherDocuments'){
                                        if (d.DocumentType == args.DocumentType) {
                                            //
                                        this.personalInfomation.Documents[dIndex] =  doc//args
                                            this.increVal++
                                            this.checkForDocsUpdate(this.personalInfomation,'personal', docStatus)
                                    }

                                    }else{
                                        if(args.OtherDocumentCategory == d.OtherDocumentCategory){
                                            this.disablePersonalSaveBtn
                                        this.personalInfomation.Documents[dIndex] = doc //args
                                            this.increVal++
                                            this.checkForDocsUpdate(this.personalInfomation,'personal', docStatus)
                                        }
                                    }
                                })
                            }
                            else{
                                this.$loading({}).close()
                                if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                    this.isShowWarningMsgPopup = true
                                    this.warningContent = res.data.WarningMessage
                                }
                                else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })
                                }
                            }
                        })


                    },
                    updateDocsObj(index, args, docStatus) {
                    //
                    let doc
                        this.$loading({ 'loadingText': 'Saving...' })
                        ajax.post(`H1BCheckList/UpdateCheckListDocumentsByGroup?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}&tabType=Personal`, args, (res) => {
                            if(res.data.State == true){
                                //
                                this.$loading({}).close()
                                //this.personalInfomation = res.data.PersonalInfomation
                                doc = res.data.Document
                                this.personalInfoId = res.data.tabId
                                 this.personalInfomation.Documents.forEach((d, dIndex) => {
                                    if(args.DocumentType != 'OtherDocuments'){
                                        if (d.DocumentType == args.DocumentType) {
                                            //
                                        this.disablePersonalSaveBtn
                                        this.personalInfomation.Documents[dIndex] =  doc//args
                                            // this.UpdatedisablePersonalSaveBtn = false
                                        //  this.$forceUpdate();
                                            this.increVal++
                                            this.checkForDocsUpdate(this.personalInfomation,'personal', docStatus)
                                    }

                                    }else{
                                        if(args.OtherDocumentCategory == d.OtherDocumentCategory){
                                            this.disablePersonalSaveBtn
                                        this.personalInfomation.Documents[dIndex] = doc //args
                                            // this.UpdatedisablePersonalSaveBtn = false
                                        //  this.$forceUpdate();
                                            this.increVal++
                                            this.checkForDocsUpdate(this.personalInfomation,'personal', docStatus)
                                        }
                                    }
                                })
                            }
                            else{
                                this.$loading({}).close()
                                if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                    this.isShowWarningMsgPopup = true
                                    this.warningContent = res.data.WarningMessage
                                }
                                else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })
                                }
                            }
                        })



                    },
                    updateDependentDocsObj(index, args) {

                       // this.dependentsArray.forEach((depndentArr, dIndex) => {
                            this.dependentsArray[index].Documents.forEach((d,dI)=>{
                                   if (d.DocumentType == args.DocumentType) {
                                // this.disabledpdntSaveBtn = false
                                this.dependentsArray[index].Documents[dI] = args

                                    this.increVal++
                                    this.checkForDocsUpdate(this.dependentsArray[index],'Dependent')
                            }
                            })

                        //})

                    },
                    updateImmigrationInfoDoc(index, args) {
                        //
                        this.immigrationInfomation.Documents.forEach((d, dIndex) => {
                            if (d.DocumentType == args.DocumentType) {
                                this.immigrationInfomation.Documents[dIndex] = args
                                this.disableImmigrationSaveBtn = false
                                    this.increVal++
                            }
                        })

                    },

                    isEducationDocumentAvailable(argsDocObj) {
                        //
                        let tempFlag = false
                        let tempArrVal = []
                        let BoolCount = 0
                        this.educationInfomation.Documents.forEach((d, dIndex) => {
                            if(argsDocObj.DocumentType != 'OtherDocuments'){
                                if (d.DocumentType == argsDocObj.DocumentType) {
                                    this.educationInfomation.Documents[dIndex] = argsDocObj
                                }
                            }else{
                                if(argsDocObj.OtherDocumentCategory == d.OtherDocumentCategory){
                                    this.educationInfomation.Documents[dIndex] = argsDocObj
                                }
                            }
                        })

                        if(this.educationInfomation.Documents){
                            this.educationInfomation.Documents.forEach((personalDocs ,pIndex) =>{
                                if(personalDocs.DocumentType != 'DegreeCerificates' && personalDocs.DocumentType != 'Certifications'){
                                    if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                        //this.disablePersonalSaveBtn = false
                                        var boolFlag = false
                                        tempArrVal.push(boolFlag)
                                    }else{
                                        if(personalDocs.IsDocumentNotAvailable == true){
                                            var boolCRFlag = false
                                            tempArrVal.push(boolCRFlag)
                                        }
                                        else {
                                            var boolTrueFlag = true
                                            tempArrVal.push(boolTrueFlag)
                                        }
                                    }
                                }
                            })

                           BoolCount  = (tempArrVal.filter(v => v).length);

                        }
                        if(BoolCount > 0){
                            tempFlag = true
                        }else{
                            tempFlag = false
                        }
                        this.disableEducSaveBtn = tempFlag
                    },

                    removeEducationDoc(index, args, docStatus) {
                        let doc
                        this.$loading({ 'loadingText': 'Removing...' })
                        ajax.post(`H1BCheckList/RemoveCheckListDocuments?documentId=${args.DocumentId}&h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}&tabType=Education&docType=${args.DocumentType}`, args, (res) => {
                            if(res.data.State == true){
                                //
                                this.$loading({}).close()
                                doc = res.data.Document
                                this.educationalInfoId = this.tabId
                                 this.educationInfomation.Documents.forEach((d, dIndex) => {
                                    if (d.DocumentType == args.DocumentType) {
                                        this.educationInfomation.Documents[dIndex] = doc//args
                                        this.increVal++
                                        this.checkForDocsUpdate(this.educationInfomation,'educational', docStatus)
                                    }
                                })
                            }
                            else{
                                this.$loading({}).close()
                                if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                    this.isShowWarningMsgPopup = true
                                    this.warningContent = res.data.WarningMessage
                                }
                                else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })
                                }
                            }
                        })
                    },

                    updateeducatonalDoc(index, args, docStatus) {
                        //
                        let doc
                        this.$loading({ 'loadingText': 'Saving...' })
                        ajax.post(`H1BCheckList/UpdateCheckListDocumentsByGroup?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}&tabType=Education`, args, (res) => {
                            if(res.data.State == true){
                                //
                                this.$loading({}).close()
                                //this.personalInfomation = res.data.PersonalInfomation
                                doc = res.data.Document
                                this.educationalInfoId = this.tabId
                                 this.educationInfomation.Documents.forEach((d, dIndex) => {
                                    if (d.DocumentType == args.DocumentType) {
                                        this.educationInfomation.Documents[dIndex] = doc //args
                                        this.increVal++
                                        this.checkForDocsUpdate(this.educationInfomation,'educational', docStatus)
                                    }
                                })
                            }
                            else{
                                this.$loading({}).close()
                                if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                    this.isShowWarningMsgPopup = true
                                    this.warningContent = res.data.WarningMessage
                                }
                                else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })
                                }
                            }
                        })
                    },

                    isEmploymentDocumentAvailable(argsDocObj) {
                        //
                        let tempFlag = false
                        let tempArrVal = []
                        let BoolCount = 0
                        this.employmentInfomation.Documents.forEach((d, dIndex) => {
                            if(argsDocObj.DocumentType != 'OtherDocuments'){
                                if (d.DocumentType == argsDocObj.DocumentType) {
                                    this.employmentInfomation.Documents[dIndex] = argsDocObj
                                }
                            }else{
                                if(argsDocObj.OtherDocumentCategory == d.OtherDocumentCategory){
                                    this.employmentInfomation.Documents[dIndex] = argsDocObj
                                }
                            }
                        })

                        if(this.employmentInfomation.Documents){
                            this.employmentInfomation.Documents.forEach((personalDocs ,pIndex) => {
                                if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                    //this.disablePersonalSaveBtn = false
                                    var boolFlag = false
                                    tempArrVal.push(boolFlag)
                                }else{
                                    if(personalDocs.IsDocumentNotAvailable == true){
                                        var boolCRFlag = false
                                        tempArrVal.push(boolCRFlag)
                                    }
                                    else {
                                         if(personalDocs.DocumentType == "DirectDeposit" && personalDocs.DirectDepositBankDetails != null && personalDocs.DirectDepositBankDetails.length >0){
                                                var boolCRFlag = false
                                                tempArrVal.push(boolCRFlag)
                                            }else{
                                            var boolTrueFlag = true
                                            tempArrVal.push(boolTrueFlag)
                                            }
                                    }
                                }
                            })
                            BoolCount  = (tempArrVal.filter(v => v).length);
                            if(BoolCount > 0){
                                tempFlag = true
                            }else{
                                tempFlag = false
                            }
                            //}
                        }
                    this.disableEmpSaveBtn = tempFlag
                    },

                    removeEmploymentDoc(index,args, docStatus) {
                        let doc
                        this.$loading({ 'loadingText': 'Removing...' })
                        ajax.post(`H1BCheckList/RemoveCheckListDocuments?documentId=${args.DocumentId}&h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}&tabType=Employment&docType=${args.DocumentType}`, args, (res) => {
                            if(res.data.State == true){
                                //
                                this.$loading({}).close()
                                doc = res.data.Document
                                 this.employmentInfoId = this.tabId
                                this.employmentInfomation.Documents.forEach((d, dIndex) => {
                                    if(args.DocumentType != 'OtherDocuments'){
                                        if (d.DocumentType == args.DocumentType) {
                                            this.employmentInfomation.Documents[dIndex] =  doc//args
                                            this.increVal++
                                            this.checkForDocsUpdate(this.employmentInfomation,'employment', docStatus)
                                        }
                                    }else{
                                        if(args.OtherDocumentCategory == d.OtherDocumentCategory){
                                            this.employmentInfomation.Documents[dIndex] = doc//args
                                            this.increVal++
                                            this.checkForDocsUpdate(this.employmentInfomation,'employment', docStatus)
                                        }
                                    }
                                })
                            }
                            else{
                                this.$loading({}).close()
                                if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                    this.isShowWarningMsgPopup = true
                                    this.warningContent = res.data.WarningMessage
                                }
                                else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })
                                }
                            }
                        })
                    },

                 updateEmpDocumentsObj(index,args, docStatus) {
                     //
                        let doc
                        this.$loading({ 'loadingText': 'Saving...' })
                        ajax.post(`H1BCheckList/UpdateCheckListDocumentsByGroup?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}&tabType=Employment`, args, (res) => {
                            if(res.data.State == true){
                                //
                                this.$loading({}).close()
                                //this.personalInfomation = res.data.PersonalInfomation
                                doc = res.data.Document
                                this.employmentInfoId = this.tabId
                                if(this.employmentInfomation && this.employmentInfomation.Documents != null && this.employmentInfomation.Documents.length > 0){
                                    this.employmentInfomation.Documents.forEach((d, dIndex) => {
                                        if(d != null){
                                            if(args.DocumentType != 'OtherDocuments'){
                                                if (d.DocumentType == args.DocumentType) {
                                                    this.employmentInfomation.Documents[dIndex] =  doc//args
                                                    this.increVal++
                                                    this.checkForDocsUpdate(this.employmentInfomation,'employment', docStatus)
                                                }
                                            }else{
                                                if(args.OtherDocumentCategory == d.OtherDocumentCategory){
                                                    this.employmentInfomation.Documents[dIndex] = doc//args
                                                    this.increVal++
                                                    this.checkForDocsUpdate(this.employmentInfomation,'employment', docStatus)
                                                }
                                            }
                                        }
                                    })
                                }
                            }
                            else{
                                this.$loading({}).close()
                                if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                    this.isShowWarningMsgPopup = true
                                    this.warningContent = res.data.WarningMessage
                                }
                                else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })
                                }
                            }
                        })
                  },
                  checkForDocsUpdate(v,typeOfDoc, docStatus ){
                     let tempFlag = false
                     let tempArrVal = []
                     let BoolCount = 0
                     if(typeOfDoc == 'Dependent'){
                          if(v){
                            v.Documents.forEach((personalDocs ,pIndex) =>{
                                if( personalDocs.DocumentType != 'Passport' && personalDocs.DocumentType != 'I94' ){
                                   // if(v.selectH4 == '1' && (personalDocs.DocumentType == 'BirthCertificate' && v.type == 'child') || (personalDocs.DocumentType == 'MarriageCertificate' && v.type == 'Spouse')){


                                    if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                        let tempObj ={
                                            'docType': personalDocs.DocumentType

                                        }
                                        if(v.tempDocsBinding.filter(x => x.docType == personalDocs.DocumentType).length == 0){
                                        v.tempDocsBinding.push(tempObj)
                                        }
                                     //this.disablePersonalSaveBtn = false
                                     var boolFlag = false
                                     tempArrVal.push(boolFlag)
                                 }else{
                                       var boolTrueFlag = true
                                     tempArrVal.push(boolTrueFlag)
                                 }
                                   // }
                                }
                                })

                            }

                     }else{
                         //
                            if(v){
                                v.Documents.forEach((personalDocs ,pIndex) =>{
                                    if(personalDocs.DocumentType != 'DegreeCerificates' && personalDocs.DocumentType != 'Certifications' && personalDocs.DocumentType != 'FormI539'){
                                        if(personalDocs.MetadataValues && personalDocs.MetadataValues.length > 0){
                                        //this.disablePersonalSaveBtn = false
                                        var boolFlag = false
                                        tempArrVal.push(boolFlag)
                                        }else{
                                            if(personalDocs.IsDocumentNotAvailable == true){
                                                var boolCRFlag = false
                                                tempArrVal.push(boolCRFlag)
                                            }
                                            else {
                                                var boolTrueFlag = true
                                                tempArrVal.push(boolTrueFlag)
                                            }
                                        }
                                    }
                                })
                            }
                        }
                        //

                        BoolCount  = (tempArrVal.filter(v => v).length);
                        //
                            if(BoolCount > 0){
                                tempFlag = true
                           }else{
                               tempFlag = false
                           }
                           if(typeOfDoc == 'personal')
                           this.disablePersonalSaveBtn = tempFlag
                           else if(typeOfDoc == 'educational')
                           this.disableEducSaveBtn = tempFlag
                           else if(typeOfDoc == 'employment')
                           this.disableEmpSaveBtn = tempFlag
                            else if(typeOfDoc == 'Dependent')
                           this.disabledpdntSaveBtn = tempFlag

                           if(typeOfDoc == 'employment'){
                             this.updateDisableForEmploymentSave()
                         }

                           //return true

                  },




            ShowSubmitionSuccess() {
             this.$loading({'loadingText':'Loading...' })

           // var tempPreviewHTML = $('#EssPreviewSubmitPrint').html();

              //var w = window.open();
                var printOne = $('#EssPreviewSubmitPrint').html();

               // w.document.write('<html><head>  </head><style> body{ font-family: "Open Sans", sans-serif;font-size:14px }#project_clientDetails{overflow:auto;} .ul{margin:4px;display:inline-flex;} .li{width:145px;height:64px;position:relative;list-style-type:none;background:white;padding:12px 10px 10px 12px;border:2px solid white;-webkit-box-shadow:0 0 9.5px #dcd7d7;box-shadow:0 0 9.5px #dcd7d7;border-radius:0%;float:left;margin-left:62px;margin-bottom:25px;} .li .website_txt{font-size:11px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding-bottom:1.5px;font-weight:600;} .li .website_org{color:#143361;font-size:13px;font-weight:600;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;} .li:after{content:\'\';background:#656262;position:absolute;top:28.6px;width:46px;height:2px;margin-left:165px;} .li .circle{width:1em;height:1em;box-sizing:initial;background:#fff;border:0.3em solid #656262;color:#666;border-radius:50%;line-height:2rem;box-sizing:content-box;} .li:last-child:after{width:0px !important;} .li:last-child .left{display:none;} .li:first-child{margin-left:0;} .li i{border:solid #656262;border-width:0 1.5px 1.5px 0;display:inline-block;padding:3px;} .li .right{position:absolute;left:-20px;top:26px;border-color:none;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);} .li .left{position:absolute;right:-14px;margin-right:-4px;top:26px;z-index:1;border-color:none;transform:rotate(135deg);-webkit-transform:rotate(135deg);} #project_clientDetails .ul .Vendor-org i.left{display:none;}.borderd{border:2px solid gray !important;background:white !important;-webkit-box-shadow:0 0 0 !important;box-shadow:0 0 0 !important;}.hide-in-print{display:none} table{border-collapse:collapse;border-spacing:0;}td,th{padding:0;} .table-tag{ width:-webkit-fill-available; background-color: transparent; border-spacing: 0; border-collapse: collapse; display: table; border-color: grey; } .tbody-class{ display: table-row-group; vertical-align: middle; border-color: inherit; } .tr-class{ display: table-row; vertical-align: inherit; border-color: inherit; } .hide-visibility{ visibility:hidden !important } .document-list__heading{border:1px solid #1DC942;background:#f4fef7;}.document-list__status{background:#a4f3b5;color:#1DC942;}.pL0{padding-left:0 !important;}.pR0{padding-right:0 !important;}.modal{display:none}.document-list__header{position:relative;z-index:1;} .document-list__heading{padding:5px 10px;border:1px solid $default-border-color;display:inline-block;border-radius:30px;font-weight:bold;background:$default-background-color;float:left;} .document-list__headings{padding:5px 10px;border:1px solid #c2c2c2;display:inline-block;border-radius:30px;font-weight:bold;background:$default-background-color;float:left;} .document-list__status{background:$default-border-color;color:$default-background-color;padding:0px 5px;border-radius:100%;} .multilpe-doc{background:#c2c2c2;color:#fdfdfd;padding:0px 5px;border-radius:100%;} .document-list__controls{float:right;}  .document-list__body{position:relative; padding: 25px 10px 15px 0} .file_name_span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:600px;display:inline-block;} .progress{overflow:hidden;height:5px;margin-bottom:0;background-color:#f5f5f5;border-radius:10px;-webkit-box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);} .upload_div, .upload_file_div{padding:35px;background:#FAFEFF;border:2px dashed #ccc;border-radius:8px;display:table;width:100%;cursor:pointer;text-align:center;&.dragover{background:#fff;} } .upload_file_div{padding:15px;cursor:default;} .upload-inner{display:table-cell;vertical-align:middle;padding:15px;width:15%;} .width-70{width:70%;} .testt{padding:0px } .margin-top-25{margin-top:25px;} .upload_img{padding:15px 0 20px 0;} .upload_text{padding:0 0 20px 0;} .icon{width:50px;} .icon1{width:35px;} .info{margin:0;font-size:13px;line-height:18px;color:#999;display:inline-block;} .file_name_span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;//width:600px;display:inline;} .error-holder{margin:10px 0;} .error-msg{color:$ob-error-red;} .slide-fade-enter-active{transition:all .3s ease;} .slide-fade-leave-active{transition:all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);} .slide-fade-enter, .slide-fade-leave-to{transform:translateX(10px);opacity:0;} .signature-holder{.document-signer{font-size:16px;font-weight:600;color:#337AB5;} .signauture-success{font-size:9px;color:#FFFFFF;background:#3CB55B !important;} .signauture-pending{font-size:9px;color:#FFFFFF;background:#008BE7 !important;} .document-signature-details{font-size:14px;color:#2A2A2A;} }.animation{animation-duration:1s;animation-fill-mode:both;display:inline-block;} .bounceOutLeft{animation-name:bounceOutLeft } @keyframes bounceOutLeft{18%{transform:translate3d(27px, 0, 0) } 33%{transform:translate3d(-12px, 0, 0) } 48%{transform:translate3d(8px, 0, 0) } 100%{transform:translate3d(-300%, 0, 0) } } @keyframes bounceInUp{0%{opacity:0;-webkit-transform:translateY(2000px);-ms-transform:translateY(2000px);transform:translateY(2000px);} 60%{opacity:1;-webkit-transform:translateY(-30px);-ms-transform:translateY(-30px);transform:translateY(-30px);} 80%{-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px);} 100%{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);} } .bounceOuttop{animation-name:bounceInUp } .ActionTruncateStyle{z-index:unset !important;} .fontWeightStyle{font-weight:bold;} .PaddingBottomStyle{padding-bottom:10px;} .document-table-value{font-size:13px;font-weight:600;color:#143361;margin-top: 0}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}@media (min-width:768px){.container{width:750px;}}@media (min-width:992px){.container{width:970px;}}@media (min-width:1200px){.container{width:1170px;}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}.row{margin-left:-15px;margin-right:-15px;}.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12{position:relative;min-height:1px;padding-left:15px;}.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12{float:left;}.col-xs-12{width:100%;}.col-xs-11{width:91.66666667%;}.col-xs-10{width:83.33333333%;}.col-xs-9{width:75%;}.col-xs-8{width:66.66666667%;}.col-xs-7{width:58.33333333%;}.col-xs-6{width:50%;}.col-xs-5{width:41.66666667%;}.col-xs-4{width:33.33333333%;}.col-xs-3{width:25%;}.col-xs-2{width:16.66666667%;}.col-xs-1{width:8.33333333%;}.col-xs-pull-12{right:100%;}.col-xs-pull-11{right:91.66666667%;}.col-xs-pull-10{right:83.33333333%;}.col-xs-pull-9{right:75%;}.col-xs-pull-8{right:66.66666667%;}.col-xs-pull-7{right:58.33333333%;}.col-xs-pull-6{right:50%;}.col-xs-pull-5{right:41.66666667%;}.col-xs-pull-4{right:33.33333333%;}.col-xs-pull-3{right:25%;}.col-xs-pull-2{right:16.66666667%;}.col-xs-pull-1{right:8.33333333%;}.col-xs-pull-0{right:auto;}.col-xs-push-12{left:100%;}.col-xs-push-11{left:91.66666667%;}.col-xs-push-10{left:83.33333333%;}.col-xs-push-9{left:75%;}.col-xs-push-8{left:66.66666667%;}.col-xs-push-7{left:58.33333333%;}.col-xs-push-6{left:50%;}.col-xs-push-5{left:41.66666667%;}.col-xs-push-4{left:33.33333333%;}.col-xs-push-3{left:25%;}.col-xs-push-2{left:16.66666667%;}.col-xs-push-1{left:8.33333333%;}.col-xs-push-0{left:auto;}.col-xs-offset-12{margin-left:100%;}.col-xs-offset-11{margin-left:91.66666667%;}.col-xs-offset-10{margin-left:83.33333333%;}.col-xs-offset-9{margin-left:75%;}.col-xs-offset-8{margin-left:66.66666667%;}.col-xs-offset-7{margin-left:58.33333333%;}.col-xs-offset-6{margin-left:50%;}.col-xs-offset-5{margin-left:41.66666667%;}.col-xs-offset-4{margin-left:33.33333333%;}.col-xs-offset-3{margin-left:25%;}.col-xs-offset-2{margin-left:16.66666667%;}.col-xs-offset-1{margin-left:8.33333333%;}.col-xs-offset-0{margin-left:0%;}@media (min-width:768px){.col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12{float:left;} .col-sm-12{width:100%;} .col-sm-11{width:91.66666667%;} .col-sm-10{width:83.33333333%;} .col-sm-9{width:75%;} .col-sm-8{width:66.66666667%;} .col-sm-7{width:58.33333333%;} .col-sm-6{width:50%;} .col-sm-5{width:41.66666667%;} .col-sm-4{width:33.33333333%;} .col-sm-3{width:25%;} .col-sm-2{width:16.66666667%;} .col-sm-1{width:8.33333333%;} .col-sm-pull-12{right:100%;} .col-sm-pull-11{right:91.66666667%;} .col-sm-pull-10{right:83.33333333%;} .col-sm-pull-9{right:75%;} .col-sm-pull-8{right:66.66666667%;} .col-sm-pull-7{right:58.33333333%;} .col-sm-pull-6{right:50%;} .col-sm-pull-5{right:41.66666667%;} .col-sm-pull-4{right:33.33333333%;} .col-sm-pull-3{right:25%;} .col-sm-pull-2{right:16.66666667%;} .col-sm-pull-1{right:8.33333333%;} .col-sm-pull-0{right:auto;} .col-sm-push-12{left:100%;} .col-sm-push-11{left:91.66666667%;} .col-sm-push-10{left:83.33333333%;} .col-sm-push-9{left:75%;} .col-sm-push-8{left:66.66666667%;} .col-sm-push-7{left:58.33333333%;} .col-sm-push-6{left:50%;} .col-sm-push-5{left:41.66666667%;} .col-sm-push-4{left:33.33333333%;} .col-sm-push-3{left:25%;} .col-sm-push-2{left:16.66666667%;} .col-sm-push-1{left:8.33333333%;} .col-sm-push-0{left:auto;} .col-sm-offset-12{margin-left:100%;} .col-sm-offset-11{margin-left:91.66666667%;} .col-sm-offset-10{margin-left:83.33333333%;} .col-sm-offset-9{margin-left:75%;} .col-sm-offset-8{margin-left:66.66666667%;}.col-sm-offset-7{margin-left:58.33333333%;} .col-sm-offset-6{margin-left:50%;} .col-sm-offset-5{margin-left:41.66666667%;} .col-sm-offset-4{margin-left:33.33333333%;} .col-sm-offset-3{margin-left:25%;} .col-sm-offset-2{margin-left:16.66666667%;} .col-sm-offset-1{margin-left:8.33333333%;} .col-sm-offset-0{margin-left:0%;}}@media (min-width:992px){.col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12{float:left;} .col-md-12{width:100%;} .col-md-11{width:91.66666667%;} .col-md-10{width:83.33333333%;} .col-md-9{width:75%;} .col-md-8{width:66.66666667%;} .col-md-7{width:58.33333333%;} .col-md-6{width:50%;} .col-md-5{width:41.66666667%;} .col-md-4{width:33.33333333%;} .col-md-3{width:25%;} .col-md-2{width:16.66666667%;} .col-md-1{width:8.33333333%;} .col-md-pull-12{right:100%;} .col-md-pull-11{right:91.66666667%;} .col-md-pull-10{right:83.33333333%;} .col-md-pull-9{right:75%;} .col-md-pull-8{right:66.66666667%;} .col-md-pull-7{right:58.33333333%;} .col-md-pull-6{right:50%;} .col-md-pull-5{right:41.66666667%;} .col-md-pull-4{right:33.33333333%;} .col-md-pull-3{right:25%;} .col-md-pull-2{right:16.66666667%;} .col-md-pull-1{right:8.33333333%;} .col-md-pull-0{right:auto;} .col-md-push-12{left:100%;} .col-md-push-11{left:91.66666667%;} .col-md-push-10{left:83.33333333%;} .col-md-push-9{left:75%;} .col-md-push-8{left:66.66666667%;} .col-md-push-7{left:58.33333333%;} .col-md-push-6{left:50%;} .col-md-push-5{left:41.66666667%;} .col-md-push-4{left:33.33333333%;} .col-md-push-3{left:25%;} .col-md-push-2{left:16.66666667%;} .col-md-push-1{left:8.33333333%;} .col-md-push-0{left:auto;} .col-md-offset-12{margin-left:100%;} .col-md-offset-11{margin-left:91.66666667%;} .col-md-offset-10{margin-left:83.33333333%;} .col-md-offset-9{margin-left:75%;} .col-md-offset-8{margin-left:66.66666667%;} .col-md-offset-7{margin-left:58.33333333%;} .col-md-offset-6{margin-left:50%;} .col-md-offset-5{margin-left:41.66666667%;} .col-md-offset-4{margin-left:33.33333333%;} .col-md-offset-3{margin-left:25%;} .col-md-offset-2{margin-left:16.66666667%;} .col-md-offset-1{margin-left:8.33333333%;} .col-md-offset-0{margin-left:0%;}}@media (min-width:1200px){.col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12{float:left;} .col-lg-12{width:100%;} .col-lg-11{width:91.66666667%;} .col-lg-10{width:83.33333333%;} .col-lg-9{width:75%;} .col-lg-8{width:66.66666667%;} .col-lg-7{width:58.33333333%;} .col-lg-6{width:50%;} .col-lg-5{width:41.66666667%;} .col-lg-4{width:33.33333333%;} .col-lg-3{width:25%;} .col-lg-2{width:16.66666667%;} .col-lg-1{width:8.33333333%;} .col-lg-pull-12{right:100%;} .col-lg-pull-11{right:91.66666667%;} .col-lg-pull-10{right:83.33333333%;} .col-lg-pull-9{right:75%;} .col-lg-pull-8{right:66.66666667%;} .col-lg-pull-7{right:58.33333333%;} .col-lg-pull-6{right:50%;} .col-lg-pull-5{right:41.66666667%;} .col-lg-pull-4{right:33.33333333%;} .col-lg-pull-3{right:25%;} .col-lg-pull-2{right:16.66666667%;} .col-lg-pull-1{right:8.33333333%;} .col-lg-pull-0{right:auto;} .col-lg-push-12{left:100%;} .col-lg-push-11{left:91.66666667%;} .col-lg-push-10{left:83.33333333%;} .col-lg-push-9{left:75%;} .col-lg-push-8{left:66.66666667%;} .col-lg-push-7{left:58.33333333%;} .col-lg-push-6{left:50%;} .col-lg-push-5{left:41.66666667%;} .col-lg-push-4{left:33.33333333%;} .col-lg-push-3{left:25%;} .col-lg-push-2{left:16.66666667%;} .col-lg-push-1{left:8.33333333%;} .col-lg-push-0{left:auto;} .col-lg-offset-12{margin-left:100%;} .col-lg-offset-11{margin-left:91.66666667%;} .col-lg-offset-10{margin-left:83.33333333%;} .col-lg-offset-9{margin-left:75%;} .col-lg-offset-8{margin-left:66.66666667%;} .col-lg-offset-7{margin-left:58.33333333%;} .col-lg-offset-6{margin-left:50%;} .col-lg-offset-5{margin-left:41.66666667%;} .col-lg-offset-4{margin-left:33.33333333%;} .col-lg-offset-3{margin-left:25%;} .col-lg-offset-2{margin-left:16.66666667%;} .col-lg-offset-1{margin-left:8.33333333%;} .col-lg-offset-0{margin-left:0%;}}.footer-line{margin-top:20px;border-bottom:1px dashed grey;margin-bottom:20px;} .doc-header{color:#000;font-weight:600;font-size:14px;font-weight:600px;} .request-doc-header{color:#143361;font-weight:700;font-size:16px;padding-left:25px;} .icon-header{padding-right:50px;} .info-text-blue{color:#4A90E2;font-size:15px;} .info-text-green{color:#1DC942;font-size:15px;} .info-text{font-size:15px;} .listDocs-text{color:#4A90E2;font-weight:600;font-size:13px;} .doc-overflow{overflow:auto;height:100%;} .status-options{margin:26px 0 0 0;} .section-personal{border-bottom:2px dashed #c2c2c2;padding:10px 0;} .checklist-docs{overflow:auto;height:100%;} .btnUpload{width:79px;height:28px;background-color:#1d437b } .document-list__headingStyle{padding:5px 10px;border:1px solid #c2c2c2;display:inline-block;border-radius:30px;font-weight:bold;//background:#c2c2c2;} .document-list__statusStyle{background:#c2c2c2;color:#fdfdfd;padding:0px 5px;border-radius:100%;margin-left:30px;} .star{color:red;} .heading-text{color:#000;font-weight:700;font-size:13px;padding:20px 0px 0px 15px;} .upload-text{padding:0px 0px 10px 25px } .names-text{color:#000;padding-top:20px;font-weight:700;font-size:12px;} .label-text{padding-bottom:5px;color:#000;font-size:13px;} .checklist-docs{overflow:auto;height:100%;} .contact-info-text{color:#000;font-size:13px;font-weight:700;padding-top:15px;} .radio-buttons{margin-left:-20px;} .current-info-text{color:#000;padding:15px 0px 0px 15px;font-weight:700;font-size:13px;} .footer-buttons{text-align:center;padding-top:30px;} .actions-text{padding-bottom:20px;text-align:right;margin-left:186px;} .required-docs-text{color:#000;padding:15px 0px 0px 0px;font-weight:700;font-size:13px;} .add-name{color:#4A90E2;font-style:italic;text-decoration:underline;font-weight:700;padding-left:5px;cursor:pointer;} .btn-upload{padding-bottom:20px;} .section-heading-dependent{color:#393939;font-weight:600;font-size:17px } .radio-label{color:#393939;font-weight:600;} .remove-worklocation{float:right;color:#D60000;font-size:11px;font-weight:650;margin-top:5px;padding-right:4px } .remove-location{float:right;color:#D60000;font-size:11px;font-weight:650;margin-top:5px;padding-right:26px } .fontStyle{font-weight:bold;padding:15px;font-size:17px;border-bottom:1px dashed #ccc;} .infoStyle{color:#4191ef;padding-bottom:25px;font-weight:600;} .fontHeadStyle{padding-bottom:15px;font-weight:600;font-size:15px;color:#143361;} .fontSubHeadPadStyle{padding-bottom:10px;} .fontSubHeadStyle{font-size:14px;padding-bottom:10px;font-weight:600;color:#143361;} .fontSubHeadBoldStyle{font-weight:600;color:#143361;overflow-wrap:break-word;font-size:14px} .fontSubHeBoldStyle{font-weight:bold;} .fontSubHeadBoldPadStyle{font-weight:600;padding-left:8px;color:#143361;overflow-wrap:break-word;} .fontStySubHeadBoldPadStyle{font-weight:600;padding-left:22px;color:#143361;overflow-wrap:break-word;} .IconTitleColor{color:rgb(40, 167, 69);font-weight:bold;} .IconTitleblueColor{padding-left:0px;font-weight:bold;color:#4A90E2;} .padIconStyle{padding-bottom:20px;} .padStyle{padding-top:10px;padding-bottom:15px;} .padArrowLeftStyle{padding-left:60px;} .document-list__headingApprovedStyle{padding:5px 10px;border:1px solid #3CB55B;display:inline-block;border-radius:30px;font-weight:bold;background:#F9F9F9;float:left;} .document-list__statusApprovedStyle{background:#ACF3BE;color:#3CB55B;padding:0px 5px;border-radius:100%;} .fontCheckStyle{font-size:14px;font-weight:600;color:#143361;} .fontborderStyle{padding-bottom:25px;padding-top:25px;padding-left:0px;border-top:1px dashed #ccc;} .fontborderSolidStyle{padding-top:35px;padding-left:0px;padding-bottom:40px;border-top:1px solid #ccc;text-align:center;} .fontSizeInfoIconStyle{font-size:17px;} .margPillStyle{margin-left:-10px;} .at{color:#143361;font-weight:600;font-size:21px;padding-top:13px;} .pas{font-weight:normal;font-size:14px;padding-bottom:30px;} .pas p{color:#727d8c;font-size:13px;font-weight:600;} .ContenttoBottomStyle{//padding-bottom:10% !important;} .BorderStyle{border-bottom:1px solid grey;padding-bottom:20px;} .close{border:1px solid black;border-radius:12px;}.input-field-field{width:60%;height:20px;//padding:1.5%;margin-right:5%;display:inline-block;border-radius:10px;//box-sizing:border-box;}.input-field{width:100%;margin-right:5%;background:#666666;border-radius:10px;box-sizing:border-box;}.fixed-org{display:flex;justify-content:left;padding-top:2%;}.align-org{display:flex;justify-content:left;padding-top:4%;}.vl{border-left:1px solid #DFDFDF;position:inherit;margin-left:5%;margin-top:-12px;width:134%;}.org-vl{border-left:1px solid #DFDFDF;position:inherit;margin-left:5%;margin-top:-12px;width:134%;padding-left:57px;}.org-main-align{border-left:1px solid #DFDFDF;position:inherit;}.add-another-text-align{position:inherit;margin-left:5%;margin-top:-10px;width:134%;margin-top:-22px;margin-left:42px;}.add-position{margin-top:5%;margin-left:-14px;cursor:pointer;}.line{margin-top:40px;width:10%;}.heading{padding-top:5% !important;padding-bottom:5% !important;}.normal-input{background:white !important;}*:focus{outline:none;}.flow-digram{height:50%;width:30%}.add-another-client{margin-top:10px;color:#4A90E2;font-style:italic;font-weight:700;font-size:11px;cursor:pointer;}.endclient-details{display:flex;width:140%;justify-content:left;padding-left:5%;} .end-client-name{//text-align:left;// padding-left:80px !important;font-size:12px;color:#000;padding-bottom:5px;} .end-client-website{// float:right;//margin-right:-38px !important;font-size:12px;color:#000;padding-bottom:5px;} .client-details{font-size:12px;color:#000;margin-left:15%;margin-bottom:-18px;display:inline-block;} .client-website{font-size:12px;color:#000;margin-left:45%;display:inline-block;} .vendor-details{font-size:12px;color:#000;margin-left:15%;margin-bottom:-18px;display:inline-block;}.vendor-website{font-size:12px;color:#000;margin-left:40%;display:inline-block;} .organization{font-size:12px;color:#000;padding-left:0px;padding-bottom:5px;//margin-left:39px;} .input-client-field{//width:100%;// margin-right:5%;border-radius:10px;box-sizing:border-box;} .padToppSty{padding-top:10px;} .remove-name{color:#D60000;font-style:italic;text-decoration:underline;font-weight:800;font-size:13px;padding-left:5px;cursor:pointer;} .commentTopStyle{background:#ffd9cd;border-radius:4px;white-space:normal;padding-left:9px;padding-top:5px;padding-bottom:5px;overflow-wrap:break-word;} .commentStyle{background:#efefef;border-radius:4px;white-space:normal;padding-left:9px;padding-top:5px;padding-bottom:5px;overflow-wrap:break-word;} .document-list__ApproveStatusESSStyle{background:#c7ffd3;color:#079f6c;padding:0px 5px;border-radius:100%;font-size:10px;} .document-list__RejectStatusESSStyle{background:#D60000;color:#fff;padding:0px 5px;border-radius:100%;font-size:10px;} .padBottomStyle{padding-top:10px;} .conditionalBorder{border-bottom:2px dashed #789acc;margin-bottom:15px !important;padding-top:15px !important;} </style> <body>' + printOne + '</body></html>');

                // setTimeout(() => {
                //     w.window.print();
                //     w.document.close();

                // }, 100)
                var updatedPrint = '<html><head>  </head><style> body{ font-family: "Open Sans", sans-serif;font-size:14px }#project_clientDetails{overflow:auto;} .ul{margin:4px;display:inline-flex;} .li{width:145px;height:64px;position:relative;list-style-type:none;background:white;padding:12px 10px 10px 12px;border:2px solid white;-webkit-box-shadow:0 0 9.5px #dcd7d7;box-shadow:0 0 9.5px #dcd7d7;border-radius:0%;float:left;margin-left:62px;margin-bottom:25px;} .li .website_txt{font-size:11px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding-bottom:1.5px;font-weight:600;} .li .website_org{color:#143361;font-size:13px;font-weight:600;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;} .info-icon{ background: url(`${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_icon.svg``) no-repeat; } .li:after{content:\'\';background:#656262;position:absolute;top:28.6px;width:46px;height:2px;margin-left:165px;} .li .circle{width:1em;height:1em;box-sizing:initial;background:#fff;border:0.3em solid #656262;color:#666;border-radius:50%;line-height:2rem;box-sizing:content-box;} .li:last-child:after{width:0px !important;} .li:last-child .left{display:none;} .li:first-child{margin-left:0;} .li i{border:solid #656262;border-width:0 1.5px 1.5px 0;display:inline-block;padding:3px;} .li .right{position:absolute;left:-20px;top:26px;border-color:none;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);} .li .left{position:absolute;right:-14px;margin-right:-4px;top:26px;z-index:1;border-color:none;transform:rotate(135deg);-webkit-transform:rotate(135deg);} #project_clientDetails .ul .Vendor-org i.left{display:none;}.borderd{border:2px solid gray !important;background:white !important;-webkit-box-shadow:0 0 0 !important;box-shadow:0 0 0 !important;}.hide-in-print{display:none} table{border-collapse:collapse;border-spacing:0;}td,th{padding:0;} .table-tag{ width:-webkit-fill-available; background-color: transparent; border-spacing: 0; border-collapse: collapse; display: table; border-color: grey; } .tbody-class{ display: table-row-group; vertical-align: middle; border-color: inherit; } .tr-class{ display: table-row; vertical-align: inherit; border-color: inherit; } .hide-visibility{ visibility:hidden !important } .document-list__heading{border:1px solid #1DC942;background:#f4fef7;}.document-list__status{background:#a4f3b5;color:#1DC942;}.pL0{padding-left:0 !important;}.pR0{padding-right:0 !important;}.modal{display:none}.document-list__header{position:relative;z-index:1;} .document-list__heading{padding:5px 10px;border:1px solid $default-border-color;display:inline-block;border-radius:30px;font-weight:bold;background:$default-background-color;float:left;} .document-list__headings{padding:5px 10px;border:1px solid #c2c2c2;display:inline-block;border-radius:30px;font-weight:bold;background:$default-background-color;float:left;} .document-list__status{background:$default-border-color;color:$default-background-color;padding:0px 5px;border-radius:100%;} .multilpe-doc{background:#c2c2c2;color:#fdfdfd;padding:0px 5px;border-radius:100%;} .document-list__controls{float:right;}  .document-list__body{position:relative; padding: 25px 10px 15px 0} .file_name_span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:600px;display:inline-block;} .progress{overflow:hidden;height:5px;margin-bottom:0;background-color:#f5f5f5;border-radius:10px;-webkit-box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);} .upload_div, .upload_file_div{padding:35px;background:#FAFEFF;border:2px dashed #ccc;border-radius:8px;display:table;width:100%;cursor:pointer;text-align:center;&.dragover{background:#fff;} } .upload_file_div{padding:15px;cursor:default;} .upload-inner{display:table-cell;vertical-align:middle;padding:15px;width:15%;} .width-70{width:70%;} .testt{padding:0px } .margin-top-25{margin-top:25px;} .upload_img{padding:15px 0 20px 0;} .upload_text{padding:0 0 20px 0;} .icon{width:50px;} .icon1{width:35px;} .info{margin:0;font-size:13px;line-height:18px;color:#999;display:inline-block;} .file_name_span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;//width:600px;display:inline;} .error-holder{margin:10px 0;} .error-msg{color:$ob-error-red;} .slide-fade-enter-active{transition:all .3s ease;} .slide-fade-leave-active{transition:all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);} .slide-fade-enter, .slide-fade-leave-to{transform:translateX(10px);opacity:0;} .signature-holder{.document-signer{font-size:16px;font-weight:600;color:#337AB5;} .signauture-success{font-size:9px;color:#FFFFFF;background:#3CB55B !important;} .signauture-pending{font-size:9px;color:#FFFFFF;background:#008BE7 !important;} .document-signature-details{font-size:14px;color:#2A2A2A;} }.animation{animation-duration:1s;animation-fill-mode:both;display:inline-block;} .bounceOutLeft{animation-name:bounceOutLeft } @keyframes bounceOutLeft{18%{transform:translate3d(27px, 0, 0) } 33%{transform:translate3d(-12px, 0, 0) } 48%{transform:translate3d(8px, 0, 0) } 100%{transform:translate3d(-300%, 0, 0) } } @keyframes bounceInUp{0%{opacity:0;-webkit-transform:translateY(2000px);-ms-transform:translateY(2000px);transform:translateY(2000px);} 60%{opacity:1;-webkit-transform:translateY(-30px);-ms-transform:translateY(-30px);transform:translateY(-30px);} 80%{-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px);} 100%{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);} } .bounceOuttop{animation-name:bounceInUp } .ActionTruncateStyle{z-index:unset !important;} .fontWeightStyle{font-weight:bold;} .PaddingBottomStyle{padding-bottom:10px;} .document-table-value{font-size:13px;font-weight:600;color:#143361;margin-top: 0}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}@media (min-width:768px){.container{width:750px;}}@media (min-width:992px){.container{width:970px;}}@media (min-width:1200px){.container{width:1170px;}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}.row{margin-left:-15px;margin-right:-15px;}.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12{position:relative;min-height:1px;padding-left:15px;}.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12{float:left;}.col-xs-12{width:100%;}.col-xs-11{width:91.66666667%;}.col-xs-10{width:83.33333333%;}.col-xs-9{width:75%;}.col-xs-8{width:66.66666667%;}.col-xs-7{width:58.33333333%;}.col-xs-6{width:50%;}.col-xs-5{width:41.66666667%;}.col-xs-4{width:33.33333333%;}.col-xs-3{width:25%;}.col-xs-2{width:16.66666667%;}.col-xs-1{width:8.33333333%;}.col-xs-pull-12{right:100%;}.col-xs-pull-11{right:91.66666667%;}.col-xs-pull-10{right:83.33333333%;}.col-xs-pull-9{right:75%;}.col-xs-pull-8{right:66.66666667%;}.col-xs-pull-7{right:58.33333333%;}.col-xs-pull-6{right:50%;}.col-xs-pull-5{right:41.66666667%;}.col-xs-pull-4{right:33.33333333%;}.col-xs-pull-3{right:25%;}.col-xs-pull-2{right:16.66666667%;}.col-xs-pull-1{right:8.33333333%;}.col-xs-pull-0{right:auto;}.col-xs-push-12{left:100%;}.col-xs-push-11{left:91.66666667%;}.col-xs-push-10{left:83.33333333%;}.col-xs-push-9{left:75%;}.col-xs-push-8{left:66.66666667%;}.col-xs-push-7{left:58.33333333%;}.col-xs-push-6{left:50%;}.col-xs-push-5{left:41.66666667%;}.col-xs-push-4{left:33.33333333%;}.col-xs-push-3{left:25%;}.col-xs-push-2{left:16.66666667%;}.col-xs-push-1{left:8.33333333%;}.col-xs-push-0{left:auto;}.col-xs-offset-12{margin-left:100%;}.col-xs-offset-11{margin-left:91.66666667%;}.col-xs-offset-10{margin-left:83.33333333%;}.col-xs-offset-9{margin-left:75%;}.col-xs-offset-8{margin-left:66.66666667%;}.col-xs-offset-7{margin-left:58.33333333%;}.col-xs-offset-6{margin-left:50%;}.col-xs-offset-5{margin-left:41.66666667%;}.col-xs-offset-4{margin-left:33.33333333%;}.col-xs-offset-3{margin-left:25%;}.col-xs-offset-2{margin-left:16.66666667%;}.col-xs-offset-1{margin-left:8.33333333%;}.col-xs-offset-0{margin-left:0%;}@media (min-width:768px){.col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12{float:left;} .col-sm-12{width:100%;} .col-sm-11{width:91.66666667%;} .col-sm-10{width:83.33333333%;} .col-sm-9{width:75%;} .col-sm-8{width:66.66666667%;} .col-sm-7{width:58.33333333%;} .col-sm-6{width:50%;} .col-sm-5{width:41.66666667%;} .col-sm-4{width:33.33333333%;} .col-sm-3{width:25%;} .col-sm-2{width:16.66666667%;} .col-sm-1{width:8.33333333%;} .col-sm-pull-12{right:100%;} .col-sm-pull-11{right:91.66666667%;} .col-sm-pull-10{right:83.33333333%;} .col-sm-pull-9{right:75%;} .col-sm-pull-8{right:66.66666667%;} .col-sm-pull-7{right:58.33333333%;} .col-sm-pull-6{right:50%;} .col-sm-pull-5{right:41.66666667%;} .col-sm-pull-4{right:33.33333333%;} .col-sm-pull-3{right:25%;} .col-sm-pull-2{right:16.66666667%;} .col-sm-pull-1{right:8.33333333%;} .col-sm-pull-0{right:auto;} .col-sm-push-12{left:100%;} .col-sm-push-11{left:91.66666667%;} .col-sm-push-10{left:83.33333333%;} .col-sm-push-9{left:75%;} .col-sm-push-8{left:66.66666667%;} .col-sm-push-7{left:58.33333333%;} .col-sm-push-6{left:50%;} .col-sm-push-5{left:41.66666667%;} .col-sm-push-4{left:33.33333333%;} .col-sm-push-3{left:25%;} .col-sm-push-2{left:16.66666667%;} .col-sm-push-1{left:8.33333333%;} .col-sm-push-0{left:auto;} .col-sm-offset-12{margin-left:100%;} .col-sm-offset-11{margin-left:91.66666667%;} .col-sm-offset-10{margin-left:83.33333333%;} .col-sm-offset-9{margin-left:75%;} .col-sm-offset-8{margin-left:66.66666667%;}.col-sm-offset-7{margin-left:58.33333333%;} .col-sm-offset-6{margin-left:50%;} .col-sm-offset-5{margin-left:41.66666667%;} .col-sm-offset-4{margin-left:33.33333333%;} .col-sm-offset-3{margin-left:25%;} .col-sm-offset-2{margin-left:16.66666667%;} .col-sm-offset-1{margin-left:8.33333333%;} .col-sm-offset-0{margin-left:0%;}}@media (min-width:992px){.col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12{float:left;} .col-md-12{width:100%;} .col-md-11{width:91.66666667%;} .col-md-10{width:83.33333333%;} .col-md-9{width:75%;} .col-md-8{width:66.66666667%;} .col-md-7{width:58.33333333%;} .col-md-6{width:50%;} .col-md-5{width:41.66666667%;} .col-md-4{width:33.33333333%;} .col-md-3{width:25%;} .col-md-2{width:16.66666667%;} .col-md-1{width:8.33333333%;} .col-md-pull-12{right:100%;} .col-md-pull-11{right:91.66666667%;} .col-md-pull-10{right:83.33333333%;} .col-md-pull-9{right:75%;} .col-md-pull-8{right:66.66666667%;} .col-md-pull-7{right:58.33333333%;} .col-md-pull-6{right:50%;} .col-md-pull-5{right:41.66666667%;} .col-md-pull-4{right:33.33333333%;} .col-md-pull-3{right:25%;} .col-md-pull-2{right:16.66666667%;} .col-md-pull-1{right:8.33333333%;} .col-md-pull-0{right:auto;} .col-md-push-12{left:100%;} .col-md-push-11{left:91.66666667%;} .col-md-push-10{left:83.33333333%;} .col-md-push-9{left:75%;} .col-md-push-8{left:66.66666667%;} .col-md-push-7{left:58.33333333%;} .col-md-push-6{left:50%;} .col-md-push-5{left:41.66666667%;} .col-md-push-4{left:33.33333333%;} .col-md-push-3{left:25%;} .col-md-push-2{left:16.66666667%;} .col-md-push-1{left:8.33333333%;} .col-md-push-0{left:auto;} .col-md-offset-12{margin-left:100%;} .col-md-offset-11{margin-left:91.66666667%;} .col-md-offset-10{margin-left:83.33333333%;} .col-md-offset-9{margin-left:75%;} .col-md-offset-8{margin-left:66.66666667%;} .col-md-offset-7{margin-left:58.33333333%;} .col-md-offset-6{margin-left:50%;} .col-md-offset-5{margin-left:41.66666667%;} .col-md-offset-4{margin-left:33.33333333%;} .col-md-offset-3{margin-left:25%;} .col-md-offset-2{margin-left:16.66666667%;} .col-md-offset-1{margin-left:8.33333333%;} .col-md-offset-0{margin-left:0%;}}@media (min-width:1200px){.col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12{float:left;} .col-lg-12{width:100%;} .col-lg-11{width:91.66666667%;} .col-lg-10{width:83.33333333%;} .col-lg-9{width:75%;} .col-lg-8{width:66.66666667%;} .col-lg-7{width:58.33333333%;} .col-lg-6{width:50%;} .col-lg-5{width:41.66666667%;} .col-lg-4{width:33.33333333%;} .col-lg-3{width:25%;} .col-lg-2{width:16.66666667%;} .col-lg-1{width:8.33333333%;} .col-lg-pull-12{right:100%;} .col-lg-pull-11{right:91.66666667%;} .col-lg-pull-10{right:83.33333333%;} .col-lg-pull-9{right:75%;} .col-lg-pull-8{right:66.66666667%;} .col-lg-pull-7{right:58.33333333%;} .col-lg-pull-6{right:50%;} .col-lg-pull-5{right:41.66666667%;} .col-lg-pull-4{right:33.33333333%;} .col-lg-pull-3{right:25%;} .col-lg-pull-2{right:16.66666667%;} .col-lg-pull-1{right:8.33333333%;} .col-lg-pull-0{right:auto;} .col-lg-push-12{left:100%;} .col-lg-push-11{left:91.66666667%;} .col-lg-push-10{left:83.33333333%;} .col-lg-push-9{left:75%;} .col-lg-push-8{left:66.66666667%;} .col-lg-push-7{left:58.33333333%;} .col-lg-push-6{left:50%;} .col-lg-push-5{left:41.66666667%;} .col-lg-push-4{left:33.33333333%;} .col-lg-push-3{left:25%;} .col-lg-push-2{left:16.66666667%;} .col-lg-push-1{left:8.33333333%;} .col-lg-push-0{left:auto;} .col-lg-offset-12{margin-left:100%;} .col-lg-offset-11{margin-left:91.66666667%;} .col-lg-offset-10{margin-left:83.33333333%;} .col-lg-offset-9{margin-left:75%;} .col-lg-offset-8{margin-left:66.66666667%;} .col-lg-offset-7{margin-left:58.33333333%;} .col-lg-offset-6{margin-left:50%;} .col-lg-offset-5{margin-left:41.66666667%;} .col-lg-offset-4{margin-left:33.33333333%;} .col-lg-offset-3{margin-left:25%;} .col-lg-offset-2{margin-left:16.66666667%;} .col-lg-offset-1{margin-left:8.33333333%;} .col-lg-offset-0{margin-left:0%;}}.footer-line{margin-top:20px;border-bottom:1px dashed grey;margin-bottom:20px;} .doc-header{color:#000;font-weight:600;font-size:14px;font-weight:600px;} .request-doc-header{color:#143361;font-weight:700;font-size:16px;padding-left:25px;} .icon-header{padding-right:50px;} .info-text-blue{color:#4A90E2;font-size:15px;} .info-text-green{color:#1DC942;font-size:15px;} .info-text{font-size:15px;} .listDocs-text{color:#4A90E2;font-weight:600;font-size:13px;} .doc-overflow{overflow:auto;height:100%;} .status-options{margin:26px 0 0 0;} .section-personal{border-bottom:2px dashed #c2c2c2;padding:10px 0;} .checklist-docs{overflow:auto;height:100%;} .btnUpload{width:79px;height:28px;background-color:#1d437b } .document-list__headingStyle{padding:5px 10px;border:1px solid #c2c2c2;display:inline-block;border-radius:30px;font-weight:bold;//background:#c2c2c2;} .document-list__statusStyle{background:#c2c2c2;color:#fdfdfd;padding:0px 5px;border-radius:100%;margin-left:30px;} .star{color:red;} .heading-text{color:#000;font-weight:700;font-size:13px;padding:20px 0px 0px 15px;} .upload-text{padding:0px 0px 10px 25px } .names-text{color:#000;padding-top:20px;font-weight:700;font-size:12px;} .label-text{padding-bottom:5px;color:#000;font-size:13px;} .checklist-docs{overflow:auto;height:100%;} .contact-info-text{color:#000;font-size:13px;font-weight:700;padding-top:15px;} .radio-buttons{margin-left:-20px;} .current-info-text{color:#000;padding:15px 0px 0px 15px;font-weight:700;font-size:13px;} .footer-buttons{text-align:center;padding-top:30px;} .actions-text{padding-bottom:20px;text-align:right;margin-left:186px;} .required-docs-text{color:#000;padding:15px 0px 0px 0px;font-weight:700;font-size:13px;} .add-name{color:#4A90E2;font-style:italic;text-decoration:underline;font-weight:700;padding-left:5px;cursor:pointer;} .btn-upload{padding-bottom:20px;} .section-heading-dependent{color:#393939;font-weight:600;font-size:17px } .radio-label{color:#393939;font-weight:600;} .remove-worklocation{float:right;color:#D60000;font-size:11px;font-weight:650;margin-top:5px;padding-right:4px } .remove-location{float:right;color:#D60000;font-size:11px;font-weight:650;margin-top:5px;padding-right:26px } .fontStyle{font-weight:bold;padding:15px;font-size:17px;border-bottom:1px dashed #ccc;} .infoStyle{color:#4191ef;padding-bottom:25px;font-weight:600;} .fontHeadStyle{padding-bottom:15px;font-weight:600;font-size:15px;color:#143361;} .fontSubHeadPadStyle{padding-bottom:10px;} .fontSubHeadStyle{font-size:14px;padding-bottom:10px;font-weight:600;color:#143361;} .fontSubHeadBoldStyle{font-weight:600;color:#143361;overflow-wrap:break-word;font-size:14px} .fontSubHeBoldStyle{font-weight:bold;} .fontSubHeadBoldPadStyle{font-weight:600;padding-left:8px;color:#143361;overflow-wrap:break-word;} .fontStySubHeadBoldPadStyle{font-weight:600;padding-left:22px;color:#143361;overflow-wrap:break-word;} .IconTitleColor{color:rgb(40, 167, 69);font-weight:bold;} .IconTitleblueColor{padding-left:0px;font-weight:bold;color:#4A90E2;} .padIconStyle{padding-bottom:20px;} .padStyle{padding-top:10px;padding-bottom:15px;} .padArrowLeftStyle{padding-left:60px;} .document-list__headingApprovedStyle{padding:5px 10px;border:1px solid #3CB55B;display:inline-block;border-radius:30px;font-weight:bold;background:#F9F9F9;float:left;} .document-list__statusApprovedStyle{background:#ACF3BE;color:#3CB55B;padding:0px 5px;border-radius:100%;} .fontCheckStyle{font-size:14px;font-weight:600;color:#143361;} .fontborderStyle{padding-bottom:25px;padding-top:25px;padding-left:0px;border-top:1px dashed #ccc;} .fontborderSolidStyle{padding-top:35px;padding-left:0px;padding-bottom:40px;border-top:1px solid #ccc;text-align:center;} .fontSizeInfoIconStyle{font-size:17px;} .margPillStyle{margin-left:-10px;} .at{color:#143361;font-weight:600;font-size:21px;padding-top:13px;} .pas{font-weight:normal;font-size:14px;padding-bottom:30px;} .pas p{color:#727d8c;font-size:13px;font-weight:600;} .ContenttoBottomStyle{//padding-bottom:10% !important;} .BorderStyle{border-bottom:1px solid grey;padding-bottom:20px;} .close{border:1px solid black;border-radius:12px;}.input-field-field{width:60%;height:20px;//padding:1.5%;margin-right:5%;display:inline-block;border-radius:10px;//box-sizing:border-box;}.input-field{width:100%;margin-right:5%;background:#666666;border-radius:10px;box-sizing:border-box;}.fixed-org{display:flex;justify-content:left;padding-top:2%;}.align-org{display:flex;justify-content:left;padding-top:4%;}.vl{border-left:1px solid #DFDFDF;position:inherit;margin-left:5%;margin-top:-12px;width:134%;}.org-vl{border-left:1px solid #DFDFDF;position:inherit;margin-left:5%;margin-top:-12px;width:134%;padding-left:57px;}.org-main-align{border-left:1px solid #DFDFDF;position:inherit;}.add-another-text-align{position:inherit;margin-left:5%;margin-top:-10px;width:134%;margin-top:-22px;margin-left:42px;}.add-position{margin-top:5%;margin-left:-14px;cursor:pointer;}.line{margin-top:40px;width:10%;}.heading{padding-top:5% !important;padding-bottom:5% !important;}.normal-input{background:white !important;}*:focus{outline:none;}.flow-digram{height:50%;width:30%}.add-another-client{margin-top:10px;color:#4A90E2;font-style:italic;font-weight:700;font-size:11px;cursor:pointer;}.endclient-details{display:flex;width:140%;justify-content:left;padding-left:5%;} .end-client-name{//text-align:left;// padding-left:80px !important;font-size:12px;color:#000;padding-bottom:5px;} .end-client-website{// float:right;//margin-right:-38px !important;font-size:12px;color:#000;padding-bottom:5px;} .client-details{font-size:12px;color:#000;margin-left:15%;margin-bottom:-18px;display:inline-block;} .client-website{font-size:12px;color:#000;margin-left:45%;display:inline-block;} .vendor-details{font-size:12px;color:#000;margin-left:15%;margin-bottom:-18px;display:inline-block;}.vendor-website{font-size:12px;color:#000;margin-left:40%;display:inline-block;} .organization{font-size:12px;color:#000;padding-left:0px;padding-bottom:5px;//margin-left:39px;} .input-client-field{//width:100%;// margin-right:5%;border-radius:10px;box-sizing:border-box;} .padToppSty{padding-top:10px;} .remove-name{color:#D60000;font-style:italic;text-decoration:underline;font-weight:800;font-size:13px;padding-left:5px;cursor:pointer;} .commentTopStyle{background:#ffd9cd;border-radius:4px;white-space:normal;padding-left:9px;padding-top:5px;padding-bottom:5px;overflow-wrap:break-word;} .commentStyle{background:#efefef;border-radius:4px;white-space:normal;padding-left:9px;padding-top:5px;padding-bottom:5px;overflow-wrap:break-word;} .document-list__ApproveStatusESSStyle{background:#c7ffd3;color:#079f6c;padding:0px 5px;border-radius:100%;font-size:10px;} .document-list__RejectStatusESSStyle{background:#D60000;color:#fff;padding:0px 5px;border-radius:100%;font-size:10px;} .padBottomStyle{padding-top:10px;} .conditionalBorder{border-bottom:2px dashed #789acc;margin-bottom:15px !important;padding-top:15px !important;} </style> <body>' + printOne + '</body></html>'
            let obj = {
                'essHTML' : updatedPrint

            }

              // this.$loading({}).close()
            ajax.post(`H1BCheckList/ESSSubmittingRequestedDocs?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}`, obj, (res) => {
            if(res.data.State==true){
            this.$loading({}).close()
            this.showSuccessPopup=true
            }else{
              this.$loading({}).close()
            if(res.data.WarningMessage != "" && res.data.WarningMessage != null){
                this.isShowWarningMsgPopup = true
                this.warningContent = res.data.WarningMessage
            }else{
                this.$message({
                type:'error',
                message:res.data.Message
            })
           }
            }
            })

            },


                    changeDependentType(vIndex) {


                        if (this.dependentsArray.length == 0) {
                            this.AddAnotherDependent(v)
                        } else {
                            this.updateDependentType(vIndex)
                        }

                    },
                    updateDependentType(index) {
                        this.dependentsArray[index].foreginAddressObj.type = this.dependentsArray[index].type
                        this.dependentsArray[index].basicInfoObj.familyName = ''
                        this.dependentsArray[index].basicInfoObj.givenName = ''
                        this.dependentsArray[index].basicInfoObj.middleName = ''
                        this.dependentsArray[index].basicInfoObj.birthDate = ''
                        this.dependentsArray[index].basicInfoObj.countryCitizenShip = ''
                        this.dependentsArray[index].basicInfoObj.birthCountry = ''
                        this.dependentsArray[index].basicInfoObj.ssnNumber = ''
                        this.dependentsArray[index].addressObj.Number = ''
                        this.dependentsArray[index].addressObj.aptRadio = "Apt"
                        this.dependentsArray[index].addressObj.cityState = ''
                        this.dependentsArray[index].addressObj.immigrationStatus = ''
                        this.dependentsArray[index].addressObj.streetName = ''
                        this.dependentsArray[index].addressObj.zipCode = ''
                        if(this.dependentsArray[index].passPortDetails.showPassportDetails){
                            this.dependentsArray[index].passPortDetails.showPassportDetails = false
                            this.dependentsArray[index].passPortDetails.Number = ''
                            this.dependentsArray[index].passPortDetails.issueDate = ''
                            this.dependentsArray[index].passPortDetails.expirydate = ''
                            this.dependentsArray[index].passPortDetails.issuedBy = ''
                            this.dependentsArray[index].passPortDetails.documentUrl = ''
                            this.dependentsArray[index].passPortDetails.passportDocIncrement++
                        }
                        if(this.dependentsArray[index].I94DetailsObj.showI94Details){
                            this.dependentsArray[index].I94DetailsObj.showI94Details = false
                            this.dependentsArray[index].I94DetailsObj.i94ReceiptNumber = ''
                            this.dependentsArray[index].I94DetailsObj.i94StartDate = ''
                            this.dependentsArray[index].I94DetailsObj.i94EndDate = ''
                            this.dependentsArray[index].I94DetailsObj.documentUrl = ''
                            this.dependentsArray[index].I94DetailsObj.i94DocIncrement++
                        }
                    },
                    getZipCode(l) {
                        setTimeout(() => {
                            if (l.cityState != '' && l.cityState != null) {
                                ajax.get(`/Account/GetZipCode?location=${l.cityState}`, {}, (res) => {
                                    l.zipCode = res.data.ZipCodeModel.ZipCode
                                })
                            } else
                                l.zipCode = ''

                        }, 100)
                    },
                    getZipCodeForEmpInfo(l) {
                        setTimeout(() => {
                            if (l.empcurrentCity != '' && l.empcurrentCity != null) {
                                ajax.get(`/Account/GetZipCode?location=${l.empcurrentCity}`, {}, (res) => {
                                    this.Employeeinfo.empzipcode = res.data.ZipCodeModel.ZipCode
                                })
                            } else
                                this.Employeeinfo.empzipcode = ''

                        }, 100)
                    },
                    getZipCodeForForeignAddr(l) {
                        setTimeout(() => {
                            if (l != '' && l != null) {
                                ajax.get(`/Account/GetZipCode?location=${l}`, {}, (res) => {
                                    this.personalInfoForeignAddressZip = res.data.ZipCodeModel.ZipCode
                                })
                            } else
                                this.personalInfoForeignAddressZip = ''

                        }, 100)
                    },
                    getZipCodeForDependentForeignAddr(l) {
                        setTimeout(() => {
                            if (l.cityState != '' && l.cityState != null) {
                                ajax.get(`/Account/GetZipCode?location=${l.cityState}`, {}, (res) => {
                                    l.Zip = res.data.ZipCodeModel.ZipCode
                                })
                            } else
                                this.dependentsArray.foreginAddressObj.Zip = ''

                        }, 100)
                    },
                    resetForeignAddrsValues(dpntArr){
                        if(dpntArr.Country =='United States'){
                            dpntArr.cityState = ''
                            dpntArr.Zip = ''
                            dpntArr.Province = ''
                        }else{
                            dpntArr.city = ''
                            dpntArr.State = ''
                            dpntArr.Province = ''
                            dpntArr.CountryCode = ''
                        }

                    },
                    bindingResetvalues(){
                        if(this.isresetForeginValues == true){
                            this.personalInformationESSData()
                            this.isresetForeginValues = false
                        }
                    },
                    getZipCodeForCurrentAddr(l) {
                        setTimeout(() => {
                            if (l != '' && l != null) {
                                ajax.get(`/Account/GetZipCode?location=${l}`, {}, (res) => {
                                    this.personalInfoCurrentAddressZip = res.data.ZipCodeModel.ZipCode
                                })
                            } else
                                this.personalInfoCurrentAddressZip = ''

                        }, 100)
                    },
                    getZipCodeForEduInfo(l) {
                        setTimeout(() => {
                            if (l.currentCity != '' && l.currentCity != null) {
                                ajax.get(`/Account/GetZipCode?location=${l.currentCity}`, {}, (res) => {
                                    this.educationinfo.zipcode = res.data.ZipCodeModel.ZipCode
                                })
                            } else
                                this.educationinfo.zipcode = ''

                        }, 100)

                    },

                    removeDependent(arr, index) {
                        arr.splice(index, 1)
                        this.dependentsArray = []
                        this.dependentsArray = arr
                            //this.CompleteWorkLocationDetails.WorkLocation
                    },
                    removeAddanotherStayperiod(arr, index) {
                        arr.splice(index, 1)
                        this.addAnotherStayArray = []
                        this.addAnotherStayArray = arr
                    },
                    removeAddanotherApproval(arr, index) {
                        arr.splice(index, 1)
                        this.addAnotherApprovalArray = []
                        this.addAnotherApprovalArray = arr
                    },
                    removeAddanotherName(arr, index) {
                        arr.splice(index, 1)
                        this.addAnotherNameArray = []
                        this.addAnotherNameArray = arr
                    },
                     AddAnotherDependent(v) {

                        let tempDependentType = ''
                          let tempH4RadioBtn = ''
                          let tempMarriageDocObj = {}
                          let tempBirthCertificateDocObj = {}
                          let tempFormI539DocObj = {}
                          let docsArray = []
                        if (v == 'Child') {
                            tempDependentType = 'Child'
                            tempH4RadioBtn ='1'

                        } else {
                            tempDependentType = 'Spouse'
                              tempH4RadioBtn ='2'
                        }
                           tempBirthCertificateDocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "BirthCertificate",
                                            "DisplayName": "Birth Certificate",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                    "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }

                                        docsArray.push(tempBirthCertificateDocObj)

                          tempMarriageDocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "MarriageCertificate",
                                            "DisplayName": "Marriage Certificate",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                    "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }

                                        docsArray.push(tempMarriageDocObj)

                                        tempFormI539DocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "FormI539",
                                            "DisplayName": "Form I-539",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                     "IsRequired": true
                                                },

                                            ],
                                            "MetadataValues": []
                                        }
                                        docsArray.push(tempFormI539DocObj)



                        let obj = {

                            type: tempDependentType,
                            id:'',
                            basicInfoObj: {
                                "familyName": '',
                                "givenName": '',
                                "middleName": '',
                                "maidenName": '',
                                "birthDate": '',
                                "countryCitizenShip": '',
                                "birthCountry": '',
                                "ssnNumber": '',
                                "emailAddr": '',
                                "phoneNum": ''
                            },
                            selectH4:tempH4RadioBtn,
                            addressObj: {
                                "streetName": '',
                                "aptRadio": 'Apt',
                                "Number": '',
                                "cityState": '',
                                "zipCode": '',
                                "immigrationStatus": ''

                            },
                            foreginAddressObj:{
                                "streetName": '',
                                "aptRadio": 'Flr',
                                "AptNumber": '',
                                "cityState": '',
                                "city": '',
                                "State": '',
                                "Zip": '',
                                "Province": '',
                                "CountryCode": '',
                                "Country":'' ,
                                'type':tempDependentType
                            },

                            passPortDetails: {
                                "Number": '',
                                "issueDate": '',
                                "expirydate": '',
                                "issuedBy": '',
                                "documentUrl": '',
                                'showPassportDetails':false,
                                "passportDocIncrement": 0,
                            },
                            // visaDetailsObj: {
                            //     "lastEntrydate": '',
                            //     "admitUntil": '',
                            //     "currenStatus": '',
                            //     "documentUrl": ''

                            // },
                            I94DetailsObj: {
                                "i94ReceiptNumber": '',
                                "i94StartDate": '',
                                "i94EndDate": '',
                                "documentUrl": '',
                                "showI94Details":false,
                                "i94DocIncrement": 0,
                            },
                            tempDocsBinding:[],
                            Documents:docsArray

                        }

                        this.dependentsArray.push(obj)
                        this.increVal1++
                    },
                    selectDependentRadioBtn(v) {
                        //
                        if (v == '1') {
                            if (this.dependentsArray.length == 0) {
                                this.AddAnotherDependent('Spouse')
                                this.$v.dependentsArray.$reset()

                            } else {
                                this.$v.dependentsArray.$reset()
                            }
                        }

                    },
                    selectDependentNoRadioBtn(v) {
                        if(v=='2') {
                            //
                            this.dependentsArray = []
                            this.selectH4Dpdnt('2') // Changing the 'Do you have extension/change of status of H-4 dependent?' to 'No'
                        }
                    },
                    // alienpatterMatch: function() {
                    //     let regex = /^(A)([0-9]{8,9})$/gm
                    //     let re = new RegExp(regex, 'g')
                    //     let res = re.test(this.personalInfoAlienNumber)
                    //     if (res == false && this.personalInfoAlienNumber !='') {
                    //         this.isShowAlienNumberVal = true
                    //     } else {
                    //         this.isShowAlienNumberVal = false
                    //     }
                    // },
                    isOpenUploadPopup() {
                        // this.showUpdatePopup = true
                    },
                    cancelUpload() {
                        this.showUpdatePopup = false
                    },
                    patternMatch: function(a) {
                        if (a == 1) {
                            this.isShowEADValidation = true
                            if (this.ImmigrationInfo.EADNumber.length == 16 || this.ImmigrationInfo.EADNumber == '') {
                                this.isShowEADValidation = false
                            }
                        } else {
                            let regex = /^(N)([0-9]{10})$/gm
                            let re = new RegExp(regex, 'g')
                            let res = re.test(this.ImmigrationInfo.SEVISNumber)
                            if (res == false && this.ImmigrationInfo.SEVISNumber !='') {
                                this.isShowSEVISNumberVal = true
                            } else {
                                this.isShowSEVISNumberVal = false
                            }
                        }
                    },
                    backtoEmpinfo() {
                        // if(this.Employeeinfo.empAddressVal == 'No'){
                        //     this.resetEmployeeAddressValues()
                        // }
                        this.OpenemploymentinfoForm = true
                        this.OpenimmigrationinfoForm = false
                        if(this.OpenemploymentinfoForm == true){
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=false
                         this.showEmploymentApproveOrRejectComments=true
                         this.showImmigrationApproveOrRejectComments=false
                         this.showDependentApproveOrRejectComments=false
                         //this.showPersonalApproveOrRejectIcon=true
                         //this.showEducationalApproveOrRejectIcon=true
                         //this.showEmploymentApproveOrRejectIcon=true
                         //this.showImmigrationApproveOrRejectIcon=false
                         //this.showDependentApproveOrRejectIcon=false
                         }

                    },
                    backtoHome() {
                        let from = this.$route.query.from
                        if (from != null && from != "") {
                            this.$router.push({
                                name: from
                            })
                        }
                    },
                    gotoeduinfo() {
                        // this.$v.PersonalInfo.$touch();
                        this.$v.personalInfoPrimaryContactLastNameVal.$touch();
                        this.$v.personalInfoPrimaryContactFirstNameVal.$touch();
                        this.$v.personalInfoPrimaryContactMiddleNameVal.$touch();
                        // this.$v.PersonalInfoLegalContactsLastName.$touch();
                        // this.$v.PersonalInfoLegalContactsFirstName.$touch();
                        // this.$v.PersonalInfoLegalContactsMiddleName.$touch();
                        this.$v.extranameOtherLastName.$touch();
                        this.$v.extranameOtherFirstName.$touch();
                        this.$v.extranameOtherMiddleName.$touch();
                        this.$v.personalInfoPrimaryContactMobileNoVal.$touch();
                        this.$v.personalInfoPrimaryContactEmailVal.$touch();
                        this.$v.personaInfoPrimaryContactDOB.$touch();
                        this.$v.personalInfoBirthCountry.$touch();
                        this.$v.personalInfoProvienceOfBirth.$touch();
                        this.$v.personalInfoNationality.$touch();
                        this.$v.personalInfoPrimaryContactSocialSecurtiyNumber.$touch();
                        this.$v.personalInfoAlienNumber.$touch();
                        this.$v.personalInfoCurrentAddressZip.$touch();
                        this.$v.personalInfoForeignAddressCity.$touch();
                        this.$v.personalInfoForeignAddressZip.$touch();
                        // this.$v.personalInfoForeignAddressProvince.$touch();
                        this.$v.personalInfoForeignAddressCountryCode.$touch();
                        this.$v.personalInfoForeignAddressCounty.$touch();
                        this.$v.personalInfoForeignAddressIndiaState.$touch();
                        this.$v.personalInfoForeignAddressIndiaCity.$touch();
                        if (this.$v.personalInfoPrimaryContactLastNameVal.$invalid == false && this.$v.personalInfoPrimaryContactFirstNameVal.$invalid == false && this.$v.personalInfoPrimaryContactMiddleNameVal.$invalid == false && this.$v.personalInfoPrimaryContactMobileNoVal.$invalid == false && this.$v.personalInfoPrimaryContactEmailVal.$invalid == false && this.$v.personaInfoPrimaryContactDOB.$invalid == false && this.$v.personalInfoBirthCountry.$invalid == false && this.$v.personalInfoProvienceOfBirth.$invalid == false && this.$v.personalInfoNationality.$invalid == false && this.$v.personalInfoPrimaryContactSocialSecurtiyNumber.$invalid == false && this.$v.personalInfoAlienNumber.$invalid == false && this.$v.personalInfoCurrentAddressZip.$invalid == false && this.$v.personalInfoForeignAddressCity.$invalid == false && this.$v.personalInfoForeignAddressZip.$invalid == false  && this.$v.personalInfoForeignAddressCountryCode.$invalid == false && this.$v.personalInfoForeignAddressCounty.$invalid == false  && this.$v.personalInfoForeignAddressIndiaState.$invalid == false  && this.$v.personalInfoForeignAddressIndiaCity.$invalid == false) {
                        this.saveStructureForPersonalInfo()
                        }
                    },
                    saveStructureForPersonalInfo() {
                        this.$loading({
                            'loadingText': 'Loading...'
                        })
                        if (this.PersonalInfoIsLegalContactAvailable == "No") {
                            this.PersonalInfoIsLegalContactAvailableYes = false
                        } else {
                            this.PersonalInfoIsLegalContactAvailableYes = true
                        }
                        if (this.personalInfoCurrentAddressAptORSteOrFlr == "Apt") {
                            this.personalInfoCurrentAddressApt = true
                        } else if (this.personalInfoCurrentAddressAptORSteOrFlr == "Ste") {
                            this.personalInfoCurrentAddressSte = true
                        } else {
                            this.personalInfoCurrentAddressFlr = true
                        }
                        if (this.personalInfoForeignAddressAptORSteOrFlr == "Apt") {
                            this.personalInfoForeignAddressApt = true
                        } else if (this.personalInfoForeignAddressAptORSteOrFlr == "Ste") {
                            this.personalInfoForeignAddressSte = true
                        } else {
                            this.personalInfoForeignAddressFlr = true
                        }
                         var currentStr = this.personalInfoCurrentAddressCity
                        var currentStrArray = currentStr.split(',')
                        var personalInfoForeignCityLocation = ''
                        var personalInfoForeignStateLocation= ''
                        var tempAddrsummary = ''

                        var personalInfoCurentCityLocation = currentStrArray[0]
                        var personalInfoCurrentStateLocation = currentStrArray[1]
                        var foreignStr = this.personalInfoForeignAddressCity
                        var foreignStrArray = foreignStr.split(',')
                        if(this.personalInfoForeignAddressCounty == 'United States'){
                             personalInfoForeignCityLocation = foreignStrArray[0]
                         personalInfoForeignStateLocation = foreignStrArray[1]
                         tempAddrsummary = this.personalInfoForeignAddressCity  //this.personalInfoCurrentAddressCity
                        }else{
                          personalInfoForeignCityLocation =  this.personalInfoForeignAddressIndiaCity
                           personalInfoForeignStateLocation =  this.personalInfoForeignAddressIndiaState
                            tempAddrsummary = personalInfoForeignCityLocation+', '+personalInfoForeignStateLocation
                        }


                        var legalContactList = []
                        if(this.PersonalInfoIsLegalContactAvailableYes) {
                            if(this.addAnotherNameArray.length > 0) {
                                this.addAnotherNameArray.forEach((contact, dIndex) => {
                                    if((contact.OtherFirstName != null && contact.OtherFirstName != '')||
                                    (contact.OtherLastName != null && contact.OtherLastName != '') ||
                                    (contact.OtherMiddleName != null && contact.OtherMiddleName != '')) {
                                        var legalContact = {
                                            "FirstName": contact.OtherFirstName,
                                            "LastName": contact.OtherLastName,
                                            "MiddleName" : contact.OtherMiddleName
                                        }
                                        legalContactList.push(legalContact)
                                    }
                                })
                            }
                        }

                        let obj = []
                        obj = {
                            'Id':this.personalInfoId,
                            'PrimaryContact': {
                                'FirstName': this.personalInfoPrimaryContactFirstNameVal,
                                'LastName': this.personalInfoPrimaryContactLastNameVal,
                                'MiddleName': this.personalInfoPrimaryContactMiddleNameVal,
                                'MobileNo': this.personalInfoPrimaryContactMobileNoVal,
                                'Email': this.personalInfoPrimaryContactEmailVal,
                                'SocialSecurtiyNumber': this.personalInfoPrimaryContactSocialSecurtiyNumber,
                                'DOB': moment(this.personaInfoPrimaryContactDOB).format("MM/DD/YYYY")
                            },
                            'IsLegalContactAvailable': this.PersonalInfoIsLegalContactAvailableYes,
                            'LegalContacts' : legalContactList,
                            // 'LegalContacts': [{
                            //     'FirstName': this.PersonalInfoLegalContactsFirstName,
                            //     'LastName': this.PersonalInfoLegalContactsLastName,
                            //     'MiddleName': this.PersonalInfoLegalContactsMiddleName,
                            // }],
                            'Gender': this.PersonalInfoGender,
                            'MaritalStatus': this.personalInfoMaritalStatus,
                            'BirthCountry': this.personalInfoBirthCountry,
                            'ProvienceOfBirth': this.personalInfoProvienceOfBirth,
                            'Nationality': this.personalInfoNationality,
                            'AlienNumber': this.personalInfoAlienNumber,
                            'CurrentAddress': {
                                'Address1': this.personalInfoCurrentAddressStreetNo,
                                'IsApt': this.personalInfoCurrentAddressApt,
                                'IsSuite': this.personalInfoCurrentAddressSte,
                                'IsFloor': this.personalInfoCurrentAddressFlr,
                                // IsApt/IsSuite/IsFloor: true/false,
                                'AptNumber': this.personalInfoCurrentAddressAptNumber,
                                'City': personalInfoCurentCityLocation,
                                'State': personalInfoCurrentStateLocation,
                                'Zip': this.personalInfoCurrentAddressZip,
                                'AddressSummary': this.personalInfoCurrentAddressCity
                            },
                            'ForeignAddress': {
                                'Address1': this.personalInfoForeignAddressStreetNo,
                                'IsApt': this.personalInfoForeignAddressApt,
                                'IsSuite': this.personalInfoForeignAddressSte,
                                'IsFloor': this.personalInfoForeignAddressFlr,
                                'AptNumber': this.personalInfoForeignAddressAptNumber,
                                'City': personalInfoForeignCityLocation,
                                'State': personalInfoForeignStateLocation,
                                'Zip': this.personalInfoForeignAddressZip,
                                'AddressSummary': tempAddrsummary,
                                'Province': this.personalInfoForeignAddressProvince,
                                'CountryCode': this.personalInfoForeignAddressCountryCode,
                                'County': this.personalInfoForeignAddressCounty
                            },
                            'Documents': this.personalInfomation.Documents
                        }

                        ajax.post(`H1BCheckList/AddOrUpdatePersonalInfoForESS?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}`, obj, (res) => {
                         if(res.data.State == true){
                             this.$loading({}).close()
                             this.personalInfomation = res.data.PersonalInfomation
                         this.OpeneducationalInfoForm = true
                         if(this.OpeneducationalInfoForm == true){
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=true
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=false
                         this.showDependentApproveOrRejectComments=false
                         //this.showPersonalApproveOrRejectIcon=true
                         //this.showEducationalApproveOrRejectIcon=true
                         //this.showEmploymentApproveOrRejectIcon=false
                         //this.showImmigrationApproveOrRejectIcon=false
                         //this.showDependentApproveOrRejectIcon=false
                         }
                        }else{
                            this.$loading({}).close()
                            if(res.data.WarningMessage != "" && res.data.WarningMessage != null) {
                                this.isShowWarningMsgPopup = true
                                this.warningContent = res.data.WarningMessage
                            }
                            else {
                                 this.$message({
                            type: 'error',
                            message: res.data.Message
                              })

                            }

                        }
                        })

                    },
                    saveStructureForEducationalInfo(){
                        this.$loading({
                            'loadingText': 'Loading...'
                        })
                    let obje = []
                         this.educationInfomation.Documents.forEach((edInfoDocs , eIndex) =>{
                            if(edInfoDocs.DocumentType == 'DegreeCerificates'){
                                if(this.educationinfo.mastersDegreeVal == "Yes"){
                                    if(edInfoDocs.MetadataValues.length > 0){
                                        edInfoDocs.MetadataValues.forEach((g) =>{
                                            g.DocumentId = g.DocumentId
                                            g.DocumentData.forEach((f) =>{
                                                if(f.Key == 'Name'){
                                                    f.Value = 'Degree Cerificates'
                                                }
                                                else if(f.Key == 'DocumentUrl'){
                                                    f.Value = this.educationDetailsDocURL
                                                }
                                            })
                                        })
                                    }
                                    else{
                                        let tempMetadataVal1 = [{
                                            "DocumentId": '',
                                            "DocumentData": [{
                                                    "Key": "Name",
                                                    "Value": 'Degree Cerificates'
                                                },
                                                {
                                                    "Key": "DocumentUrl",
                                                    "Value": this.educationDetailsDocURL
                                                }],
                                        }]
                                        edInfoDocs.MetadataValues = tempMetadataVal1
                                    }
                                }
                                else{
                                    edInfoDocs.MetadataValues = []
                                }
                            }

                            if(edInfoDocs.DocumentType == 'Certifications'){
                                if(this.educationinfo.appeareYes == "Yes"){
                                    if(edInfoDocs.MetadataValues.length > 0){
                                        edInfoDocs.MetadataValues.forEach((g) =>{
                                            g.DocumentId = g.DocumentId
                                            g.DocumentData.forEach((f) =>{
                                                if(f.Key == 'Name'){
                                                    f.Value = 'Certifications'
                                                }
                                                else if(f.Key == 'DocumentUrl'){
                                                    f.Value = this.higherEducationDetailsDocURL
                                                }
                                            })
                                        })
                                    }else{
                                        let tempMetadataVal2 = [{
                                            "DocumentId": '',
                                            "DocumentData": [{
                                                "Key": "Name",
                                                "Value": 'Certifications'
                                            },
                                            {
                                                "Key": "DocumentUrl",
                                                "Value": this.higherEducationDetailsDocURL
                                            }],
                                        }]
                                        edInfoDocs.MetadataValues = tempMetadataVal2
                                    }
                                }
                                else{
                                    edInfoDocs.MetadataValues = []
                                }
                            }
                        })

                        var strArray = this.educationinfo.currentCity.split(',')
                            var eduCityLocation = strArray[0]
                            var eduStateLocation = strArray[1]

                        obje = {
                            'Id':this.educationalInfoId,
                            "EducationDetails": {
                                "DegreeCompletedDate": this.educationinfo.mastersDegreeVal == "Yes" ? this.educationinfo.Datedegree : "",
                                "DegreeType": this.educationinfo.mastersDegreeVal == "Yes" ? this.educationinfo.TypeofDegree : "",
                                "StudyCategory": this.educationinfo.mastersDegreeVal == "Yes" ? this.educationinfo.Majorfield : "",
                                "InstituteName": this.educationinfo.mastersDegreeVal == "Yes" ? this.educationinfo.Nameofinstitution : ""

                            },
                            "IsEducationDetails": this.educationinfo.mastersDegreeVal == "Yes" ? true : false,
                             "IsMasterDegree":this.educationinfo.appeareYes == "Yes" ? true : false,
                             "HigherEducationDetails":{
                                "DegreeCompletedDate":this.educationinfo.appeareYes == "Yes" ? this.educationinfo.yesDatedegree : "",
                                "DegreeType": this.educationinfo.appeareYes == "Yes" ? this.educationinfo.yesTypeofDegree : "",
                                "StudyCategory":this.educationinfo.appeareYes == "Yes" ? this.educationinfo.yesMajorfield : "",
                                "InstituteName":this.educationinfo.appeareYes == "Yes" ? this.educationinfo.yesNameofinstitution : ""
                             },
                             "Address":{
                                "Address1":this.educationinfo.Street ,
                                "AptNumber":this.educationinfo.BuildingNumber,
                                "IsApt":this.educationinfo.Selectedapt == "ap3" && this.educationinfo.appeareYes == "Yes" ? true : false,
                                "IsSuite":this.educationinfo.Selectedste == "st4" && this.educationinfo.appeareYes == "Yes" ? true : false,
                                "IsFloor":this.educationinfo.Selectedflr == "fl4" && this.educationinfo.appeareYes == "Yes" ? true : false,
                                "City": eduCityLocation,
                                "State": eduStateLocation,
                                "Zip": this.educationinfo.zipcode,
                                "AddressSummary": this.educationinfo.currentCity
                             },
                             'Documents': this.educationInfomation.Documents
                        }
                           ajax.post(`H1BCheckList/AddOrUpdateEducationInfoForESS?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}`, obje, (res) => {
                               if(res.data.State == true){
                                   this.$loading({}).close()
                                   this.educationInfomation = res.data.EducationInfomation
                                   this.OpeneducationalInfoForm = false
                                   this.OpenemploymentinfoForm = true
                                   if(this.OpenemploymentinfoForm == true){
                                    this.showPersonalApproveOrRejectComments = false
                                    this.showEducationalApproveOrRejectComments=false
                                    this.showEmploymentApproveOrRejectComments=true
                                    this.showImmigrationApproveOrRejectComments=false
                                    this.showDependentApproveOrRejectComments=false
                                    // this.showPersonalApproveOrRejectIcon=true
                                    // this.showEducationalApproveOrRejectIcon=true
                                    // this.showEmploymentApproveOrRejectIcon=true
                                    // this.showImmigrationApproveOrRejectIcon=false
                                    // this.showDependentApproveOrRejectIcon=false
                                    }
                                   this.showgreenEduicon = true
                               }else{
                                   this.$loading({}).close()
                                   if(res.data.WarningMessage != "" && res.data.WarningMessage != null){
                                       this.isShowWarningMsgPopup = true
                                       this.warningContent = res.data.WarningMessage
                                   }else{
                                       this.$message({
                                           type: 'error',
                                           message: res.data.Message
                                       })
                                   }
                               }
                         })
                    },

                   saveStructureForImmigrationInfo() {
                       this.$loading({
                            'loadingText': 'Loading...'
                        })
                       if(this.immigrationInfomation.Documents !=''){
                             this.immigrationInfomation.Documents.forEach((docs, dIndex) => {
                                 if(docs.MetadataValues.length > 0){
                                     if(docs.DocumentType == 'Passport'){
                                         docs.MetadataValues.forEach((g) => {
                                             g.DocumentId = g.DocumentId
                                            g.DocumentData.forEach((k) => {
                                            if(k.Key == 'DocumentNumber'){
                                                k.Value = this.ImmigrationInfo.docNumber
                                            }
                                            if(k.Key == 'IssuingAuthority'){
                                                k.Value = this.ImmigrationInfo.Country
                                            }
                                            if(k.Key == 'IssueDate'){
                                                k.Value = this.ImmigrationInfo.PassportIssueDate
                                            }
                                            if(k.Key == 'ExpiryDate'){
                                                k.Value = this.ImmigrationInfo.PassportExpireDate
                                            }
                                            if(k.Key == 'DocumentUrl'){
                                                k.Value = this.immigrationPassportDocURL
                                            }
                                            if(k.Key == 'Name'){
                                                k.Value = "Passport"
                                            }
                                            if(k.Key == 'SignedDocumentUrl'){
                                                k.Value = ""
                                            }
                                            })
                                    })

                                     }else if(docs.DocumentType == 'Visa'){
                                         docs.MetadataValues.forEach((g) => {
                                             g.DocumentId = g.DocumentId
                                            g.DocumentData.forEach((k) => {
                                            if(k.Key == 'Name'){
                                                if( this.ImmigrationInfo.visaStatus != 'Others' || this.ImmigrationInfo.otherVisaName == ''){
                                                    k.Value = this.ImmigrationInfo.visaStatus
                                                }
                                                else{
                                                    k.Value = this.ImmigrationInfo.otherVisaName
                                                }

                                            }
                                            if(k.Key == 'Others'){
                                                if( this.ImmigrationInfo.visaStatus != 'Others' || this.ImmigrationInfo.otherVisaName == ''){
                                                    k.Value = false
                                                }
                                                else{
                                                    k.Value = true
                                                }

                                            }
                                            if(k.Key == 'IssueDate'){
                                                k.Value = this.ImmigrationInfo.lastArrivalDate
                                            }
                                            if(k.Key == 'ExpiryDate'){
                                                k.Value = this.ImmigrationInfo.admitUntil
                                            }
                                            if(k.Key == 'DocumentUrl'){
                                                k.Value = this.immigrationVisaDocURL
                                            }
                                            })
                                    })
                                     }else if(docs.DocumentType == 'ApprovedFormI140'){
                                            if(this.ImmigrationInfo.i140Approval != 'Yes')
                                            docs.MetadataValues = []
                                     }

                                 }else{
                                     if(docs.DocumentType == 'Passport'){
                                         let passportMetadataValues =   [{
                                                "DocumentId": '',
                                                "DocumentData": [{
                                                        "Key": "DocumentNumber",
                                                        "Value": this.ImmigrationInfo.docNumber
                                                    }, {
                                                        "Key": "IssuingAuthority",
                                                        "Value": this.ImmigrationInfo.Country
                                                    },  {
                                                        "Key": "IssueDate",
                                                        "Value": this.ImmigrationInfo.PassportIssueDate
                                                    }, {
                                                        "Key": "ExpiryDate",
                                                        "Value": this.ImmigrationInfo.PassportExpireDate
                                                    }, {
                                                        "Key": "DocumentUrl",
                                                        "Value": this.immigrationPassportDocURL
                                                    },
                                                    {
                                                        "Key": "SignedDocumentUrl",
                                                        "Value": ""
                                                    }, {
                                                        "Key": "Name",
                                                        "Value": "Passport"
                                                    },

                                                ],
                                            }]
                                        //this.immigrationInfomation.Documents.push(tempPassportDocObj)
                                        docs.MetadataValues = passportMetadataValues
                                     }else if(docs.DocumentType == 'Visa'){
                                         let visaMetadataValues =  [{
                                                "DocumentId": '',
                                                "DocumentData": [{
                                                        "Key": "Name",
                                                        "Value":  (this.ImmigrationInfo.visaStatus != "Others" ||  this.ImmigrationInfo.otherVisaName =='') ?  this.ImmigrationInfo.visaStatus : this.ImmigrationInfo.otherVisaName
                                                    },  {
                                                        "Key": "IssueDate",
                                                        "Value": this.ImmigrationInfo.lastArrivalDate
                                                    }, {
                                                        "Key": "ExpiryDate",
                                                        "Value": this.ImmigrationInfo.admitUntil
                                                    }, {
                                                        "Key": "DocumentUrl",
                                                        "Value": this.immigrationVisaDocURL
                                                    },
                                                    {
                                                        "Key": "Others",
                                                        "Value":  (this.ImmigrationInfo.visaStatus != "Others" ||  this.ImmigrationInfo.otherVisaName =='') ?  false : true
                                                    },

                                                ],
                                            }]
                                        //}
                                        //this.immigrationInfomation.Documents.push(tempVisaDocObj)
                                        docs.MetadataValues = visaMetadataValues
                                     }else if(docs.DocumentType == 'ApprovedFormI140'){
                                            if(this.ImmigrationInfo.i140Approval != 'Yes')
                                            docs.MetadataValues = []
                                     }
                                 }
                        })
                    }
                        let immiAddStayArr = []
                        if(this.ImmigrationInfo.outofStates == 'Yes'){
                            this.addAnotherStayArray.forEach((addArray, dIndex) => {
                                let tempAddArray = {
                                    "StartDate": addArray.entryDate,
                                    "EndDate": addArray.exitDate
                                }
                                immiAddStayArr.push(tempAddArray)
                            })
                        }
                        // else{
                        //      this.addAnotherStayArray.forEach((addArray, dIndex) => {
                        //         let tempAddArray = {
                        //             "StartDate": "",
                        //             "EndDate": ""
                        //         }
                        //         immiAddStayArr.push(tempAddArray)
                        //     })
                        // }

                        let immAddApprovalArr = []
                        if(this.ImmigrationInfo.h1bApproval == 'Yes'){
                            this.addAnotherApprovalArray.forEach((addApprovalArray, dIndex) => {
                                let tempAddapprovalArray = []
                                tempAddapprovalArray = {
                                    "StartDate": addApprovalArray.startDate,
                                    "EndDate": addApprovalArray.endDate,
                                    "CompanyName": addApprovalArray.compName,
                                    "DocumentNumber": addApprovalArray.h1orl1approval
                                }
                                immAddApprovalArr.push(tempAddapprovalArray)
                            })
                        }
                        // else {
                        //     let tempAddapprovalArray = []
                        //         tempAddapprovalArray = {
                        //             "StartDate": "",
                        //             "EndDate": "",
                        //             "CompanyName": "",
                        //             "DocumentNumber": ""
                        //         }
                        //         immAddApprovalArr.push(tempAddapprovalArray)
                        // }
						 if(this.ImmigrationInfo.visible == 'Yes'){
                            this.ImmigrationInfo.IsoutOfStates = true
                        }else{
                            this.ImmigrationInfo.IsoutOfStates = false
                        }
                        if(this.ImmigrationInfo.h1bApproval == 'Yes'){
                            this.ImmigrationInfo.Ish1bApproval = true
                        }else{
                            this.ImmigrationInfo.Ish1bApproval = false
                        }
                        if(this.ImmigrationInfo.i140Approval == 'Yes'){
                            this.ImmigrationInfo.Isi140Approval = true
                        }else{
                            this.ImmigrationInfo.Isi140Approval = false
                        }

                        // if(this.ImmigrationInfo.visible == 'No' && this.IsVisaDetailsprovided){
                        if(!this.IsVisaDetailsprovided){
                                   this.immigrationInfomation.Documents = this.immigrationInfomation.Documents.filter(x => x.DocumentType != 'Visa')
                        }

                        let immigrationObj = []
                        immigrationObj = {
                            "Id":this.immigrationInfomation.Id,
                            "I94Number":this.ImmigrationInfo.visible == 'Yes' ? this.ImmigrationInfo.recordNumber : "",
                            "LastArrivalDate":this.ImmigrationInfo.visible == 'Yes' ? this.ImmigrationInfo.immLastArrivalDate : "",
                            "NonImmigrantStatus":this.ImmigrationInfo.visible == 'Yes' ? this.ImmigrationInfo.nonimmigrantStatus : "",
                            "StatusExpiresDate":this.ImmigrationInfo.visible == 'Yes' ? this.ImmigrationInfo.StatusExpDate : "",
                            "SEVISNumber":this.ImmigrationInfo.visible == 'Yes' ? this.ImmigrationInfo.SEVISNumber : "",
                            "EADNumber":this.ImmigrationInfo.visible == 'Yes' ? this.ImmigrationInfo.EADNumber : "",
                            "IsOutsideUS":this.ImmigrationInfo.IsoutOfStates,
                            "EntryExitDetails": immiAddStayArr,
                            "IsPreviousApproval":this.ImmigrationInfo.Ish1bApproval,
                            "ApprovalsData": immAddApprovalArr,
                            "IsApprovedI140":this.ImmigrationInfo.i140Approval == 'Yes' ? true : false,
                            "Documents":this.immigrationInfomation.Documents
                        }
                         ajax.post(`H1BCheckList/AddOrUpdateImmigrationInfoForESS?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}`, immigrationObj, (res) => {
                            if(res.data.State == true){
                            this.immigrationInfomation = res.data.ImmigrationInfomation
                            this.$loading({}).close()
                            this.OpenimmigrationinfoForm = false
                            this.OpendependentInfoForm = true
                            if(this.OpendependentInfoForm == true){
                                    this.showPersonalApproveOrRejectComments = false
                                    this.showEducationalApproveOrRejectComments=false
                                    this.showEmploymentApproveOrRejectComments=false
                                    this.showImmigrationApproveOrRejectComments=false
                                    this.showDependentApproveOrRejectComments=true
                                    // this.showPersonalApproveOrRejectIcon=true
                                    // this.showEducationalApproveOrRejectIcon=true
                                    // this.showEmploymentApproveOrRejectIcon=true
                                    // this.showImmigrationApproveOrRejectIcon=true
                                    // this.showDependentApproveOrRejectIcon=true
                            }
                            this.showgreenEmpicon = true
                            this.showgreenImmicon = true
                            }else{
                                this.$loading({}).close()
                                if(res.data.WarningMessage != "" && res.data.WarningMessage != null){
                                    this.isShowWarningMsgPopup = true
                                    this.warningContent = res.data.WarningMessage
                                }else{
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })
                                }
                         }
                        })

                    },
                    checkvisaName(val){
var isValid = false
if(val =="H-1B" || val =="New H-1B (CAP)"
 ||val =="H-1B Extension"
 ||val =="H-1B Transfer"
 ||val =="H-1B Amendment"
 ||val =="New H-1B (CAP Exempt)"
 ||val =="H-1B Amendment + Extension"
 ||val =="H-1B Concurrent"
 ||val =="L-1 Visa"
 ||val =="E-3 Visa"
 ||val =="TN Visa"
 ||val =="Green Card"
 ||val =="US Citizen"
 ||val =="CPT"
 ||val =="EAD OTHERS"
 ||val =="OPT EAD"
 ||val =="STEM OPT")
 {
    isValid = true
 }
return isValid;
                    },

                    gotoempInfo() {
                        this.$v.educationinfo.$touch()
                        this.$v.higherEducationDetailsDocURL.$touch()
                        this.$v.educationDetailsDocURL.$touch()
                         if(!this.$v.educationinfo.$invalid && !this.$v.educationDetailsDocURL.$invalid && !this.$v.higherEducationDetailsDocURL.$invalid){
                          this.saveStructureForEducationalInfo()
                         }
                    },
                    gotoimmiinfo() {
                         this.$v.Employeeinfo.$touch()
                         if(!this.$v.Employeeinfo.$invalid){
                        this.saveStructureForEmployeeInfo()
                             }
                    },
                    saveStructureForEmployeeInfo(){
                     this.$loading({
                            'loadingText': 'Loading...'
                        })


                      let empAddStayArr = []
                     let tempempeObj = []
                      this.clientsList.forEach((addempArray, dIndex) => {
                            let tempempArray = []

                            if(addempArray.OrganizationName != ''){
                             empAddStayArr.push(addempArray)
                            }

                        })

                    //  tempempeObj = {
                    //      "IsEdit": false,
                    //         "OrganizationName": this.EndClient.OrganizationName,
                    //         "WebSite": this.EndClient.website,
                    //         "Type": this.EndClient.type
                    // }
                    // empAddStayArr.push(tempempeObj)

                    //    this.clientsList.forEach((addempArray, dIndex) => {
                    //         let tempempArray = []
                    //         tempempArray = {
                    //             "IsEdit": true,
                    //             "OrganizationName": addempArray.OrganizationName,
                    //             "WebSite": addempArray.website,
                    //             "Type": addempArray.type
                    //         }
                    //         empAddStayArr.push(tempempArray)
                    //     })

                    // let tempselfObj = []
                    //     tempselfObj = {
                    //     "IsEdit": false,
                    //     "OrganizationName": this.candidatesOrgName, //this.loggedInUserObj.OrgName,
                    //     "Type": this.self.type
                    // }
                    // empAddStayArr.push(tempselfObj)





                    //  this.vendorsList.forEach((addvendorArray, dIndex) => {
                    //     let tempempvendorArray = []
                    //         tempempvendorArray = {
                    //             "IsEdit": true,
                    //             "OrganizationName": addvendorArray.vendorOrganizationName,
                    //             "WebSite": addvendorArray.vendorWebsite,
                    //             "Type": addvendorArray.type
                    //         }
                    //         empAddStayArr.push(tempempvendorArray)
                    //     })

                     let tempISEmpApt = false
                     let tempIsEmpSte = false
                     let tempIsEmpFlr = false
                    // if(this.Employeeinfo.buildApt == 'apt2'){
                    //      tempISEmpApt = true
                    // }
                    // else if(this.Employeeinfo.buildSte == 'ste2'){
                    //     tempIsEmpSte = true
                    // }
                    // else if(this.Employeeinfo.buildFlr == 'flr2'){
                    //     tempIsEmpFlr = true
                    // }
                    //
                    if(this.Employeeinfo.buildType == 'apt2'){
                         tempISEmpApt = true
                    }
                    else if(this.Employeeinfo.buildType == 'ste2'){
                        tempIsEmpSte = true
                    }
                    else if(this.Employeeinfo.buildType == 'flr2'){
                        tempIsEmpFlr = true
                    }

                   let EmployeeObj = []
                      EmployeeObj = {
                        'id':this.employmentInfoId,
                        "EmployerName": this.Employeeinfo.Name,
                         "Address": {
                                    "Address1": this.Employeeinfo.empAddressVal == "Yes" ? this.Employeeinfo.empStreet : "",
                                    "IsApt": this.Employeeinfo.empAddressVal == "Yes" ? tempISEmpApt : false,
                                    "IsSuite": this.Employeeinfo.empAddressVal == "Yes" ? tempIsEmpSte : false,
                                    "IsFloor": this.Employeeinfo.empAddressVal == "Yes" ? tempIsEmpFlr : false,
                                    "AptNumber" : this.Employeeinfo.empAddressVal == "Yes" ? this.Employeeinfo.empBuildingNumber : "",
                                    "Zip": this.Employeeinfo.empAddressVal == "Yes" ? this.Employeeinfo.empzipcode : "",
                                   "AddressSummary": this.Employeeinfo.empAddressVal == "Yes" ? this.Employeeinfo.empcurrentCity : ""
                         },
                        'Documents':this.employmentInfomation.Documents,
                        "H1BId": this.$route.query.H1bId,
                        "consultantId" : this.loggedInUserObj.consultantId,
                        "LayerDetails" : empAddStayArr,
                        "IsAddress" : this.Employeeinfo.empAddressVal == "Yes" ? true : false,
                        "Designation" : this.employmentInfomation.Designation,
                        "JobTitle": this.employmentInfomation.JobTitle,
                        "MinSalaryOffered": this.employmentInfomation.MinSalaryOffered,
                        "MaxSalaryOffered": this.employmentInfomation.MaxSalaryOffered,
                        "SalaryCycle": this.employmentInfomation.SalaryCycle
                        }
                       ajax.post(`H1BCheckList/AddOrUpdateEmploymentInfoForESS?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}`, EmployeeObj, (res) => {
                        if(res.data.State == true){
                         this.$loading({}).close()
                         this.employmentInfomation = res.data.EmploymentInfomation
                         this.dataDetails = this.employmentInfomation.LayerDetails
                         this.OpenemploymentinfoForm = false
                         this.OpenimmigrationinfoForm = true
                        if(this.OpenimmigrationinfoForm == true){
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=false
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=true
                         this.showDependentApproveOrRejectComments=false
                        //  this.showPersonalApproveOrRejectIcon=true
                        //  this.showEducationalApproveOrRejectIcon=true
                        //  this.showEmploymentApproveOrRejectIcon=true
                        //  this.showImmigrationApproveOrRejectIcon=true
                        //  this.showDependentApproveOrRejectIcon=false
                         }
                         this.showgreenEduicon = true
                         this.showgreenEmpicon = true
                    //      this.$message({
                    //       type: 'success',
                    //       message: res.data.Message
                    // })
                      }else{
                          this.$loading({}).close()
                                   if(res.data.WarningMessage != "" && res.data.WarningMessage != null){
                                       this.isShowWarningMsgPopup = true
                                       this.warningContent = res.data.WarningMessage
                                   }else{
                                       this.$message({
                                           type: 'error',
                                           message: res.data.Message
                                       })
                                   }
                      }
                     })
                    },
                    gotodepInfo() {
                         this.$v.ImmigrationInfo.$touch();
                         this.$v.addAnotherStayArray.$touch();
                         this.$v.addAnotherApprovalArray.$touch();
                         this.$v.immigrationPassportDocURL.$touch();
                         this.$v.immigrationVisaDocURL.$touch();
                        if(!this.$v.ImmigrationInfo.$invalid && !this.$v.addAnotherStayArray.$invalid && !this.$v.addAnotherApprovalArray.$invalid
                        && !this.$v.immigrationPassportDocURL.$invalid && !this.$v.immigrationVisaDocURL.$invalid){
                        this.saveStructureForImmigrationInfo()
                          }
                    },
                    gotopreInfo() {

                         this.$v.dependentsArray.$touch()
                       if(!this.$v.dependentsArray.$invalid){
                        this.saveStructureForDependentInfo()
                            }
                    },
                    backtodepInfo() {
                       this.OpenpreviewForm = false
                        this.OpendependentInfoForm = true
                        this.showgreenEmpicon = true
                        this.showgreenImmicon = true
                        if(this.OpendependentInfoForm == true){
                            this.BindingDependentInformationData()
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=false
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=false
                         this.showDependentApproveOrRejectComments=true
                        //  this.showPersonalApproveOrRejectIcon=true
                        //  this.showEducationalApproveOrRejectIcon=true
                        //  this.showEmploymentApproveOrRejectIcon=true
                        //  this.showImmigrationApproveOrRejectIcon=true
                        //  this.showDependentApproveOrRejectIcon=true
                         }
                    },
                    gotoprevInfo() {
                        this.showgreenDepicon = true
                    },
                    // isopenOtherNames() {
                    //     this.OpenotherName = true
                    // },
                    // isopenothernames() {
                    //     this.OpenotherName = false
                    // },
                    backforEduInfo() {
                        this.OpeneducationalInfoForm = false
                        if(this.OpeneducationalInfoForm == false){
                         this.showPersonalApproveOrRejectComments = true
                         this.showEducationalApproveOrRejectComments=false
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=false
                         this.showDependentApproveOrRejectComments=false
                        //  this.showPersonalApproveOrRejectIcon=true
                        //  this.showEducationalApproveOrRejectIcon=false
                        //  this.showEmploymentApproveOrRejectIcon=false
                        //  this.showImmigrationApproveOrRejectIcon=false
                        //  this.showDependentApproveOrRejectIcon=false
                         }
                    },
                    backforEmpInfo() {
                        // if(this.educationinfo.mastersDegreeVal == 'No'){
                        //     this.resetMasterDegreeValues()
                        // }
                        this.OpenemploymentinfoForm = false
                        this.OpeneducationalInfoForm = true
                        if(this.OpeneducationalInfoForm == true){
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=true
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=false
                         this.showDependentApproveOrRejectComments=false
                        //  this.showPersonalApproveOrRejectIcon=true
                        //  this.showEducationalApproveOrRejectIcon=true
                        //  this.showEmploymentApproveOrRejectIcon=false
                        //  this.showImmigrationApproveOrRejectIcon=false
                        //  this.showDependentApproveOrRejectIcon=false
                         }

                    },
                  backforImmigrationInfo() {
                        this.OpendependentInfoForm = false
                        this.OpenimmigrationinfoForm = true
                        if(this.ImmigrationInfo.visible == 'No'){
                        this.ImmigrationInfo.recordNumber = ''
                        this.ImmigrationInfo.immLastArrivalDate = ''
                        this.ImmigrationInfo.nonimmigrantStatus = ''
                        this.ImmigrationInfo.StatusExpDate = ''
                        this.ImmigrationInfo.SEVISNumber = ''
                        this.ImmigrationInfo.EADNumber = ''
                        }
                        if(this.ImmigrationInfo.h1bApproval == 'No'){
                        this.addAnotherApprovalArray = []
                        this.addAnotherApproval()
                        }
                        if(this.ImmigrationInfo.outofStates == 'No'){
                        this.addAnotherStayArray = []
                        this.anotherStayPeriodAdding()
                        }
                        if(this.ImmigrationInfo.i140Approval == 'No'){
                            this.immigrationI140DocURL = ''
                        }
                        if(this.OpenimmigrationinfoForm == true){
                         this.showPersonalApproveOrRejectComments = false
                         this.showEducationalApproveOrRejectComments=false
                         this.showEmploymentApproveOrRejectComments=false
                         this.showImmigrationApproveOrRejectComments=true
                         this.showDependentApproveOrRejectComments=false
                        //  this.showPersonalApproveOrRejectIcon=true
                        //  this.showEducationalApproveOrRejectIcon=true
                        //  this.showEmploymentApproveOrRejectIcon=true
                        //  this.showImmigrationApproveOrRejectIcon=true
                        //  this.showDependentApproveOrRejectIcon=false
                         }

                    },
                    uploadw2Docs() {
                        // this.openw2docpopup = true
                    },
                    Cancel() {
                        this.openw2docpopup = false
                    },
                     getDependentInfoObjectStructure(){
                         //
                           let tempDependentArr = []
                           if(this.checkDependents == '1') {
                        this.dependentsArray.forEach((dependentItem ,dIndex) =>{
                            let obj = []
                            let tempIsSuite = false
                            let tempIsApt = false
                            let tempIsFloor = false
                            let tempForeignIsSte = false
                            let tempForeignIsApt = false
                            let tempForeignIsFloor = false
                            var str = dependentItem.addressObj.cityState
                            var strArray = str.split(',')
                            var cityLocation = strArray[0]
                            var stateLocation = strArray[1]
                            if(stateLocation == null){
                                stateLocation = ''
                            }
                            if(cityLocation == null){
                                  cityLocation = ''
                            }


                            if(dependentItem.addressObj.aptRadio == 'Apt')
                                tempIsApt = true
                            else if(dependentItem.addressObj.aptRadio == 'Ste')
                                tempIsSuite = true
                            else if(dependentItem.addressObj.aptRadio == 'Flr')
                                tempIsFloor = true

                            if(dependentItem.foreginAddressObj.aptRadio == 'Apt')
                                tempForeignIsApt = true
                            else if(dependentItem.foreginAddressObj.aptRadio == 'Ste')
                                tempForeignIsSte = true
                            else if(dependentItem.foreginAddressObj.aptRadio == 'Flr')
                                tempForeignIsFloor = true

                            let tempDocumentsArray = []
                            let tempDependentId = ''
                            if(this.dependentInformation.length == 0){
                                tempDependentId = ''

                                tempDocumentsArray = this.getInitialDependentStructure(dependentItem ,dIndex)

                            }
                            else if(this.dependentInformation.length > 0 && dependentItem.id != '')
                            {
                                if(dependentItem.Documents.filter(x => x.DocumentType == 'Passport').length  > 0){
                                    dependentItem.Documents.forEach((docs, dIndex) => {
                                        if(docs.MetadataValues.length > 0){
                                            if(docs.DocumentType == 'Passport'){
                                                if(dependentItem.passPortDetails.showPassportDetails){
                                                    docs.Message = dependentItem.type+' ('+dependentItem.basicInfoObj.givenName+ ' '+dependentItem.basicInfoObj.familyName+')'
                                                   // docs.DependentDocumentCategory  = dependentItem.type
                                                    docs.MetadataValues.forEach((g) => {
                                                        g.DocumentId = g.DocumentId
                                                        g.DocumentData.forEach((k) => {
                                                            if(k.Key == 'DocumentNumber'){
                                                                k.Value = dependentItem.passPortDetails.Number
                                                            }
                                                            if(k.Key == 'IssuingAuthority'){
                                                                k.Value = dependentItem.passPortDetails.issuedBy
                                                            }
                                                            if(k.Key == 'IssueDate'){
                                                                k.Value = dependentItem.passPortDetails.issueDate
                                                            }
                                                            if(k.Key == 'ExpiryDate'){
                                                                k.Value = dependentItem.passPortDetails.expirydate
                                                            }
                                                            if(k.Key == 'DocumentUrl'){
                                                                k.Value = dependentItem.passPortDetails.documentUrl
                                                            }
                                                        })
                                                    })
                                                }
                                            }
                                            //  else if(docs.DocumentType == 'Visa'){
                                            //      docs.Message = dependentItem.type
                                            //      docs.MetadataValues.forEach((g) => {
                                            //          g.DocumentId = g.DocumentId
                                            //         g.DocumentData.forEach((k) => {
                                            //         if(k.Key == 'Name'){
                                            //             k.Value = dependentItem.visaDetailsObj.currenStatus
                                            //         }
                                            //         if(k.Key == 'IssueDate'){
                                            //             k.Value = dependentItem.visaDetailsObj.lastEntrydate
                                            //         }
                                            //         if(k.Key == 'ExpiryDate'){
                                            //             k.Value = dependentItem.visaDetailsObj.admitUntil
                                            //         }
                                            //         if(k.Key == 'DocumentUrl'){
                                            //             k.Value = dependentItem.visaDetailsObj.documentUrl
                                            //         }
                                            //         })
                                            // })
                                            //  }
                                        }
                                    })
                                }
                                else
                                {
                                    var passportTmpObj = {}
                                    passportTmpObj =  this.structurePassportDocument(dependentItem ,dIndex)
                                     if(passportTmpObj != undefined){
                                    dependentItem.Documents.push(passportTmpObj)
                                     }
                                }

                                if(dependentItem.Documents.filter(x => x.DocumentType == 'I94').length  > 0){
                                    dependentItem.Documents.forEach((docs, dIndex) => {
                                        if(docs.MetadataValues.length > 0){
                                            if(docs.DocumentType == 'I94'){
                                                if(dependentItem.I94DetailsObj.showI94Details){
                                                    docs.Message = dependentItem.type+' ('+dependentItem.basicInfoObj.givenName+ ' '+dependentItem.basicInfoObj.familyName+')'
                                                    //docs.DependentDocumentCategory  = dependentItem.type
                                                    docs.MetadataValues.forEach((g) => {
                                                        g.DocumentId = g.DocumentId
                                                        g.DocumentData.forEach((k) => {
                                                            if(k.Key == 'DocumentNumber'){
                                                                k.Value = dependentItem.I94DetailsObj.i94ReceiptNumber
                                                            }
                                                            else if(k.Key == 'IssueDate'){
                                                                k.Value = dependentItem.I94DetailsObj.i94StartDate
                                                            }
                                                            else if(k.Key == 'ExpiryDate'){
                                                                k.Value = dependentItem.I94DetailsObj.i94EndDate
                                                            }
                                                            else if(k.Key == 'DocumentUrl'){
                                                                k.Value = dependentItem.I94DetailsObj.documentUrl
                                                            }
                                                        })
                                                    })
                                                }
                                            }
                                            //  else if(docs.DocumentType == 'MarriageCertificate'  && docs.MetadataValues.length > 0 && dependentItem.selectH4 == "2"){
                                            //       docs.MetadataValues = []
                                            //  }
                                        }
                                    })
                                }
                                else
                                {
                                    var I94TmpObj = {}
                                    I94TmpObj =  this.structureI94Document(dependentItem ,dIndex)
                                    if(I94TmpObj != undefined){
                                        dependentItem.Documents.push(I94TmpObj)
                                    }

                                }
                                //  dependentItem.Documents.forEach((docs, dIndex) => {
                                //         if(docs.DocumentType == 'MarriageCertificate'  && docs.MetadataValues.length > 0 && dependentItem.selectH4 == "2"){
                                //                 docs.MetadataValues = []
                                //             }
                                //  })
                                if(dependentItem.passPortDetails.showPassportDetails == false){
                                   dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'Passport')
                                }
                                if(dependentItem.I94DetailsObj.showI94Details == false){
                                   dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'I94')
                                }
                                if(dependentItem.type == 'Spouse'){
                                    if(dependentItem.Documents.filter(x => x.DocumentType == 'BirthCertificate').length  > 0){
                                            dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'BirthCertificate')
                                    }
                                     if(dependentItem.Documents.filter(x => x.DocumentType == 'FormI539').length  > 0){
                                         let tempFormI539 = dependentItem.Documents.find(x => x.DocumentType == 'FormI539')
                                         if(tempFormI539 && tempFormI539.MetadataValues && tempFormI539.MetadataValues.length <= 0 ){
                                                  dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'FormI539')
                                         }

                                    }
                                    if(dependentItem.selectH4 == '2'){
                                         if(dependentItem.Documents.filter(x => x.DocumentType == 'MarriageCertificate').length  > 0){
                                            dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'MarriageCertificate')
                                    } if(dependentItem.Documents.filter(x => x.DocumentType == 'FormI539').length  > 0){
                                            dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'FormI539')
                                    }

                                    }


                                } if(dependentItem.type == 'Child'){
                                    if(dependentItem.Documents.filter(x => x.DocumentType == 'MarriageCertificate').length  > 0){
                                            dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'MarriageCertificate')
                                    }
                                    if(dependentItem.Documents.filter(x => x.DocumentType == 'FormI539').length  > 0){

                                                  dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'FormI539')


                                    }
                                     if(dependentItem.selectH4 == '2'){
                                         if(dependentItem.Documents.filter(x => x.DocumentType == 'BirthCertificate').length  > 0){
                                            dependentItem.Documents = dependentItem.Documents.filter(x => x.DocumentType != 'BirthCertificate')
                                    }

                                    }



                                }

                                tempDocumentsArray = dependentItem.Documents
                            }
                            else
                            {
                                tempDocumentsArray = this.getInitialDependentStructure(dependentItem ,dIndex)
                            }
                            //
                                //  if(dependentItem.Documents.length > 0){
                                //            dependentItem.Documents.forEach((depDoc, ddINdex) =>{

                                //                    if(depDoc.MetadataValues && depDoc.MetadataValues.length > 0){
                                //                      tempDocumentsArray.push(depDoc)
                                //                    }


                                //            })
                                //        }
                                if(dependentItem.addressObj.cityState == null || dependentItem.addressObj.cityState == ',null'){
                                     dependentItem.addressObj.cityState = ''
                                }
                          obj =
                              {
                                  "Id" : dependentItem.id,
                                "IsAnyDependent": true,
                                "DependentType" : dependentItem.type ,
                                "SpouseDetails": {
                                    "FirstName" : dependentItem.basicInfoObj.givenName,
                                    "LastName": dependentItem.basicInfoObj.familyName,
                                    "MiddleName": dependentItem.basicInfoObj.middleName,
                                    "MobileNo": dependentItem.basicInfoObj.phoneNum,
                                    "Email" : dependentItem.basicInfoObj.emailAddr,
                                    "SocialSecurtiyNumber":dependentItem.basicInfoObj.ssnNumber,
                                    "DOB": moment(dependentItem.basicInfoObj.birthDate).format('MM/DD/YYYY'),
                                    "OtherLastName": dependentItem.basicInfoObj.maidenName, //Maiden Name,
                                    "DateOfBirth": dependentItem.basicInfoObj.birthCountry
                                    // ??? : country of citizen,
                                    // ??? : country of Birth
                                },
                                "CountryOfCitizenShip": dependentItem.basicInfoObj.countryCitizenShip,
                                "ImmigrationStatus":dependentItem.addressObj.immigrationStatus,
                                "SpouseAddress": {
                                    "Address1": dependentItem.addressObj.streetName,
                                    "IsApt": tempIsApt,
                                    "IsSuite":tempIsSuite,
                                    "IsFloor":tempIsFloor,
                                    "AptNumber" : dependentItem.addressObj.Number,
                                    "City": cityLocation,
                                    "State": stateLocation,
                                    "Zip": dependentItem.addressObj.zipCode,
                                    "AddressSummary":dependentItem.addressObj.cityState
                                    // ??? : Immigration status
                                },
                                "SpouseForeignAddress": {
                                    'Address1': dependentItem.foreginAddressObj.streetName,
                                    'IsApt': tempForeignIsApt,
                                    'IsSuite': tempForeignIsSte,
                                    'IsFloor': tempForeignIsFloor,
                                    'AptNumber': dependentItem.foreginAddressObj.AptNumber,
                                    'City': dependentItem.foreginAddressObj.Country != 'United States' ? dependentItem.foreginAddressObj.city : '',
                                    'State': dependentItem.foreginAddressObj.Country != 'United States' ? dependentItem.foreginAddressObj.State : '',
                                    'Zip': dependentItem.foreginAddressObj.Zip,
                                    'AddressSummary': dependentItem.foreginAddressObj.Country == 'United States' ? dependentItem.foreginAddressObj.cityState : dependentItem.foreginAddressObj.city +','+ dependentItem.foreginAddressObj.State,
                                    'Province': dependentItem.foreginAddressObj.Province,
                                    'CountryCode': dependentItem.foreginAddressObj.Country != 'United States' ? dependentItem.foreginAddressObj.CountryCode : '',
                                    'County': dependentItem.foreginAddressObj.Country
                                },
                                "Documents":tempDocumentsArray,
                                "IsH4Dependent": true
                            }

                            tempDependentArr.push(obj)

                        })
                     }
                        //tempDependentArr

                        return tempDependentArr

                    },
                    structureI94Document(docs , docIndex){
                         let tempI94Obj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "I94",
                                            "DisplayName": "I94",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                             "Message" : docs.type+' ('+docs.basicInfoObj.givenName+ ' '+docs.basicInfoObj.familyName+')',
                                           // "DependentDocumentCategory" : docs.type,
                                            "Metadata": [{
                                                    "DataType": "System.String",
                                                    "Key": "DocumentNumber",
                                                    "DisplayName": "I-94 Number",
                                                },  {
                                                    "DataType": "System.String",
                                                    "Key": "IssueDate",
                                                    "DisplayName": "Issue Date",
                                                }, {
                                                    "DataType": "System.String",
                                                    "Key": "ExpiryDate",
                                                    "DisplayName": "Expiry Date",
                                                }, {
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                },
                                                 {
                                                    "DataType": "System.String",
                                                    "Key": "SignedDocumentUrl",
                                                    "DisplayName": "Signed Document Url",
                                                },

                                            ],
                                            "MetadataValues": [{
                                               // "DocumentId": L.PDA[1].documentID1,
                                                "DocumentData": [{
                                                        "Key": "DocumentNumber",
                                                        "Value": docs.I94DetailsObj.i94ReceiptNumber
                                                    }, {
                                                        "Key": "IssueDate",
                                                        "Value": docs.I94DetailsObj.i94StartDate
                                                    }, {
                                                        "Key": "ExpiryDate",
                                                        "Value": docs.I94DetailsObj.i94EndDate
                                                    }, {
                                                        "Key": "DocumentUrl",
                                                        "Value": docs.I94DetailsObj.documentUrl
                                                    },{
                                                        "Key": "SignedDocumentUrl",
                                                        "Value": ''
                                                    },

                                                ],
                                            }]
                                        }
                                    //       if(docs.I94DetailsObj.showI94Details){
                                    //    tempDocumentsArray.push(tempI94Obj)
                                    //    }tempI94Obj
                                    return tempI94Obj

                    },
                    structurePassportDocument(docs , docIndex){

                         let tempPassportDocObj =  {
                                            "Group": "DependentDocuments",
                                            "DocumentType": "Passport",
                                            "DisplayName": "Passport",
                                            "UploadMultiple": false,
                                            "CanESign": false,
                                            "EntityType": 0,
                                            "CanBeApproved": true,
                                            "DocumentStatus": "Initiate",
                                             "Message" : docs.type+' ('+docs.basicInfoObj.givenName+ ' '+docs.basicInfoObj.familyName+')',
                                            //"DependentDocumentCategory" : docs.type,
                                            "Metadata": [  {
                                                    "DataType": "System.String",
                                                    "Key": "Name",
                                                    "DisplayName": "Document Name",
                                                },
                                                {
                                                    "DataType": "System.String",
                                                    "Key": "DocumentNumber",
                                                    "DisplayName": "Passport Number",
                                                }, {
                                                    "DataType": "System.String",
                                                    "Key": "IssuingAuthority",
                                                    "DisplayName": "Issuing Authority",
                                                }, {
                                                    "DataType": "System.String",
                                                    "Key": "IssueDate",
                                                    "DisplayName": "Issue Date",
                                                }, {
                                                    "DataType": "System.String",
                                                    "Key": "ExpiryDate",
                                                    "DisplayName": "Expiry Date",
                                                }, {
                                                    "DataType": "System.String",
                                                    "Key": "DocumentUrl",
                                                    "DisplayName": "Document Url",
                                                },
                                                 {
                                                    "DataType": "System.String",
                                                    "Key": "SignedDocumentUrl",
                                                    "DisplayName": "Signed Document Url",
                                                },

                                            ],
                                            "MetadataValues": [{
                                               // "DocumentId": L.PDA[1].documentID1,
                                                "DocumentData": [{
                                                        "Key": "Name",
                                                        "Value": 'Passport'
                                                    },{
                                                        "Key": "DocumentNumber",
                                                        "Value": docs.passPortDetails.Number
                                                    }, {
                                                        "Key": "IssuingAuthority",
                                                        "Value": docs.passPortDetails.issuedBy
                                                    },  {
                                                        "Key": "IssueDate",
                                                        "Value": docs.passPortDetails.issueDate
                                                    }, {
                                                        "Key": "ExpiryDate",
                                                        "Value": docs.passPortDetails.expirydate
                                                    }, {
                                                        "Key": "DocumentUrl",
                                                        "Value": docs.passPortDetails.documentUrl
                                                    },{
                                                        "Key": "SignedDocumentUrl",
                                                        "Value": ''
                                                    },

                                                ],
                                            }]
                                        }

                                       if(docs.passPortDetails.showPassportDetails){
                                            // tempDocumentsArray.push(tempPassportDocObj)
                                            return tempPassportDocObj
                                       }

                    },
                    getInitialDependentStructure(docs , docIndex){
                        let tempDocumentsArray = []
                        let tempPassportDocObj = {}
                        let tempI94Obj = {}
                       tempPassportDocObj  = this.structurePassportDocument(docs ,docIndex)
                       tempI94Obj = this.structureI94Document(docs ,docIndex)

                                        //  let tempVisaDocObj =  {
                                        //     "Group": "DependentDocuments",
                                        //     "DocumentType": "Visa",
                                        //     "DisplayName": "Visa",
                                        //     "UploadMultiple": false,
                                        //     "CanESign": false,
                                        //     "EntityType": 0,
                                        //     "CanBeApproved": true,
                                        //     "DocumentStatus": "Initiate",
                                        //     "Message":docs.type,
                                        //     "Metadata": [{
                                        //             "DataType": "System.String",
                                        //             "Key": "Name",
                                        //             "DisplayName": "Document Name",
                                        //         },  {
                                        //             "DataType": "System.String",
                                        //             "Key": "IssueDate",
                                        //             "DisplayName": "Issue Date",
                                        //         }, {
                                        //             "DataType": "System.String",
                                        //             "Key": "ExpiryDate",
                                        //             "DisplayName": "Expiry Date",
                                        //         }, {
                                        //             "DataType": "System.String",
                                        //             "Key": "DocumentUrl",
                                        //             "DisplayName": "Document Url",
                                        //         },

                                        //     ],
                                        //     "MetadataValues": [{
                                        //        // "DocumentId": L.PDA[1].documentID1,
                                        //         "DocumentData": [ {
                                        //                 "Key": "Name",
                                        //                 "Value": docs.visaDetailsObj.currenStatus
                                        //             },{
                                        //                 "Key": "IssueDate",
                                        //                 "Value": docs.visaDetailsObj.lastEntrydate
                                        //             }, {
                                        //                 "Key": "ExpiryDate",
                                        //                 "Value": docs.visaDetailsObj.admitUntil
                                        //             }, {
                                        //                 "Key": "DocumentUrl",
                                        //                 "Value": docs.visaDetailsObj.documentUrl
                                        //             },

                                        //         ],
                                        //     }]
                                        // }


                                      if(docs.passPortDetails.showPassportDetails){
                                             tempDocumentsArray.push(tempPassportDocObj)
                                           // return tempPassportDocObj
                                       }
                                       //tempDocumentsArray.push(tempVisaDocObj)
                                       if(docs.I94DetailsObj.showI94Details){
                                       tempDocumentsArray.push(tempI94Obj)
                                       }



                                       docs.Documents.forEach((doc, ddINDEX) =>{
                                           if(docs.type == 'Spouse'){
                                                if(doc.DocumentType == 'MarriageCertificate' || doc.DocumentType == 'FormI539'){
                                                    if( doc.MetadataValues != null && doc.MetadataValues.length > 0){
                                                        if(docs.selectH4 == "2"){
                                                         doc.MetadataValues = []
                                                     }
                                                    // doc.Message=docs.type
                                                    doc.Message  = docs.type+' ('+docs.basicInfoObj.givenName+ ' '+docs.basicInfoObj.familyName+')',
                                                   //doc.DependentDocumentCategory = docs.type,
                                                     tempDocumentsArray.push(doc)
                                                    }
                                             }
                                           }else{
                                               if(doc.DocumentType == 'BirthCertificate'){
                                                  if( doc.MetadataValues != null  && doc.MetadataValues.length > 0){
                                                      // doc.Message=docs.type
                                                      doc.Message  = docs.type+' ('+docs.basicInfoObj.givenName+ ' '+docs.basicInfoObj.familyName+')',
                                                  // doc.DependentDocumentCategory = docs.type,
                                                 tempDocumentsArray.push(doc)
                                                  }
                                             }
                                           }

                                       })
                                       return  tempDocumentsArray

                    },

                    saveStructureForDependentInfo(){
                    this.$loading({'loadingText': 'Loading...'})
                        ////
                        let tempObj = {}
                        if(this.checkDependents == '2')
                        {
                            tempObj = {}
                        }
                        else if(this.checkDependents == '1') {
                            tempObj = this.getDependentInfoObjectStructure()
                        }
                         ajax.post(`H1BCheckList/AddOrUpdateDependentInfoForESS?h1bId=${this.$route.query.H1bId}&orgId=${loggedInUserObj.orgId}`, tempObj, (res) => {
                                  if(res.data.State == true){
                                      this.$loading({}).close()
                                      if(res.data.DependentInformation == null){
                                           this.dependentInformation = []
                                      }else{
                                           this.dependentInformation = res.data.DependentInformation

                                      }

                                // this.OpenpreviewForm = true
                                 this.OpendependentInfoForm = false
                                this.OpenpreviewForm = true
                                this.showgreenImmicon = true
                                this.showgreenDepicon = true
                                 if(this.OpenpreviewForm == true){
                                this.showDependentApproveOrRejectComments = false
                                this.showPersonalApproveOrRejectComments = false
                                this.showEducationalApproveOrRejectComments=false
                                this.showEmploymentApproveOrRejectComments=false
                                this.showImmigrationApproveOrRejectComments=false
                                this.showDependentApproveOrRejectComments=false
                                // this.showPersonalApproveOrRejectIcon=true
                                // this.showEducationalApproveOrRejectIcon=true
                                // this.showEmploymentApproveOrRejectIcon=true
                                // this.showImmigrationApproveOrRejectIcon=true
                                // this.showDependentApproveOrRejectIcon=true
                                }
                               }else{
                                   this.$loading({}).close()
                                    if(res.data.WarningMessage != "" && res.data.WarningMessage != null){
                                        this.isShowWarningMsgPopup = true
                                        this.warningContent = res.data.WarningMessage
                                    }else{
                                        this.$message({
                                             type: 'error',
                                             message: res.data.Message
                                        })
                                    }
                               }
                        })

                    },
                    isavailableDegree() {
                        this.Opendegree = true
                        this.educationinfo.appeareNo = false
                        this.$v.educationinfo.yesDatedegree.$reset()
                        this.$v.educationinfo.yesTypeofDegree.$reset()
                        this.$v.educationinfo.yesMajorfield.$reset()
                        this.$v.educationinfo.yesNameofinstitution.$reset()
                        this.$v.educationinfo.Street.$reset()
                        this.$v.educationinfo.BuildingNumber.$reset()
                        this.$v.educationinfo.currentCity.$reset()
                        this.$v.educationinfo.zipcode.$reset()
                        this.$v.higherEducationDetailsDocURL.$reset()
                    },
                    resetMasterDegreeValues(){
                        this.educationinfo.Datedegree = ""
                        this.educationinfo.TypeofDegree = ""
                        this.educationinfo.Majorfield = ""
                        this.educationinfo.Nameofinstitution = ""
                        this.educationDetailsDocURL = ""
                        this.$v.educationinfo.Datedegree.$reset()
                        this.$v.educationinfo.TypeofDegree.$reset()
                        this.$v.educationinfo.Majorfield.$reset()
                        this.$v.educationinfo.Nameofinstitution.$reset()
                        this.$v.educationDetailsDocURL.$reset()
                    },
                    resetEmployeeAddressValues(){
                        this.Employeeinfo.empStreet = '',
                        this.Employeeinfo.empBuildingNumber = '',
                        this.Employeeinfo.empzipcode = ''
                        this.Employeeinfo.empcurrentCity = ''
                        this.$v.Employeeinfo.empStreet.$reset()
                        this.$v.Employeeinfo.empBuildingNumber.$reset()
                        this.$v.Employeeinfo.empzipcode.$reset()
                        this.$v.Employeeinfo.empcurrentCity.$reset()
                    },
                    isnotavailabledegree() {
                        this.Opendegree = false
                        this.educationinfo.appeareYes = false
                    },
                    close() {
                        this.showSuccessPopup = false
                        this.backtoHome()
                    },
                   isactiveYes(a) {
                        if (a == 1) {
                            this.isShowStay = true
                            this.ImmigrationInfo.visible = 'Yes'
                            this.$v.ImmigrationInfo.recordNumber.$reset()
                            this.$v.ImmigrationInfo.immLastArrivalDate.$reset()
                            this.$v.ImmigrationInfo.nonimmigrantStatus.$reset()
                            this.$v.ImmigrationInfo.StatusExpDate.$reset()
                        } else if (a == 2) {
                            this.isShowSignificant = true
                            this.ImmigrationInfo.outofStates = 'Yes'
                            this.$v.addAnotherStayArray.$reset()
                        } else if (a == 3) {
                            this.isShowH1Bapproval = true
                            this.ImmigrationInfo.h1bApproval = 'Yes'
                            this.$v.addAnotherApprovalArray.$reset()
                        } else {
                            this.isShowi140Approval = true
                            this.ImmigrationInfo.i140Approval = 'Yes'
                        }

                    },
                    isactiveNo(b) {
                        if (b == 1) {
                            this.isShowStay = false
                            this.ImmigrationInfo.visible = 'No'
                        } else if (b == 2) {
                            this.isShowSignificant = false
                            this.ImmigrationInfo.outofStates = 'No'
                        } else if (b == 3) {
                            this.isShowH1Bapproval = false
                            this.ImmigrationInfo.h1bApproval = 'No'
                        } else {
                            this.isShowi140Approval = false
                            this.ImmigrationInfo.i140Approval = 'No'
                        }

                    },
                    addanothername() {
                        let anotherNameObj = {
                            "OtherLastName": '',
                            "OtherFirstName": '',
                            "OtherMiddleName": '',
                        }
                        this.addAnotherNameArray.push(anotherNameObj)
                    },
                    addAnotherApproval() {
                          this.$v.addAnotherApprovalArray.$touch();
                          if (!this.$v.addAnotherApprovalArray.$invalid) {
                            let addAnotherdocuObj = {
                                "startDate": '',
                                "endDate": '',
                                "compName": '',
                                "h1orl1approval": ''
                            }
                            this.addAnotherApprovalArray.push(addAnotherdocuObj)
                        }
                    },
                    anotherStayPeriodAdding() {
                          this.$v.addAnotherStayArray.$touch();
                          if (!this.$v.addAnotherStayArray.$invalid) {
                            let addAnotherStayObj = {
                                "entryDate": '',
                                "exitDate": '',
                            }
                            this.addAnotherStayArray.push(addAnotherStayObj)
                        }
                    },
                    addClient(){
                        let addclientObj = {
                            "OrganizationName": '',
                            "website": '',
                            "type": 'Client'
                        }
                        this.clientsList.push(addclientObj)
                    },
                    // addVendor(){
                    //     let addvendorObj = {
                    //         "vendorOrganizationName": '',
                    //         "vendorWebsite": '',
                    //         "type":'Vendor',
                    //     }
                    //     this.vendorsList.push(addvendorObj)
                    // },
                    removeClient(arr, index){
                        arr.splice(index, 1)
                        this.clientsList = []
                        this.clientsList = arr
                    },
                    // removeVendor(arr,index){
                    //     arr.splice(index, 1)
                    //     this.vendorsList = []
                    //     this.vendorsList = arr
                    //  },
            },
            validations() {
                return {
                    personalInfoPrimaryContactLastNameVal: {
                        required,
                        // alphawithspace,
                    },
                    personalInfoPrimaryContactFirstNameVal: {
                        required,
                        // alphawithspace,
                    },
                    personalInfoPrimaryContactMiddleNameVal: {
                        // alphawithspace
                    },
                    extranameOtherLastName: {
                    //  alpha

                    },
                    extranameOtherFirstName: {
                        // alpha
                    },
                    extranameOtherMiddleName: {
                        // alpha
                    },
                    personalInfoPrimaryContactMobileNoVal: {
                        numeric,
                        minLength: minLength(10)
                    },
                    personalInfoPrimaryContactEmailVal: {
                        email
                    },
                    personaInfoPrimaryContactDOB: {
                        required
                    },
                    personalInfoBirthCountry: {
                        required
                    },
                    personalInfoProvienceOfBirth: {
                        required
                    },
                    personalInfoNationality: {
                        required
                    },
                    personalInfoPrimaryContactSocialSecurtiyNumber: {
                        numeric,
                        minLength: minLength(9)
                    },
                    personalInfoAlienNumber: {
                        alphanumeric,
                        noinAlienNumber,
                        maxLength: maxLength(10), // 'A' + 9 digits = 10 characters
                        minLength: minLength(9),
                    },
                    personalInfoCurrentAddressZip: {
                        numeric,
                        minLength: minLength(5)
                    },
                  personalInfoForeignAddressCity: {
                        //   requiredIf: requiredIf((a) => {
                        //      if(this.personalInfoForeignAddressCounty == 'United States'){
                        //         return true
                        //      }else{
                        //          return false
                        //      }
                        //     }),
                    },
                    personalInfoForeignAddressIndiaCity:{
                        // requiredIf: requiredIf((a) => {
                        //      if(this.personalInfoForeignAddressCounty != 'United States'){
                        //         return true
                        //      }else{
                        //          return false
                        //      }
                        //     }),
                    },
                    personalInfoForeignAddressIndiaState:{
                        //  requiredIf: requiredIf((a) => {
                        //      if(this.personalInfoForeignAddressCounty != 'United States'){
                        //         return true
                        //      }else{
                        //          return false
                        //      }
                        //     }),
                    },
                    personalInfoForeignAddressZip: {
                        // required,
                        numeric,
                        minLength: minLength(5),
                        //   requiredIf: requiredIf((a) => {
                        //      if(this.personalInfoForeignAddressCounty == 'United States'){
                        //         return true
                        //      }else{
                        //          return false
                        //      }
                        //     }),
                    },
                    // personalInfoForeignAddressProvince: {
                    //     required
                    // },
                    personalInfoForeignAddressCountryCode: {
                        // requiredIf: requiredIf((a) => {
                        //      if(this.personalInfoForeignAddressCounty != 'United States'){
                        //         return true
                        //      }else{
                        //          return false
                        //      }
                        //     }),
                    },
                    personalInfoForeignAddressCounty: {
                        //required
                    },
                    educationinfo: {
                        Datedegree: {
                             requiredIf: requiredIf((a) => {
                                if(this.educationinfo.mastersDegreeVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        yesDatedegree: {
                            requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),
                        },
                        TypeofDegree: {
                             requiredIf: requiredIf((a) => {
                                if(this.educationinfo.mastersDegreeVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        yesTypeofDegree: {
                            requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),
                           // alpha,
                        },
                        Majorfield: {
                             requiredIf: requiredIf((a) => {
                                if(this.educationinfo.mastersDegreeVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        yesMajorfield: {
                            requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),
                        },
                        Nameofinstitution: {
                             requiredIf: requiredIf((a) => {
                                if(this.educationinfo.mastersDegreeVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                            alphawithsplchar,
                        },
                        yesNameofinstitution: {
                            requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),
                            alphawithsplchar,
                        },
                        Street: {
                             requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),

                        },
                        zipcode: {
                            requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),
                            numeric,
                            minLength: minLength(5)
                        },
                        BuildingNumber: {
                             requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),

                        },
                        currentCity: {
                            requiredIf: requiredIf((a) => {
                                return a.appeareYes
                            }),

                        },
                    },
                    educationDetailsDocURL: {
                         requiredIf: requiredIf((a) => {
                                if(this.educationinfo.mastersDegreeVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                    },
                    higherEducationDetailsDocURL: {
                         requiredIf: requiredIf((a) => {
                             if(this.educationinfo.appeareYes == 'Yes'){
                                return true
                             }else{
                                 return false
                             }
                            }),
                    },
                    addAnotherNameArray:{
                        $each:{
                            OtherLastName:{
                              //  alphawithspace
                            },
                            OtherFirstName:{
                                // alphawithspace
                            },
                            OtherMiddleName:{
                                // alphawithspace
                            }
                        }
                    },
                    addAnotherApprovalArray: {
                        $each: {
                            startDate: {
                                requiredIf: requiredIf( (a) => {
                                    if(this.ImmigrationInfo.h1bApproval == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            },
                            endDate: {
                                 requiredIf: requiredIf( (a) => {
                                    if(this.ImmigrationInfo.h1bApproval == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            },
                            compName: {
                                 requiredIf: requiredIf( (a) => {
                                    if(this.ImmigrationInfo.h1bApproval == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            },
                            h1orl1approval: {
                                 requiredIf: requiredIf( (a) => {
                                    if(this.ImmigrationInfo.h1bApproval == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            }
                        }
                    },
                    addAnotherStayArray: {
                        $each: {
                            exitDate: {
                                requiredIf: requiredIf( (a) => {
                                    if(this.ImmigrationInfo.outofStates == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            },
                            entryDate: {
                                requiredIf: requiredIf( (a) => {
                                    if(this.ImmigrationInfo.outofStates == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            },
                        }
                    },
                    immigrationPassportDocURL:{
                        required
                    },
                    immigrationVisaDocURL:{
                        requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }
                                    else if(this.ImmigrationInfo.lastArrivalDate != '' || this.ImmigrationInfo.admitUntil != '' || this.ImmigrationInfo.visaStatus != '' || (this.ImmigrationInfo.immigrationVisaDocURL != '' && this.ImmigrationInfo.immigrationVisaDocURL != undefined)){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                    },
                    ImmigrationInfo: {
                        recordNumber: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        immLastArrivalDate: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        nonimmigrantStatus: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        StatusExpDate: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        docNumber: {
                            required
                        },
                        PassportIssueDate: {
                            required
                        },
                        PassportExpireDate: {
                            required
                        },
                        Country: {
                            required
                        },
                        lastArrivalDate: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }
                                    else if(this.ImmigrationInfo.lastArrivalDate != '' || this.ImmigrationInfo.admitUntil != '' || this.ImmigrationInfo.visaStatus != '' || (this.ImmigrationInfo.immigrationVisaDocURL != '' && this.ImmigrationInfo.immigrationVisaDocURL != undefined)){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        admitUntil: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }
                                    else if(this.ImmigrationInfo.lastArrivalDate != '' || this.ImmigrationInfo.admitUntil != '' || this.ImmigrationInfo.visaStatus != '' || (this.ImmigrationInfo.immigrationVisaDocURL != '' && this.ImmigrationInfo.immigrationVisaDocURL != undefined)){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        visaStatus: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visible == 'Yes'){
                                        return true
                                    }
                                    else if(this.ImmigrationInfo.lastArrivalDate != '' || this.ImmigrationInfo.admitUntil != '' || this.ImmigrationInfo.visaStatus != '' || (this.ImmigrationInfo.immigrationVisaDocURL != '' && this.ImmigrationInfo.immigrationVisaDocURL != undefined)){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        otherVisaName: {
                            requiredIf: requiredIf((a) => {
                                if(this.ImmigrationInfo.visaStatus == 'Others'){
                                        return true
                                    }
                                    else{
                                        return false
                                    }
                            }),
                        },
                    },
                   Employeeinfo: {
                        Name: {
                            required,
                        },
                        //    Job:{
                        //      required,
                        //      alpha
                        //    },
                        //    Salary:{
                        //      required,
                        //      numeric
                        //    },
                        //    Pre:{
                        //      required,
                        //    },
                        empStreet: {
                            requiredIf: requiredIf((a) => {
                                if(this.Employeeinfo.empAddressVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),

                        },
                        empBuildingNumber: {
                             requiredIf: requiredIf((a) => {
                                if(this.Employeeinfo.empAddressVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        empcurrentCity: {
                             requiredIf: requiredIf((a) => {
                                if(this.Employeeinfo.empAddressVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        },
                        empzipcode: {
                             requiredIf: requiredIf((a) => {
                                if(this.Employeeinfo.empAddressVal == 'Yes'){
                                        return true
                                    }else{
                                        return false
                                    }
                            }),
                        }
                    },
                    dependentsArray: {
                        $each: {
                            type: {
                                requiredIf: requiredIf((a) => {
                                    if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                        return true
                                    } else {
                                        return false
                                    }
                                })
                            },
                            basicInfoObj: {
                                emailAddr : {
                                    email
                                },
                                phoneNum: {
                                    minLength: minLength(10)
                                },
                                ssnNumber: {
                                 minLength: minLength(9)
                                },
                                familyName: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                            return true
                                        } else {
                                            return false
                                        }
                                    }),
                                    // alphawithspace
                                },
                                givenName: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                            return true
                                        } else {
                                            return false
                                        }
                                    }),
                                    // alphawithspace
                                },
                                middleName:{
                                    // alphawithspace
                                },
                                maidenName:{
                                    // alphawithspace
                                },
                                birthDate: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                countryCitizenShip: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                birthCountry: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                            },
                            addressObj: {
                                cityState: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                    //         return true
                                    //     } else {
                                    //         return false
                                    //     }
                                    // })
                                },
                                zipCode: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                    //         return true
                                    //     } else {
                                    //         return false
                                    //     }
                                    // })
                                },
                                immigrationStatus: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                    //         return true
                                    //     } else {
                                    //         return false
                                    //     }
                                    // })
                                },
                                streetName: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                                    //         return true
                                    //     } else {
                                    //         return false
                                    //     }
                                    // })
                                }
                            },
                            foreginAddressObj: {
                                Country: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.type == 'Spouse') {
                                    //         return true


                                    //     } else{
                                    //          return false
                                    //     }
                                    // })
                                },
                                city: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1'  && a.type == 'Spouse') {
                                    //         if(a.Country != 'United States'){
                                    //                 return true
                                    //             }else{
                                    //                 return false
                                    //             }
                                    //     } else{
                                    //          return false
                                    //     }
                                    // })
                                },
                                State: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1'  && a.type == 'Spouse') {
                                    //         if(a.Country != 'United States'){
                                    //                 return true
                                    //             }else{
                                    //                 return false
                                    //             }
                                    //     } else{
                                    //          return false
                                    //     }
                                    // })
                                },
                                Zip: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1'  && a.type == 'Spouse') {
                                    //         if(a.Country == 'United States'){
                                    //                 return true
                                    //             }else{
                                    //                 return false
                                    //             }
                                    //     } else{
                                    //          return false
                                    //     }
                                    // })
                                },
                                CountryCode: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1'  && a.type == 'Spouse') {
                                    //         if(a.Country != 'United States'){
                                    //                 return true
                                    //             }else{
                                    //                 return false
                                    //             }
                                    //     }else{
                                    //          return false
                                    //     }
                                    // })
                                },
                                cityState: {
                                    // requiredIf: requiredIf((a) => {
                                    //     if (this.dependentsArray.length > 0 && this.checkDependents == '1'  && a.type == 'Spouse') {
                                    //         if(a.Country == 'United States'){
                                    //                 return true
                                    //             }else{
                                    //                 return false
                                    //             }
                                    //     }else{
                                    //          return false
                                    //     }
                                    // })
                                }
                            },
                           passPortDetails: {
                                Number: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showPassportDetails) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                issueDate: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showPassportDetails) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                expirydate: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showPassportDetails) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                issuedBy: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showPassportDetails) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                documentUrl:{
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showPassportDetails) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })

                                }

                            },

                            // visaDetailsObj: {
                            //     lastEntrydate: {
                            //         requiredIf: requiredIf((a) => {
                            //             if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                            //                 return true
                            //             } else {
                            //                 return false
                            //             }
                            //         })
                            //     },
                            //     admitUntil: {
                            //         requiredIf: requiredIf((a) => {
                            //             if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                            //                 return true
                            //             } else {
                            //                 return false
                            //             }
                            //         })
                            //     },
                            //     currenStatus: {
                            //         requiredIf: requiredIf((a) => {
                            //             if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                            //                 return true
                            //             } else {
                            //                 return false
                            //             }
                            //         })
                            //     },

                            //     documentUrl:{
                            //          requiredIf: requiredIf((a) => {
                            //             if (this.dependentsArray.length > 0 && this.checkDependents == '1') {
                            //                 return true
                            //             } else {
                            //                 return false
                            //             }
                            //         })
                            //     }
                            // },
                            I94DetailsObj: {
                                i94ReceiptNumber: {
                                     minLength: minLength(11),
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showI94Details) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                i94StartDate: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showI94Details) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },
                                i94EndDate: {
                                    requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showI94Details) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                },

                                documentUrl:{
                                     requiredIf: requiredIf((a) => {
                                        if (this.dependentsArray.length > 0 && this.checkDependents == '1' && a.showI94Details) {
                                            return true
                                        } else {
                                            return false
                                        }
                                    })
                                }

                            }

                        }
                    }
                }
            },
            watch: {
				personalInfoCurrentAddressCity(val) {
                    if(val != null && val != '' && val != undefined) {
                        this.getZipCodeForCurrentAddr(val)
                    }
                },
                personalInfoForeignAddressCity(val) {
                    if(val != null && val != '' && val != undefined) {
                        this.getZipCodeForForeignAddr(val)
                    }
                },
                i140Approval(val){
                    if(val == "No"){
                        this.disableImmigrationSaveBtn = false
                    }else{
                        this.showImmigrationButtons()
                    }

                },
                PersonalInfoIsLegalContactAvailable(val) {
                    if (val == "No") {
                        this.OpenotherName = false

                    } else {
                        if(this.addAnotherNameArray.length == 0) {
                            this.addanothername()
                        }
                        this.OpenotherName = true
                    }

                },
                    checkboxValue(val) {
                        if (val == "1") {
                            this.disableCheckValue = false
                        } else {
                            this.disableCheckValue = true
                        }
                    },
                    personalInfoForeignAddressCounty(val){
                        if(val != "United States"){
                            this.personalInfoForeignAddressIndiaState = ''
                            this.personalInfoForeignAddressIndiaCity = ''
                            this.personalInfoForeignAddressProvince = ''
                            this.personalInfoForeignAddressCountryCode = ''
                        }else{
                            this.personalInfoForeignAddressCity = ''
                            this.personalInfoForeignAddressZip = ''
                            this.personalInfoForeignAddressProvince = ''
                        }
                        this.bindingResetvalues()
                    },
            },
        filters: {
        fileName(value) {
            if (!value) return ''
            value = value.toString()
            if (value.indexOf('https://') !== -1 || value.indexOf('http://') !== -1) {
                // URL
                let split = value.split('/')
                split = split[split.length - 1].split('?')
                return split[0]
            } else {
                return value
            }
        }
    },

    }
</script>
<style lang="scss" scoped>
    .footer-line {
        margin-top: 20px;
        border-bottom: 1px dashed grey;
        margin-bottom: 20px;
    }

    .doc-header {
        color: #000;
        font-weight: 600;
        font-size: 14px;
        font-weight: 600px;
    }

    .request-doc-header {
        color: #143361;
        font-weight: 700;
        font-size: 16px;
        padding-left: 25px;
        padding-top:15px
    }

    .icon-header {
        padding-right: 50px;
    }

    .info-text-blue {
        color: #4A90E2;
        font-size: 15px;
    }

    .info-text-green {
        color: #1DC942;
        font-size: 15px;
    }

    .info-text {
        font-size: 15px;
    }

    .listDocs-text {
        color: #4A90E2;
        font-weight: 600;
        font-size: 13px;
    }

    .doc-overflow {
        overflow: auto;
        height: 100%;
        background: #f6f7f8 !important
    }

    .status-options {
        margin: 26px 0 0 0;
    }

    .section-personal {
        border-bottom: 2px dashed #c2c2c2;
        padding: 10px 0;
    }

    .checklist-docs {
        overflow: auto;
        height: 100%;
    }

    .btnUpload {
        width: 79px;
        height: 28px;
        background-color: #1d437b
    }





    .document-list__headingStyle {
        padding: 5px 10px;
        border: 1px solid #c2c2c2;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        //background: #c2c2c2;
    }

    .document-list__statusStyle {
        background: #c2c2c2;
        color: #fdfdfd;
        padding: 0px 5px;
        border-radius: 100%;
        margin-left: 30px;
    }

    .star {
        color: red;
    }

    .heading-text {
        color: #000;
        font-weight: 700;
        font-size: 13px;
        padding: 20px 0px 0px 15px;
    }

    .upload-text {
        padding: 0px 0px 10px 25px
    }

    .names-text {
        color: #000;
        padding-top: 20px;
        font-weight: 700;
        font-size: 12px;
    }

    .label-text {
        padding-bottom: 5px;
        color: #000;
        font-size: 13px;
    }

    .checklist-docs {
        overflow: auto;
        height: 100%;
    }

    .contact-info-text {
        color: #000;
        font-size: 13px;
        font-weight: 700;
        padding-top: 15px;
    }

    .radio-buttons {
        margin-left: -20px;
    }

    .current-info-text {
        color: #000;
        padding: 15px 0px 0px 15px;
        font-weight: 700;
        font-size: 13px;
    }

    .footer-buttons {
        text-align: center;
        padding-top: 30px;
    }

    .actions-text {
        padding-bottom: 20px;
        text-align: right;
        margin-left: 186px;
    }

    .required-docs-text {
        color: #000;
        padding: 15px 0px 0px 0px;
        font-weight: 700;
        font-size: 13px;
    }

    .add-name {
        color: #4A90E2;
        font-style: italic;
        text-decoration: underline;
        font-weight: 700;
        padding-left: 5px;
        cursor: pointer;
    }

    .btn-upload {
        padding-bottom: 20px;
    }

    .section-heading-dependent {
        color: #393939;
        font-weight: 600;
        font-size: 17px
    }

    .radio-label {
        color: #393939;
        font-weight: 600;
    }

    .remove-worklocation {
        float: right;
        color: #D60000;
        font-size: 11px;
        font-weight: 650;
        margin-top: 5px;
        padding-right: 4px
    }
    .remove-location{
        float: right;
        color: #D60000;
        font-size: 11px;
        font-weight: 650;
        margin-top: 5px;
        padding-right: 26px
    }

    .fontStyle {
        font-weight: bold;
        padding: 15px;
        font-size: 17px;
        border-bottom: 1px dashed #ccc;
    }

    .infoStyle {
        color: #4191ef;
        padding-bottom: 25px;
        font-weight: 600;
    }

    .fontHeadStyle {
        padding-bottom: 15px;
        font-weight: 600;
        font-size: 13px;
        color: #143361;
    }

    .fontSubHeadPadStyle {
        padding-bottom: 10px;
    }

    .fontSubHeadStyle {
        font-size: 14px;
        padding-bottom: 10px;
        font-weight: 600;
        color: #143361;
    }

    .fontSubHeadBoldStyle {
        font-weight: 600;
        color: #143361;
        overflow-wrap: break-word;
    }

    .fontSubHeBoldStyle {
        font-weight: bold;
    }

    .fontSubHeadBoldPadStyle {
        font-weight: 600;
        padding-left: 8px;
        color: #143361;
        overflow-wrap: break-word;
    }
    .fontStySubHeadBoldPadStyle {
        font-weight: 600;
        padding-left: 22px;
        color: #143361;
        overflow-wrap: break-word;
    }
    /* .IconSize{
    width:30%;

} */

    .IconTitleColor {
        color: rgb(40, 167, 69);
        font-weight: bold;
    }

    .IconTitleblueColor {
        padding-left: 0px;
        font-weight: bold;
        color: #4A90E2;
    }

    .padIconStyle {
        padding-bottom: 20px;
    }

    .padStyle {
        padding-top: 10px;
        padding-bottom: 30px;
    }
    /* .alignStyle{
    text-align:center;
} */
    /* .padLeftStyle{
    padding-left:15px;
} */

    .padArrowLeftStyle {
        padding-left: 60px;
    }

    .document-list__headingApprovedStyle {
        padding: 5px 10px;
        border: 1px solid #3CB55B;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #F9F9F9;
        float: left;
    }

    .document-list__statusApprovedStyle {
        background: #ACF3BE;
        color: #3CB55B;
        padding: 0px 5px;
        border-radius: 100%;
    }

    // #project_clientDetails{
    //    // overflow: auto;
    //   .ul{
    //     margin:4px;
    //     display: inline-flex;
    //     .li{
    //          width: 145px;
    //     height: 64px;
    //     position: relative;
    //     list-style-type: none;
    //     background: white;
    //     padding: 12px 10px 10px 12px;
    //     border: 2px solid white;
    //    -webkit-box-shadow: 0 0 9.5px #dcd7d7;
    //     box-shadow: 0 0 9.5px #dcd7d7;
    //     border-radius: 0%;
    //     float: left;
    //     margin-left: 62px;
    //     margin-bottom: 25px;
    //     .website_txt{
    //                 font-size: 11px;
    //                 white-space: nowrap;
    //                 text-overflow: ellipsis;
    //                 overflow: hidden;
    //                 padding-bottom:1.5px;
    //                 font-weight:600;
    //       }
    //       .website_org{
    //             color: #143361;
    //             font-size: 13px;
    //             font-weight: 600;
    //             white-space: nowrap;
    //             text-overflow: ellipsis;
    //             overflow: hidden;
    //       }
    //       &:after{
    //         content: '';
    //         background: #656262;
    //         position: absolute;
    //         top: 28.6px;
    //         width: 46px;
    //         height: 2px;
    //         margin-left:139px;
    //       }
    //       .circle {
    //           width: 1em;
    //           height: 1em;
    //           box-sizing: initial;
    //           background: #fff;
    //           border: 0.3em solid #656262;
    //           color: #666;
    //           border-radius: 50%;
    //           line-height: 2rem;
    //           box-sizing: content-box;
    //         }
    //        &:last-child:after{
    //           width: 0px !important;
    //         }
    //         &:last-child{
    //          .left {
    //            display:none;
    //          }
    //         }
    //         &:first-child{
    //          margin-left:0;
    //         }
    //         i {
    //             border: solid #656262 ;
    //             border-width: 0 1.5px 1.5px 0;
    //             display: inline-block;
    //             padding: 3px;
    //         }
    //         .right {
    //             position: absolute;
    //             left: -20px;
    //             top: 26px;
    //             border-color:none;
    //             transform: rotate(-45deg);
    //             -webkit-transform: rotate(-45deg);
    //         }
    //         .left {
    //             position: absolute;
    //             right:-14px;
    //             margin-right: -4px;
    //             top: 26px;
    //             z-index: 1;
    //             border-color:none;
    //             transform: rotate(135deg);
    //             -webkit-transform: rotate(135deg);
    //            }
    //          }
    //      }
    //   }
    .fontCheckStyle {
        font-size: 14px;
        font-weight: 600;
        color: #143361;
    }

    .fontborderStyle {
        padding-bottom: 25px;
        padding-top: 25px;
        padding-left: 0px;
        border-top: 1px dashed #ccc;
    }

    .fontborderSolidStyle {
        padding-top: 35px;
        padding-left: 0px;
        padding-bottom: 40px;
        border-top: 1px solid #ccc;
        text-align: center;
    }

    .fontSizeInfoIconStyle {
        font-size: 17px;
    }

    .margPillStyle {
        margin-left: -10px;
    }

    .at {
        color: #143361;
        font-weight: 600;
        font-size: 21px;
        padding-top: 13px;
    }

    .pas {
        font-weight: normal;
        font-size: 14px;
        padding-bottom: 30px;
    }

    .pas p {
        color: #727d8c;
        font-size: 13px;
        font-weight: 600;
    }

    .ContenttoBottomStyle {
        //padding-bottom: 10% !important;
    }

    .BorderStyle {
        border-bottom: 1px solid grey;
        padding-bottom: 35px;
    }
    .close {
         border: 1px solid black;
         border-radius: 12px;
        }

.input-field-field {
  width: 60%;
  height:20px;
  //padding: 1.5%;
  margin-right: 5%;
  display: inline-block;
  border-radius: 10px;
  //box-sizing: border-box;
}
.input-field{
    width: 100%;
    margin-right: 5%;
    background: #666666;
    border-radius: 10px;
    box-sizing: border-box;
}

.fixed-org {
  display: flex;
  justify-content: left;
  padding-top: 2%;
}

.align-org {
  display: flex;
  justify-content: left;
  padding-top: 4%;
}

.vl {
  border-left: 1px solid #DFDFDF;
  position: inherit;
  margin-left: 5%;
  margin-top: -12px;
  width:134%;
}
.org-vl {
  border-left: 1px solid #DFDFDF;
  position: inherit;
  margin-left: 5%;
  width:134%;
  padding-left: 57px;
  height: 58px;
}
.org-line{
  margin-top: 37px;
  width: 10%;
  margin-left: -58px;
}
.org-main-align{
  border-left: 1px solid #DFDFDF;
  position: inherit;
}
.add-another-text-align{
  position: inherit;
  margin-left: 5%;
  margin-top: -10px;
  width:134%;
  margin-top: -22px;
  margin-left: 42px;
}
.add-position{
  margin-top: 5%;
  margin-left: -14px;
  cursor: pointer;
}

.line{
  margin-top: 40px;
  width: 10%;
}

.heading{
  padding-top: 5% !important;
  padding-bottom: 5% !important;
}
.normal-input {
background: white !important;
}

*:focus {
  outline: none;
}
.flow-digram{
   height:50%;
   width:30%
}
.add-another-client{
   margin-top:10px;
   color: #4A90E2;
   font-style: italic;
   font-weight:700;
   font-size:11px;
   cursor:pointer;
}
.endclient-details{
  display: flex;
  width:140%;
  justify-content: left;
  padding-left: 5%;
  }
  .end-client-name{
   //text-align:left;
  // padding-left:80px !important;
   font-size:12px;
   color:#000;
   padding-bottom: 5px;
  }
  .end-client-website{
   // float:right;
    //margin-right:-38px !important;
   font-size:12px;
   color:#000;
   padding-bottom: 5px;
  }
  .client-details{
    font-size:12px;
   color:#000;
    margin-left:15%;
    margin-bottom:-18px;
   display:inline-block;
  }
  .client-website{
   font-size:12px;
   color:#000;
   margin-left:45%;
   display:inline-block;
   }
   .vendor-details{
    font-size:12px;
   color:#000;
    margin-left:15%;
    margin-bottom:-18px;
   display:inline-block;
   }
   .vendor-website{
    font-size:12px;
   color:#000;
   margin-left:40%;
   display:inline-block;
   }
  .organization{
      font-size:12px;
      color:#000;
      padding-left:0px;
      padding-bottom: 5px;
      //margin-left:39px;
  }
    .input-client-field{
        //width: 100%;
    // margin-right: 5%;
        border-radius: 10px;
        box-sizing: border-box;
    }
  .padToppSty{
    padding-top:10px;
  }
  .remove-name {
        color: #D60000;
        font-style: italic;
        text-decoration: underline;
        font-weight: 800;
        font-size: 13px;
        padding-left: 5px;
        cursor: pointer;
    }
    .commentTopStyle {
        background: #ffd9cd;
        border-radius: 4px;
        white-space: normal;
        padding-left: 9px;
        padding-top: 5px;
        padding-bottom: 5px;
        overflow-wrap: break-word;
    }

    .commentStyle {
        background: #efefef;
        border-radius: 4px;
        white-space: normal;
        padding-left: 9px;
        padding-top: 5px;
        padding-bottom: 5px;
        overflow-wrap: break-word;
    }
    .document-list__ApproveStatusESSStyle {
        background: #c7ffd3;
        color: #079f6c;
        padding: 0px 5px;
        border-radius: 100%;
        font-size: 10px;
    }
    .document-list__RejectStatusESSStyle {
        background: #D60000;
        color: #fff;
        padding: 0px 5px;
        border-radius: 100%;
        font-size: 10px;
    }
    .padBottomStyle{
        padding-top:10px;
    }
    .conditionalBorder {
        border-bottom: 2px dashed #789acc;
        margin-bottom: 15px !important;
        padding-top: 15px !important;
    }
    .variant-border{
        border-top: 1px dashed #789acc;
    padding-top: 15px;
    }
    </style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpH1B/H1BPetitionEmpChecklistDocs.vue